function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8a92"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8a92"] = parcelRequire;
}
parcelRequire.register("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRequire.register("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRequire.register("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRequire.register("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRequire.register("5Gn6I", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = mergeWith;

});

parcelRequire.register("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

parcelRequire.register("8RYFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $675256233f0d2ee0$export$2e2bcd8739ae039);

var $gvVBt = parcelRequire("gvVBt");
var $675256233f0d2ee0$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $675256233f0d2ee0$var$index = (0, $gvVBt.default)(function(prop) {
    return $675256233f0d2ee0$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $675256233f0d2ee0$export$2e2bcd8739ae039 = $675256233f0d2ee0$var$index;

});
parcelRequire.register("gvVBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c05c3971f0aa92b4$export$2e2bcd8739ae039);
function $c05c3971f0aa92b4$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $c05c3971f0aa92b4$export$2e2bcd8739ae039 = $c05c3971f0aa92b4$var$memoize;

});


var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;



parcelRequire("acw62");
/**
 * React Router v6.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @remix-run/router v1.9.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1d34d5c4a288b213$var$safelyDecodeURI(pathname));
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:\w+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $1d34d5c4a288b213$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $1d34d5c4a288b213$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1d34d5c4a288b213$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($1d34d5c4a288b213$var$_extends({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $1d34d5c4a288b213$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $1d34d5c4a288b213$var$ResultType.error,
                        error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $1d34d5c4a288b213$var$ResultType.error ? $1d34d5c4a288b213$var$ResultType.error : $1d34d5c4a288b213$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || obj.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}


function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367
    }).initialize();
}



/**
 * lucide-react v0.279.0 - ISC
 */ /**
 * lucide-react v0.279.0 - ISC
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * lucide-react v0.279.0 - ISC
 */ var $65855df5fc59b2ec$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};


const $810dc495bedb1cb1$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $810dc495bedb1cb1$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $acw62.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, children: children, ...rest }, ref)=>(0, $acw62.createElement)("svg", {
            ref: ref,
            ...(0, $65855df5fc59b2ec$export$2e2bcd8739ae039),
            width: size,
            height: size,
            stroke: color,
            strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
            className: `lucide lucide-${$810dc495bedb1cb1$export$73bda83cddbc7187(iconName)}`,
            ...rest
        }, [
            ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
            ...(Array.isArray(children) ? children : [
                children
            ]) || []
        ]));
    Component.displayName = `${iconName}`;
    return Component;
};


const $c31db635520dc385$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ChevronLeft", [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
]);

/**
 * lucide-react v0.279.0 - ISC
 */ 
const $7979593adeba180b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ChevronRight", [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
]);

/**
 * lucide-react v0.279.0 - ISC
 */ 
const $0c90bba72fbdd9e9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Heart", [
    [
        "path",
        {
            d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
            key: "c3ymky"
        }
    ]
]);

/**
 * lucide-react v0.279.0 - ISC
 */ 
const $ee6f13a46cf9100a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ShoppingCart", [
    [
        "circle",
        {
            cx: "8",
            cy: "21",
            r: "1",
            key: "jimo8o"
        }
    ],
    [
        "circle",
        {
            cx: "19",
            cy: "21",
            r: "1",
            key: "13723u"
        }
    ],
    [
        "path",
        {
            d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
            key: "9zh506"
        }
    ]
]);

/**
 * lucide-react v0.279.0 - ISC
 */ 
const $eebbdbda5fc86e89$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("User2", [
    [
        "circle",
        {
            cx: "12",
            cy: "8",
            r: "5",
            key: "1hypcn"
        }
    ],
    [
        "path",
        {
            d: "M20 21a8 8 0 1 0-16 0",
            key: "199sx2"
        }
    ]
]);



var $acw62 = parcelRequire("acw62");
// src/utils/create-transform.ts
// src/index.ts
var $abe97432afb3d989$export$a274e22fb40f762e = (...classNames)=>classNames.filter(Boolean).join(" ");
function $abe97432afb3d989$var$isDev() {
    return false;
}
function $abe97432afb3d989$export$a6cdc56e425d0d0a(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}
var $abe97432afb3d989$export$c106dd0671a0fc2d = (options)=>{
    const { condition: condition, message: message } = options;
    if (condition && $abe97432afb3d989$var$isDev()) console.warn(message);
};
function $abe97432afb3d989$export$624e501d81f5ffce(valueOrFn, ...args) {
    return $abe97432afb3d989$var$isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
var $abe97432afb3d989$var$isFunction = (value)=>typeof value === "function";
var $abe97432afb3d989$export$5cc3b7b83e34ade7 = (condition)=>condition ? "" : void 0;
var $abe97432afb3d989$export$91a6105db3d4be7b = (condition)=>condition ? true : void 0;
function $abe97432afb3d989$export$5bdd3f730ec2c47e(...fns) {
    return function func(event) {
        fns.some((fn)=>{
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $abe97432afb3d989$export$9dd9a52f2dd5b9ce(...fns) {
    return function mergedFn(arg) {
        fns.forEach((fn)=>{
            fn == null || fn(arg);
        });
    };
}



var $5Gn6I = parcelRequire("5Gn6I");
var $47a6d9fbbf7ee42d$var$isImportant = (value)=>/!(important)?$/.test(value);
var $47a6d9fbbf7ee42d$var$withoutImportant = (value)=>typeof value === "string" ? value.replace(/!(important)?$/, "").trim() : value;
var $47a6d9fbbf7ee42d$export$92f5bb613cffac78 = (scale, value)=>(theme)=>{
        const valueStr = String(value);
        const important = $47a6d9fbbf7ee42d$var$isImportant(valueStr);
        const valueWithoutImportant = $47a6d9fbbf7ee42d$var$withoutImportant(valueStr);
        const key = scale ? `${scale}.${valueWithoutImportant}` : valueWithoutImportant;
        let transformed = (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(theme.__cssMap) && key in theme.__cssMap ? theme.__cssMap[key].varRef : value;
        transformed = $47a6d9fbbf7ee42d$var$withoutImportant(transformed);
        return important ? `${transformed} !important` : transformed;
    };
function $47a6d9fbbf7ee42d$var$createTransform(options) {
    const { scale: scale, transform: transform2, compose: compose } = options;
    const fn = (value, theme)=>{
        var _a;
        const _value = $47a6d9fbbf7ee42d$export$92f5bb613cffac78(scale, value)(theme);
        let result = (_a = transform2 == null ? void 0 : transform2(_value, theme)) != null ? _a : _value;
        if (compose) result = compose(result, theme);
        return result;
    };
    return fn;
}
// src/utils/pipe.ts
var $47a6d9fbbf7ee42d$var$pipe = (...fns)=>(v)=>fns.reduce((a, b)=>b(a), v);
// src/utils/prop-config.ts
function $47a6d9fbbf7ee42d$var$toConfig(scale, transform2) {
    return (property)=>{
        const result = {
            property: property,
            scale: scale
        };
        result.transform = $47a6d9fbbf7ee42d$var$createTransform({
            scale: scale,
            transform: transform2
        });
        return result;
    };
}
var $47a6d9fbbf7ee42d$var$getRtl = ({ rtl: rtl, ltr: ltr })=>(theme)=>theme.direction === "rtl" ? rtl : ltr;
function $47a6d9fbbf7ee42d$var$logical(options) {
    const { property: property, scale: scale, transform: transform2 } = options;
    return {
        scale: scale,
        property: $47a6d9fbbf7ee42d$var$getRtl(property),
        transform: scale ? $47a6d9fbbf7ee42d$var$createTransform({
            scale: scale,
            compose: transform2
        }) : transform2
    };
}
// src/utils/templates.ts
var $47a6d9fbbf7ee42d$var$transformTemplate = [
    "rotate(var(--chakra-rotate, 0))",
    "scaleX(var(--chakra-scale-x, 1))",
    "scaleY(var(--chakra-scale-y, 1))",
    "skewX(var(--chakra-skew-x, 0))",
    "skewY(var(--chakra-skew-y, 0))"
];
function $47a6d9fbbf7ee42d$var$getTransformTemplate() {
    return [
        "translateX(var(--chakra-translate-x, 0))",
        "translateY(var(--chakra-translate-y, 0))",
        ...$47a6d9fbbf7ee42d$var$transformTemplate
    ].join(" ");
}
function $47a6d9fbbf7ee42d$var$getTransformGpuTemplate() {
    return [
        "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
        ...$47a6d9fbbf7ee42d$var$transformTemplate
    ].join(" ");
}
var $47a6d9fbbf7ee42d$var$filterTemplate = {
    "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
    filter: [
        "var(--chakra-blur)",
        "var(--chakra-brightness)",
        "var(--chakra-contrast)",
        "var(--chakra-grayscale)",
        "var(--chakra-hue-rotate)",
        "var(--chakra-invert)",
        "var(--chakra-saturate)",
        "var(--chakra-sepia)",
        "var(--chakra-drop-shadow)"
    ].join(" ")
};
var $47a6d9fbbf7ee42d$var$backdropFilterTemplate = {
    backdropFilter: [
        "var(--chakra-backdrop-blur)",
        "var(--chakra-backdrop-brightness)",
        "var(--chakra-backdrop-contrast)",
        "var(--chakra-backdrop-grayscale)",
        "var(--chakra-backdrop-hue-rotate)",
        "var(--chakra-backdrop-invert)",
        "var(--chakra-backdrop-opacity)",
        "var(--chakra-backdrop-saturate)",
        "var(--chakra-backdrop-sepia)"
    ].join(" "),
    "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function $47a6d9fbbf7ee42d$var$getRingTemplate(value) {
    return {
        "--chakra-ring-offset-shadow": `var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)`,
        "--chakra-ring-shadow": `var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)`,
        "--chakra-ring-width": value,
        boxShadow: [
            `var(--chakra-ring-offset-shadow)`,
            `var(--chakra-ring-shadow)`,
            `var(--chakra-shadow, 0 0 #0000)`
        ].join(", ")
    };
}
var $47a6d9fbbf7ee42d$var$flexDirectionTemplate = {
    "row-reverse": {
        space: "--chakra-space-x-reverse",
        divide: "--chakra-divide-x-reverse"
    },
    "column-reverse": {
        space: "--chakra-space-y-reverse",
        divide: "--chakra-divide-y-reverse"
    }
};
// src/utils/parse-gradient.ts
var $47a6d9fbbf7ee42d$var$directionMap = {
    "to-t": "to top",
    "to-tr": "to top right",
    "to-r": "to right",
    "to-br": "to bottom right",
    "to-b": "to bottom",
    "to-bl": "to bottom left",
    "to-l": "to left",
    "to-tl": "to top left"
};
var $47a6d9fbbf7ee42d$var$valueSet = new Set(Object.values($47a6d9fbbf7ee42d$var$directionMap));
var $47a6d9fbbf7ee42d$var$globalSet = /* @__PURE__ */ new Set([
    "none",
    "-moz-initial",
    "inherit",
    "initial",
    "revert",
    "unset"
]);
var $47a6d9fbbf7ee42d$var$trimSpace = (str)=>str.trim();
function $47a6d9fbbf7ee42d$var$parseGradient(value, theme) {
    if (value == null || $47a6d9fbbf7ee42d$var$globalSet.has(value)) return value;
    const prevent = $47a6d9fbbf7ee42d$var$isCSSFunction(value) || $47a6d9fbbf7ee42d$var$globalSet.has(value);
    if (!prevent) return `url('${value}')`;
    const regex = /(^[a-z-A-Z]+)\((.*)\)/g;
    const results = regex.exec(value);
    const type = results == null ? void 0 : results[1];
    const values = results == null ? void 0 : results[2];
    if (!type || !values) return value;
    const _type = type.includes("-gradient") ? type : `${type}-gradient`;
    const [maybeDirection, ...stops] = values.split(",").map($47a6d9fbbf7ee42d$var$trimSpace).filter(Boolean);
    if ((stops == null ? void 0 : stops.length) === 0) return value;
    const direction = maybeDirection in $47a6d9fbbf7ee42d$var$directionMap ? $47a6d9fbbf7ee42d$var$directionMap[maybeDirection] : maybeDirection;
    stops.unshift(direction);
    const _values = stops.map((stop)=>{
        if ($47a6d9fbbf7ee42d$var$valueSet.has(stop)) return stop;
        const firstStop = stop.indexOf(" ");
        const [_color, _stop] = firstStop !== -1 ? [
            stop.substr(0, firstStop),
            stop.substr(firstStop + 1)
        ] : [
            stop
        ];
        const _stopOrFunc = $47a6d9fbbf7ee42d$var$isCSSFunction(_stop) ? _stop : _stop && _stop.split(" ");
        const key = `colors.${_color}`;
        const color2 = key in theme.__cssMap ? theme.__cssMap[key].varRef : _color;
        return _stopOrFunc ? [
            color2,
            ...Array.isArray(_stopOrFunc) ? _stopOrFunc : [
                _stopOrFunc
            ]
        ].join(" ") : color2;
    });
    return `${_type}(${_values.join(", ")})`;
}
var $47a6d9fbbf7ee42d$var$isCSSFunction = (value)=>{
    return typeof value === "string" && value.includes("(") && value.includes(")");
};
var $47a6d9fbbf7ee42d$var$gradientTransform = (value, theme)=>$47a6d9fbbf7ee42d$var$parseGradient(value, theme != null ? theme : {});
// src/utils/transform-functions.ts
function $47a6d9fbbf7ee42d$var$isCssVar(value) {
    return /^var\(--.+\)$/.test(value);
}
var $47a6d9fbbf7ee42d$var$analyzeCSSValue = (value)=>{
    const num = parseFloat(value.toString());
    const unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
};
var $47a6d9fbbf7ee42d$var$wrap = (str)=>(value)=>`${str}(${value})`;
var $47a6d9fbbf7ee42d$var$transformFunctions = {
    filter (value) {
        return value !== "auto" ? value : $47a6d9fbbf7ee42d$var$filterTemplate;
    },
    backdropFilter (value) {
        return value !== "auto" ? value : $47a6d9fbbf7ee42d$var$backdropFilterTemplate;
    },
    ring (value) {
        return $47a6d9fbbf7ee42d$var$getRingTemplate($47a6d9fbbf7ee42d$var$transformFunctions.px(value));
    },
    bgClip (value) {
        return value === "text" ? {
            color: "transparent",
            backgroundClip: "text"
        } : {
            backgroundClip: value
        };
    },
    transform (value) {
        if (value === "auto") return $47a6d9fbbf7ee42d$var$getTransformTemplate();
        if (value === "auto-gpu") return $47a6d9fbbf7ee42d$var$getTransformGpuTemplate();
        return value;
    },
    vh (value) {
        return value === "$100vh" ? "var(--chakra-vh)" : value;
    },
    px (value) {
        if (value == null) return value;
        const { unitless: unitless } = $47a6d9fbbf7ee42d$var$analyzeCSSValue(value);
        return unitless || typeof value === "number" ? `${value}px` : value;
    },
    fraction (value) {
        return !(typeof value === "number") || value > 1 ? value : `${value * 100}%`;
    },
    float (value, theme) {
        const map = {
            left: "right",
            right: "left"
        };
        return theme.direction === "rtl" ? map[value] : value;
    },
    degree (value) {
        if ($47a6d9fbbf7ee42d$var$isCssVar(value) || value == null) return value;
        const unitless = typeof value === "string" && !value.endsWith("deg");
        return typeof value === "number" || unitless ? `${value}deg` : value;
    },
    gradient: $47a6d9fbbf7ee42d$var$gradientTransform,
    blur: $47a6d9fbbf7ee42d$var$wrap("blur"),
    opacity: $47a6d9fbbf7ee42d$var$wrap("opacity"),
    brightness: $47a6d9fbbf7ee42d$var$wrap("brightness"),
    contrast: $47a6d9fbbf7ee42d$var$wrap("contrast"),
    dropShadow: $47a6d9fbbf7ee42d$var$wrap("drop-shadow"),
    grayscale: $47a6d9fbbf7ee42d$var$wrap("grayscale"),
    hueRotate: $47a6d9fbbf7ee42d$var$wrap("hue-rotate"),
    invert: $47a6d9fbbf7ee42d$var$wrap("invert"),
    saturate: $47a6d9fbbf7ee42d$var$wrap("saturate"),
    sepia: $47a6d9fbbf7ee42d$var$wrap("sepia"),
    bgImage (value) {
        if (value == null) return value;
        const prevent = $47a6d9fbbf7ee42d$var$isCSSFunction(value) || $47a6d9fbbf7ee42d$var$globalSet.has(value);
        return !prevent ? `url(${value})` : value;
    },
    outline (value) {
        const isNoneOrZero = String(value) === "0" || String(value) === "none";
        return value !== null && isNoneOrZero ? {
            outline: "2px solid transparent",
            outlineOffset: "2px"
        } : {
            outline: value
        };
    },
    flexDirection (value) {
        var _a;
        const { space: space2, divide: divide2 } = (_a = $47a6d9fbbf7ee42d$var$flexDirectionTemplate[value]) != null ? _a : {};
        const result = {
            flexDirection: value
        };
        if (space2) result[space2] = 1;
        if (divide2) result[divide2] = 1;
        return result;
    }
};
// src/utils/index.ts
var $47a6d9fbbf7ee42d$var$t = {
    borderWidths: $47a6d9fbbf7ee42d$var$toConfig("borderWidths"),
    borderStyles: $47a6d9fbbf7ee42d$var$toConfig("borderStyles"),
    colors: $47a6d9fbbf7ee42d$var$toConfig("colors"),
    borders: $47a6d9fbbf7ee42d$var$toConfig("borders"),
    gradients: $47a6d9fbbf7ee42d$var$toConfig("gradients", $47a6d9fbbf7ee42d$var$transformFunctions.gradient),
    radii: $47a6d9fbbf7ee42d$var$toConfig("radii", $47a6d9fbbf7ee42d$var$transformFunctions.px),
    space: $47a6d9fbbf7ee42d$var$toConfig("space", $47a6d9fbbf7ee42d$var$pipe($47a6d9fbbf7ee42d$var$transformFunctions.vh, $47a6d9fbbf7ee42d$var$transformFunctions.px)),
    spaceT: $47a6d9fbbf7ee42d$var$toConfig("space", $47a6d9fbbf7ee42d$var$pipe($47a6d9fbbf7ee42d$var$transformFunctions.vh, $47a6d9fbbf7ee42d$var$transformFunctions.px)),
    degreeT (property) {
        return {
            property: property,
            transform: $47a6d9fbbf7ee42d$var$transformFunctions.degree
        };
    },
    prop (property, scale, transform2) {
        return {
            property: property,
            scale: scale,
            ...scale && {
                transform: $47a6d9fbbf7ee42d$var$createTransform({
                    scale: scale,
                    transform: transform2
                })
            }
        };
    },
    propT (property, transform2) {
        return {
            property: property,
            transform: transform2
        };
    },
    sizes: $47a6d9fbbf7ee42d$var$toConfig("sizes", $47a6d9fbbf7ee42d$var$pipe($47a6d9fbbf7ee42d$var$transformFunctions.vh, $47a6d9fbbf7ee42d$var$transformFunctions.px)),
    sizesT: $47a6d9fbbf7ee42d$var$toConfig("sizes", $47a6d9fbbf7ee42d$var$pipe($47a6d9fbbf7ee42d$var$transformFunctions.vh, $47a6d9fbbf7ee42d$var$transformFunctions.fraction)),
    shadows: $47a6d9fbbf7ee42d$var$toConfig("shadows"),
    logical: $47a6d9fbbf7ee42d$var$logical,
    blur: $47a6d9fbbf7ee42d$var$toConfig("blur", $47a6d9fbbf7ee42d$var$transformFunctions.blur)
};
// src/config/background.ts
var $47a6d9fbbf7ee42d$export$8ce1fd94bee2f412 = {
    background: $47a6d9fbbf7ee42d$var$t.colors("background"),
    backgroundColor: $47a6d9fbbf7ee42d$var$t.colors("backgroundColor"),
    backgroundImage: $47a6d9fbbf7ee42d$var$t.gradients("backgroundImage"),
    backgroundSize: true,
    backgroundPosition: true,
    backgroundRepeat: true,
    backgroundAttachment: true,
    backgroundClip: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.bgClip
    },
    bgSize: $47a6d9fbbf7ee42d$var$t.prop("backgroundSize"),
    bgPosition: $47a6d9fbbf7ee42d$var$t.prop("backgroundPosition"),
    bg: $47a6d9fbbf7ee42d$var$t.colors("background"),
    bgColor: $47a6d9fbbf7ee42d$var$t.colors("backgroundColor"),
    bgPos: $47a6d9fbbf7ee42d$var$t.prop("backgroundPosition"),
    bgRepeat: $47a6d9fbbf7ee42d$var$t.prop("backgroundRepeat"),
    bgAttachment: $47a6d9fbbf7ee42d$var$t.prop("backgroundAttachment"),
    bgGradient: $47a6d9fbbf7ee42d$var$t.gradients("backgroundImage"),
    bgClip: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.bgClip
    }
};
Object.assign($47a6d9fbbf7ee42d$export$8ce1fd94bee2f412, {
    bgImage: $47a6d9fbbf7ee42d$export$8ce1fd94bee2f412.backgroundImage,
    bgImg: $47a6d9fbbf7ee42d$export$8ce1fd94bee2f412.backgroundImage
});
// src/config/border.ts
var $47a6d9fbbf7ee42d$export$1edee58a52776cd9 = {
    border: $47a6d9fbbf7ee42d$var$t.borders("border"),
    borderWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderWidth"),
    borderStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderStyle"),
    borderColor: $47a6d9fbbf7ee42d$var$t.colors("borderColor"),
    borderRadius: $47a6d9fbbf7ee42d$var$t.radii("borderRadius"),
    borderTop: $47a6d9fbbf7ee42d$var$t.borders("borderTop"),
    borderBlockStart: $47a6d9fbbf7ee42d$var$t.borders("borderBlockStart"),
    borderTopLeftRadius: $47a6d9fbbf7ee42d$var$t.radii("borderTopLeftRadius"),
    borderStartStartRadius: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderTopLeftRadius",
            rtl: "borderTopRightRadius"
        }
    }),
    borderEndStartRadius: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderBottomLeftRadius",
            rtl: "borderBottomRightRadius"
        }
    }),
    borderTopRightRadius: $47a6d9fbbf7ee42d$var$t.radii("borderTopRightRadius"),
    borderStartEndRadius: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderTopRightRadius",
            rtl: "borderTopLeftRadius"
        }
    }),
    borderEndEndRadius: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderBottomRightRadius",
            rtl: "borderBottomLeftRadius"
        }
    }),
    borderRight: $47a6d9fbbf7ee42d$var$t.borders("borderRight"),
    borderInlineEnd: $47a6d9fbbf7ee42d$var$t.borders("borderInlineEnd"),
    borderBottom: $47a6d9fbbf7ee42d$var$t.borders("borderBottom"),
    borderBlockEnd: $47a6d9fbbf7ee42d$var$t.borders("borderBlockEnd"),
    borderBottomLeftRadius: $47a6d9fbbf7ee42d$var$t.radii("borderBottomLeftRadius"),
    borderBottomRightRadius: $47a6d9fbbf7ee42d$var$t.radii("borderBottomRightRadius"),
    borderLeft: $47a6d9fbbf7ee42d$var$t.borders("borderLeft"),
    borderInlineStart: {
        property: "borderInlineStart",
        scale: "borders"
    },
    borderInlineStartRadius: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ],
            rtl: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ]
        }
    }),
    borderInlineEndRadius: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ],
            rtl: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ]
        }
    }),
    borderX: $47a6d9fbbf7ee42d$var$t.borders([
        "borderLeft",
        "borderRight"
    ]),
    borderInline: $47a6d9fbbf7ee42d$var$t.borders("borderInline"),
    borderY: $47a6d9fbbf7ee42d$var$t.borders([
        "borderTop",
        "borderBottom"
    ]),
    borderBlock: $47a6d9fbbf7ee42d$var$t.borders("borderBlock"),
    borderTopWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderTopWidth"),
    borderBlockStartWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderBlockStartWidth"),
    borderTopColor: $47a6d9fbbf7ee42d$var$t.colors("borderTopColor"),
    borderBlockStartColor: $47a6d9fbbf7ee42d$var$t.colors("borderBlockStartColor"),
    borderTopStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderTopStyle"),
    borderBlockStartStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderBlockStartStyle"),
    borderBottomWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderBottomWidth"),
    borderBlockEndWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderBlockEndWidth"),
    borderBottomColor: $47a6d9fbbf7ee42d$var$t.colors("borderBottomColor"),
    borderBlockEndColor: $47a6d9fbbf7ee42d$var$t.colors("borderBlockEndColor"),
    borderBottomStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderBottomStyle"),
    borderBlockEndStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderBlockEndStyle"),
    borderLeftWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderLeftWidth"),
    borderInlineStartWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderInlineStartWidth"),
    borderLeftColor: $47a6d9fbbf7ee42d$var$t.colors("borderLeftColor"),
    borderInlineStartColor: $47a6d9fbbf7ee42d$var$t.colors("borderInlineStartColor"),
    borderLeftStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderLeftStyle"),
    borderInlineStartStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderInlineStartStyle"),
    borderRightWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderRightWidth"),
    borderInlineEndWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderInlineEndWidth"),
    borderRightColor: $47a6d9fbbf7ee42d$var$t.colors("borderRightColor"),
    borderInlineEndColor: $47a6d9fbbf7ee42d$var$t.colors("borderInlineEndColor"),
    borderRightStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderRightStyle"),
    borderInlineEndStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderInlineEndStyle"),
    borderTopRadius: $47a6d9fbbf7ee42d$var$t.radii([
        "borderTopLeftRadius",
        "borderTopRightRadius"
    ]),
    borderBottomRadius: $47a6d9fbbf7ee42d$var$t.radii([
        "borderBottomLeftRadius",
        "borderBottomRightRadius"
    ]),
    borderLeftRadius: $47a6d9fbbf7ee42d$var$t.radii([
        "borderTopLeftRadius",
        "borderBottomLeftRadius"
    ]),
    borderRightRadius: $47a6d9fbbf7ee42d$var$t.radii([
        "borderTopRightRadius",
        "borderBottomRightRadius"
    ])
};
Object.assign($47a6d9fbbf7ee42d$export$1edee58a52776cd9, {
    rounded: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderRadius,
    roundedTop: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderTopRadius,
    roundedTopLeft: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderTopLeftRadius,
    roundedTopRight: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderTopRightRadius,
    roundedTopStart: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderStartStartRadius,
    roundedTopEnd: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderStartEndRadius,
    roundedBottom: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderBottomRadius,
    roundedBottomLeft: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderBottomLeftRadius,
    roundedBottomRight: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderBottomRightRadius,
    roundedBottomStart: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderEndStartRadius,
    roundedBottomEnd: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderEndEndRadius,
    roundedLeft: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderLeftRadius,
    roundedRight: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderRightRadius,
    roundedStart: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineStartRadius,
    roundedEnd: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineEndRadius,
    borderStart: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineStart,
    borderEnd: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineEnd,
    borderTopStartRadius: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderStartStartRadius,
    borderTopEndRadius: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderStartEndRadius,
    borderBottomStartRadius: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderEndStartRadius,
    borderBottomEndRadius: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderEndEndRadius,
    borderStartRadius: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineStartRadius,
    borderEndRadius: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineEndRadius,
    borderStartWidth: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineStartWidth,
    borderEndWidth: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineEndWidth,
    borderStartColor: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineStartColor,
    borderEndColor: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineEndColor,
    borderStartStyle: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineStartStyle,
    borderEndStyle: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineEndStyle
});
// src/config/color.ts
var $47a6d9fbbf7ee42d$export$35e9368ef982300f = {
    color: $47a6d9fbbf7ee42d$var$t.colors("color"),
    textColor: $47a6d9fbbf7ee42d$var$t.colors("color"),
    fill: $47a6d9fbbf7ee42d$var$t.colors("fill"),
    stroke: $47a6d9fbbf7ee42d$var$t.colors("stroke")
};
// src/config/effect.ts
var $47a6d9fbbf7ee42d$export$dc573d8a6576cdb3 = {
    boxShadow: $47a6d9fbbf7ee42d$var$t.shadows("boxShadow"),
    mixBlendMode: true,
    blendMode: $47a6d9fbbf7ee42d$var$t.prop("mixBlendMode"),
    backgroundBlendMode: true,
    bgBlendMode: $47a6d9fbbf7ee42d$var$t.prop("backgroundBlendMode"),
    opacity: true
};
Object.assign($47a6d9fbbf7ee42d$export$dc573d8a6576cdb3, {
    shadow: $47a6d9fbbf7ee42d$export$dc573d8a6576cdb3.boxShadow
});
// src/config/filter.ts
var $47a6d9fbbf7ee42d$export$3dea766d36a8935f = {
    filter: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.filter
    },
    blur: $47a6d9fbbf7ee42d$var$t.blur("--chakra-blur"),
    brightness: $47a6d9fbbf7ee42d$var$t.propT("--chakra-brightness", $47a6d9fbbf7ee42d$var$transformFunctions.brightness),
    contrast: $47a6d9fbbf7ee42d$var$t.propT("--chakra-contrast", $47a6d9fbbf7ee42d$var$transformFunctions.contrast),
    hueRotate: $47a6d9fbbf7ee42d$var$t.degreeT("--chakra-hue-rotate"),
    invert: $47a6d9fbbf7ee42d$var$t.propT("--chakra-invert", $47a6d9fbbf7ee42d$var$transformFunctions.invert),
    saturate: $47a6d9fbbf7ee42d$var$t.propT("--chakra-saturate", $47a6d9fbbf7ee42d$var$transformFunctions.saturate),
    dropShadow: $47a6d9fbbf7ee42d$var$t.propT("--chakra-drop-shadow", $47a6d9fbbf7ee42d$var$transformFunctions.dropShadow),
    backdropFilter: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.backdropFilter
    },
    backdropBlur: $47a6d9fbbf7ee42d$var$t.blur("--chakra-backdrop-blur"),
    backdropBrightness: $47a6d9fbbf7ee42d$var$t.propT("--chakra-backdrop-brightness", $47a6d9fbbf7ee42d$var$transformFunctions.brightness),
    backdropContrast: $47a6d9fbbf7ee42d$var$t.propT("--chakra-backdrop-contrast", $47a6d9fbbf7ee42d$var$transformFunctions.contrast),
    backdropHueRotate: $47a6d9fbbf7ee42d$var$t.degreeT("--chakra-backdrop-hue-rotate"),
    backdropInvert: $47a6d9fbbf7ee42d$var$t.propT("--chakra-backdrop-invert", $47a6d9fbbf7ee42d$var$transformFunctions.invert),
    backdropSaturate: $47a6d9fbbf7ee42d$var$t.propT("--chakra-backdrop-saturate", $47a6d9fbbf7ee42d$var$transformFunctions.saturate)
};
// src/config/flexbox.ts
var $47a6d9fbbf7ee42d$export$feec61708a55c80e = {
    alignItems: true,
    alignContent: true,
    justifyItems: true,
    justifyContent: true,
    flexWrap: true,
    flexDirection: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.flexDirection
    },
    flex: true,
    flexFlow: true,
    flexGrow: true,
    flexShrink: true,
    flexBasis: $47a6d9fbbf7ee42d$var$t.sizes("flexBasis"),
    justifySelf: true,
    alignSelf: true,
    order: true,
    placeItems: true,
    placeContent: true,
    placeSelf: true,
    gap: $47a6d9fbbf7ee42d$var$t.space("gap"),
    rowGap: $47a6d9fbbf7ee42d$var$t.space("rowGap"),
    columnGap: $47a6d9fbbf7ee42d$var$t.space("columnGap")
};
Object.assign($47a6d9fbbf7ee42d$export$feec61708a55c80e, {
    flexDir: $47a6d9fbbf7ee42d$export$feec61708a55c80e.flexDirection
});
// src/config/grid.ts
var $47a6d9fbbf7ee42d$export$85fc379452d91af0 = {
    gridGap: $47a6d9fbbf7ee42d$var$t.space("gridGap"),
    gridColumnGap: $47a6d9fbbf7ee42d$var$t.space("gridColumnGap"),
    gridRowGap: $47a6d9fbbf7ee42d$var$t.space("gridRowGap"),
    gridColumn: true,
    gridRow: true,
    gridAutoFlow: true,
    gridAutoColumns: true,
    gridColumnStart: true,
    gridColumnEnd: true,
    gridRowStart: true,
    gridRowEnd: true,
    gridAutoRows: true,
    gridTemplate: true,
    gridTemplateColumns: true,
    gridTemplateRows: true,
    gridTemplateAreas: true,
    gridArea: true
};
// src/config/interactivity.ts
var $47a6d9fbbf7ee42d$export$2499a341a8256d68 = {
    appearance: true,
    cursor: true,
    resize: true,
    userSelect: true,
    pointerEvents: true,
    outline: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.outline
    },
    outlineOffset: true,
    outlineColor: $47a6d9fbbf7ee42d$var$t.colors("outlineColor")
};
// src/config/layout.ts
var $47a6d9fbbf7ee42d$export$b3219800bda33a1f = {
    width: $47a6d9fbbf7ee42d$var$t.sizesT("width"),
    inlineSize: $47a6d9fbbf7ee42d$var$t.sizesT("inlineSize"),
    height: $47a6d9fbbf7ee42d$var$t.sizes("height"),
    blockSize: $47a6d9fbbf7ee42d$var$t.sizes("blockSize"),
    boxSize: $47a6d9fbbf7ee42d$var$t.sizes([
        "width",
        "height"
    ]),
    minWidth: $47a6d9fbbf7ee42d$var$t.sizes("minWidth"),
    minInlineSize: $47a6d9fbbf7ee42d$var$t.sizes("minInlineSize"),
    minHeight: $47a6d9fbbf7ee42d$var$t.sizes("minHeight"),
    minBlockSize: $47a6d9fbbf7ee42d$var$t.sizes("minBlockSize"),
    maxWidth: $47a6d9fbbf7ee42d$var$t.sizes("maxWidth"),
    maxInlineSize: $47a6d9fbbf7ee42d$var$t.sizes("maxInlineSize"),
    maxHeight: $47a6d9fbbf7ee42d$var$t.sizes("maxHeight"),
    maxBlockSize: $47a6d9fbbf7ee42d$var$t.sizes("maxBlockSize"),
    overflow: true,
    overflowX: true,
    overflowY: true,
    overscrollBehavior: true,
    overscrollBehaviorX: true,
    overscrollBehaviorY: true,
    display: true,
    aspectRatio: true,
    hideFrom: {
        scale: "breakpoints",
        transform: (value, theme)=>{
            var _a, _b, _c;
            const breakpoint = (_c = (_b = (_a = theme.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b.minW) != null ? _c : value;
            const mq = `@media screen and (min-width: ${breakpoint})`;
            return {
                [mq]: {
                    display: "none"
                }
            };
        }
    },
    hideBelow: {
        scale: "breakpoints",
        transform: (value, theme)=>{
            var _a, _b, _c;
            const breakpoint = (_c = (_b = (_a = theme.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b._minW) != null ? _c : value;
            const mq = `@media screen and (max-width: ${breakpoint})`;
            return {
                [mq]: {
                    display: "none"
                }
            };
        }
    },
    verticalAlign: true,
    boxSizing: true,
    boxDecorationBreak: true,
    float: $47a6d9fbbf7ee42d$var$t.propT("float", $47a6d9fbbf7ee42d$var$transformFunctions.float),
    objectFit: true,
    objectPosition: true,
    visibility: true,
    isolation: true
};
Object.assign($47a6d9fbbf7ee42d$export$b3219800bda33a1f, {
    w: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.width,
    h: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.height,
    minW: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.minWidth,
    maxW: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.maxWidth,
    minH: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.minHeight,
    maxH: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.maxHeight,
    overscroll: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.overscrollBehavior,
    overscrollX: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.overscrollBehaviorX,
    overscrollY: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.overscrollBehaviorY
});
// src/config/list.ts
var $47a6d9fbbf7ee42d$export$8837f4fc672e936d = {
    listStyleType: true,
    listStylePosition: true,
    listStylePos: $47a6d9fbbf7ee42d$var$t.prop("listStylePosition"),
    listStyleImage: true,
    listStyleImg: $47a6d9fbbf7ee42d$var$t.prop("listStyleImage")
};
// src/get.ts
function $47a6d9fbbf7ee42d$var$get(obj, path, fallback, index) {
    const key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === void 0 ? fallback : obj;
}
var $47a6d9fbbf7ee42d$var$memoize = (fn)=>{
    const cache = /* @__PURE__ */ new WeakMap();
    const memoizedFn = (obj, path, fallback, index)=>{
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, /* @__PURE__ */ new Map());
        const map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        const value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
var $47a6d9fbbf7ee42d$var$memoizedGet = $47a6d9fbbf7ee42d$var$memoize($47a6d9fbbf7ee42d$var$get);
// src/config/others.ts
var $47a6d9fbbf7ee42d$var$srOnly = {
    border: "0px",
    clip: "rect(0, 0, 0, 0)",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
};
var $47a6d9fbbf7ee42d$var$srFocusable = {
    position: "static",
    width: "auto",
    height: "auto",
    clip: "auto",
    padding: "0",
    margin: "0",
    overflow: "visible",
    whiteSpace: "normal"
};
var $47a6d9fbbf7ee42d$var$getWithPriority = (theme, key, styles)=>{
    const result = {};
    const obj = $47a6d9fbbf7ee42d$var$memoizedGet(theme, key, {});
    for(const prop in obj){
        const isInStyles = prop in styles && styles[prop] != null;
        if (!isInStyles) result[prop] = obj[prop];
    }
    return result;
};
var $47a6d9fbbf7ee42d$export$36263e8f8d7ce3b1 = {
    srOnly: {
        transform (value) {
            if (value === true) return $47a6d9fbbf7ee42d$var$srOnly;
            if (value === "focusable") return $47a6d9fbbf7ee42d$var$srFocusable;
            return {};
        }
    },
    layerStyle: {
        processResult: true,
        transform: (value, theme, styles)=>$47a6d9fbbf7ee42d$var$getWithPriority(theme, `layerStyles.${value}`, styles)
    },
    textStyle: {
        processResult: true,
        transform: (value, theme, styles)=>$47a6d9fbbf7ee42d$var$getWithPriority(theme, `textStyles.${value}`, styles)
    },
    apply: {
        processResult: true,
        transform: (value, theme, styles)=>$47a6d9fbbf7ee42d$var$getWithPriority(theme, value, styles)
    }
};
// src/config/position.ts
var $47a6d9fbbf7ee42d$export$5880b8b5730aff45 = {
    position: true,
    pos: $47a6d9fbbf7ee42d$var$t.prop("position"),
    zIndex: $47a6d9fbbf7ee42d$var$t.prop("zIndex", "zIndices"),
    inset: $47a6d9fbbf7ee42d$var$t.spaceT("inset"),
    insetX: $47a6d9fbbf7ee42d$var$t.spaceT([
        "left",
        "right"
    ]),
    insetInline: $47a6d9fbbf7ee42d$var$t.spaceT("insetInline"),
    insetY: $47a6d9fbbf7ee42d$var$t.spaceT([
        "top",
        "bottom"
    ]),
    insetBlock: $47a6d9fbbf7ee42d$var$t.spaceT("insetBlock"),
    top: $47a6d9fbbf7ee42d$var$t.spaceT("top"),
    insetBlockStart: $47a6d9fbbf7ee42d$var$t.spaceT("insetBlockStart"),
    bottom: $47a6d9fbbf7ee42d$var$t.spaceT("bottom"),
    insetBlockEnd: $47a6d9fbbf7ee42d$var$t.spaceT("insetBlockEnd"),
    left: $47a6d9fbbf7ee42d$var$t.spaceT("left"),
    insetInlineStart: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "space",
        property: {
            ltr: "left",
            rtl: "right"
        }
    }),
    right: $47a6d9fbbf7ee42d$var$t.spaceT("right"),
    insetInlineEnd: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "space",
        property: {
            ltr: "right",
            rtl: "left"
        }
    })
};
Object.assign($47a6d9fbbf7ee42d$export$5880b8b5730aff45, {
    insetStart: $47a6d9fbbf7ee42d$export$5880b8b5730aff45.insetInlineStart,
    insetEnd: $47a6d9fbbf7ee42d$export$5880b8b5730aff45.insetInlineEnd
});
// src/config/ring.ts
var $47a6d9fbbf7ee42d$export$e7d0da6968da5dd = {
    ring: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.ring
    },
    ringColor: $47a6d9fbbf7ee42d$var$t.colors("--chakra-ring-color"),
    ringOffset: $47a6d9fbbf7ee42d$var$t.prop("--chakra-ring-offset-width"),
    ringOffsetColor: $47a6d9fbbf7ee42d$var$t.colors("--chakra-ring-offset-color"),
    ringInset: $47a6d9fbbf7ee42d$var$t.prop("--chakra-ring-inset")
};
// src/config/space.ts
var $47a6d9fbbf7ee42d$export$a941ed4b947d12f8 = {
    margin: $47a6d9fbbf7ee42d$var$t.spaceT("margin"),
    marginTop: $47a6d9fbbf7ee42d$var$t.spaceT("marginTop"),
    marginBlockStart: $47a6d9fbbf7ee42d$var$t.spaceT("marginBlockStart"),
    marginRight: $47a6d9fbbf7ee42d$var$t.spaceT("marginRight"),
    marginInlineEnd: $47a6d9fbbf7ee42d$var$t.spaceT("marginInlineEnd"),
    marginBottom: $47a6d9fbbf7ee42d$var$t.spaceT("marginBottom"),
    marginBlockEnd: $47a6d9fbbf7ee42d$var$t.spaceT("marginBlockEnd"),
    marginLeft: $47a6d9fbbf7ee42d$var$t.spaceT("marginLeft"),
    marginInlineStart: $47a6d9fbbf7ee42d$var$t.spaceT("marginInlineStart"),
    marginX: $47a6d9fbbf7ee42d$var$t.spaceT([
        "marginInlineStart",
        "marginInlineEnd"
    ]),
    marginInline: $47a6d9fbbf7ee42d$var$t.spaceT("marginInline"),
    marginY: $47a6d9fbbf7ee42d$var$t.spaceT([
        "marginTop",
        "marginBottom"
    ]),
    marginBlock: $47a6d9fbbf7ee42d$var$t.spaceT("marginBlock"),
    padding: $47a6d9fbbf7ee42d$var$t.space("padding"),
    paddingTop: $47a6d9fbbf7ee42d$var$t.space("paddingTop"),
    paddingBlockStart: $47a6d9fbbf7ee42d$var$t.space("paddingBlockStart"),
    paddingRight: $47a6d9fbbf7ee42d$var$t.space("paddingRight"),
    paddingBottom: $47a6d9fbbf7ee42d$var$t.space("paddingBottom"),
    paddingBlockEnd: $47a6d9fbbf7ee42d$var$t.space("paddingBlockEnd"),
    paddingLeft: $47a6d9fbbf7ee42d$var$t.space("paddingLeft"),
    paddingInlineStart: $47a6d9fbbf7ee42d$var$t.space("paddingInlineStart"),
    paddingInlineEnd: $47a6d9fbbf7ee42d$var$t.space("paddingInlineEnd"),
    paddingX: $47a6d9fbbf7ee42d$var$t.space([
        "paddingInlineStart",
        "paddingInlineEnd"
    ]),
    paddingInline: $47a6d9fbbf7ee42d$var$t.space("paddingInline"),
    paddingY: $47a6d9fbbf7ee42d$var$t.space([
        "paddingTop",
        "paddingBottom"
    ]),
    paddingBlock: $47a6d9fbbf7ee42d$var$t.space("paddingBlock")
};
Object.assign($47a6d9fbbf7ee42d$export$a941ed4b947d12f8, {
    m: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.margin,
    mt: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginTop,
    mr: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginRight,
    me: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginInlineEnd,
    marginEnd: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginInlineEnd,
    mb: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginBottom,
    ml: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginLeft,
    ms: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginInlineStart,
    marginStart: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginInlineStart,
    mx: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginX,
    my: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginY,
    p: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.padding,
    pt: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingTop,
    py: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingY,
    px: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingX,
    pb: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingBottom,
    pl: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingLeft,
    ps: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingInlineStart,
    paddingStart: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingInlineStart,
    pr: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingRight,
    pe: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingInlineEnd,
    paddingEnd: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingInlineEnd
});
// src/config/text-decoration.ts
var $47a6d9fbbf7ee42d$export$6b7f9af9aa033040 = {
    textDecorationColor: $47a6d9fbbf7ee42d$var$t.colors("textDecorationColor"),
    textDecoration: true,
    textDecor: {
        property: "textDecoration"
    },
    textDecorationLine: true,
    textDecorationStyle: true,
    textDecorationThickness: true,
    textUnderlineOffset: true,
    textShadow: $47a6d9fbbf7ee42d$var$t.shadows("textShadow")
};
// src/config/transform.ts
var $47a6d9fbbf7ee42d$export$51186ad6e864892a = {
    clipPath: true,
    transform: $47a6d9fbbf7ee42d$var$t.propT("transform", $47a6d9fbbf7ee42d$var$transformFunctions.transform),
    transformOrigin: true,
    translateX: $47a6d9fbbf7ee42d$var$t.spaceT("--chakra-translate-x"),
    translateY: $47a6d9fbbf7ee42d$var$t.spaceT("--chakra-translate-y"),
    skewX: $47a6d9fbbf7ee42d$var$t.degreeT("--chakra-skew-x"),
    skewY: $47a6d9fbbf7ee42d$var$t.degreeT("--chakra-skew-y"),
    scaleX: $47a6d9fbbf7ee42d$var$t.prop("--chakra-scale-x"),
    scaleY: $47a6d9fbbf7ee42d$var$t.prop("--chakra-scale-y"),
    scale: $47a6d9fbbf7ee42d$var$t.prop([
        "--chakra-scale-x",
        "--chakra-scale-y"
    ]),
    rotate: $47a6d9fbbf7ee42d$var$t.degreeT("--chakra-rotate")
};
// src/config/transition.ts
var $47a6d9fbbf7ee42d$export$66bb15e2994e6a26 = {
    transition: true,
    transitionDelay: true,
    animation: true,
    willChange: true,
    transitionDuration: $47a6d9fbbf7ee42d$var$t.prop("transitionDuration", "transition.duration"),
    transitionProperty: $47a6d9fbbf7ee42d$var$t.prop("transitionProperty", "transition.property"),
    transitionTimingFunction: $47a6d9fbbf7ee42d$var$t.prop("transitionTimingFunction", "transition.easing")
};
// src/config/typography.ts
var $47a6d9fbbf7ee42d$export$d846a084e680d8e = {
    fontFamily: $47a6d9fbbf7ee42d$var$t.prop("fontFamily", "fonts"),
    fontSize: $47a6d9fbbf7ee42d$var$t.prop("fontSize", "fontSizes", $47a6d9fbbf7ee42d$var$transformFunctions.px),
    fontWeight: $47a6d9fbbf7ee42d$var$t.prop("fontWeight", "fontWeights"),
    lineHeight: $47a6d9fbbf7ee42d$var$t.prop("lineHeight", "lineHeights"),
    letterSpacing: $47a6d9fbbf7ee42d$var$t.prop("letterSpacing", "letterSpacings"),
    textAlign: true,
    fontStyle: true,
    textIndent: true,
    wordBreak: true,
    overflowWrap: true,
    textOverflow: true,
    textTransform: true,
    whiteSpace: true,
    isTruncated: {
        transform (value) {
            if (value === true) return {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
            };
        }
    },
    noOfLines: {
        static: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: "var(--chakra-line-clamp)"
        },
        property: "--chakra-line-clamp"
    }
};
// src/config/scroll.ts
var $47a6d9fbbf7ee42d$export$209876d7b1ac8f3 = {
    scrollBehavior: true,
    scrollSnapAlign: true,
    scrollSnapStop: true,
    scrollSnapType: true,
    scrollMargin: $47a6d9fbbf7ee42d$var$t.spaceT("scrollMargin"),
    scrollMarginTop: $47a6d9fbbf7ee42d$var$t.spaceT("scrollMarginTop"),
    scrollMarginBottom: $47a6d9fbbf7ee42d$var$t.spaceT("scrollMarginBottom"),
    scrollMarginLeft: $47a6d9fbbf7ee42d$var$t.spaceT("scrollMarginLeft"),
    scrollMarginRight: $47a6d9fbbf7ee42d$var$t.spaceT("scrollMarginRight"),
    scrollMarginX: $47a6d9fbbf7ee42d$var$t.spaceT([
        "scrollMarginLeft",
        "scrollMarginRight"
    ]),
    scrollMarginY: $47a6d9fbbf7ee42d$var$t.spaceT([
        "scrollMarginTop",
        "scrollMarginBottom"
    ]),
    scrollPadding: $47a6d9fbbf7ee42d$var$t.spaceT("scrollPadding"),
    scrollPaddingTop: $47a6d9fbbf7ee42d$var$t.spaceT("scrollPaddingTop"),
    scrollPaddingBottom: $47a6d9fbbf7ee42d$var$t.spaceT("scrollPaddingBottom"),
    scrollPaddingLeft: $47a6d9fbbf7ee42d$var$t.spaceT("scrollPaddingLeft"),
    scrollPaddingRight: $47a6d9fbbf7ee42d$var$t.spaceT("scrollPaddingRight"),
    scrollPaddingX: $47a6d9fbbf7ee42d$var$t.spaceT([
        "scrollPaddingLeft",
        "scrollPaddingRight"
    ]),
    scrollPaddingY: $47a6d9fbbf7ee42d$var$t.spaceT([
        "scrollPaddingTop",
        "scrollPaddingBottom"
    ])
};
function $47a6d9fbbf7ee42d$var$resolveReference(operand) {
    if ((0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
var $47a6d9fbbf7ee42d$var$toExpression = (operator, ...operands)=>operands.map($47a6d9fbbf7ee42d$var$resolveReference).join(` ${operator} `).replace(/calc/g, "");
var $47a6d9fbbf7ee42d$var$add = (...operands)=>`calc(${$47a6d9fbbf7ee42d$var$toExpression("+", ...operands)})`;
var $47a6d9fbbf7ee42d$var$subtract = (...operands)=>`calc(${$47a6d9fbbf7ee42d$var$toExpression("-", ...operands)})`;
var $47a6d9fbbf7ee42d$var$multiply = (...operands)=>`calc(${$47a6d9fbbf7ee42d$var$toExpression("*", ...operands)})`;
var $47a6d9fbbf7ee42d$var$divide = (...operands)=>`calc(${$47a6d9fbbf7ee42d$var$toExpression("/", ...operands)})`;
var $47a6d9fbbf7ee42d$var$negate = (x)=>{
    const value = $47a6d9fbbf7ee42d$var$resolveReference(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    return $47a6d9fbbf7ee42d$var$multiply(value, -1);
};
var $47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a = Object.assign((x)=>({
        add: (...operands)=>$47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a($47a6d9fbbf7ee42d$var$add(x, ...operands)),
        subtract: (...operands)=>$47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a($47a6d9fbbf7ee42d$var$subtract(x, ...operands)),
        multiply: (...operands)=>$47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a($47a6d9fbbf7ee42d$var$multiply(x, ...operands)),
        divide: (...operands)=>$47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a($47a6d9fbbf7ee42d$var$divide(x, ...operands)),
        negate: ()=>$47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a($47a6d9fbbf7ee42d$var$negate(x)),
        toString: ()=>x.toString()
    }), {
    add: $47a6d9fbbf7ee42d$var$add,
    subtract: $47a6d9fbbf7ee42d$var$subtract,
    multiply: $47a6d9fbbf7ee42d$var$multiply,
    divide: $47a6d9fbbf7ee42d$var$divide,
    negate: $47a6d9fbbf7ee42d$var$negate
});
// src/create-theme-vars/css-var.ts
function $47a6d9fbbf7ee42d$var$replaceWhiteSpace(value, replaceValue = "-") {
    return value.replace(/\s+/g, replaceValue);
}
function $47a6d9fbbf7ee42d$var$escape(value) {
    const valueStr = $47a6d9fbbf7ee42d$var$replaceWhiteSpace(value.toString());
    return $47a6d9fbbf7ee42d$var$escapeSymbol($47a6d9fbbf7ee42d$var$escapeDot(valueStr));
}
function $47a6d9fbbf7ee42d$var$escapeDot(value) {
    if (value.includes("\\.")) return value;
    const isDecimal = !Number.isInteger(parseFloat(value.toString()));
    return isDecimal ? value.replace(".", `\\.`) : value;
}
function $47a6d9fbbf7ee42d$var$escapeSymbol(value) {
    return value.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
}
function $47a6d9fbbf7ee42d$export$9748efee331ec573(value, prefix = "") {
    return [
        prefix,
        value
    ].filter(Boolean).join("-");
}
function $47a6d9fbbf7ee42d$export$bb435e137b4b8e38(name, fallback) {
    return `var(${name}${fallback ? `, ${fallback}` : ""})`;
}
function $47a6d9fbbf7ee42d$export$3695bd65cc73dae9(value, prefix = "") {
    return $47a6d9fbbf7ee42d$var$escape(`--${$47a6d9fbbf7ee42d$export$9748efee331ec573(value, prefix)}`);
}
function $47a6d9fbbf7ee42d$export$8b4981022bd80a4e(name, fallback, cssVarPrefix) {
    const cssVariable = $47a6d9fbbf7ee42d$export$3695bd65cc73dae9(name, cssVarPrefix);
    return {
        variable: cssVariable,
        reference: $47a6d9fbbf7ee42d$export$bb435e137b4b8e38(cssVariable, fallback)
    };
}
function $47a6d9fbbf7ee42d$export$bd40561c6c056841(scope, keys2) {
    const vars = {};
    for (const key of keys2){
        if (Array.isArray(key)) {
            const [name, fallback] = key;
            vars[name] = $47a6d9fbbf7ee42d$export$8b4981022bd80a4e(`${scope}-${name}`, fallback);
            continue;
        }
        vars[key] = $47a6d9fbbf7ee42d$export$8b4981022bd80a4e(`${scope}-${key}`);
    }
    return vars;
}
function $47a6d9fbbf7ee42d$var$getLastItem(array) {
    const length = array == null ? 0 : array.length;
    return length ? array[length - 1] : void 0;
}
function $47a6d9fbbf7ee42d$var$analyzeCSSValue2(value) {
    const num = parseFloat(value.toString());
    const unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
}
function $47a6d9fbbf7ee42d$var$px(value) {
    if (value == null) return value;
    const { unitless: unitless } = $47a6d9fbbf7ee42d$var$analyzeCSSValue2(value);
    return unitless || typeof value === "number" ? `${value}px` : value;
}
var $47a6d9fbbf7ee42d$var$sortByBreakpointValue = (a, b)=>parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
var $47a6d9fbbf7ee42d$var$sortBps = (breakpoints)=>Object.fromEntries(Object.entries(breakpoints).sort($47a6d9fbbf7ee42d$var$sortByBreakpointValue));
function $47a6d9fbbf7ee42d$var$normalize(breakpoints) {
    const sorted = $47a6d9fbbf7ee42d$var$sortBps(breakpoints);
    return Object.assign(Object.values(sorted), sorted);
}
function $47a6d9fbbf7ee42d$var$keys(breakpoints) {
    const value = Object.keys($47a6d9fbbf7ee42d$var$sortBps(breakpoints));
    return new Set(value);
}
function $47a6d9fbbf7ee42d$var$subtract2(value) {
    var _a;
    if (!value) return value;
    value = (_a = $47a6d9fbbf7ee42d$var$px(value)) != null ? _a : value;
    const OFFSET = -0.02;
    return typeof value === "number" ? `${value + OFFSET}` : value.replace(/(\d+\.?\d*)/u, (m)=>`${parseFloat(m) + OFFSET}`);
}
function $47a6d9fbbf7ee42d$var$toMediaQueryString(min, max) {
    const query = [
        "@media screen"
    ];
    if (min) query.push("and", `(min-width: ${$47a6d9fbbf7ee42d$var$px(min)})`);
    if (max) query.push("and", `(max-width: ${$47a6d9fbbf7ee42d$var$px(max)})`);
    return query.join(" ");
}
function $47a6d9fbbf7ee42d$var$analyzeBreakpoints(breakpoints) {
    var _a;
    if (!breakpoints) return null;
    breakpoints.base = (_a = breakpoints.base) != null ? _a : "0px";
    const normalized = $47a6d9fbbf7ee42d$var$normalize(breakpoints);
    const queries = Object.entries(breakpoints).sort($47a6d9fbbf7ee42d$var$sortByBreakpointValue).map(([breakpoint, minW], index, entry)=>{
        var _a2;
        let [, maxW] = (_a2 = entry[index + 1]) != null ? _a2 : [];
        maxW = parseFloat(maxW) > 0 ? $47a6d9fbbf7ee42d$var$subtract2(maxW) : void 0;
        return {
            _minW: $47a6d9fbbf7ee42d$var$subtract2(minW),
            breakpoint: breakpoint,
            minW: minW,
            maxW: maxW,
            maxWQuery: $47a6d9fbbf7ee42d$var$toMediaQueryString(null, maxW),
            minWQuery: $47a6d9fbbf7ee42d$var$toMediaQueryString(minW),
            minMaxQuery: $47a6d9fbbf7ee42d$var$toMediaQueryString(minW, maxW)
        };
    });
    const _keys = $47a6d9fbbf7ee42d$var$keys(breakpoints);
    const _keysArr = Array.from(_keys.values());
    return {
        keys: _keys,
        normalized: normalized,
        isResponsive (test) {
            const keys2 = Object.keys(test);
            return keys2.length > 0 && keys2.every((key)=>_keys.has(key));
        },
        asObject: $47a6d9fbbf7ee42d$var$sortBps(breakpoints),
        asArray: $47a6d9fbbf7ee42d$var$normalize(breakpoints),
        details: queries,
        get (key) {
            return queries.find((q)=>q.breakpoint === key);
        },
        media: [
            null,
            ...normalized.map((minW)=>$47a6d9fbbf7ee42d$var$toMediaQueryString(minW)).slice(1)
        ],
        toArrayValue (test) {
            if (!(0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(test)) throw new Error("toArrayValue: value must be an object");
            const result = _keysArr.map((bp)=>{
                var _a2;
                return (_a2 = test[bp]) != null ? _a2 : null;
            });
            while($47a6d9fbbf7ee42d$var$getLastItem(result) === null)result.pop();
            return result;
        },
        toObjectValue (test) {
            if (!Array.isArray(test)) throw new Error("toObjectValue: value must be an array");
            return test.reduce((acc, value, index)=>{
                const key = _keysArr[index];
                if (key != null && value != null) acc[key] = value;
                return acc;
            }, {});
        }
    };
}
// src/pseudos.ts
var $47a6d9fbbf7ee42d$var$state = {
    hover: (str, post)=>`${str}:hover ${post}, ${str}[data-hover] ${post}`,
    focus: (str, post)=>`${str}:focus ${post}, ${str}[data-focus] ${post}`,
    focusVisible: (str, post)=>`${str}:focus-visible ${post}`,
    focusWithin: (str, post)=>`${str}:focus-within ${post}`,
    active: (str, post)=>`${str}:active ${post}, ${str}[data-active] ${post}`,
    disabled: (str, post)=>`${str}:disabled ${post}, ${str}[data-disabled] ${post}`,
    invalid: (str, post)=>`${str}:invalid ${post}, ${str}[data-invalid] ${post}`,
    checked: (str, post)=>`${str}:checked ${post}, ${str}[data-checked] ${post}`,
    indeterminate: (str, post)=>`${str}:indeterminate ${post}, ${str}[aria-checked=mixed] ${post}, ${str}[data-indeterminate] ${post}`,
    readOnly: (str, post)=>`${str}:read-only ${post}, ${str}[readonly] ${post}, ${str}[data-read-only] ${post}`,
    expanded: (str, post)=>`${str}:read-only ${post}, ${str}[aria-expanded=true] ${post}, ${str}[data-expanded] ${post}`,
    placeholderShown: (str, post)=>`${str}:placeholder-shown ${post}`
};
var $47a6d9fbbf7ee42d$var$toGroup = (fn)=>$47a6d9fbbf7ee42d$var$merge((v)=>fn(v, "&"), "[role=group]", "[data-group]", ".group");
var $47a6d9fbbf7ee42d$var$toPeer = (fn)=>$47a6d9fbbf7ee42d$var$merge((v)=>fn(v, "~ &"), "[data-peer]", ".peer");
var $47a6d9fbbf7ee42d$var$merge = (fn, ...selectors)=>selectors.map(fn).join(", ");
var $47a6d9fbbf7ee42d$export$a36cf593fde2a546 = {
    _hover: "&:hover, &[data-hover]",
    _active: "&:active, &[data-active]",
    _focus: "&:focus, &[data-focus]",
    _highlighted: "&[data-highlighted]",
    _focusWithin: "&:focus-within",
    _focusVisible: "&:focus-visible, &[data-focus-visible]",
    _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
    _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
    _before: "&::before",
    _after: "&::after",
    _empty: "&:empty",
    _expanded: "&[aria-expanded=true], &[data-expanded]",
    _checked: "&[aria-checked=true], &[data-checked]",
    _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
    _pressed: "&[aria-pressed=true], &[data-pressed]",
    _invalid: "&[aria-invalid=true], &[data-invalid]",
    _valid: "&[data-valid], &[data-state=valid]",
    _loading: "&[data-loading], &[aria-busy=true]",
    _selected: "&[aria-selected=true], &[data-selected]",
    _hidden: "&[hidden], &[data-hidden]",
    _autofill: "&:-webkit-autofill",
    _even: "&:nth-of-type(even)",
    _odd: "&:nth-of-type(odd)",
    _first: "&:first-of-type",
    _firstLetter: "&::first-letter",
    _last: "&:last-of-type",
    _notFirst: "&:not(:first-of-type)",
    _notLast: "&:not(:last-of-type)",
    _visited: "&:visited",
    _activeLink: "&[aria-current=page]",
    _activeStep: "&[aria-current=step]",
    _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
    _groupHover: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.hover),
    _peerHover: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.hover),
    _groupFocus: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.focus),
    _peerFocus: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.focus),
    _groupFocusVisible: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.focusVisible),
    _peerFocusVisible: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.focusVisible),
    _groupActive: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.active),
    _peerActive: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.active),
    _groupDisabled: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.disabled),
    _peerDisabled: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.disabled),
    _groupInvalid: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.invalid),
    _peerInvalid: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.invalid),
    _groupChecked: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.checked),
    _peerChecked: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.checked),
    _groupFocusWithin: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.focusWithin),
    _peerFocusWithin: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.focusWithin),
    _peerPlaceholderShown: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.placeholderShown),
    _placeholder: "&::placeholder",
    _placeholderShown: "&:placeholder-shown",
    _fullScreen: "&:fullscreen",
    _selection: "&::selection",
    _rtl: "[dir=rtl] &, &[dir=rtl]",
    _ltr: "[dir=ltr] &, &[dir=ltr]",
    _mediaDark: "@media (prefers-color-scheme: dark)",
    _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
    _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
    _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
    _horizontal: "&[data-orientation=horizontal]",
    _vertical: "&[data-orientation=vertical]"
};
var $47a6d9fbbf7ee42d$export$4ec9644154df43c2 = Object.keys($47a6d9fbbf7ee42d$export$a36cf593fde2a546);
function $47a6d9fbbf7ee42d$var$tokenToCssVar(token, prefix) {
    return $47a6d9fbbf7ee42d$export$8b4981022bd80a4e(String(token).replace(/\./g, "-"), void 0, prefix);
}
function $47a6d9fbbf7ee42d$var$createThemeVars(flatTokens, options) {
    let cssVars = {};
    const cssMap = {};
    for (const [token, tokenValue] of Object.entries(flatTokens)){
        const { isSemantic: isSemantic, value: value } = tokenValue;
        const { variable: variable, reference: reference } = $47a6d9fbbf7ee42d$var$tokenToCssVar(token, options == null ? void 0 : options.cssVarPrefix);
        if (!isSemantic) {
            if (token.startsWith("space")) {
                const keys2 = token.split(".");
                const [firstKey, ...referenceKeys] = keys2;
                const negativeLookupKey = `${firstKey}.-${referenceKeys.join(".")}`;
                const negativeValue = $47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a.negate(value);
                const negatedReference = $47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a.negate(reference);
                cssMap[negativeLookupKey] = {
                    value: negativeValue,
                    var: variable,
                    varRef: negatedReference
                };
            }
            cssVars[variable] = value;
            cssMap[token] = {
                value: value,
                var: variable,
                varRef: reference
            };
            continue;
        }
        const lookupToken = (maybeToken)=>{
            const scale = String(token).split(".")[0];
            const withScale = [
                scale,
                maybeToken
            ].join(".");
            const resolvedTokenValue = flatTokens[withScale];
            if (!resolvedTokenValue) return maybeToken;
            const { reference: reference2 } = $47a6d9fbbf7ee42d$var$tokenToCssVar(withScale, options == null ? void 0 : options.cssVarPrefix);
            return reference2;
        };
        const normalizedValue = (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(value) ? value : {
            default: value
        };
        cssVars = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))(cssVars, Object.entries(normalizedValue).reduce((acc, [conditionAlias, conditionValue])=>{
            var _a, _b;
            if (!conditionValue) return acc;
            const tokenReference = lookupToken(`${conditionValue}`);
            if (conditionAlias === "default") {
                acc[variable] = tokenReference;
                return acc;
            }
            const conditionSelector = (_b = (_a = $47a6d9fbbf7ee42d$export$a36cf593fde2a546) == null ? void 0 : _a[conditionAlias]) != null ? _b : conditionAlias;
            acc[conditionSelector] = {
                [variable]: tokenReference
            };
            return acc;
        }, {}));
        cssMap[token] = {
            value: reference,
            var: variable,
            varRef: reference
        };
    }
    return {
        cssVars: cssVars,
        cssMap: cssMap
    };
}
// ../../utilities/object-utils/src/omit.ts
function $47a6d9fbbf7ee42d$var$omit(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit)if (key in clone) delete clone[key];
    return clone;
}
// ../../utilities/object-utils/src/pick.ts
function $47a6d9fbbf7ee42d$var$pick(object, keysToPick) {
    const result = {};
    for (const key of keysToPick)if (key in object) result[key] = object[key];
    return result;
}
// ../../utilities/object-utils/src/walk-object.ts
function $47a6d9fbbf7ee42d$var$isObject5(value) {
    return typeof value === "object" && value != null && !Array.isArray(value);
}
function $47a6d9fbbf7ee42d$var$walkObject(target, predicate, options = {}) {
    const { stop: stop, getKey: getKey } = options;
    function inner(value, path = []) {
        var _a;
        if ($47a6d9fbbf7ee42d$var$isObject5(value) || Array.isArray(value)) {
            const result = {};
            for (const [prop, child] of Object.entries(value)){
                const key = (_a = getKey == null ? void 0 : getKey(prop)) != null ? _a : prop;
                const childPath = [
                    ...path,
                    key
                ];
                if (stop == null ? void 0 : stop(value, childPath)) return predicate(value, path);
                result[key] = inner(child, childPath);
            }
            return result;
        }
        return predicate(value, path);
    }
    return inner(target);
}
// src/create-theme-vars/theme-tokens.ts
var $47a6d9fbbf7ee42d$var$tokens = [
    "colors",
    "borders",
    "borderWidths",
    "borderStyles",
    "fonts",
    "fontSizes",
    "fontWeights",
    "gradients",
    "letterSpacings",
    "lineHeights",
    "radii",
    "space",
    "shadows",
    "sizes",
    "zIndices",
    "transition",
    "blur",
    "breakpoints"
];
function $47a6d9fbbf7ee42d$var$extractTokens(theme) {
    const _tokens = $47a6d9fbbf7ee42d$var$tokens;
    return $47a6d9fbbf7ee42d$var$pick(theme, _tokens);
}
function $47a6d9fbbf7ee42d$var$extractSemanticTokens(theme) {
    return theme.semanticTokens;
}
function $47a6d9fbbf7ee42d$var$omitVars(rawTheme) {
    const { __cssMap: __cssMap, __cssVars: __cssVars, __breakpoints: __breakpoints, ...cleanTheme } = rawTheme;
    return cleanTheme;
}
// src/create-theme-vars/flatten-tokens.ts
var $47a6d9fbbf7ee42d$var$isSemanticCondition = (key)=>$47a6d9fbbf7ee42d$export$4ec9644154df43c2.includes(key) || "default" === key;
function $47a6d9fbbf7ee42d$export$8f520cff3dbc4769({ tokens: tokens2, semanticTokens: semanticTokens }) {
    const result = {};
    $47a6d9fbbf7ee42d$var$walkObject(tokens2, (value, path)=>{
        if (value == null) return;
        result[path.join(".")] = {
            isSemantic: false,
            value: value
        };
    });
    $47a6d9fbbf7ee42d$var$walkObject(semanticTokens, (value, path)=>{
        if (value == null) return;
        result[path.join(".")] = {
            isSemantic: true,
            value: value
        };
    }, {
        stop: (value)=>Object.keys(value).every($47a6d9fbbf7ee42d$var$isSemanticCondition)
    });
    return result;
}
// src/create-theme-vars/to-css-var.ts
function $47a6d9fbbf7ee42d$export$d4e5dc2a444c0164(rawTheme) {
    var _a;
    const theme = $47a6d9fbbf7ee42d$var$omitVars(rawTheme);
    const tokens2 = $47a6d9fbbf7ee42d$var$extractTokens(theme);
    const semanticTokens = $47a6d9fbbf7ee42d$var$extractSemanticTokens(theme);
    const flatTokens = $47a6d9fbbf7ee42d$export$8f520cff3dbc4769({
        tokens: tokens2,
        semanticTokens: semanticTokens
    });
    const cssVarPrefix = (_a = theme.config) == null ? void 0 : _a.cssVarPrefix;
    const { cssMap: cssMap, cssVars: cssVars } = $47a6d9fbbf7ee42d$var$createThemeVars(flatTokens, {
        cssVarPrefix: cssVarPrefix
    });
    const defaultCssVars = {
        "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
        "--chakra-ring-offset-width": "0px",
        "--chakra-ring-offset-color": "#fff",
        "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
        "--chakra-ring-offset-shadow": "0 0 #0000",
        "--chakra-ring-shadow": "0 0 #0000",
        "--chakra-space-x-reverse": "0",
        "--chakra-space-y-reverse": "0"
    };
    Object.assign(theme, {
        __cssVars: {
            ...defaultCssVars,
            ...cssVars
        },
        __cssMap: cssMap,
        __breakpoints: $47a6d9fbbf7ee42d$var$analyzeBreakpoints(theme.breakpoints)
    });
    return theme;
}
var $47a6d9fbbf7ee42d$export$30cfa87a708babfc = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, $47a6d9fbbf7ee42d$export$8ce1fd94bee2f412, $47a6d9fbbf7ee42d$export$1edee58a52776cd9, $47a6d9fbbf7ee42d$export$35e9368ef982300f, $47a6d9fbbf7ee42d$export$feec61708a55c80e, $47a6d9fbbf7ee42d$export$b3219800bda33a1f, $47a6d9fbbf7ee42d$export$3dea766d36a8935f, $47a6d9fbbf7ee42d$export$e7d0da6968da5dd, $47a6d9fbbf7ee42d$export$2499a341a8256d68, $47a6d9fbbf7ee42d$export$85fc379452d91af0, $47a6d9fbbf7ee42d$export$36263e8f8d7ce3b1, $47a6d9fbbf7ee42d$export$5880b8b5730aff45, $47a6d9fbbf7ee42d$export$dc573d8a6576cdb3, $47a6d9fbbf7ee42d$export$a941ed4b947d12f8, $47a6d9fbbf7ee42d$export$209876d7b1ac8f3, $47a6d9fbbf7ee42d$export$d846a084e680d8e, $47a6d9fbbf7ee42d$export$6b7f9af9aa033040, $47a6d9fbbf7ee42d$export$51186ad6e864892a, $47a6d9fbbf7ee42d$export$8837f4fc672e936d, $47a6d9fbbf7ee42d$export$66bb15e2994e6a26);
var $47a6d9fbbf7ee42d$var$layoutSystem = Object.assign({}, $47a6d9fbbf7ee42d$export$a941ed4b947d12f8, $47a6d9fbbf7ee42d$export$b3219800bda33a1f, $47a6d9fbbf7ee42d$export$feec61708a55c80e, $47a6d9fbbf7ee42d$export$85fc379452d91af0, $47a6d9fbbf7ee42d$export$5880b8b5730aff45);
var $47a6d9fbbf7ee42d$export$bccb7c6ca2f4f912 = Object.keys($47a6d9fbbf7ee42d$var$layoutSystem);
var $47a6d9fbbf7ee42d$export$332cc7004bcbb8b4 = [
    ...Object.keys($47a6d9fbbf7ee42d$export$30cfa87a708babfc),
    ...$47a6d9fbbf7ee42d$export$4ec9644154df43c2
];
var $47a6d9fbbf7ee42d$var$styleProps = {
    ...$47a6d9fbbf7ee42d$export$30cfa87a708babfc,
    ...$47a6d9fbbf7ee42d$export$a36cf593fde2a546
};
var $47a6d9fbbf7ee42d$export$95b76554d0cd12d6 = (prop)=>prop in $47a6d9fbbf7ee42d$var$styleProps;
var $47a6d9fbbf7ee42d$var$expandResponsive = (styles)=>(theme)=>{
        if (!theme.__breakpoints) return styles;
        const { isResponsive: isResponsive, toArrayValue: toArrayValue, media: medias } = theme.__breakpoints;
        const computedStyles = {};
        for(const key in styles){
            let value = (0, $abe97432afb3d989$export$624e501d81f5ffce)(styles[key], theme);
            if (value == null) continue;
            value = (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(value) && isResponsive(value) ? toArrayValue(value) : value;
            if (!Array.isArray(value)) {
                computedStyles[key] = value;
                continue;
            }
            const queries = value.slice(0, medias.length).length;
            for(let index = 0; index < queries; index += 1){
                const media = medias == null ? void 0 : medias[index];
                if (!media) {
                    computedStyles[key] = value[index];
                    continue;
                }
                computedStyles[media] = computedStyles[media] || {};
                if (value[index] == null) continue;
                computedStyles[media][key] = value[index];
            }
        }
        return computedStyles;
    };
// src/utils/split-by-comma.ts
function $47a6d9fbbf7ee42d$var$splitByComma(value) {
    const chunks = [];
    let chunk = "";
    let inParens = false;
    for(let i = 0; i < value.length; i++){
        const char = value[i];
        if (char === "(") {
            inParens = true;
            chunk += char;
        } else if (char === ")") {
            inParens = false;
            chunk += char;
        } else if (char === "," && !inParens) {
            chunks.push(chunk);
            chunk = "";
        } else chunk += char;
    }
    chunk = chunk.trim();
    if (chunk) chunks.push(chunk);
    return chunks;
}
// src/css.ts
function $47a6d9fbbf7ee42d$var$isCssVar2(value) {
    return /^var\(--.+\)$/.test(value);
}
var $47a6d9fbbf7ee42d$var$isCSSVariableTokenValue = (key, value)=>key.startsWith("--") && typeof value === "string" && !$47a6d9fbbf7ee42d$var$isCssVar2(value);
var $47a6d9fbbf7ee42d$var$resolveTokenValue = (theme, value)=>{
    var _a, _b;
    if (value == null) return value;
    const getVar = (val)=>{
        var _a2, _b2;
        return (_b2 = (_a2 = theme.__cssMap) == null ? void 0 : _a2[val]) == null ? void 0 : _b2.varRef;
    };
    const getValue = (val)=>{
        var _a2;
        return (_a2 = getVar(val)) != null ? _a2 : val;
    };
    const [tokenValue, fallbackValue] = $47a6d9fbbf7ee42d$var$splitByComma(value);
    value = (_b = (_a = getVar(tokenValue)) != null ? _a : getValue(fallbackValue)) != null ? _b : getValue(value);
    return value;
};
function $47a6d9fbbf7ee42d$export$955358618f994a11(options) {
    const { configs: configs = {}, pseudos: pseudos = {}, theme: theme } = options;
    const css2 = (stylesOrFn, nested = false)=>{
        var _a, _b, _c;
        const _styles = (0, $abe97432afb3d989$export$624e501d81f5ffce)(stylesOrFn, theme);
        const styles = $47a6d9fbbf7ee42d$var$expandResponsive(_styles)(theme);
        let computedStyles = {};
        for(let key in styles){
            const valueOrFn = styles[key];
            let value = (0, $abe97432afb3d989$export$624e501d81f5ffce)(valueOrFn, theme);
            if (key in pseudos) key = pseudos[key];
            if ($47a6d9fbbf7ee42d$var$isCSSVariableTokenValue(key, value)) value = $47a6d9fbbf7ee42d$var$resolveTokenValue(theme, value);
            let config = configs[key];
            if (config === true) config = {
                property: key
            };
            if ((0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(value)) {
                computedStyles[key] = (_a = computedStyles[key]) != null ? _a : {};
                computedStyles[key] = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, computedStyles[key], css2(value, true));
                continue;
            }
            let rawValue = (_c = (_b = config == null ? void 0 : config.transform) == null ? void 0 : _b.call(config, value, theme, _styles)) != null ? _c : value;
            rawValue = (config == null ? void 0 : config.processResult) ? css2(rawValue, true) : rawValue;
            const configProperty = (0, $abe97432afb3d989$export$624e501d81f5ffce)(config == null ? void 0 : config.property, theme);
            if (!nested && (config == null ? void 0 : config.static)) {
                const staticStyles = (0, $abe97432afb3d989$export$624e501d81f5ffce)(config.static, theme);
                computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, computedStyles, staticStyles);
            }
            if (configProperty && Array.isArray(configProperty)) {
                for (const property of configProperty)computedStyles[property] = rawValue;
                continue;
            }
            if (configProperty) {
                if (configProperty === "&" && (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(rawValue)) computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, computedStyles, rawValue);
                else computedStyles[configProperty] = rawValue;
                continue;
            }
            if ((0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(rawValue)) {
                computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, computedStyles, rawValue);
                continue;
            }
            computedStyles[key] = rawValue;
        }
        return computedStyles;
    };
    return css2;
}
var $47a6d9fbbf7ee42d$export$dbf350e5966cf602 = (styles)=>(theme)=>{
        const cssFn = $47a6d9fbbf7ee42d$export$955358618f994a11({
            theme: theme,
            pseudos: $47a6d9fbbf7ee42d$export$a36cf593fde2a546,
            configs: $47a6d9fbbf7ee42d$export$30cfa87a708babfc
        });
        return cssFn(styles);
    };
// src/define-styles.ts
function $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839(styles) {
    return styles;
}
function $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4(config) {
    return config;
}
function $47a6d9fbbf7ee42d$export$d5f717dc145477b8(parts) {
    return {
        definePartsStyle (config) {
            return config;
        },
        defineMultiStyleConfig (config) {
            return {
                parts: parts,
                ...config
            };
        }
    };
}
function $47a6d9fbbf7ee42d$var$normalize2(value, toArray) {
    if (Array.isArray(value)) return value;
    if ((0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(value)) return toArray(value);
    if (value != null) return [
        value
    ];
}
function $47a6d9fbbf7ee42d$var$getNextIndex(values, i) {
    for(let j = i + 1; j < values.length; j++){
        if (values[j] != null) return j;
    }
    return -1;
}
function $47a6d9fbbf7ee42d$var$createResolver(theme) {
    const breakpointUtil = theme.__breakpoints;
    return function resolver(config, prop, value, props) {
        var _a, _b;
        if (!breakpointUtil) return;
        const result = {};
        const normalized = $47a6d9fbbf7ee42d$var$normalize2(value, breakpointUtil.toArrayValue);
        if (!normalized) return result;
        const len = normalized.length;
        const isSingle = len === 1;
        const isMultipart = !!config.parts;
        for(let i = 0; i < len; i++){
            const key = breakpointUtil.details[i];
            const nextKey = breakpointUtil.details[$47a6d9fbbf7ee42d$var$getNextIndex(normalized, i)];
            const query = $47a6d9fbbf7ee42d$var$toMediaQueryString(key.minW, nextKey == null ? void 0 : nextKey._minW);
            const styles = (0, $abe97432afb3d989$export$624e501d81f5ffce)((_a = config[prop]) == null ? void 0 : _a[normalized[i]], props);
            if (!styles) continue;
            if (isMultipart) {
                (_b = config.parts) == null || _b.forEach((part)=>{
                    (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))(result, {
                        [part]: isSingle ? styles[part] : {
                            [query]: styles[part]
                        }
                    });
                });
                continue;
            }
            if (!isMultipart) {
                if (isSingle) (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))(result, styles);
                else result[query] = styles;
                continue;
            }
            result[query] = styles;
        }
        return result;
    };
}
function $47a6d9fbbf7ee42d$export$f94106bbb00e81eb(config) {
    return (props)=>{
        var _a;
        const { variant: variant, size: size, theme: theme } = props;
        const recipe = $47a6d9fbbf7ee42d$var$createResolver(theme);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, (0, $abe97432afb3d989$export$624e501d81f5ffce)((_a = config.baseStyle) != null ? _a : {}, props), recipe(config, "sizes", size, props), recipe(config, "variants", variant, props));
    };
}
// src/get-css-var.ts
function $47a6d9fbbf7ee42d$export$93c8e06b7014dc33(theme, scale, value) {
    var _a, _b, _c;
    return (_c = (_b = (_a = theme.__cssMap) == null ? void 0 : _a[`${scale}.${value}`]) == null ? void 0 : _b.varRef) != null ? _c : value;
}
// src/theming-props.ts
function $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785(props) {
    return $47a6d9fbbf7ee42d$var$omit(props, [
        "styleConfig",
        "size",
        "variant",
        "colorScheme"
    ]);
}


"use client";
var $f041f5bc425d9240$var$allPropNames = /* @__PURE__ */ new Set([
    ...(0, $47a6d9fbbf7ee42d$export$332cc7004bcbb8b4),
    "textStyle",
    "layerStyle",
    "apply",
    "noOfLines",
    "focusBorderColor",
    "errorBorderColor",
    "as",
    "__css",
    "css",
    "sx"
]);
var $f041f5bc425d9240$var$validHTMLProps = /* @__PURE__ */ new Set([
    "htmlWidth",
    "htmlHeight",
    "htmlSize",
    "htmlTranslate"
]);
function $f041f5bc425d9240$export$3ba67b570e26eea0(prop) {
    return $f041f5bc425d9240$var$validHTMLProps.has(prop) || !$f041f5bc425d9240$var$allPropNames.has(prop);
}



var $acw62 = parcelRequire("acw62");
"use client";
var $b80b1cf263c5808a$export$49ddd74a6729fdb0 = (0, $acw62.createContext)({});
$b80b1cf263c5808a$export$49ddd74a6729fdb0.displayName = "ColorModeContext";
function $b80b1cf263c5808a$export$20f3076712c8dfa() {
    const context = (0, $acw62.useContext)($b80b1cf263c5808a$export$49ddd74a6729fdb0);
    if (context === void 0) throw new Error("useColorMode must be used within a ColorModeProvider");
    return context;
}
function $b80b1cf263c5808a$export$d18f2ef57b0d7644(light, dark) {
    const { colorMode: colorMode } = $b80b1cf263c5808a$export$20f3076712c8dfa();
    return colorMode === "dark" ? dark : light;
}



// src/object.ts

var $5Gn6I = parcelRequire("5Gn6I");
function $8cabe7dbd312f1c1$export$30a06c8d3562193f(object, keys) {
    const result = {};
    Object.keys(object).forEach((key)=>{
        if (keys.includes(key)) return;
        result[key] = object[key];
    });
    return result;
}
function $8cabe7dbd312f1c1$export$357523c63a2253b9(object, keys) {
    const result = {};
    keys.forEach((key)=>{
        if (key in object) result[key] = object[key];
    });
    return result;
}
function $8cabe7dbd312f1c1$export$65980d18b75784e2(object, keys) {
    const picked = {};
    const omitted = {};
    Object.keys(object).forEach((key)=>{
        if (keys.includes(key)) picked[key] = object[key];
        else omitted[key] = object[key];
    });
    return [
        picked,
        omitted
    ];
}
function $8cabe7dbd312f1c1$export$3988ae62b71be9a3(obj, path, fallback, index) {
    const key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === void 0 ? fallback : obj;
}
var $8cabe7dbd312f1c1$export$fc10aeed3a532e2a = (fn)=>{
    const cache = /* @__PURE__ */ new WeakMap();
    const memoizedFn = (obj, path, fallback, index)=>{
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, /* @__PURE__ */ new Map());
        const map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        const value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
var $8cabe7dbd312f1c1$export$1bb32d0c65da6059 = $8cabe7dbd312f1c1$export$fc10aeed3a532e2a($8cabe7dbd312f1c1$export$3988ae62b71be9a3);
function $8cabe7dbd312f1c1$export$73b8ef55a37133c7(path, scale) {
    return $8cabe7dbd312f1c1$export$1bb32d0c65da6059(scale, path, path);
}
function $8cabe7dbd312f1c1$export$3417cf6417437960(object, fn) {
    const result = {};
    Object.keys(object).forEach((key)=>{
        const value = object[key];
        const shouldPass = fn(value, key, object);
        if (shouldPass) result[key] = value;
    });
    return result;
}
var $8cabe7dbd312f1c1$export$2458ce75c8ef9806 = (object)=>$8cabe7dbd312f1c1$export$3417cf6417437960(object, (val)=>val !== null && val !== void 0);
var $8cabe7dbd312f1c1$export$259b4dd69e654a7a = (obj)=>Object.keys(obj);
var $8cabe7dbd312f1c1$export$5150077fc2e7c662 = (entries)=>entries.reduce((carry, [key, value])=>{
        carry[key] = value;
        return carry;
    }, {});
var $8cabe7dbd312f1c1$export$93c8e06b7014dc33 = (theme, scale, value)=>{
    var _a, _b, _c;
    return (_c = (_b = (_a = theme.__cssMap) == null ? void 0 : _a[`${scale}.${value}`]) == null ? void 0 : _b.varRef) != null ? _c : value;
};

// src/assertion.ts
function $fbf5a7a3c8624538$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $fbf5a7a3c8624538$export$3f283ac14831e759(value) {
    return typeof value !== "number" || Number.isNaN(value) || !Number.isFinite(value);
}
function $fbf5a7a3c8624538$export$e90fb89750dba83f(value) {
    return value != null && value - parseFloat(value) + 1 >= 0;
}
function $fbf5a7a3c8624538$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $fbf5a7a3c8624538$export$4c0262a4f954db45(value) {
    return $fbf5a7a3c8624538$export$43bee75e5e14138e(value) && value.length === 0;
}
function $fbf5a7a3c8624538$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $fbf5a7a3c8624538$export$4e62c701997796c1(value) {
    return typeof value !== "undefined" && value !== void 0;
}
function $fbf5a7a3c8624538$export$fce6876652108ab(value) {
    return typeof value === "undefined" || value === void 0;
}
function $fbf5a7a3c8624538$export$a6cdc56e425d0d0a(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !$fbf5a7a3c8624538$export$43bee75e5e14138e(value);
}
function $fbf5a7a3c8624538$export$83b788b1a3698c03(value) {
    return $fbf5a7a3c8624538$export$a6cdc56e425d0d0a(value) && Object.keys(value).length === 0;
}
function $fbf5a7a3c8624538$export$e0287cc73292b477(value) {
    return value && !$fbf5a7a3c8624538$export$83b788b1a3698c03(value);
}
function $fbf5a7a3c8624538$export$630801d484da15df(value) {
    return value == null;
}
function $fbf5a7a3c8624538$export$844ec244b1367d54(value) {
    return Object.prototype.toString.call(value) === "[object String]";
}
function $fbf5a7a3c8624538$export$30a9abfd5fb9f5f6(value) {
    return /^var\(--.+\)$/.test(value);
}
function $fbf5a7a3c8624538$export$dd1bc94b04021eeb(value) {
    if ($fbf5a7a3c8624538$export$43bee75e5e14138e(value)) return $fbf5a7a3c8624538$export$4c0262a4f954db45(value);
    if ($fbf5a7a3c8624538$export$a6cdc56e425d0d0a(value)) return $fbf5a7a3c8624538$export$83b788b1a3698c03(value);
    if (value == null || value === "") return true;
    return false;
}
var $fbf5a7a3c8624538$export$a866f231438cc228 = false;
var $fbf5a7a3c8624538$export$61cb32cff9a99948 = false;
function $fbf5a7a3c8624538$export$dedd81df7bc1307(val) {
    return "current" in val;
}
function $fbf5a7a3c8624538$export$4215e022093e324e(value) {
    return value && $fbf5a7a3c8624538$export$a6cdc56e425d0d0a(value) && $fbf5a7a3c8624538$export$a6cdc56e425d0d0a(value.target);
}


// src/function.ts
function $7e9e3a2462729b7f$export$624e501d81f5ffce(valueOrFn, ...args) {
    return (0, $fbf5a7a3c8624538$export$f6e2535fb5126e54)(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
function $7e9e3a2462729b7f$export$5bdd3f730ec2c47e(...fns) {
    return function func(event) {
        fns.some((fn)=>{
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $7e9e3a2462729b7f$export$9dd9a52f2dd5b9ce(...fns) {
    return function mergedFn(arg) {
        fns.forEach((fn)=>{
            fn == null || fn(arg);
        });
    };
}
var $7e9e3a2462729b7f$export$f672e0b6f7222cd7 = (fn1, ...fns)=>fns.reduce((f1, f2)=>(...args)=>f1(f2(...args)), fn1);
function $7e9e3a2462729b7f$export$d2de3aaeafa91619(fn) {
    let result;
    return function func(...args) {
        if (fn) {
            result = fn.apply(this, args);
            fn = null;
        }
        return result;
    };
}
var $7e9e3a2462729b7f$export$8793edee2d425525 = ()=>{};
var $7e9e3a2462729b7f$export$c106dd0671a0fc2d = /* @__PURE__ */ $7e9e3a2462729b7f$export$d2de3aaeafa91619((options)=>()=>{
        const { condition: condition, message: message } = options;
        if (condition && (0, $fbf5a7a3c8624538$export$a866f231438cc228)) console.warn(message);
    });
var $7e9e3a2462729b7f$export$a3bc9b8ed74fc = /* @__PURE__ */ $7e9e3a2462729b7f$export$d2de3aaeafa91619((options)=>()=>{
        const { condition: condition, message: message } = options;
        if (condition && (0, $fbf5a7a3c8624538$export$a866f231438cc228)) console.error(message);
    });
var $7e9e3a2462729b7f$export$a4627e546088548d = (...fns)=>(v)=>fns.reduce((a, b)=>b(a), v);
var $7e9e3a2462729b7f$var$distance1D = (a, b)=>Math.abs(a - b);
var $7e9e3a2462729b7f$var$isPoint = (point)=>"x" in point && "y" in point;
function $7e9e3a2462729b7f$export$9f17032d917177de(a, b) {
    if ((0, $fbf5a7a3c8624538$export$7e4aa119212bc614)(a) && (0, $fbf5a7a3c8624538$export$7e4aa119212bc614)(b)) return $7e9e3a2462729b7f$var$distance1D(a, b);
    if ($7e9e3a2462729b7f$var$isPoint(a) && $7e9e3a2462729b7f$var$isPoint(b)) {
        const xDelta = $7e9e3a2462729b7f$var$distance1D(a.x, b.x);
        const yDelta = $7e9e3a2462729b7f$var$distance1D(a.y, b.y);
        return Math.sqrt(xDelta ** 2 + yDelta ** 2);
    }
    return 0;
}


// src/assign-after.ts
function $497654f4cc41b610$export$1ab078c80230a125(target, ...sources) {
    if (target == null) throw new TypeError("Cannot convert undefined or null to object");
    const result = {
        ...target
    };
    for (const nextSource of sources){
        if (nextSource == null) continue;
        for(const nextKey in nextSource){
            if (!Object.prototype.hasOwnProperty.call(nextSource, nextKey)) continue;
            if (nextKey in result) delete result[nextKey];
            result[nextKey] = nextSource[nextKey];
        }
    }
    return result;
}


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}



var $acw62 = parcelRequire("acw62");
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $acw62 = parcelRequire("acw62");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $e18645ac1956fbe6$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $e18645ac1956fbe6$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e18645ac1956fbe6$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e18645ac1956fbe6$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $e18645ac1956fbe6$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};



var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)) break;
        (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)();
    }
    return (0, $298fb931ed4fbf8b$export$58adb3bec8346d0f)(begin, (0, $298fb931ed4fbf8b$export$5880b8b5730aff45));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $298fb931ed4fbf8b$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $298fb931ed4fbf8b$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $298fb931ed4fbf8b$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $298fb931ed4fbf8b$export$45918ac1574455b1)($fc182b1f84212d3f$var$toRules((0, $298fb931ed4fbf8b$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $fc182b1f84212d3f$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $fc182b1f84212d3f$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($fc182b1f84212d3f$var$ignoreFlag) > -1;
};
var $fc182b1f84212d3f$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($fc182b1f84212d3f$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $fc182b1f84212d3f$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $fc182b1f84212d3f$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$fc182b1f84212d3f$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $fc182b1f84212d3f$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $fc182b1f84212d3f$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$fc182b1f84212d3f$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    } else if ($fc182b1f84212d3f$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $298fb931ed4fbf8b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-item-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "stretch") ? $fc182b1f84212d3f$var$prefix((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, (0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 3 - (~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $298fb931ed4fbf8b$export$527d108ccf083c2b:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                    (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                        value: (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $298fb931ed4fbf8b$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $298fb931ed4fbf8b$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $298fb931ed4fbf8b$export$fac44ee5b035f737),
        (0, $298fb931ed4fbf8b$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $e18645ac1956fbe6$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};




var $72623ab6bcb0a33b$exports = {};
"use strict";
var $3251146683c5d714$exports = {};
"use strict";

$3251146683c5d714$exports = (parcelRequire("9cCWX"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($3251146683c5d714$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f1be2661c8fac766$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(targetComponent, sourceComponent);
};


var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $90ba2da1f62e5f1b$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $90ba2da1f62e5f1b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $90ba2da1f62e5f1b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $90ba2da1f62e5f1b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $90ba2da1f62e5f1b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $90ba2da1f62e5f1b$var$processStyleName = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(styleName) {
    return $90ba2da1f62e5f1b$var$isCustomProperty(styleName) ? styleName : styleName.replace($90ba2da1f62e5f1b$var$hyphenateRegex, "-$&").toLowerCase();
});
var $90ba2da1f62e5f1b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($90ba2da1f62e5f1b$var$animationRegex, function(match, p1, p2) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $936be3b045ab836e$export$2e2bcd8739ae039)[key] !== 1 && !$90ba2da1f62e5f1b$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $90ba2da1f62e5f1b$var$contentValuePattern, $90ba2da1f62e5f1b$var$contentValues, $90ba2da1f62e5f1b$var$oldProcessStyleValue, $90ba2da1f62e5f1b$var$msPattern, $90ba2da1f62e5f1b$var$hyphenPattern, $90ba2da1f62e5f1b$var$hyphenatedCache;
var $90ba2da1f62e5f1b$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $90ba2da1f62e5f1b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $90ba2da1f62e5f1b$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $90ba2da1f62e5f1b$var$cursor;
                var result = interpolation(mergedProps);
                $90ba2da1f62e5f1b$var$cursor = previousCursor;
                return $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($90ba2da1f62e5f1b$var$isProcessableValue(value)) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($90ba2da1f62e5f1b$var$isProcessableValue(value[_i])) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $90ba2da1f62e5f1b$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $90ba2da1f62e5f1b$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $90ba2da1f62e5f1b$var$cursor;
var $90ba2da1f62e5f1b$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $90ba2da1f62e5f1b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $90ba2da1f62e5f1b$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $90ba2da1f62e5f1b$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $90ba2da1f62e5f1b$var$cursor
    };
};



var $acw62 = parcelRequire("acw62");
var $19b532704a3a90e7$var$syncFallback = function syncFallback(create) {
    return create();
};
var $19b532704a3a90e7$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $19b532704a3a90e7$export$db21c7ffa21794e7 = $19b532704a3a90e7$var$useInsertionEffect || $19b532704a3a90e7$var$syncFallback;
var $19b532704a3a90e7$export$811a713a7276cb9d = $19b532704a3a90e7$var$useInsertionEffect || $acw62.useLayoutEffect;


var $0fe24a6591b39473$export$23f2a1d2818174ef = true;
var $0fe24a6591b39473$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $0fe24a6591b39473$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
    key: "css"
}) : null);
var $0fe24a6591b39473$export$e7094788287c5e9b = $0fe24a6591b39473$var$EmotionCacheContext.Provider;
var $0fe24a6591b39473$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
};
var $0fe24a6591b39473$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$0fe24a6591b39473$export$23f2a1d2818174ef) $0fe24a6591b39473$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
                key: "css"
            });
            return /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $0fe24a6591b39473$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $0fe24a6591b39473$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
};
var $0fe24a6591b39473$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $0fe24a6591b39473$var$createCacheWithTheme = /* #__PURE__ */ (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(theme) {
        return $0fe24a6591b39473$var$getTheme(outerTheme, theme);
    });
});
var $0fe24a6591b39473$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $0fe24a6591b39473$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $0fe24a6591b39473$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $f1be2661c8fac766$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $0fe24a6591b39473$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $0fe24a6591b39473$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $0fe24a6591b39473$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $0fe24a6591b39473$var$getLastPart(match[1]);
    return undefined;
};
var $0fe24a6591b39473$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $0fe24a6591b39473$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $0fe24a6591b39473$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $0fe24a6591b39473$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($0fe24a6591b39473$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $0fe24a6591b39473$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $0fe24a6591b39473$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $0fe24a6591b39473$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $0fe24a6591b39473$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($0fe24a6591b39473$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$0fe24a6591b39473$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $0fe24a6591b39473$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        return (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $0fe24a6591b39473$var$Emotion = /* #__PURE__ */ $0fe24a6591b39473$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$0fe24a6591b39473$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $1f6791d0a193b918$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(registeredStyles, undefined, $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($0fe24a6591b39473$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $0fe24a6591b39473$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $0fe24a6591b39473$export$a9c23c6ac3fc3eca = $0fe24a6591b39473$var$Emotion;



var $acw62 = parcelRequire("acw62");




var $27ab08c24269de64$exports = {};
function $27ab08c24269de64$var$_extends() {
    $27ab08c24269de64$exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;
    return $27ab08c24269de64$var$_extends.apply(this, arguments);
}
$27ab08c24269de64$exports = $27ab08c24269de64$var$_extends, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;





var $63d46a01db878c10$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $63d46a01db878c10$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $0fe24a6591b39473$export$dda1d9f60106f0e9).call(props, "css")) // $FlowFixMe
    return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $0fe24a6591b39473$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $0fe24a6591b39473$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $acw62.createElement.apply(null, createElementArgArray);
};
var $63d46a01db878c10$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d46a01db878c10$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $0fe24a6591b39473$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)([
        styles
    ], undefined, $acw62.useContext((0, $0fe24a6591b39473$export$971d5caa766a69d7)));
    if (!(0, $0fe24a6591b39473$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $63d46a01db878c10$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args);
}
var $63d46a01db878c10$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $63d46a01db878c10$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $63d46a01db878c10$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $63d46a01db878c10$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $1f6791d0a193b918$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d46a01db878c10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d46a01db878c10$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $0fe24a6591b39473$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d46a01db878c10$var$merge(cache.registered, css, $63d46a01db878c10$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $0fe24a6591b39473$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($63d46a01db878c10$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $63d46a01db878c10$var$isBrowser, $63d46a01db878c10$var$isTestEnv, $63d46a01db878c10$var$globalContext, $63d46a01db878c10$var$globalKey;





var $60e97af874e8cdaa$var$testOmitPropsOnStringTag = (0, $bcd4e42ca4163639$export$2e2bcd8739ae039);
var $60e97af874e8cdaa$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $60e97af874e8cdaa$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $60e97af874e8cdaa$var$testOmitPropsOnStringTag : $60e97af874e8cdaa$var$testOmitPropsOnComponent;
};
var $60e97af874e8cdaa$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $60e97af874e8cdaa$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $60e97af874e8cdaa$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        return (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $60e97af874e8cdaa$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $60e97af874e8cdaa$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $60e97af874e8cdaa$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $0fe24a6591b39473$export$efccba1c4a2ef57b)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $acw62.useContext((0, $0fe24a6591b39473$export$971d5caa766a69d7));
            }
            if (typeof props.className === "string") className = (0, $1f6791d0a193b918$export$95d99596f328fd52)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $60e97af874e8cdaa$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($60e97af874e8cdaa$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $acw62.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, nextOptions, {
                shouldForwardProp: $60e97af874e8cdaa$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};



parcelRequire("acw62");





var $12ab803fa905d303$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $12ab803fa905d303$export$2e2bcd8739ae039 = (0, $60e97af874e8cdaa$export$2e2bcd8739ae039).bind();
$12ab803fa905d303$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $12ab803fa905d303$export$2e2bcd8739ae039[tagName] = $12ab803fa905d303$export$2e2bcd8739ae039(tagName);
});



var $acw62 = parcelRequire("acw62");
"use client";
var $279cd6dea0e062c7$var$_a;
var $279cd6dea0e062c7$var$emotion_styled = ($279cd6dea0e062c7$var$_a = (0, $12ab803fa905d303$export$2e2bcd8739ae039).default) != null ? $279cd6dea0e062c7$var$_a : (0, $12ab803fa905d303$export$2e2bcd8739ae039);
var $279cd6dea0e062c7$export$9dba07f3d84163bb = ({ baseStyle: baseStyle })=>(props)=>{
        const { theme: theme, css: cssProp, __css: __css, sx: sx, ...rest } = props;
        const styleProps = (0, $8cabe7dbd312f1c1$export$3417cf6417437960)(rest, (_, prop)=>(0, $47a6d9fbbf7ee42d$export$95b76554d0cd12d6)(prop));
        const finalBaseStyle = (0, $7e9e3a2462729b7f$export$624e501d81f5ffce)(baseStyle, props);
        const finalStyles = (0, $497654f4cc41b610$export$1ab078c80230a125)({}, __css, finalBaseStyle, (0, $8cabe7dbd312f1c1$export$2458ce75c8ef9806)(styleProps), sx);
        const computedCSS = (0, $47a6d9fbbf7ee42d$export$dbf350e5966cf602)(finalStyles)(props.theme);
        return cssProp ? [
            computedCSS,
            cssProp
        ] : computedCSS;
    };
function $279cd6dea0e062c7$export$3817b7a54a07cec7(component, options) {
    const { baseStyle: baseStyle, ...styledOptions } = options != null ? options : {};
    if (!styledOptions.shouldForwardProp) styledOptions.shouldForwardProp = (0, $f041f5bc425d9240$export$3ba67b570e26eea0);
    const styleObject = $279cd6dea0e062c7$export$9dba07f3d84163bb({
        baseStyle: baseStyle
    });
    const Component = $279cd6dea0e062c7$var$emotion_styled(component, styledOptions)(styleObject);
    const chakraComponent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function ChakraComponent(props, ref) {
        const { colorMode: colorMode, forced: forced } = (0, $b80b1cf263c5808a$export$20f3076712c8dfa)();
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, {
            ref: ref,
            "data-theme": forced ? colorMode : void 0,
            ...props
        });
    });
    return chakraComponent;
}


"use client";
// src/factory.ts
function $7a77d8ad783bc3e2$var$factory() {
    const cache = /* @__PURE__ */ new Map();
    return new Proxy((0, $279cd6dea0e062c7$export$3817b7a54a07cec7), {
        /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */ apply (target, thisArg, argArray) {
            return (0, $279cd6dea0e062c7$export$3817b7a54a07cec7)(...argArray);
        },
        /**
     * @example
     * <chakra.div />
     */ get (_, element) {
            if (!cache.has(element)) cache.set(element, (0, $279cd6dea0e062c7$export$3817b7a54a07cec7)(element));
            return cache.get(element);
        }
    });
}
var $7a77d8ad783bc3e2$export$7cd122d781af9fa4 = $7a77d8ad783bc3e2$var$factory();


var $acw62 = parcelRequire("acw62");
"use client";
function $b271d58d4d1ccb07$export$257a8862b851cb5b(component) {
    return (0, $acw62.forwardRef)(component);
}



"use client";
var $2032f24e0e9145ee$export$e71c4d32a2263218 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)("div");
$2032f24e0e9145ee$export$e71c4d32a2263218.displayName = "Box";
var $2032f24e0e9145ee$export$b09fb900337259de = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Square2(props, ref) {
    const { size: size, centerContent: centerContent = true, ...rest } = props;
    const styles = centerContent ? {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    } : {};
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($2032f24e0e9145ee$export$e71c4d32a2263218, {
        ref: ref,
        boxSize: size,
        __css: {
            ...styles,
            flexShrink: 0,
            flexGrow: 0
        },
        ...rest
    });
});
$2032f24e0e9145ee$export$b09fb900337259de.displayName = "Square";
var $2032f24e0e9145ee$export$c89a927ffc67e6fa = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Circle2(props, ref) {
    const { size: size, ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($2032f24e0e9145ee$export$b09fb900337259de, {
        size: size,
        ref: ref,
        borderRadius: "9999px",
        ...rest
    });
});
$2032f24e0e9145ee$export$c89a927ffc67e6fa.displayName = "Circle";

"use client";
var $1ecb8f4b9f1b6b98$var$__defProp = Object.defineProperty;
var $1ecb8f4b9f1b6b98$var$__defNormalProp = (obj, key, value)=>key in obj ? $1ecb8f4b9f1b6b98$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $1ecb8f4b9f1b6b98$export$5cb848ba4d1f099 = (obj, key, value)=>{
    $1ecb8f4b9f1b6b98$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};



var $acw62 = parcelRequire("acw62");
"use client";
var $b09f0d09ca2d779f$var$ModalManager = class {
    constructor(){
        (0, $1ecb8f4b9f1b6b98$export$5cb848ba4d1f099)(this, "modals");
        this.modals = /* @__PURE__ */ new Map();
    }
    add(modal) {
        this.modals.set(modal, this.modals.size + 1);
        return this.modals.size;
    }
    remove(modal) {
        this.modals.delete(modal);
    }
    isTopModal(modal) {
        if (!modal) return false;
        return this.modals.get(modal) === this.modals.size;
    }
};
var $b09f0d09ca2d779f$export$78d35f50a4fd5552 = new $b09f0d09ca2d779f$var$ModalManager();
function $b09f0d09ca2d779f$export$8557a94b9bb25060(ref, isOpen) {
    const [index, setIndex] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        const node = ref.current;
        if (!node) return;
        if (isOpen) {
            const index2 = $b09f0d09ca2d779f$export$78d35f50a4fd5552.add(node);
            setIndex(index2);
        }
        return ()=>{
            $b09f0d09ca2d779f$export$78d35f50a4fd5552.remove(node);
            setIndex(0);
        };
    }, [
        isOpen,
        ref
    ]);
    return index;
}




var $acw62 = parcelRequire("acw62");
"use client";
function $457901a59fc0a4e6$export$d734136a7b018efe(ref, value) {
    if (ref == null) return;
    if (typeof ref === "function") {
        ref(value);
        return;
    }
    try {
        ref.current = value;
    } catch (error) {
        throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
    }
}
function $457901a59fc0a4e6$export$c9058316764c140e(...refs) {
    return (node)=>{
        refs.forEach((ref)=>{
            $457901a59fc0a4e6$export$d734136a7b018efe(ref, node);
        });
    };
}
function $457901a59fc0a4e6$export$74665b213cb5c4cf(...refs) {
    return (0, $acw62.useMemo)(()=>$457901a59fc0a4e6$export$c9058316764c140e(...refs), refs);
}


var $4a7537e072260c10$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $4a7537e072260c10$var$counterMap = new WeakMap();
var $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
var $4a7537e072260c10$var$markerMap = {};
var $4a7537e072260c10$var$lockCount = 0;
var $4a7537e072260c10$var$unwrapHost = function(node) {
    return node && (node.host || $4a7537e072260c10$var$unwrapHost(node.parentNode));
};
var $4a7537e072260c10$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $4a7537e072260c10$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $4a7537e072260c10$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $4a7537e072260c10$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$4a7537e072260c10$var$markerMap[markerName]) $4a7537e072260c10$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $4a7537e072260c10$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($4a7537e072260c10$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $4a7537e072260c10$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $4a7537e072260c10$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $4a7537e072260c10$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $4a7537e072260c10$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $4a7537e072260c10$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$4a7537e072260c10$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $4a7537e072260c10$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $4a7537e072260c10$var$lockCount--;
        if (!$4a7537e072260c10$var$lockCount) {
            // clear
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
            $4a7537e072260c10$var$markerMap = {};
        }
    };
};
var $4a7537e072260c10$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $4a7537e072260c10$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $4a7537e072260c10$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $4a7537e072260c10$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $4a7537e072260c10$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $4a7537e072260c10$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($4a7537e072260c10$export$cc95fea82d705fca() ? $4a7537e072260c10$export$59151cc8db999a24 : $4a7537e072260c10$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};



var $acw62 = parcelRequire("acw62");
"use client";
function $fa7450baa69baf87$export$33ffd74ebf07f060(props) {
    const { isOpen: isOpen, onClose: onClose, id: id, closeOnOverlayClick: closeOnOverlayClick = true, closeOnEsc: closeOnEsc = true, useInert: useInert = true, onOverlayClick: onOverlayClickProp, onEsc: onEsc } = props;
    const dialogRef = (0, $acw62.useRef)(null);
    const overlayRef = (0, $acw62.useRef)(null);
    const [dialogId, headerId, bodyId] = $fa7450baa69baf87$var$useIds(id, `chakra-modal`, `chakra-modal--header`, `chakra-modal--body`);
    $fa7450baa69baf87$export$bf01aaa71a18e30b(dialogRef, isOpen && useInert);
    const index = (0, $b09f0d09ca2d779f$export$8557a94b9bb25060)(dialogRef, isOpen);
    const mouseDownTarget = (0, $acw62.useRef)(null);
    const onMouseDown = (0, $acw62.useCallback)((event)=>{
        mouseDownTarget.current = event.target;
    }, []);
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.key === "Escape") {
            event.stopPropagation();
            if (closeOnEsc) onClose == null || onClose();
            onEsc == null || onEsc();
        }
    }, [
        closeOnEsc,
        onClose,
        onEsc
    ]);
    const [headerMounted, setHeaderMounted] = (0, $acw62.useState)(false);
    const [bodyMounted, setBodyMounted] = (0, $acw62.useState)(false);
    const getDialogProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            role: "dialog",
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(ref, dialogRef),
            id: dialogId,
            tabIndex: -1,
            "aria-modal": true,
            "aria-labelledby": headerMounted ? headerId : void 0,
            "aria-describedby": bodyMounted ? bodyId : void 0,
            onClick: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onClick, (event)=>event.stopPropagation())
        }), [
        bodyId,
        bodyMounted,
        dialogId,
        headerId,
        headerMounted
    ]);
    const onOverlayClick = (0, $acw62.useCallback)((event)=>{
        event.stopPropagation();
        if (mouseDownTarget.current !== event.target) return;
        if (!(0, $b09f0d09ca2d779f$export$78d35f50a4fd5552).isTopModal(dialogRef.current)) return;
        if (closeOnOverlayClick) onClose == null || onClose();
        onOverlayClickProp == null || onOverlayClickProp();
    }, [
        onClose,
        closeOnOverlayClick,
        onOverlayClickProp
    ]);
    const getDialogContainerProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(ref, overlayRef),
            onClick: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onClick, onOverlayClick),
            onKeyDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onKeyDown, onKeyDown),
            onMouseDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseDown, onMouseDown)
        }), [
        onKeyDown,
        onMouseDown,
        onOverlayClick
    ]);
    return {
        isOpen: isOpen,
        onClose: onClose,
        headerId: headerId,
        bodyId: bodyId,
        setBodyMounted: setBodyMounted,
        setHeaderMounted: setHeaderMounted,
        dialogRef: dialogRef,
        overlayRef: overlayRef,
        getDialogProps: getDialogProps,
        getDialogContainerProps: getDialogContainerProps,
        index: index
    };
}
function $fa7450baa69baf87$export$bf01aaa71a18e30b(ref, shouldHide) {
    const currentElement = ref.current;
    (0, $acw62.useEffect)(()=>{
        if (!ref.current || !shouldHide) return void 0;
        return (0, $4a7537e072260c10$export$6e33d16126ed003c)(ref.current);
    }, [
        shouldHide,
        ref,
        currentElement
    ]);
}
function $fa7450baa69baf87$var$useIds(idProp, ...prefixes) {
    const reactId = (0, $acw62.useId)();
    const id = idProp || reactId;
    return (0, $acw62.useMemo)(()=>{
        return prefixes.map((prefix)=>`${prefix}-${id}`);
    }, [
        id,
        prefixes
    ]);
}



var $acw62 = parcelRequire("acw62");
"use client";
function $61ba61605ac0202a$var$getErrorMessage(hook, provider) {
    return `${hook} returned \`undefined\`. Seems you forgot to wrap component within ${provider}`;
}
function $61ba61605ac0202a$export$fd42f52fd3ae1109(options = {}) {
    const { name: name, strict: strict = true, hookName: hookName = "useContext", providerName: providerName = "Provider", errorMessage: errorMessage, defaultValue: defaultValue } = options;
    const Context = (0, $acw62.createContext)(defaultValue);
    Context.displayName = name;
    function useContext() {
        var _a;
        const context = (0, $acw62.useContext)(Context);
        if (!context && strict) {
            const error = new Error(errorMessage != null ? errorMessage : $61ba61605ac0202a$var$getErrorMessage(hookName, providerName));
            error.name = "ContextError";
            (_a = Error.captureStackTrace) == null || _a.call(Error, error, useContext);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext,
        Context
    ];
}



"use client";
var [$cb17b1dba222b22e$var$PortalManagerContextProvider, $cb17b1dba222b22e$export$ef203b29c2cc1f5d] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    strict: false,
    name: "PortalManagerContext"
});
function $cb17b1dba222b22e$export$52c7ef79917c2f38(props) {
    const { children: children, zIndex: zIndex } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($cb17b1dba222b22e$var$PortalManagerContextProvider, {
        value: {
            zIndex: zIndex
        },
        children: children
    });
}
$cb17b1dba222b22e$export$52c7ef79917c2f38.displayName = "PortalManager";



var $acw62 = parcelRequire("acw62");
"use client";
var $79d69f59c8a92bff$export$deebe11a338de063 = Boolean(globalThis == null ? void 0 : globalThis.document) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);





var $acw62 = parcelRequire("acw62");

"use client";
var [$b71276780b6a43df$var$PortalContextProvider, $b71276780b6a43df$var$usePortalContext] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    strict: false,
    name: "PortalContext"
});
var $b71276780b6a43df$var$PORTAL_CLASSNAME = "chakra-portal";
var $b71276780b6a43df$var$PORTAL_SELECTOR = `.chakra-portal`;
var $b71276780b6a43df$var$Container = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "chakra-portal-zIndex",
        style: {
            position: "absolute",
            zIndex: props.zIndex,
            top: 0,
            left: 0,
            right: 0
        },
        children: props.children
    });
var $b71276780b6a43df$var$DefaultPortal = (props)=>{
    const { appendToParentPortal: appendToParentPortal, children: children } = props;
    const [tempNode, setTempNode] = (0, $acw62.useState)(null);
    const portal = (0, $acw62.useRef)(null);
    const [, forceUpdate] = (0, $acw62.useState)({});
    (0, $acw62.useEffect)(()=>forceUpdate({}), []);
    const parentPortal = $b71276780b6a43df$var$usePortalContext();
    const manager = (0, $cb17b1dba222b22e$export$ef203b29c2cc1f5d)();
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (!tempNode) return;
        const doc = tempNode.ownerDocument;
        const host = appendToParentPortal ? parentPortal != null ? parentPortal : doc.body : doc.body;
        if (!host) return;
        portal.current = doc.createElement("div");
        portal.current.className = $b71276780b6a43df$var$PORTAL_CLASSNAME;
        host.appendChild(portal.current);
        forceUpdate({});
        const portalNode = portal.current;
        return ()=>{
            if (host.contains(portalNode)) host.removeChild(portalNode);
        };
    }, [
        tempNode
    ]);
    const _children = (manager == null ? void 0 : manager.zIndex) ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($b71276780b6a43df$var$Container, {
        zIndex: manager == null ? void 0 : manager.zIndex,
        children: children
    }) : children;
    return portal.current ? (0, $11492dca620dcaa5$exports.createPortal)(/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($b71276780b6a43df$var$PortalContextProvider, {
        value: portal.current,
        children: _children
    }), portal.current) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
        ref: (el)=>{
            if (el) setTempNode(el);
        }
    });
};
var $b71276780b6a43df$var$ContainerPortal = (props)=>{
    const { children: children, containerRef: containerRef, appendToParentPortal: appendToParentPortal } = props;
    const containerEl = containerRef.current;
    const host = containerEl != null ? containerEl : typeof window !== "undefined" ? document.body : void 0;
    const portal = (0, $acw62.useMemo)(()=>{
        const node = containerEl == null ? void 0 : containerEl.ownerDocument.createElement("div");
        if (node) node.className = $b71276780b6a43df$var$PORTAL_CLASSNAME;
        return node;
    }, [
        containerEl
    ]);
    const [, forceUpdate] = (0, $acw62.useState)({});
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>forceUpdate({}), []);
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (!portal || !host) return;
        host.appendChild(portal);
        return ()=>{
            host.removeChild(portal);
        };
    }, [
        portal,
        host
    ]);
    if (host && portal) return (0, $11492dca620dcaa5$exports.createPortal)(/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($b71276780b6a43df$var$PortalContextProvider, {
        value: appendToParentPortal ? portal : null,
        children: children
    }), portal);
    return null;
};
function $b71276780b6a43df$export$602eac185826482c(props) {
    const portalProps = {
        appendToParentPortal: true,
        ...props
    };
    const { containerRef: containerRef, ...rest } = portalProps;
    return containerRef ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($b71276780b6a43df$var$ContainerPortal, {
        containerRef: containerRef,
        ...rest
    }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($b71276780b6a43df$var$DefaultPortal, {
        ...rest
    });
}
$b71276780b6a43df$export$602eac185826482c.className = $b71276780b6a43df$var$PORTAL_CLASSNAME;
$b71276780b6a43df$export$602eac185826482c.selector = $b71276780b6a43df$var$PORTAL_SELECTOR;
$b71276780b6a43df$export$602eac185826482c.displayName = "Portal";





var $acw62 = parcelRequire("acw62");
"use client";
function $5f6bf330f809db0e$export$93d4e7f90805808f() {
    const theme = (0, $acw62.useContext)((0, $0fe24a6591b39473$export$971d5caa766a69d7));
    if (!theme) throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
    return theme;
}



"use client";
function $d637f68b5e43da19$export$a513a93efd9ab8a7() {
    const colorModeResult = (0, $b80b1cf263c5808a$export$20f3076712c8dfa)();
    const theme = (0, $5f6bf330f809db0e$export$93d4e7f90805808f)();
    return {
        ...colorModeResult,
        theme: theme
    };
}
function $d637f68b5e43da19$var$getBreakpointValue(theme, value, fallback) {
    var _a, _b;
    if (value == null) return value;
    const getValue = (val)=>{
        var _a2, _b2;
        return (_b2 = (_a2 = theme.__breakpoints) == null ? void 0 : _a2.asArray) == null ? void 0 : _b2[val];
    };
    return (_b = (_a = getValue(value)) != null ? _a : getValue(fallback)) != null ? _b : fallback;
}
function $d637f68b5e43da19$var$getTokenValue(theme, value, fallback) {
    var _a, _b;
    if (value == null) return value;
    const getValue = (val)=>{
        var _a2, _b2;
        return (_b2 = (_a2 = theme.__cssMap) == null ? void 0 : _a2[val]) == null ? void 0 : _b2.value;
    };
    return (_b = (_a = getValue(value)) != null ? _a : getValue(fallback)) != null ? _b : fallback;
}
function $d637f68b5e43da19$export$31dcd79391e423fe(scale, token, fallback) {
    const theme = (0, $5f6bf330f809db0e$export$93d4e7f90805808f)();
    return $d637f68b5e43da19$export$257b2d10b709d8ef(scale, token, fallback)(theme);
}
function $d637f68b5e43da19$export$257b2d10b709d8ef(scale, token, fallback) {
    const _token = Array.isArray(token) ? token : [
        token
    ];
    const _fallback = Array.isArray(fallback) ? fallback : [
        fallback
    ];
    return (theme)=>{
        const fallbackArr = _fallback.filter(Boolean);
        const result = _token.map((token2, index)=>{
            var _a, _b;
            if (scale === "breakpoints") return $d637f68b5e43da19$var$getBreakpointValue(theme, token2, (_a = fallbackArr[index]) != null ? _a : token2);
            const path = `${scale}.${token2}`;
            return $d637f68b5e43da19$var$getTokenValue(theme, path, (_b = fallbackArr[index]) != null ? _b : token2);
        });
        return Array.isArray(token) ? result : result[0];
    };
}



// src/extend-theme.ts
// src/utils/is-chakra-theme.ts

var $aef2905091b67153$export$1fad0bb5bac74e8f = [
    "borders",
    "breakpoints",
    "colors",
    "components",
    "config",
    "direction",
    "fonts",
    "fontSizes",
    "fontWeights",
    "letterSpacings",
    "lineHeights",
    "radii",
    "shadows",
    "sizes",
    "space",
    "styles",
    "transition",
    "zIndices"
];
function $aef2905091b67153$export$73a6ae01926a4f0e(unit) {
    if (!(0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(unit)) return false;
    return $aef2905091b67153$export$1fad0bb5bac74e8f.every((propertyName)=>Object.prototype.hasOwnProperty.call(unit, propertyName));
}


// src/foundations/transition.ts
var $eb8fb47cfbaf0bb1$var$transitionProperty = {
    common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
    colors: "background-color, border-color, color, fill, stroke",
    dimensions: "width, height",
    position: "left, right, top, bottom",
    background: "background-color, background-image, background-position"
};
var $eb8fb47cfbaf0bb1$var$transitionTimingFunction = {
    "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
    "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
    "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
};
var $eb8fb47cfbaf0bb1$var$transitionDuration = {
    "ultra-fast": "50ms",
    faster: "100ms",
    fast: "150ms",
    normal: "200ms",
    slow: "300ms",
    slower: "400ms",
    "ultra-slow": "500ms"
};
var $eb8fb47cfbaf0bb1$var$transition = {
    property: $eb8fb47cfbaf0bb1$var$transitionProperty,
    easing: $eb8fb47cfbaf0bb1$var$transitionTimingFunction,
    duration: $eb8fb47cfbaf0bb1$var$transitionDuration
};
var $eb8fb47cfbaf0bb1$export$6b266f9cfc4b7bb8 = $eb8fb47cfbaf0bb1$var$transition;


// src/foundations/z-index.ts
var $5c128a6478f2f777$var$zIndices = {
    hide: -1,
    auto: "auto",
    base: 0,
    docked: 10,
    dropdown: 1e3,
    sticky: 1100,
    banner: 1200,
    overlay: 1300,
    modal: 1400,
    popover: 1500,
    skipLink: 1600,
    toast: 1700,
    tooltip: 1800
};
var $5c128a6478f2f777$export$d9d5ef55fed42171 = $5c128a6478f2f777$var$zIndices;


// src/foundations/borders.ts
var $8c29ebe7b5760de6$var$borders = {
    none: 0,
    "1px": "1px solid",
    "2px": "2px solid",
    "4px": "4px solid",
    "8px": "8px solid"
};
var $8c29ebe7b5760de6$export$196bfcf31ca4deb7 = $8c29ebe7b5760de6$var$borders;


// src/foundations/breakpoints.ts
var $3e302c9a7cffe64d$var$breakpoints = {
    base: "0em",
    sm: "30em",
    md: "48em",
    lg: "62em",
    xl: "80em",
    "2xl": "96em"
};
var $3e302c9a7cffe64d$export$d0717e75346b884a = $3e302c9a7cffe64d$var$breakpoints;


// src/foundations/colors.ts
var $f42a724eb45b3bb9$var$colors = {
    transparent: "transparent",
    current: "currentColor",
    black: "#000000",
    white: "#FFFFFF",
    whiteAlpha: {
        50: "rgba(255, 255, 255, 0.04)",
        100: "rgba(255, 255, 255, 0.06)",
        200: "rgba(255, 255, 255, 0.08)",
        300: "rgba(255, 255, 255, 0.16)",
        400: "rgba(255, 255, 255, 0.24)",
        500: "rgba(255, 255, 255, 0.36)",
        600: "rgba(255, 255, 255, 0.48)",
        700: "rgba(255, 255, 255, 0.64)",
        800: "rgba(255, 255, 255, 0.80)",
        900: "rgba(255, 255, 255, 0.92)"
    },
    blackAlpha: {
        50: "rgba(0, 0, 0, 0.04)",
        100: "rgba(0, 0, 0, 0.06)",
        200: "rgba(0, 0, 0, 0.08)",
        300: "rgba(0, 0, 0, 0.16)",
        400: "rgba(0, 0, 0, 0.24)",
        500: "rgba(0, 0, 0, 0.36)",
        600: "rgba(0, 0, 0, 0.48)",
        700: "rgba(0, 0, 0, 0.64)",
        800: "rgba(0, 0, 0, 0.80)",
        900: "rgba(0, 0, 0, 0.92)"
    },
    gray: {
        50: "#F7FAFC",
        100: "#EDF2F7",
        200: "#E2E8F0",
        300: "#CBD5E0",
        400: "#A0AEC0",
        500: "#718096",
        600: "#4A5568",
        700: "#2D3748",
        800: "#1A202C",
        900: "#171923"
    },
    red: {
        50: "#FFF5F5",
        100: "#FED7D7",
        200: "#FEB2B2",
        300: "#FC8181",
        400: "#F56565",
        500: "#E53E3E",
        600: "#C53030",
        700: "#9B2C2C",
        800: "#822727",
        900: "#63171B"
    },
    orange: {
        50: "#FFFAF0",
        100: "#FEEBC8",
        200: "#FBD38D",
        300: "#F6AD55",
        400: "#ED8936",
        500: "#DD6B20",
        600: "#C05621",
        700: "#9C4221",
        800: "#7B341E",
        900: "#652B19"
    },
    yellow: {
        50: "#FFFFF0",
        100: "#FEFCBF",
        200: "#FAF089",
        300: "#F6E05E",
        400: "#ECC94B",
        500: "#D69E2E",
        600: "#B7791F",
        700: "#975A16",
        800: "#744210",
        900: "#5F370E"
    },
    green: {
        50: "#F0FFF4",
        100: "#C6F6D5",
        200: "#9AE6B4",
        300: "#68D391",
        400: "#48BB78",
        500: "#38A169",
        600: "#2F855A",
        700: "#276749",
        800: "#22543D",
        900: "#1C4532"
    },
    teal: {
        50: "#E6FFFA",
        100: "#B2F5EA",
        200: "#81E6D9",
        300: "#4FD1C5",
        400: "#38B2AC",
        500: "#319795",
        600: "#2C7A7B",
        700: "#285E61",
        800: "#234E52",
        900: "#1D4044"
    },
    blue: {
        50: "#ebf8ff",
        100: "#bee3f8",
        200: "#90cdf4",
        300: "#63b3ed",
        400: "#4299e1",
        500: "#3182ce",
        600: "#2b6cb0",
        700: "#2c5282",
        800: "#2a4365",
        900: "#1A365D"
    },
    cyan: {
        50: "#EDFDFD",
        100: "#C4F1F9",
        200: "#9DECF9",
        300: "#76E4F7",
        400: "#0BC5EA",
        500: "#00B5D8",
        600: "#00A3C4",
        700: "#0987A0",
        800: "#086F83",
        900: "#065666"
    },
    purple: {
        50: "#FAF5FF",
        100: "#E9D8FD",
        200: "#D6BCFA",
        300: "#B794F4",
        400: "#9F7AEA",
        500: "#805AD5",
        600: "#6B46C1",
        700: "#553C9A",
        800: "#44337A",
        900: "#322659"
    },
    pink: {
        50: "#FFF5F7",
        100: "#FED7E2",
        200: "#FBB6CE",
        300: "#F687B3",
        400: "#ED64A6",
        500: "#D53F8C",
        600: "#B83280",
        700: "#97266D",
        800: "#702459",
        900: "#521B41"
    },
    linkedin: {
        50: "#E8F4F9",
        100: "#CFEDFB",
        200: "#9BDAF3",
        300: "#68C7EC",
        400: "#34B3E4",
        500: "#00A0DC",
        600: "#008CC9",
        700: "#0077B5",
        800: "#005E93",
        900: "#004471"
    },
    facebook: {
        50: "#E8F4F9",
        100: "#D9DEE9",
        200: "#B7C2DA",
        300: "#6482C0",
        400: "#4267B2",
        500: "#385898",
        600: "#314E89",
        700: "#29487D",
        800: "#223B67",
        900: "#1E355B"
    },
    messenger: {
        50: "#D0E6FF",
        100: "#B9DAFF",
        200: "#A2CDFF",
        300: "#7AB8FF",
        400: "#2E90FF",
        500: "#0078FF",
        600: "#0063D1",
        700: "#0052AC",
        800: "#003C7E",
        900: "#002C5C"
    },
    whatsapp: {
        50: "#dffeec",
        100: "#b9f5d0",
        200: "#90edb3",
        300: "#65e495",
        400: "#3cdd78",
        500: "#22c35e",
        600: "#179848",
        700: "#0c6c33",
        800: "#01421c",
        900: "#001803"
    },
    twitter: {
        50: "#E5F4FD",
        100: "#C8E9FB",
        200: "#A8DCFA",
        300: "#83CDF7",
        400: "#57BBF5",
        500: "#1DA1F2",
        600: "#1A94DA",
        700: "#1681BF",
        800: "#136B9E",
        900: "#0D4D71"
    },
    telegram: {
        50: "#E3F2F9",
        100: "#C5E4F3",
        200: "#A2D4EC",
        300: "#7AC1E4",
        400: "#47A9DA",
        500: "#0088CC",
        600: "#007AB8",
        700: "#006BA1",
        800: "#005885",
        900: "#003F5E"
    }
};
var $f42a724eb45b3bb9$export$59d2d4241383b416 = $f42a724eb45b3bb9$var$colors;


// src/foundations/radius.ts
var $beb2548c75cdd2c4$var$radii = {
    none: "0",
    sm: "0.125rem",
    base: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "0.75rem",
    "2xl": "1rem",
    "3xl": "1.5rem",
    full: "9999px"
};
var $beb2548c75cdd2c4$export$9aaceac1356558f4 = $beb2548c75cdd2c4$var$radii;


// src/foundations/shadows.ts
var $a1d552cef6acc66c$var$shadows = {
    xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
    inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
    none: "none",
    "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
};
var $a1d552cef6acc66c$export$e70f92e6000288b2 = $a1d552cef6acc66c$var$shadows;


// src/foundations/blur.ts
var $f5367ce162a53076$var$blur = {
    none: 0,
    sm: "4px",
    base: "8px",
    md: "12px",
    lg: "16px",
    xl: "24px",
    "2xl": "40px",
    "3xl": "64px"
};
var $f5367ce162a53076$export$6b4e890355bf1451 = $f5367ce162a53076$var$blur;


// src/foundations/typography.ts
var $bba87cd2f18bf49d$var$typography = {
    letterSpacings: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
    },
    lineHeights: {
        normal: "normal",
        none: 1,
        shorter: 1.25,
        short: 1.375,
        base: 1.5,
        tall: 1.625,
        taller: "2",
        "3": ".75rem",
        "4": "1rem",
        "5": "1.25rem",
        "6": "1.5rem",
        "7": "1.75rem",
        "8": "2rem",
        "9": "2.25rem",
        "10": "2.5rem"
    },
    fontWeights: {
        hairline: 100,
        thin: 200,
        light: 300,
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800,
        black: 900
    },
    fonts: {
        heading: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        body: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        mono: `SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`
    },
    fontSizes: {
        "3xs": "0.45rem",
        "2xs": "0.625rem",
        xs: "0.75rem",
        sm: "0.875rem",
        md: "1rem",
        lg: "1.125rem",
        xl: "1.25rem",
        "2xl": "1.5rem",
        "3xl": "1.875rem",
        "4xl": "2.25rem",
        "5xl": "3rem",
        "6xl": "3.75rem",
        "7xl": "4.5rem",
        "8xl": "6rem",
        "9xl": "8rem"
    }
};
var $bba87cd2f18bf49d$export$d7c5d8884f83c8db = $bba87cd2f18bf49d$var$typography;


// src/foundations/spacing.ts
var $143dd6fc2d04db62$export$5458b64234d1333c = {
    px: "1px",
    0.5: "0.125rem",
    1: "0.25rem",
    1.5: "0.375rem",
    2: "0.5rem",
    2.5: "0.625rem",
    3: "0.75rem",
    3.5: "0.875rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem",
    12: "3rem",
    14: "3.5rem",
    16: "4rem",
    20: "5rem",
    24: "6rem",
    28: "7rem",
    32: "8rem",
    36: "9rem",
    40: "10rem",
    44: "11rem",
    48: "12rem",
    52: "13rem",
    56: "14rem",
    60: "15rem",
    64: "16rem",
    72: "18rem",
    80: "20rem",
    96: "24rem"
};


// src/foundations/sizes.ts
var $5013d2c172615a00$var$largeSizes = {
    max: "max-content",
    min: "min-content",
    full: "100%",
    "3xs": "14rem",
    "2xs": "16rem",
    xs: "20rem",
    sm: "24rem",
    md: "28rem",
    lg: "32rem",
    xl: "36rem",
    "2xl": "42rem",
    "3xl": "48rem",
    "4xl": "56rem",
    "5xl": "64rem",
    "6xl": "72rem",
    "7xl": "80rem",
    "8xl": "90rem",
    prose: "60ch"
};
var $5013d2c172615a00$var$container = {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px"
};
var $5013d2c172615a00$var$sizes = {
    ...(0, $143dd6fc2d04db62$export$5458b64234d1333c),
    ...$5013d2c172615a00$var$largeSizes,
    container: $5013d2c172615a00$var$container
};
var $5013d2c172615a00$export$d7d4c689520cc141 = $5013d2c172615a00$var$sizes;



// src/foundations/index.ts
var $0f31d8688ec7fbf0$export$651a0b7b10dae380 = {
    breakpoints: (0, $3e302c9a7cffe64d$export$d0717e75346b884a),
    zIndices: (0, $5c128a6478f2f777$export$d9d5ef55fed42171),
    radii: (0, $beb2548c75cdd2c4$export$9aaceac1356558f4),
    blur: (0, $f5367ce162a53076$export$6b4e890355bf1451),
    colors: (0, $f42a724eb45b3bb9$export$59d2d4241383b416),
    ...(0, $bba87cd2f18bf49d$export$d7c5d8884f83c8db),
    sizes: (0, $5013d2c172615a00$export$d7d4c689520cc141),
    shadows: (0, $a1d552cef6acc66c$export$e70f92e6000288b2),
    space: (0, $143dd6fc2d04db62$export$5458b64234d1333c),
    borders: (0, $8c29ebe7b5760de6$export$196bfcf31ca4deb7),
    transition: (0, $eb8fb47cfbaf0bb1$export$6b266f9cfc4b7bb8)
};










// src/components/stepper.ts

var { defineMultiStyleConfig: $b8eda56a5e8ca863$var$defineMultiStyleConfig, definePartsStyle: $b8eda56a5e8ca863$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)([
    "stepper",
    "step",
    "title",
    "description",
    "indicator",
    "separator",
    "icon",
    "number"
]);
var $b8eda56a5e8ca863$var$$size = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("stepper-indicator-size");
var $b8eda56a5e8ca863$var$$iconSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("stepper-icon-size");
var $b8eda56a5e8ca863$var$$titleFontSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("stepper-title-font-size");
var $b8eda56a5e8ca863$var$$descFontSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("stepper-description-font-size");
var $b8eda56a5e8ca863$var$$accentColor = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("stepper-accent-color");
var $b8eda56a5e8ca863$var$baseStyle = $b8eda56a5e8ca863$var$definePartsStyle(({ colorScheme: c })=>({
        stepper: {
            display: "flex",
            justifyContent: "space-between",
            gap: "4",
            "&[data-orientation=vertical]": {
                flexDirection: "column",
                alignItems: "flex-start"
            },
            "&[data-orientation=horizontal]": {
                flexDirection: "row",
                alignItems: "center"
            },
            [$b8eda56a5e8ca863$var$$accentColor.variable]: `colors.${c}.500`,
            _dark: {
                [$b8eda56a5e8ca863$var$$accentColor.variable]: `colors.${c}.200`
            }
        },
        title: {
            fontSize: $b8eda56a5e8ca863$var$$titleFontSize.reference,
            fontWeight: "medium"
        },
        description: {
            fontSize: $b8eda56a5e8ca863$var$$descFontSize.reference,
            color: "chakra-subtle-text"
        },
        number: {
            fontSize: $b8eda56a5e8ca863$var$$titleFontSize.reference
        },
        step: {
            flexShrink: 0,
            position: "relative",
            display: "flex",
            gap: "2",
            "&[data-orientation=horizontal]": {
                alignItems: "center"
            },
            flex: "1",
            "&:last-of-type:not([data-stretch])": {
                flex: "initial"
            }
        },
        icon: {
            flexShrink: 0,
            width: $b8eda56a5e8ca863$var$$iconSize.reference,
            height: $b8eda56a5e8ca863$var$$iconSize.reference
        },
        indicator: {
            flexShrink: 0,
            borderRadius: "full",
            width: $b8eda56a5e8ca863$var$$size.reference,
            height: $b8eda56a5e8ca863$var$$size.reference,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "&[data-status=active]": {
                borderWidth: "2px",
                borderColor: $b8eda56a5e8ca863$var$$accentColor.reference
            },
            "&[data-status=complete]": {
                bg: $b8eda56a5e8ca863$var$$accentColor.reference,
                color: "chakra-inverse-text"
            },
            "&[data-status=incomplete]": {
                borderWidth: "2px"
            }
        },
        separator: {
            bg: "chakra-border-color",
            flex: "1",
            "&[data-status=complete]": {
                bg: $b8eda56a5e8ca863$var$$accentColor.reference
            },
            "&[data-orientation=horizontal]": {
                width: "100%",
                height: "2px",
                marginStart: "2"
            },
            "&[data-orientation=vertical]": {
                width: "2px",
                position: "absolute",
                height: "100%",
                maxHeight: `calc(100% - ${$b8eda56a5e8ca863$var$$size.reference} - 8px)`,
                top: `calc(${$b8eda56a5e8ca863$var$$size.reference} + 4px)`,
                insetStart: `calc(${$b8eda56a5e8ca863$var$$size.reference} / 2 - 1px)`
            }
        }
    }));
var $b8eda56a5e8ca863$export$54c84d54375c8d75 = $b8eda56a5e8ca863$var$defineMultiStyleConfig({
    baseStyle: $b8eda56a5e8ca863$var$baseStyle,
    sizes: {
        xs: $b8eda56a5e8ca863$var$definePartsStyle({
            stepper: {
                [$b8eda56a5e8ca863$var$$size.variable]: "sizes.4",
                [$b8eda56a5e8ca863$var$$iconSize.variable]: "sizes.3",
                [$b8eda56a5e8ca863$var$$titleFontSize.variable]: "fontSizes.xs",
                [$b8eda56a5e8ca863$var$$descFontSize.variable]: "fontSizes.xs"
            }
        }),
        sm: $b8eda56a5e8ca863$var$definePartsStyle({
            stepper: {
                [$b8eda56a5e8ca863$var$$size.variable]: "sizes.6",
                [$b8eda56a5e8ca863$var$$iconSize.variable]: "sizes.4",
                [$b8eda56a5e8ca863$var$$titleFontSize.variable]: "fontSizes.sm",
                [$b8eda56a5e8ca863$var$$descFontSize.variable]: "fontSizes.xs"
            }
        }),
        md: $b8eda56a5e8ca863$var$definePartsStyle({
            stepper: {
                [$b8eda56a5e8ca863$var$$size.variable]: "sizes.8",
                [$b8eda56a5e8ca863$var$$iconSize.variable]: "sizes.5",
                [$b8eda56a5e8ca863$var$$titleFontSize.variable]: "fontSizes.md",
                [$b8eda56a5e8ca863$var$$descFontSize.variable]: "fontSizes.sm"
            }
        }),
        lg: $b8eda56a5e8ca863$var$definePartsStyle({
            stepper: {
                [$b8eda56a5e8ca863$var$$size.variable]: "sizes.10",
                [$b8eda56a5e8ca863$var$$iconSize.variable]: "sizes.6",
                [$b8eda56a5e8ca863$var$$titleFontSize.variable]: "fontSizes.lg",
                [$b8eda56a5e8ca863$var$$descFontSize.variable]: "fontSizes.md"
            }
        })
    },
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});


// src/components/switch.ts
// src/anatomy.ts
function $113cb1d974d2c079$export$477202748c7242bf(name, map = {}) {
    let called = false;
    function assert() {
        if (!called) {
            called = true;
            return;
        }
        throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");
    }
    function parts(...values) {
        assert();
        for (const part of values)map[part] = toPart(part);
        return $113cb1d974d2c079$export$477202748c7242bf(name, map);
    }
    function extend(...parts2) {
        for (const part of parts2){
            if (part in map) continue;
            map[part] = toPart(part);
        }
        return $113cb1d974d2c079$export$477202748c7242bf(name, map);
    }
    function selectors() {
        const value = Object.fromEntries(Object.entries(map).map(([key, part])=>[
                key,
                part.selector
            ]));
        return value;
    }
    function classnames() {
        const value = Object.fromEntries(Object.entries(map).map(([key, part])=>[
                key,
                part.className
            ]));
        return value;
    }
    function toPart(part) {
        const el = [
            "container",
            "root"
        ].includes(part != null ? part : "") ? [
            name
        ] : [
            name,
            part
        ];
        const attr = el.filter(Boolean).join("__");
        const className = `chakra-${attr}`;
        const partObj = {
            className: className,
            selector: `.${className}`,
            toString: ()=>part
        };
        return partObj;
    }
    const __type = {};
    return {
        parts: parts,
        toPart: toPart,
        extend: extend,
        selectors: selectors,
        classnames: classnames,
        get keys () {
            return Object.keys(map);
        },
        __type: __type
    };
}


// src/components.ts
var $f87e4685273d35d8$export$377a77e99e7c73a5 = (0, $113cb1d974d2c079$export$477202748c7242bf)("accordion").parts("root", "container", "button", "panel").extend("icon");
var $f87e4685273d35d8$export$fc51889fa4de265a = (0, $113cb1d974d2c079$export$477202748c7242bf)("alert").parts("title", "description", "container").extend("icon", "spinner");
var $f87e4685273d35d8$export$60f8655d889e17c7 = (0, $113cb1d974d2c079$export$477202748c7242bf)("avatar").parts("label", "badge", "container").extend("excessLabel", "group");
var $f87e4685273d35d8$export$2fb03f744a6ecf93 = (0, $113cb1d974d2c079$export$477202748c7242bf)("breadcrumb").parts("link", "item", "container").extend("separator");
var $f87e4685273d35d8$export$1699c5cb20c07888 = (0, $113cb1d974d2c079$export$477202748c7242bf)("button").parts();
var $f87e4685273d35d8$export$21946b04497ed6ac = (0, $113cb1d974d2c079$export$477202748c7242bf)("checkbox").parts("control", "icon", "container").extend("label");
var $f87e4685273d35d8$export$2c953111278f3272 = (0, $113cb1d974d2c079$export$477202748c7242bf)("progress").parts("track", "filledTrack").extend("label");
var $f87e4685273d35d8$export$d3f4aaa4b0f2907a = (0, $113cb1d974d2c079$export$477202748c7242bf)("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var $f87e4685273d35d8$export$2813c9511eeab082 = (0, $113cb1d974d2c079$export$477202748c7242bf)("editable").parts("preview", "input", "textarea");
var $f87e4685273d35d8$export$4b243e3f209a7e5e = (0, $113cb1d974d2c079$export$477202748c7242bf)("form").parts("container", "requiredIndicator", "helperText");
var $f87e4685273d35d8$export$bb18c440c00e82d9 = (0, $113cb1d974d2c079$export$477202748c7242bf)("formError").parts("text", "icon");
var $f87e4685273d35d8$export$1ffeb100b532f46d = (0, $113cb1d974d2c079$export$477202748c7242bf)("input").parts("addon", "field", "element", "group");
var $f87e4685273d35d8$export$12b3a655a94374ed = (0, $113cb1d974d2c079$export$477202748c7242bf)("list").parts("container", "item", "icon");
var $f87e4685273d35d8$export$e251092a5dcb1329 = (0, $113cb1d974d2c079$export$477202748c7242bf)("menu").parts("button", "list", "item").extend("groupTitle", "icon", "command", "divider");
var $f87e4685273d35d8$export$34e33beb8d992ac2 = (0, $113cb1d974d2c079$export$477202748c7242bf)("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var $f87e4685273d35d8$export$859cc7ca3200df97 = (0, $113cb1d974d2c079$export$477202748c7242bf)("numberinput").parts("root", "field", "stepperGroup", "stepper");
var $f87e4685273d35d8$export$12bb869d7991ac50 = (0, $113cb1d974d2c079$export$477202748c7242bf)("pininput").parts("field");
var $f87e4685273d35d8$export$afda07d12cd4337d = (0, $113cb1d974d2c079$export$477202748c7242bf)("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton");
var $f87e4685273d35d8$export$ba6328c242bd649c = (0, $113cb1d974d2c079$export$477202748c7242bf)("progress").parts("label", "filledTrack", "track");
var $f87e4685273d35d8$export$d28d06d0e29ef022 = (0, $113cb1d974d2c079$export$477202748c7242bf)("radio").parts("container", "control", "label");
var $f87e4685273d35d8$export$17993f0be9538b5a = (0, $113cb1d974d2c079$export$477202748c7242bf)("select").parts("field", "icon");
var $f87e4685273d35d8$export$c21b4b3f8b239f32 = (0, $113cb1d974d2c079$export$477202748c7242bf)("slider").parts("container", "track", "thumb", "filledTrack", "mark");
var $f87e4685273d35d8$export$2cfbad67ae6ee421 = (0, $113cb1d974d2c079$export$477202748c7242bf)("stat").parts("container", "label", "helpText", "number", "icon");
var $f87e4685273d35d8$export$921c1a2d1ce1e86a = (0, $113cb1d974d2c079$export$477202748c7242bf)("switch").parts("container", "track", "thumb");
var $f87e4685273d35d8$export$8b1b9cdd5db9f5fd = (0, $113cb1d974d2c079$export$477202748c7242bf)("table").parts("table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption");
var $f87e4685273d35d8$export$97383552563be58d = (0, $113cb1d974d2c079$export$477202748c7242bf)("tabs").parts("root", "tab", "tablist", "tabpanel", "tabpanels", "indicator");
var $f87e4685273d35d8$export$4c2f5f7f2ea94a8e = (0, $113cb1d974d2c079$export$477202748c7242bf)("tag").parts("container", "label", "closeButton");
var $f87e4685273d35d8$export$487a447ffa5755b6 = (0, $113cb1d974d2c079$export$477202748c7242bf)("card").parts("container", "header", "body", "footer");



// src/css-calc.ts

function $2ef820b9f4ef8e93$var$toRef(operand) {
    if ((0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
var $2ef820b9f4ef8e93$var$toExpr = (operator, ...operands)=>operands.map($2ef820b9f4ef8e93$var$toRef).join(` ${operator} `).replace(/calc/g, "");
var $2ef820b9f4ef8e93$var$add = (...operands)=>`calc(${$2ef820b9f4ef8e93$var$toExpr("+", ...operands)})`;
var $2ef820b9f4ef8e93$var$subtract = (...operands)=>`calc(${$2ef820b9f4ef8e93$var$toExpr("-", ...operands)})`;
var $2ef820b9f4ef8e93$var$multiply = (...operands)=>`calc(${$2ef820b9f4ef8e93$var$toExpr("*", ...operands)})`;
var $2ef820b9f4ef8e93$var$divide = (...operands)=>`calc(${$2ef820b9f4ef8e93$var$toExpr("/", ...operands)})`;
var $2ef820b9f4ef8e93$var$negate = (x)=>{
    const value = $2ef820b9f4ef8e93$var$toRef(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    return $2ef820b9f4ef8e93$var$multiply(value, -1);
};
var $2ef820b9f4ef8e93$export$42bfa9b2d4dad91a = Object.assign((x)=>({
        add: (...operands)=>$2ef820b9f4ef8e93$export$42bfa9b2d4dad91a($2ef820b9f4ef8e93$var$add(x, ...operands)),
        subtract: (...operands)=>$2ef820b9f4ef8e93$export$42bfa9b2d4dad91a($2ef820b9f4ef8e93$var$subtract(x, ...operands)),
        multiply: (...operands)=>$2ef820b9f4ef8e93$export$42bfa9b2d4dad91a($2ef820b9f4ef8e93$var$multiply(x, ...operands)),
        divide: (...operands)=>$2ef820b9f4ef8e93$export$42bfa9b2d4dad91a($2ef820b9f4ef8e93$var$divide(x, ...operands)),
        negate: ()=>$2ef820b9f4ef8e93$export$42bfa9b2d4dad91a($2ef820b9f4ef8e93$var$negate(x)),
        toString: ()=>x.toString()
    }), {
    add: $2ef820b9f4ef8e93$var$add,
    subtract: $2ef820b9f4ef8e93$var$subtract,
    multiply: $2ef820b9f4ef8e93$var$multiply,
    divide: $2ef820b9f4ef8e93$var$divide,
    negate: $2ef820b9f4ef8e93$var$negate
});

// src/css-var.ts
function $591785a32740c673$export$2ad0182371401ea4(value) {
    return !Number.isInteger(parseFloat(value.toString()));
}
function $591785a32740c673$var$replaceWhiteSpace(value, replaceValue = "-") {
    return value.replace(/\s+/g, replaceValue);
}
function $591785a32740c673$var$escape(value) {
    const valueStr = $591785a32740c673$var$replaceWhiteSpace(value.toString());
    if (valueStr.includes("\\.")) return value;
    return $591785a32740c673$export$2ad0182371401ea4(value) ? valueStr.replace(".", `\\.`) : value;
}
function $591785a32740c673$export$9748efee331ec573(value, prefix = "") {
    return [
        prefix,
        $591785a32740c673$var$escape(value)
    ].filter(Boolean).join("-");
}
function $591785a32740c673$export$44410db3a43190e8(name, fallback) {
    return `var(${$591785a32740c673$var$escape(name)}${fallback ? `, ${fallback}` : ""})`;
}
function $591785a32740c673$export$e2ffa342f278b3a3(value, prefix = "") {
    return `--${$591785a32740c673$export$9748efee331ec573(value, prefix)}`;
}
function $591785a32740c673$export$8b4981022bd80a4e(name, options) {
    const cssVariable = $591785a32740c673$export$e2ffa342f278b3a3(name, options == null ? void 0 : options.prefix);
    return {
        variable: cssVariable,
        reference: $591785a32740c673$export$44410db3a43190e8(cssVariable, $591785a32740c673$var$getFallback(options == null ? void 0 : options.fallback))
    };
}
function $591785a32740c673$var$getFallback(fallback) {
    if (typeof fallback === "string") return fallback;
    return fallback == null ? void 0 : fallback.reference;
}


var { defineMultiStyleConfig: $994d42e36253a2ed$var$defineMultiStyleConfig, definePartsStyle: $994d42e36253a2ed$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$921c1a2d1ce1e86a).keys);
var $994d42e36253a2ed$var$$width = (0, $591785a32740c673$export$8b4981022bd80a4e)("switch-track-width");
var $994d42e36253a2ed$var$$height = (0, $591785a32740c673$export$8b4981022bd80a4e)("switch-track-height");
var $994d42e36253a2ed$var$$diff = (0, $591785a32740c673$export$8b4981022bd80a4e)("switch-track-diff");
var $994d42e36253a2ed$var$diffValue = (0, $2ef820b9f4ef8e93$export$42bfa9b2d4dad91a).subtract($994d42e36253a2ed$var$$width, $994d42e36253a2ed$var$$height);
var $994d42e36253a2ed$var$$translateX = (0, $591785a32740c673$export$8b4981022bd80a4e)("switch-thumb-x");
var $994d42e36253a2ed$var$$bg = (0, $591785a32740c673$export$8b4981022bd80a4e)("switch-bg");
var $994d42e36253a2ed$var$baseStyleTrack = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        borderRadius: "full",
        p: "0.5",
        width: [
            $994d42e36253a2ed$var$$width.reference
        ],
        height: [
            $994d42e36253a2ed$var$$height.reference
        ],
        transitionProperty: "common",
        transitionDuration: "fast",
        [$994d42e36253a2ed$var$$bg.variable]: "colors.gray.300",
        _dark: {
            [$994d42e36253a2ed$var$$bg.variable]: "colors.whiteAlpha.400"
        },
        _focusVisible: {
            boxShadow: "outline"
        },
        _disabled: {
            opacity: 0.4,
            cursor: "not-allowed"
        },
        _checked: {
            [$994d42e36253a2ed$var$$bg.variable]: `colors.${c}.500`,
            _dark: {
                [$994d42e36253a2ed$var$$bg.variable]: `colors.${c}.200`
            }
        },
        bg: $994d42e36253a2ed$var$$bg.reference
    };
});
var $994d42e36253a2ed$var$baseStyleThumb = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "white",
    transitionProperty: "transform",
    transitionDuration: "normal",
    borderRadius: "inherit",
    width: [
        $994d42e36253a2ed$var$$height.reference
    ],
    height: [
        $994d42e36253a2ed$var$$height.reference
    ],
    _checked: {
        transform: `translateX(${$994d42e36253a2ed$var$$translateX.reference})`
    }
});
var $994d42e36253a2ed$var$baseStyle = $994d42e36253a2ed$var$definePartsStyle((props)=>({
        container: {
            [$994d42e36253a2ed$var$$diff.variable]: $994d42e36253a2ed$var$diffValue,
            [$994d42e36253a2ed$var$$translateX.variable]: $994d42e36253a2ed$var$$diff.reference,
            _rtl: {
                [$994d42e36253a2ed$var$$translateX.variable]: (0, $2ef820b9f4ef8e93$export$42bfa9b2d4dad91a)($994d42e36253a2ed$var$$diff).negate().toString()
            }
        },
        track: $994d42e36253a2ed$var$baseStyleTrack(props),
        thumb: $994d42e36253a2ed$var$baseStyleThumb
    }));
var $994d42e36253a2ed$var$sizes = {
    sm: $994d42e36253a2ed$var$definePartsStyle({
        container: {
            [$994d42e36253a2ed$var$$width.variable]: "1.375rem",
            [$994d42e36253a2ed$var$$height.variable]: "sizes.3"
        }
    }),
    md: $994d42e36253a2ed$var$definePartsStyle({
        container: {
            [$994d42e36253a2ed$var$$width.variable]: "1.875rem",
            [$994d42e36253a2ed$var$$height.variable]: "sizes.4"
        }
    }),
    lg: $994d42e36253a2ed$var$definePartsStyle({
        container: {
            [$994d42e36253a2ed$var$$width.variable]: "2.875rem",
            [$994d42e36253a2ed$var$$height.variable]: "sizes.6"
        }
    })
};
var $994d42e36253a2ed$export$6856b73e98185bff = $994d42e36253a2ed$var$defineMultiStyleConfig({
    baseStyle: $994d42e36253a2ed$var$baseStyle,
    sizes: $994d42e36253a2ed$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});


// src/components/table.ts


// src/component.ts
function $6eb225f883147347$export$549ff81930776885(light, dark) {
    return (props)=>props.colorMode === "dark" ? dark : light;
}
function $6eb225f883147347$export$f3eec17ee6065eee(options) {
    const { orientation: orientation, vertical: vertical, horizontal: horizontal } = options;
    if (!orientation) return {};
    return orientation === "vertical" ? vertical : horizontal;
}


var { defineMultiStyleConfig: $2a4c99e2adafaa9d$var$defineMultiStyleConfig, definePartsStyle: $2a4c99e2adafaa9d$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$8b1b9cdd5db9f5fd).keys);
var $2a4c99e2adafaa9d$var$baseStyle = $2a4c99e2adafaa9d$var$definePartsStyle({
    table: {
        fontVariantNumeric: "lining-nums tabular-nums",
        borderCollapse: "collapse",
        width: "full"
    },
    th: {
        fontFamily: "heading",
        fontWeight: "bold",
        textTransform: "uppercase",
        letterSpacing: "wider",
        textAlign: "start"
    },
    td: {
        textAlign: "start"
    },
    caption: {
        mt: 4,
        fontFamily: "heading",
        textAlign: "center",
        fontWeight: "medium"
    }
});
var $2a4c99e2adafaa9d$var$numericStyles = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    "&[data-is-numeric=true]": {
        textAlign: "end"
    }
});
var $2a4c99e2adafaa9d$var$variantSimple = $2a4c99e2adafaa9d$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        th: {
            color: (0, $6eb225f883147347$export$549ff81930776885)("gray.600", "gray.400")(props),
            borderBottom: "1px",
            borderColor: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$2a4c99e2adafaa9d$var$numericStyles
        },
        td: {
            borderBottom: "1px",
            borderColor: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$2a4c99e2adafaa9d$var$numericStyles
        },
        caption: {
            color: (0, $6eb225f883147347$export$549ff81930776885)("gray.600", "gray.100")(props)
        },
        tfoot: {
            tr: {
                "&:last-of-type": {
                    th: {
                        borderBottomWidth: 0
                    }
                }
            }
        }
    };
});
var $2a4c99e2adafaa9d$var$variantStripe = $2a4c99e2adafaa9d$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        th: {
            color: (0, $6eb225f883147347$export$549ff81930776885)("gray.600", "gray.400")(props),
            borderBottom: "1px",
            borderColor: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$2a4c99e2adafaa9d$var$numericStyles
        },
        td: {
            borderBottom: "1px",
            borderColor: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$2a4c99e2adafaa9d$var$numericStyles
        },
        caption: {
            color: (0, $6eb225f883147347$export$549ff81930776885)("gray.600", "gray.100")(props)
        },
        tbody: {
            tr: {
                "&:nth-of-type(odd)": {
                    "th, td": {
                        borderBottomWidth: "1px",
                        borderColor: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props)
                    },
                    td: {
                        background: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props)
                    }
                }
            }
        },
        tfoot: {
            tr: {
                "&:last-of-type": {
                    th: {
                        borderBottomWidth: 0
                    }
                }
            }
        }
    };
});
var $2a4c99e2adafaa9d$var$variants = {
    simple: $2a4c99e2adafaa9d$var$variantSimple,
    striped: $2a4c99e2adafaa9d$var$variantStripe,
    unstyled: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({})
};
var $2a4c99e2adafaa9d$var$sizes = {
    sm: $2a4c99e2adafaa9d$var$definePartsStyle({
        th: {
            px: "4",
            py: "1",
            lineHeight: "4",
            fontSize: "xs"
        },
        td: {
            px: "4",
            py: "2",
            fontSize: "sm",
            lineHeight: "4"
        },
        caption: {
            px: "4",
            py: "2",
            fontSize: "xs"
        }
    }),
    md: $2a4c99e2adafaa9d$var$definePartsStyle({
        th: {
            px: "6",
            py: "3",
            lineHeight: "4",
            fontSize: "xs"
        },
        td: {
            px: "6",
            py: "4",
            lineHeight: "5"
        },
        caption: {
            px: "6",
            py: "2",
            fontSize: "sm"
        }
    }),
    lg: $2a4c99e2adafaa9d$var$definePartsStyle({
        th: {
            px: "8",
            py: "4",
            lineHeight: "5",
            fontSize: "sm"
        },
        td: {
            px: "8",
            py: "5",
            lineHeight: "6"
        },
        caption: {
            px: "6",
            py: "2",
            fontSize: "md"
        }
    })
};
var $2a4c99e2adafaa9d$export$3339219781bb5161 = $2a4c99e2adafaa9d$var$defineMultiStyleConfig({
    baseStyle: $2a4c99e2adafaa9d$var$baseStyle,
    variants: $2a4c99e2adafaa9d$var$variants,
    sizes: $2a4c99e2adafaa9d$var$sizes,
    defaultProps: {
        variant: "simple",
        size: "md",
        colorScheme: "gray"
    }
});


// src/components/tabs.ts


// src/color.ts

/**
 * A simple guard function:
 *
 * ```js
 * Math.min(Math.max(low, value), high)
 * ```
 */ function $82bd23a4eacb9716$export$864d727b48066337(low, high, value) {
    return Math.min(Math.max(low, value), high);
}
class $82bd23a4eacb9716$var$ColorError extends Error {
    constructor(color){
        super(`Failed to parse color: "${color}"`);
    }
}
var $82bd23a4eacb9716$export$21f8cadbc4af9bbf = $82bd23a4eacb9716$var$ColorError;
/**
 * Parses a color into red, gree, blue, alpha parts
 *
 * @param color the input color. Can be a RGB, RBGA, HSL, HSLA, or named color
 */ function $82bd23a4eacb9716$export$88c26fe48243d749(color) {
    if (typeof color !== "string") throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
    if (color.trim().toLowerCase() === "transparent") return [
        0,
        0,
        0,
        0
    ];
    let normalizedColor = color.trim();
    normalizedColor = $82bd23a4eacb9716$var$namedColorRegex.test(color) ? $82bd23a4eacb9716$var$nameToHex(color) : color;
    const reducedHexMatch = $82bd23a4eacb9716$var$reducedHexRegex.exec(normalizedColor);
    if (reducedHexMatch) {
        const arr = Array.from(reducedHexMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt($82bd23a4eacb9716$var$r(x, 2), 16)),
            parseInt($82bd23a4eacb9716$var$r(arr[3] || "f", 2), 16) / 255
        ];
    }
    const hexMatch = $82bd23a4eacb9716$var$hexRegex.exec(normalizedColor);
    if (hexMatch) {
        const arr = Array.from(hexMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt(x, 16)),
            parseInt(arr[3] || "ff", 16) / 255
        ];
    }
    const rgbaMatch = $82bd23a4eacb9716$var$rgbaRegex.exec(normalizedColor);
    if (rgbaMatch) {
        const arr = Array.from(rgbaMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt(x, 10)),
            parseFloat(arr[3] || "1")
        ];
    }
    const hslaMatch = $82bd23a4eacb9716$var$hslaRegex.exec(normalizedColor);
    if (hslaMatch) {
        const [h, s, l, a] = Array.from(hslaMatch).slice(1).map(parseFloat);
        if ($82bd23a4eacb9716$export$864d727b48066337(0, 100, s) !== s) throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
        if ($82bd23a4eacb9716$export$864d727b48066337(0, 100, l) !== l) throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
        return [
            ...$82bd23a4eacb9716$var$hslToRgb(h, s, l),
            Number.isNaN(a) ? 1 : a
        ];
    }
    throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
}
function $82bd23a4eacb9716$var$hash(str) {
    let hash = 5381;
    let i = str.length;
    while(i)hash = hash * 33 ^ str.charCodeAt(--i);
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return (hash >>> 0) % 2341;
}
const $82bd23a4eacb9716$var$colorToInt = (x)=>parseInt(x.replace(/_/g, ""), 36);
const $82bd23a4eacb9716$var$compressedColorMap = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((acc, next)=>{
    const key = $82bd23a4eacb9716$var$colorToInt(next.substring(0, 3));
    const hex = $82bd23a4eacb9716$var$colorToInt(next.substring(3)).toString(16);
    // NOTE: padStart could be used here but it breaks Node 6 compat
    // https://github.com/ricokahler/color2k/issues/351
    let prefix = "";
    for(let i = 0; i < 6 - hex.length; i++)prefix += "0";
    acc[key] = `${prefix}${hex}`;
    return acc;
}, {});
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 */ function $82bd23a4eacb9716$var$nameToHex(color) {
    const normalizedColorName = color.toLowerCase().trim();
    const result = $82bd23a4eacb9716$var$compressedColorMap[$82bd23a4eacb9716$var$hash(normalizedColorName)];
    if (!result) throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
    return `#${result}`;
}
const $82bd23a4eacb9716$var$r = (str, amount)=>Array.from(Array(amount)).map(()=>str).join("");
const $82bd23a4eacb9716$var$reducedHexRegex = new RegExp(`^#${$82bd23a4eacb9716$var$r("([a-f0-9])", 3)}([a-f0-9])?$`, "i");
const $82bd23a4eacb9716$var$hexRegex = new RegExp(`^#${$82bd23a4eacb9716$var$r("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i");
const $82bd23a4eacb9716$var$rgbaRegex = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${$82bd23a4eacb9716$var$r(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i");
const $82bd23a4eacb9716$var$hslaRegex = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i;
const $82bd23a4eacb9716$var$namedColorRegex = /^[a-z]+$/i;
const $82bd23a4eacb9716$var$roundColor = (color)=>{
    return Math.round(color * 255);
};
const $82bd23a4eacb9716$var$hslToRgb = (hue, saturation, lightness)=>{
    let l = lightness / 100;
    if (saturation === 0) // achromatic
    return [
        l,
        l,
        l
    ].map($82bd23a4eacb9716$var$roundColor);
    // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    const huePrime = (hue % 360 + 360) % 360 / 60;
    const chroma = (1 - Math.abs(2 * l - 1)) * (saturation / 100);
    const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    let red = 0;
    let green = 0;
    let blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    const lightnessModification = l - chroma / 2;
    const finalRed = red + lightnessModification;
    const finalGreen = green + lightnessModification;
    const finalBlue = blue + lightnessModification;
    return [
        finalRed,
        finalGreen,
        finalBlue
    ].map($82bd23a4eacb9716$var$roundColor);
};
// taken from:
/**
 * Parses a color in hue, saturation, lightness, and the alpha channel.
 *
 * Hue is a number between 0 and 360, saturation, lightness, and alpha are
 * decimal percentages between 0 and 1
 */ function $82bd23a4eacb9716$export$c7d9b10ca8edee87(color) {
    const [red, green, blue, alpha] = $82bd23a4eacb9716$export$88c26fe48243d749(color).map((value, index)=>// 3rd index is alpha channel which is already normalized
        index === 3 ? value : value / 255);
    const max = Math.max(red, green, blue);
    const min = Math.min(red, green, blue);
    const lightness = (max + min) / 2;
    // achromatic
    if (max === min) return [
        0,
        0,
        lightness,
        alpha
    ];
    const delta = max - min;
    const saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    const hue = 60 * (red === max ? (green - blue) / delta + (green < blue ? 6 : 0) : green === max ? (blue - red) / delta + 2 : (red - green) / delta + 4);
    return [
        hue,
        saturation,
        lightness,
        alpha
    ];
}
/**
 * Takes in hsla parts and constructs an hsla string
 *
 * @param hue The color circle (from 0 to 360) - 0 (or 360) is red, 120 is green, 240 is blue
 * @param saturation Percentage of saturation, given as a decimal between 0 and 1
 * @param lightness Percentage of lightness, given as a decimal between 0 and 1
 * @param alpha Percentage of opacity, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$810b04175080204c(hue, saturation, lightness, alpha) {
    return `hsla(${(hue % 360).toFixed()}, ${$82bd23a4eacb9716$export$864d727b48066337(0, 100, saturation * 100).toFixed()}%, ${$82bd23a4eacb9716$export$864d727b48066337(0, 100, lightness * 100).toFixed()}%, ${parseFloat($82bd23a4eacb9716$export$864d727b48066337(0, 1, alpha).toFixed(3))})`;
}
/**
 * Adjusts the current hue of the color by the given degrees. Wraps around when
 * over 360.
 *
 * @param color input color
 * @param degrees degrees to adjust the input color, accepts degree integers
 * (0 - 360) and wraps around on overflow
 */ function $82bd23a4eacb9716$export$2b372a09365374d6(color, degrees) {
    const [h, s, l, a] = $82bd23a4eacb9716$export$c7d9b10ca8edee87(color);
    return $82bd23a4eacb9716$export$810b04175080204c(h + degrees, s, l, a);
}
/**
 * Darkens using lightness. This is equivalent to subtracting the lightness
 * from the L in HSL.
 *
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$4b073707ff63303(color, amount) {
    const [hue, saturation, lightness, alpha] = $82bd23a4eacb9716$export$c7d9b10ca8edee87(color);
    return $82bd23a4eacb9716$export$810b04175080204c(hue, saturation, lightness - amount, alpha);
}
/**
 * Desaturates the input color by the given amount via subtracting from the `s`
 * in `hsla`.
 *
 * @param amount The amount to desaturate, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$fb75607d98509d9(color, amount) {
    const [h, s, l, a] = $82bd23a4eacb9716$export$c7d9b10ca8edee87(color);
    return $82bd23a4eacb9716$export$810b04175080204c(h, s - amount, l, a);
}
// taken from:
// https://github.com/styled-components/polished/blob/0764c982551b487469043acb56281b0358b3107b/src/color/getLuminance.js
/**
 * Returns a number (float) representing the luminance of a color.
 */ function $82bd23a4eacb9716$export$c852d90bf7403b62(color) {
    if (color === "transparent") return 0;
    function f(x) {
        const channel = x / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }
    const [r, g, b] = $82bd23a4eacb9716$export$88c26fe48243d749(color);
    return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
}
// taken from:
/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 */ function $82bd23a4eacb9716$export$850ce485a60d103b(color1, color2) {
    const luminance1 = $82bd23a4eacb9716$export$c852d90bf7403b62(color1);
    const luminance2 = $82bd23a4eacb9716$export$c852d90bf7403b62(color2);
    return luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05);
}
/**
 * Takes in rgba parts and returns an rgba string
 *
 * @param red The amount of red in the red channel, given in a number between 0 and 255 inclusive
 * @param green The amount of green in the red channel, given in a number between 0 and 255 inclusive
 * @param blue The amount of blue in the red channel, given in a number between 0 and 255 inclusive
 * @param alpha Percentage of opacity, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$4e46ac54fc82cf3b(red, green, blue, alpha) {
    return `rgba(${$82bd23a4eacb9716$export$864d727b48066337(0, 255, red).toFixed()}, ${$82bd23a4eacb9716$export$864d727b48066337(0, 255, green).toFixed()}, ${$82bd23a4eacb9716$export$864d727b48066337(0, 255, blue).toFixed()}, ${parseFloat($82bd23a4eacb9716$export$864d727b48066337(0, 1, alpha).toFixed(3))})`;
}
/**
 * Mixes two colors together. Taken from sass's implementation.
 */ function $82bd23a4eacb9716$export$2c9e8a9632a706b2(color1, color2, weight) {
    const normalize = (n, index)=>// 3rd index is alpha channel which is already normalized
        index === 3 ? n : n / 255;
    const [r1, g1, b1, a1] = $82bd23a4eacb9716$export$88c26fe48243d749(color1).map(normalize);
    const [r2, g2, b2, a2] = $82bd23a4eacb9716$export$88c26fe48243d749(color2).map(normalize);
    // The formula is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
    const alphaDelta = a2 - a1;
    const normalizedWeight = weight * 2 - 1;
    const combinedWeight = normalizedWeight * alphaDelta === -1 ? normalizedWeight : normalizedWeight + alphaDelta / (1 + normalizedWeight * alphaDelta);
    const weight2 = (combinedWeight + 1) / 2;
    const weight1 = 1 - weight2;
    const r = (r1 * weight1 + r2 * weight2) * 255;
    const g = (g1 * weight1 + g2 * weight2) * 255;
    const b = (b1 * weight1 + b2 * weight2) * 255;
    const a = a2 * weight + a1 * (1 - weight);
    return $82bd23a4eacb9716$export$4e46ac54fc82cf3b(r, g, b, a);
}
/**
 * Given a series colors, this function will return a `scale(x)` function that
 * accepts a percentage as a decimal between 0 and 1 and returns the color at
 * that percentage in the scale.
 *
 * ```js
 * const scale = getScale('red', 'yellow', 'green');
 * console.log(scale(0)); // rgba(255, 0, 0, 1)
 * console.log(scale(0.5)); // rgba(255, 255, 0, 1)
 * console.log(scale(1)); // rgba(0, 128, 0, 1)
 * ```
 *
 * If you'd like to limit the domain and range like chroma-js, we recommend
 * wrapping scale again.
 *
 * ```js
 * const _scale = getScale('red', 'yellow', 'green');
 * const scale = x => _scale(x / 100);
 *
 * console.log(scale(0)); // rgba(255, 0, 0, 1)
 * console.log(scale(50)); // rgba(255, 255, 0, 1)
 * console.log(scale(100)); // rgba(0, 128, 0, 1)
 * ```
 */ function $82bd23a4eacb9716$export$5cdac61cf538712e(...colors) {
    return (n)=>{
        const lastIndex = colors.length - 1;
        const lowIndex = $82bd23a4eacb9716$export$864d727b48066337(0, lastIndex, Math.floor(n * lastIndex));
        const highIndex = $82bd23a4eacb9716$export$864d727b48066337(0, lastIndex, Math.ceil(n * lastIndex));
        const color1 = colors[lowIndex];
        const color2 = colors[highIndex];
        const unit = 1 / lastIndex;
        const weight = (n - unit * lowIndex) / unit;
        return $82bd23a4eacb9716$export$2c9e8a9632a706b2(color1, color2, weight);
    };
}
const $82bd23a4eacb9716$var$guidelines = {
    decorative: 1.5,
    readable: 3,
    aa: 4.5,
    aaa: 7
};
/**
 * Returns whether or not a color has bad contrast against a background
 * according to a given standard.
 */ function $82bd23a4eacb9716$export$f4ab80233a44f806(color, standard = "aa", background = "#fff") {
    return $82bd23a4eacb9716$export$850ce485a60d103b(color, background) < $82bd23a4eacb9716$var$guidelines[standard];
}
/**
 * Lightens a color by a given amount. This is equivalent to
 * `darken(color, -amount)`
 *
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$c0816ed86df316af(color, amount) {
    return $82bd23a4eacb9716$export$4b073707ff63303(color, -amount);
}
/**
 * Takes in a color and makes it more transparent by convert to `rgba` and
 * decreasing the amount in the alpha channel.
 *
 * @param amount The amount to increase the transparency by, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$d11da87e55cc498f(color, amount) {
    const [r, g, b, a] = $82bd23a4eacb9716$export$88c26fe48243d749(color);
    return $82bd23a4eacb9716$export$4e46ac54fc82cf3b(r, g, b, a - amount);
}
/**
 * Takes a color and un-transparentizes it. Equivalent to
 * `transparentize(color, -amount)`
 *
 * @param amount The amount to increase the opacity by, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$f4f50e3877dd0530(color, amount) {
    return $82bd23a4eacb9716$export$d11da87e55cc498f(color, -amount);
}
/**
 * An alternative function to `readableColor`. Returns whether or not the 
 * readable color (i.e. the color to be place on top the input color) should be
 * black.
 */ function $82bd23a4eacb9716$export$dcb2d24cf045d06(color) {
    return $82bd23a4eacb9716$export$c852d90bf7403b62(color) > 0.179;
}
/**
 * Returns black or white for best contrast depending on the luminosity of the
 * given color.
 */ function $82bd23a4eacb9716$export$61654c1796c44811(color) {
    return $82bd23a4eacb9716$export$dcb2d24cf045d06(color) ? "#000" : "#fff";
}
/**
 * Saturates a color by converting it to `hsl` and increasing the saturation
 * amount. Equivalent to `desaturate(color, -amount)`
 * 
 * @param color Input color
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$5fcac96f5a87e3db(color, amount) {
    return $82bd23a4eacb9716$export$fb75607d98509d9(color, -amount);
}
/**
 * Takes in any color and returns it as a hex code.
 */ function $82bd23a4eacb9716$export$7ea66e3774a60b67(color) {
    const [r, g, b, a] = $82bd23a4eacb9716$export$88c26fe48243d749(color);
    let hex = (x)=>{
        const h = $82bd23a4eacb9716$export$864d727b48066337(0, 255, x).toString(16);
        // NOTE: padStart could be used here but it breaks Node 6 compat
        // https://github.com/ricokahler/color2k/issues/351
        return h.length === 1 ? `0${h}` : h;
    };
    return `#${hex(r)}${hex(g)}${hex(b)}${a < 1 ? hex(Math.round(a * 255)) : ""}`;
}
/**
 * Takes in any color and returns it as an rgba string.
 */ function $82bd23a4eacb9716$export$5db297beaffffbfc(color) {
    return $82bd23a4eacb9716$export$4e46ac54fc82cf3b(...$82bd23a4eacb9716$export$88c26fe48243d749(color));
}
/**
 * Takes in any color and returns it as an hsla string.
 */ function $82bd23a4eacb9716$export$b9678a7d4ac803cc(color) {
    return $82bd23a4eacb9716$export$810b04175080204c(...$82bd23a4eacb9716$export$c7d9b10ca8edee87(color));
}


// ../../../node_modules/.pnpm/dlv@1.1.3/node_modules/dlv/dist/dlv.es.js
function $a031d15006571f58$var$dlv_es_default(t, e, l, n, r) {
    for(e = e.split ? e.split(".") : e, n = 0; n < e.length; n++)t = t ? t[e[n]] : r;
    return t === r ? l : t;
}
// src/color.ts
var $a031d15006571f58$var$isEmptyObject = (obj)=>Object.keys(obj).length === 0;
var $a031d15006571f58$export$5551a2d24ff40153 = (theme, color, fallback)=>{
    const hex = $a031d15006571f58$var$dlv_es_default(theme, `colors.${color}`, color);
    try {
        (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)(hex);
        return hex;
    } catch  {
        return fallback != null ? fallback : "#000000";
    }
};
var $a031d15006571f58$export$fdaf813cf8a11246 = (theme, color, fallback)=>{
    var _a;
    return (_a = (0, $47a6d9fbbf7ee42d$export$93c8e06b7014dc33)(theme, "colors", color)) != null ? _a : fallback;
};
var $a031d15006571f58$var$getBrightness = (color)=>{
    const [r, g, b] = (0, $82bd23a4eacb9716$export$88c26fe48243d749)(color);
    return (r * 299 + g * 587 + b * 114) / 1e3;
};
var $a031d15006571f58$export$7297c25227171a1f = (color)=>(theme)=>{
        const hex = $a031d15006571f58$export$5551a2d24ff40153(theme, color);
        const brightness = $a031d15006571f58$var$getBrightness(hex);
        const isDark2 = brightness < 128;
        return isDark2 ? "dark" : "light";
    };
var $a031d15006571f58$export$a79ad82046afa44e = (color)=>(theme)=>$a031d15006571f58$export$7297c25227171a1f(color)(theme) === "dark";
var $a031d15006571f58$export$44af652f4cca9039 = (color)=>(theme)=>$a031d15006571f58$export$7297c25227171a1f(color)(theme) === "light";
var $a031d15006571f58$export$d11da87e55cc498f = (color, opacity)=>(theme)=>{
        const raw = $a031d15006571f58$export$5551a2d24ff40153(theme, color);
        return (0, $82bd23a4eacb9716$export$d11da87e55cc498f)(raw, 1 - opacity);
    };
var $a031d15006571f58$export$81525e9955aa80e8 = (color, amount)=>(theme)=>{
        const raw = $a031d15006571f58$export$5551a2d24ff40153(theme, color);
        return (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$2c9e8a9632a706b2)(raw, "#fff", amount));
    };
var $a031d15006571f58$export$2b471577c483101c = (color, amount)=>(theme)=>{
        const raw = $a031d15006571f58$export$5551a2d24ff40153(theme, color);
        return (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$2c9e8a9632a706b2)(raw, "#000", amount / 100));
    };
var $a031d15006571f58$export$4b073707ff63303 = (color, amount)=>(theme)=>{
        const raw = $a031d15006571f58$export$5551a2d24ff40153(theme, color);
        return (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$4b073707ff63303)(raw, amount / 100));
    };
var $a031d15006571f58$export$c0816ed86df316af = (color, amount)=>(theme)=>{
        const raw = $a031d15006571f58$export$5551a2d24ff40153(theme, color);
        (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$c0816ed86df316af)(raw, amount / 100));
    };
var $a031d15006571f58$export$1ec78ac20028ebd4 = (fg, bg)=>(theme)=>(0, $82bd23a4eacb9716$export$850ce485a60d103b)($a031d15006571f58$export$5551a2d24ff40153(theme, bg), $a031d15006571f58$export$5551a2d24ff40153(theme, fg));
var $a031d15006571f58$export$cd41ae544cfc2a65 = (textColor, bgColor, options)=>(theme)=>$a031d15006571f58$export$3fe5b5ca1e6a6a28($a031d15006571f58$export$5551a2d24ff40153(theme, bgColor), $a031d15006571f58$export$5551a2d24ff40153(theme, textColor), options);
function $a031d15006571f58$export$3fe5b5ca1e6a6a28(color1, color2, wcag2 = {
    level: "AA",
    size: "small"
}) {
    var _a, _b;
    const readabilityLevel = $a031d15006571f58$export$b7b705aaad1c5b6a(color1, color2);
    switch(((_a = wcag2.level) != null ? _a : "AA") + ((_b = wcag2.size) != null ? _b : "small")){
        case "AAsmall":
        case "AAAlarge":
            return readabilityLevel >= 4.5;
        case "AAlarge":
            return readabilityLevel >= 3;
        case "AAAsmall":
            return readabilityLevel >= 7;
        default:
            return false;
    }
}
function $a031d15006571f58$export$b7b705aaad1c5b6a(color1, color2) {
    return (Math.max((0, $82bd23a4eacb9716$export$c852d90bf7403b62)(color1), (0, $82bd23a4eacb9716$export$c852d90bf7403b62)(color2)) + 0.05) / (Math.min((0, $82bd23a4eacb9716$export$c852d90bf7403b62)(color1), (0, $82bd23a4eacb9716$export$c852d90bf7403b62)(color2)) + 0.05);
}
var $a031d15006571f58$export$504efcfbebdbcaf = (color)=>(theme)=>{
        const raw = $a031d15006571f58$export$5551a2d24ff40153(theme, color);
        const hsl = (0, $82bd23a4eacb9716$export$c7d9b10ca8edee87)(raw);
        const complementHsl = Object.assign(hsl, [
            (hsl[0] + 180) % 360
        ]);
        return (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$810b04175080204c)(...complementHsl));
    };
function $a031d15006571f58$export$db0ffb03ee9f3080(size = "1rem", color = "rgba(255, 255, 255, 0.15)") {
    return {
        backgroundImage: `linear-gradient(
    45deg,
    ${color} 25%,
    transparent 25%,
    transparent 50%,
    ${color} 50%,
    ${color} 75%,
    transparent 75%,
    transparent
  )`,
        backgroundSize: `${size} ${size}`
    };
}
var $a031d15006571f58$var$randomHex = ()=>`#${Math.floor(Math.random() * 16777215).toString(16).padEnd(6, "0")}`;
function $a031d15006571f58$export$f3c6ed4330abfc18(opts) {
    const fallback = $a031d15006571f58$var$randomHex();
    if (!opts || $a031d15006571f58$var$isEmptyObject(opts)) return fallback;
    if (opts.string && opts.colors) return $a031d15006571f58$var$randomColorFromList(opts.string, opts.colors);
    if (opts.string && !opts.colors) return $a031d15006571f58$var$randomColorFromString(opts.string);
    if (opts.colors && !opts.string) return $a031d15006571f58$var$randomFromList(opts.colors);
    return fallback;
}
function $a031d15006571f58$var$randomColorFromString(str) {
    let hash = 0;
    if (str.length === 0) return hash.toString();
    for(let i = 0; i < str.length; i += 1){
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
    }
    let color = "#";
    for(let j = 0; j < 3; j += 1){
        const value = hash >> j * 8 & 255;
        color += `00${value.toString(16)}`.substr(-2);
    }
    return color;
}
function $a031d15006571f58$var$randomColorFromList(str, list) {
    let index = 0;
    if (str.length === 0) return list[0];
    for(let i = 0; i < str.length; i += 1){
        index = str.charCodeAt(i) + ((index << 5) - index);
        index = index & index;
    }
    index = (index % list.length + list.length) % list.length;
    return list[index];
}
function $a031d15006571f58$var$randomFromList(list) {
    return list[Math.floor(Math.random() * list.length)];
}


var $b12872ed3cae6b5f$var$$fg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tabs-color");
var $b12872ed3cae6b5f$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tabs-bg");
var $b12872ed3cae6b5f$var$$border = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tabs-border-color");
var { defineMultiStyleConfig: $b12872ed3cae6b5f$var$defineMultiStyleConfig, definePartsStyle: $b12872ed3cae6b5f$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$97383552563be58d).keys);
var $b12872ed3cae6b5f$var$baseStyleRoot = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { orientation: orientation } = props;
    return {
        display: orientation === "vertical" ? "flex" : "block"
    };
});
var $b12872ed3cae6b5f$var$baseStyleTab = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { isFitted: isFitted } = props;
    return {
        flex: isFitted ? 1 : void 0,
        transitionProperty: "common",
        transitionDuration: "normal",
        _focusVisible: {
            zIndex: 1,
            boxShadow: "outline"
        },
        _disabled: {
            cursor: "not-allowed",
            opacity: 0.4
        }
    };
});
var $b12872ed3cae6b5f$var$baseStyleTablist = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { align: align = "start", orientation: orientation } = props;
    const alignments = {
        end: "flex-end",
        center: "center",
        start: "flex-start"
    };
    return {
        justifyContent: alignments[align],
        flexDirection: orientation === "vertical" ? "column" : "row"
    };
});
var $b12872ed3cae6b5f$var$baseStyleTabpanel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    p: 4
});
var $b12872ed3cae6b5f$var$baseStyle = $b12872ed3cae6b5f$var$definePartsStyle((props)=>({
        root: $b12872ed3cae6b5f$var$baseStyleRoot(props),
        tab: $b12872ed3cae6b5f$var$baseStyleTab(props),
        tablist: $b12872ed3cae6b5f$var$baseStyleTablist(props),
        tabpanel: $b12872ed3cae6b5f$var$baseStyleTabpanel
    }));
var $b12872ed3cae6b5f$var$sizes = {
    sm: $b12872ed3cae6b5f$var$definePartsStyle({
        tab: {
            py: 1,
            px: 4,
            fontSize: "sm"
        }
    }),
    md: $b12872ed3cae6b5f$var$definePartsStyle({
        tab: {
            fontSize: "md",
            py: 2,
            px: 4
        }
    }),
    lg: $b12872ed3cae6b5f$var$definePartsStyle({
        tab: {
            fontSize: "lg",
            py: 3,
            px: 4
        }
    })
};
var $b12872ed3cae6b5f$var$variantLine = $b12872ed3cae6b5f$var$definePartsStyle((props)=>{
    const { colorScheme: c, orientation: orientation } = props;
    const isVertical = orientation === "vertical";
    const borderProp = isVertical ? "borderStart" : "borderBottom";
    const marginProp = isVertical ? "marginStart" : "marginBottom";
    return {
        tablist: {
            [borderProp]: "2px solid",
            borderColor: "inherit"
        },
        tab: {
            [borderProp]: "2px solid",
            borderColor: "transparent",
            [marginProp]: "-2px",
            _selected: {
                [$b12872ed3cae6b5f$var$$fg.variable]: `colors.${c}.600`,
                _dark: {
                    [$b12872ed3cae6b5f$var$$fg.variable]: `colors.${c}.300`
                },
                borderColor: "currentColor"
            },
            _active: {
                [$b12872ed3cae6b5f$var$$bg.variable]: "colors.gray.200",
                _dark: {
                    [$b12872ed3cae6b5f$var$$bg.variable]: "colors.whiteAlpha.300"
                }
            },
            _disabled: {
                _active: {
                    bg: "none"
                }
            },
            color: $b12872ed3cae6b5f$var$$fg.reference,
            bg: $b12872ed3cae6b5f$var$$bg.reference
        }
    };
});
var $b12872ed3cae6b5f$var$variantEnclosed = $b12872ed3cae6b5f$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            borderTopRadius: "md",
            border: "1px solid",
            borderColor: "transparent",
            mb: "-1px",
            [$b12872ed3cae6b5f$var$$border.variable]: "transparent",
            _selected: {
                [$b12872ed3cae6b5f$var$$fg.variable]: `colors.${c}.600`,
                [$b12872ed3cae6b5f$var$$border.variable]: `colors.white`,
                _dark: {
                    [$b12872ed3cae6b5f$var$$fg.variable]: `colors.${c}.300`,
                    [$b12872ed3cae6b5f$var$$border.variable]: `colors.gray.800`
                },
                borderColor: "inherit",
                borderBottomColor: $b12872ed3cae6b5f$var$$border.reference
            },
            color: $b12872ed3cae6b5f$var$$fg.reference
        },
        tablist: {
            mb: "-1px",
            borderBottom: "1px solid",
            borderColor: "inherit"
        }
    };
});
var $b12872ed3cae6b5f$var$variantEnclosedColored = $b12872ed3cae6b5f$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            border: "1px solid",
            borderColor: "inherit",
            [$b12872ed3cae6b5f$var$$bg.variable]: "colors.gray.50",
            _dark: {
                [$b12872ed3cae6b5f$var$$bg.variable]: "colors.whiteAlpha.50"
            },
            mb: "-1px",
            _notLast: {
                marginEnd: "-1px"
            },
            _selected: {
                [$b12872ed3cae6b5f$var$$bg.variable]: "colors.white",
                [$b12872ed3cae6b5f$var$$fg.variable]: `colors.${c}.600`,
                _dark: {
                    [$b12872ed3cae6b5f$var$$bg.variable]: "colors.gray.800",
                    [$b12872ed3cae6b5f$var$$fg.variable]: `colors.${c}.300`
                },
                borderColor: "inherit",
                borderTopColor: "currentColor",
                borderBottomColor: "transparent"
            },
            color: $b12872ed3cae6b5f$var$$fg.reference,
            bg: $b12872ed3cae6b5f$var$$bg.reference
        },
        tablist: {
            mb: "-1px",
            borderBottom: "1px solid",
            borderColor: "inherit"
        }
    };
});
var $b12872ed3cae6b5f$var$variantSoftRounded = $b12872ed3cae6b5f$var$definePartsStyle((props)=>{
    const { colorScheme: c, theme: theme } = props;
    return {
        tab: {
            borderRadius: "full",
            fontWeight: "semibold",
            color: "gray.600",
            _selected: {
                color: (0, $a031d15006571f58$export$5551a2d24ff40153)(theme, `${c}.700`),
                bg: (0, $a031d15006571f58$export$5551a2d24ff40153)(theme, `${c}.100`)
            }
        }
    };
});
var $b12872ed3cae6b5f$var$variantSolidRounded = $b12872ed3cae6b5f$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            borderRadius: "full",
            fontWeight: "semibold",
            [$b12872ed3cae6b5f$var$$fg.variable]: "colors.gray.600",
            _dark: {
                [$b12872ed3cae6b5f$var$$fg.variable]: "inherit"
            },
            _selected: {
                [$b12872ed3cae6b5f$var$$fg.variable]: "colors.white",
                [$b12872ed3cae6b5f$var$$bg.variable]: `colors.${c}.600`,
                _dark: {
                    [$b12872ed3cae6b5f$var$$fg.variable]: "colors.gray.800",
                    [$b12872ed3cae6b5f$var$$bg.variable]: `colors.${c}.300`
                }
            },
            color: $b12872ed3cae6b5f$var$$fg.reference,
            bg: $b12872ed3cae6b5f$var$$bg.reference
        }
    };
});
var $b12872ed3cae6b5f$var$variantUnstyled = $b12872ed3cae6b5f$var$definePartsStyle({});
var $b12872ed3cae6b5f$var$variants = {
    line: $b12872ed3cae6b5f$var$variantLine,
    enclosed: $b12872ed3cae6b5f$var$variantEnclosed,
    "enclosed-colored": $b12872ed3cae6b5f$var$variantEnclosedColored,
    "soft-rounded": $b12872ed3cae6b5f$var$variantSoftRounded,
    "solid-rounded": $b12872ed3cae6b5f$var$variantSolidRounded,
    unstyled: $b12872ed3cae6b5f$var$variantUnstyled
};
var $b12872ed3cae6b5f$export$847a245e7ebce2a1 = $b12872ed3cae6b5f$var$defineMultiStyleConfig({
    baseStyle: $b12872ed3cae6b5f$var$baseStyle,
    sizes: $b12872ed3cae6b5f$var$sizes,
    variants: $b12872ed3cae6b5f$var$variants,
    defaultProps: {
        size: "md",
        variant: "line",
        colorScheme: "blue"
    }
});


// src/components/badge.ts


var $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4 = (0, $47a6d9fbbf7ee42d$export$bd40561c6c056841)("badge", [
    "bg",
    "color",
    "shadow"
]);
var $ef3cdcb3a868c7e9$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: 1,
    textTransform: "uppercase",
    fontSize: "xs",
    borderRadius: "sm",
    fontWeight: "bold",
    bg: $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.bg.reference,
    color: $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.color.reference,
    boxShadow: $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.shadow.reference
});
var $ef3cdcb3a868c7e9$var$variantSolid = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const dark = (0, $a031d15006571f58$export$d11da87e55cc498f)(`${c}.500`, 0.6)(theme);
    return {
        [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.bg.variable]: `colors.${c}.500`,
        [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.color.variable]: `colors.white`,
        _dark: {
            [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.bg.variable]: dark,
            [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.color.variable]: `colors.whiteAlpha.800`
        }
    };
});
var $ef3cdcb3a868c7e9$var$variantSubtle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const darkBg = (0, $a031d15006571f58$export$d11da87e55cc498f)(`${c}.200`, 0.16)(theme);
    return {
        [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.bg.variable]: `colors.${c}.100`,
        [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.color.variable]: `colors.${c}.800`,
        _dark: {
            [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.bg.variable]: darkBg,
            [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.color.variable]: `colors.${c}.200`
        }
    };
});
var $ef3cdcb3a868c7e9$var$variantOutline = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const darkColor = (0, $a031d15006571f58$export$d11da87e55cc498f)(`${c}.200`, 0.8)(theme);
    return {
        [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.color.variable]: `colors.${c}.500`,
        _dark: {
            [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.color.variable]: darkColor
        },
        [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.shadow.variable]: `inset 0 0 0px 1px ${$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.color.reference}`
    };
});
var $ef3cdcb3a868c7e9$var$variants = {
    solid: $ef3cdcb3a868c7e9$var$variantSolid,
    subtle: $ef3cdcb3a868c7e9$var$variantSubtle,
    outline: $ef3cdcb3a868c7e9$var$variantOutline
};
var $ef3cdcb3a868c7e9$export$eb6e7cbc82d0f88b = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $ef3cdcb3a868c7e9$var$baseStyle,
    variants: $ef3cdcb3a868c7e9$var$variants,
    defaultProps: {
        variant: "subtle",
        colorScheme: "gray"
    }
});




var { defineMultiStyleConfig: $8e37595eb187b127$var$defineMultiStyleConfig, definePartsStyle: $8e37595eb187b127$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$4c2f5f7f2ea94a8e).keys);
var $8e37595eb187b127$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-bg");
var $8e37595eb187b127$var$$color = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-color");
var $8e37595eb187b127$var$$shadow = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-shadow");
var $8e37595eb187b127$var$$minH = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-min-height");
var $8e37595eb187b127$var$$minW = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-min-width");
var $8e37595eb187b127$var$$fontSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-font-size");
var $8e37595eb187b127$var$$paddingX = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-padding-inline");
var $8e37595eb187b127$var$baseStyleContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontWeight: "medium",
    lineHeight: 1.2,
    outline: 0,
    [$8e37595eb187b127$var$$color.variable]: (0, $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4).color.reference,
    [$8e37595eb187b127$var$$bg.variable]: (0, $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4).bg.reference,
    [$8e37595eb187b127$var$$shadow.variable]: (0, $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4).shadow.reference,
    color: $8e37595eb187b127$var$$color.reference,
    bg: $8e37595eb187b127$var$$bg.reference,
    boxShadow: $8e37595eb187b127$var$$shadow.reference,
    borderRadius: "md",
    minH: $8e37595eb187b127$var$$minH.reference,
    minW: $8e37595eb187b127$var$$minW.reference,
    fontSize: $8e37595eb187b127$var$$fontSize.reference,
    px: $8e37595eb187b127$var$$paddingX.reference,
    _focusVisible: {
        [$8e37595eb187b127$var$$shadow.variable]: "shadows.outline"
    }
});
var $8e37595eb187b127$var$baseStyleLabel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    lineHeight: 1.2,
    overflow: "visible"
});
var $8e37595eb187b127$var$baseStyleCloseButton = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontSize: "lg",
    w: "5",
    h: "5",
    transitionProperty: "common",
    transitionDuration: "normal",
    borderRadius: "full",
    marginStart: "1.5",
    marginEnd: "-1",
    opacity: 0.5,
    _disabled: {
        opacity: 0.4
    },
    _focusVisible: {
        boxShadow: "outline",
        bg: "rgba(0, 0, 0, 0.14)"
    },
    _hover: {
        opacity: 0.8
    },
    _active: {
        opacity: 1
    }
});
var $8e37595eb187b127$var$baseStyle = $8e37595eb187b127$var$definePartsStyle({
    container: $8e37595eb187b127$var$baseStyleContainer,
    label: $8e37595eb187b127$var$baseStyleLabel,
    closeButton: $8e37595eb187b127$var$baseStyleCloseButton
});
var $8e37595eb187b127$var$sizes = {
    sm: $8e37595eb187b127$var$definePartsStyle({
        container: {
            [$8e37595eb187b127$var$$minH.variable]: "sizes.5",
            [$8e37595eb187b127$var$$minW.variable]: "sizes.5",
            [$8e37595eb187b127$var$$fontSize.variable]: "fontSizes.xs",
            [$8e37595eb187b127$var$$paddingX.variable]: "space.2"
        },
        closeButton: {
            marginEnd: "-2px",
            marginStart: "0.35rem"
        }
    }),
    md: $8e37595eb187b127$var$definePartsStyle({
        container: {
            [$8e37595eb187b127$var$$minH.variable]: "sizes.6",
            [$8e37595eb187b127$var$$minW.variable]: "sizes.6",
            [$8e37595eb187b127$var$$fontSize.variable]: "fontSizes.sm",
            [$8e37595eb187b127$var$$paddingX.variable]: "space.2"
        }
    }),
    lg: $8e37595eb187b127$var$definePartsStyle({
        container: {
            [$8e37595eb187b127$var$$minH.variable]: "sizes.8",
            [$8e37595eb187b127$var$$minW.variable]: "sizes.8",
            [$8e37595eb187b127$var$$fontSize.variable]: "fontSizes.md",
            [$8e37595eb187b127$var$$paddingX.variable]: "space.3"
        }
    })
};
var $8e37595eb187b127$var$variants = {
    subtle: $8e37595eb187b127$var$definePartsStyle((props)=>{
        var _a;
        return {
            container: (_a = (0, $ef3cdcb3a868c7e9$export$eb6e7cbc82d0f88b).variants) == null ? void 0 : _a.subtle(props)
        };
    }),
    solid: $8e37595eb187b127$var$definePartsStyle((props)=>{
        var _a;
        return {
            container: (_a = (0, $ef3cdcb3a868c7e9$export$eb6e7cbc82d0f88b).variants) == null ? void 0 : _a.solid(props)
        };
    }),
    outline: $8e37595eb187b127$var$definePartsStyle((props)=>{
        var _a;
        return {
            container: (_a = (0, $ef3cdcb3a868c7e9$export$eb6e7cbc82d0f88b).variants) == null ? void 0 : _a.outline(props)
        };
    })
};
var $8e37595eb187b127$export$f8ab9ac2a319695b = $8e37595eb187b127$var$defineMultiStyleConfig({
    variants: $8e37595eb187b127$var$variants,
    baseStyle: $8e37595eb187b127$var$baseStyle,
    sizes: $8e37595eb187b127$var$sizes,
    defaultProps: {
        size: "md",
        variant: "subtle",
        colorScheme: "gray"
    }
});


// src/components/input.ts



var { definePartsStyle: $732b2cb9e8ffdec6$var$definePartsStyle, defineMultiStyleConfig: $732b2cb9e8ffdec6$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$1ffeb100b532f46d).keys);
var $732b2cb9e8ffdec6$var$$height = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("input-height");
var $732b2cb9e8ffdec6$var$$fontSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("input-font-size");
var $732b2cb9e8ffdec6$var$$padding = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("input-padding");
var $732b2cb9e8ffdec6$var$$borderRadius = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("input-border-radius");
var $732b2cb9e8ffdec6$var$baseStyle = $732b2cb9e8ffdec6$var$definePartsStyle({
    addon: {
        height: $732b2cb9e8ffdec6$var$$height.reference,
        fontSize: $732b2cb9e8ffdec6$var$$fontSize.reference,
        px: $732b2cb9e8ffdec6$var$$padding.reference,
        borderRadius: $732b2cb9e8ffdec6$var$$borderRadius.reference
    },
    field: {
        width: "100%",
        height: $732b2cb9e8ffdec6$var$$height.reference,
        fontSize: $732b2cb9e8ffdec6$var$$fontSize.reference,
        px: $732b2cb9e8ffdec6$var$$padding.reference,
        borderRadius: $732b2cb9e8ffdec6$var$$borderRadius.reference,
        minWidth: 0,
        outline: 0,
        position: "relative",
        appearance: "none",
        transitionProperty: "common",
        transitionDuration: "normal",
        _disabled: {
            opacity: 0.4,
            cursor: "not-allowed"
        }
    }
});
var $732b2cb9e8ffdec6$var$size = {
    lg: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$732b2cb9e8ffdec6$var$$fontSize.variable]: "fontSizes.lg",
        [$732b2cb9e8ffdec6$var$$padding.variable]: "space.4",
        [$732b2cb9e8ffdec6$var$$borderRadius.variable]: "radii.md",
        [$732b2cb9e8ffdec6$var$$height.variable]: "sizes.12"
    }),
    md: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$732b2cb9e8ffdec6$var$$fontSize.variable]: "fontSizes.md",
        [$732b2cb9e8ffdec6$var$$padding.variable]: "space.4",
        [$732b2cb9e8ffdec6$var$$borderRadius.variable]: "radii.md",
        [$732b2cb9e8ffdec6$var$$height.variable]: "sizes.10"
    }),
    sm: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$732b2cb9e8ffdec6$var$$fontSize.variable]: "fontSizes.sm",
        [$732b2cb9e8ffdec6$var$$padding.variable]: "space.3",
        [$732b2cb9e8ffdec6$var$$borderRadius.variable]: "radii.sm",
        [$732b2cb9e8ffdec6$var$$height.variable]: "sizes.8"
    }),
    xs: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$732b2cb9e8ffdec6$var$$fontSize.variable]: "fontSizes.xs",
        [$732b2cb9e8ffdec6$var$$padding.variable]: "space.2",
        [$732b2cb9e8ffdec6$var$$borderRadius.variable]: "radii.sm",
        [$732b2cb9e8ffdec6$var$$height.variable]: "sizes.6"
    })
};
var $732b2cb9e8ffdec6$var$sizes = {
    lg: $732b2cb9e8ffdec6$var$definePartsStyle({
        field: $732b2cb9e8ffdec6$var$size.lg,
        group: $732b2cb9e8ffdec6$var$size.lg
    }),
    md: $732b2cb9e8ffdec6$var$definePartsStyle({
        field: $732b2cb9e8ffdec6$var$size.md,
        group: $732b2cb9e8ffdec6$var$size.md
    }),
    sm: $732b2cb9e8ffdec6$var$definePartsStyle({
        field: $732b2cb9e8ffdec6$var$size.sm,
        group: $732b2cb9e8ffdec6$var$size.sm
    }),
    xs: $732b2cb9e8ffdec6$var$definePartsStyle({
        field: $732b2cb9e8ffdec6$var$size.xs,
        group: $732b2cb9e8ffdec6$var$size.xs
    })
};
function $732b2cb9e8ffdec6$var$getDefaults(props) {
    const { focusBorderColor: fc, errorBorderColor: ec } = props;
    return {
        focusBorderColor: fc || (0, $6eb225f883147347$export$549ff81930776885)("blue.500", "blue.300")(props),
        errorBorderColor: ec || (0, $6eb225f883147347$export$549ff81930776885)("red.500", "red.300")(props)
    };
}
var $732b2cb9e8ffdec6$var$variantOutline = $732b2cb9e8ffdec6$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $732b2cb9e8ffdec6$var$getDefaults(props);
    return {
        field: {
            border: "1px solid",
            borderColor: "inherit",
            bg: "inherit",
            _hover: {
                borderColor: (0, $6eb225f883147347$export$549ff81930776885)("gray.300", "whiteAlpha.400")(props)
            },
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $a031d15006571f58$export$5551a2d24ff40153)(theme, ec),
                boxShadow: `0 0 0 1px ${(0, $a031d15006571f58$export$5551a2d24ff40153)(theme, ec)}`
            },
            _focusVisible: {
                zIndex: 1,
                borderColor: (0, $a031d15006571f58$export$5551a2d24ff40153)(theme, fc),
                boxShadow: `0 0 0 1px ${(0, $a031d15006571f58$export$5551a2d24ff40153)(theme, fc)}`
            }
        },
        addon: {
            border: "1px solid",
            borderColor: (0, $6eb225f883147347$export$549ff81930776885)("inherit", "whiteAlpha.50")(props),
            bg: (0, $6eb225f883147347$export$549ff81930776885)("gray.100", "whiteAlpha.300")(props)
        }
    };
});
var $732b2cb9e8ffdec6$var$variantFilled = $732b2cb9e8ffdec6$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $732b2cb9e8ffdec6$var$getDefaults(props);
    return {
        field: {
            border: "2px solid",
            borderColor: "transparent",
            bg: (0, $6eb225f883147347$export$549ff81930776885)("gray.100", "whiteAlpha.50")(props),
            _hover: {
                bg: (0, $6eb225f883147347$export$549ff81930776885)("gray.200", "whiteAlpha.100")(props)
            },
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $a031d15006571f58$export$5551a2d24ff40153)(theme, ec)
            },
            _focusVisible: {
                bg: "transparent",
                borderColor: (0, $a031d15006571f58$export$5551a2d24ff40153)(theme, fc)
            }
        },
        addon: {
            border: "2px solid",
            borderColor: "transparent",
            bg: (0, $6eb225f883147347$export$549ff81930776885)("gray.100", "whiteAlpha.50")(props)
        }
    };
});
var $732b2cb9e8ffdec6$var$variantFlushed = $732b2cb9e8ffdec6$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $732b2cb9e8ffdec6$var$getDefaults(props);
    return {
        field: {
            borderBottom: "1px solid",
            borderColor: "inherit",
            borderRadius: "0",
            px: "0",
            bg: "transparent",
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $a031d15006571f58$export$5551a2d24ff40153)(theme, ec),
                boxShadow: `0px 1px 0px 0px ${(0, $a031d15006571f58$export$5551a2d24ff40153)(theme, ec)}`
            },
            _focusVisible: {
                borderColor: (0, $a031d15006571f58$export$5551a2d24ff40153)(theme, fc),
                boxShadow: `0px 1px 0px 0px ${(0, $a031d15006571f58$export$5551a2d24ff40153)(theme, fc)}`
            }
        },
        addon: {
            borderBottom: "2px solid",
            borderColor: "inherit",
            borderRadius: "0",
            px: "0",
            bg: "transparent"
        }
    };
});
var $732b2cb9e8ffdec6$var$variantUnstyled = $732b2cb9e8ffdec6$var$definePartsStyle({
    field: {
        bg: "transparent",
        px: "0",
        height: "auto"
    },
    addon: {
        bg: "transparent",
        px: "0",
        height: "auto"
    }
});
var $732b2cb9e8ffdec6$var$variants = {
    outline: $732b2cb9e8ffdec6$var$variantOutline,
    filled: $732b2cb9e8ffdec6$var$variantFilled,
    flushed: $732b2cb9e8ffdec6$var$variantFlushed,
    unstyled: $732b2cb9e8ffdec6$var$variantUnstyled
};
var $732b2cb9e8ffdec6$export$b1b9f3bced726e54 = $732b2cb9e8ffdec6$var$defineMultiStyleConfig({
    baseStyle: $732b2cb9e8ffdec6$var$baseStyle,
    sizes: $732b2cb9e8ffdec6$var$sizes,
    variants: $732b2cb9e8ffdec6$var$variants,
    defaultProps: {
        size: "md",
        variant: "outline"
    }
});



var $db4a338c74752624$var$_a;
var $db4a338c74752624$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    ...($db4a338c74752624$var$_a = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).baseStyle) == null ? void 0 : $db4a338c74752624$var$_a.field,
    paddingY: "2",
    minHeight: "20",
    lineHeight: "short",
    verticalAlign: "top"
});
var $db4a338c74752624$var$_a2, $db4a338c74752624$var$_b;
var $db4a338c74752624$var$variants = {
    outline: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
        var _a4, _b3;
        return (_b3 = (_a4 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants) == null ? void 0 : _a4.outline(props).field) != null ? _b3 : {};
    }),
    flushed: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
        var _a4, _b3;
        return (_b3 = (_a4 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants) == null ? void 0 : _a4.flushed(props).field) != null ? _b3 : {};
    }),
    filled: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
        var _a4, _b3;
        return (_b3 = (_a4 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants) == null ? void 0 : _a4.filled(props).field) != null ? _b3 : {};
    }),
    unstyled: ($db4a338c74752624$var$_b = ($db4a338c74752624$var$_a2 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants) == null ? void 0 : $db4a338c74752624$var$_a2.unstyled.field) != null ? $db4a338c74752624$var$_b : {}
};
var $db4a338c74752624$var$_a3, $db4a338c74752624$var$_b2, $db4a338c74752624$var$_c, $db4a338c74752624$var$_d, $db4a338c74752624$var$_e, $db4a338c74752624$var$_f, $db4a338c74752624$var$_g, $db4a338c74752624$var$_h;
var $db4a338c74752624$var$sizes = {
    xs: ($db4a338c74752624$var$_b2 = ($db4a338c74752624$var$_a3 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $db4a338c74752624$var$_a3.xs.field) != null ? $db4a338c74752624$var$_b2 : {},
    sm: ($db4a338c74752624$var$_d = ($db4a338c74752624$var$_c = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $db4a338c74752624$var$_c.sm.field) != null ? $db4a338c74752624$var$_d : {},
    md: ($db4a338c74752624$var$_f = ($db4a338c74752624$var$_e = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $db4a338c74752624$var$_e.md.field) != null ? $db4a338c74752624$var$_f : {},
    lg: ($db4a338c74752624$var$_h = ($db4a338c74752624$var$_g = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $db4a338c74752624$var$_g.lg.field) != null ? $db4a338c74752624$var$_h : {}
};
var $db4a338c74752624$export$394b8322fab774c1 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $db4a338c74752624$var$baseStyle,
    sizes: $db4a338c74752624$var$sizes,
    variants: $db4a338c74752624$var$variants,
    defaultProps: {
        size: "md",
        variant: "outline"
    }
});


// src/components/tooltip.ts


var $fd7519f20c5c0006$var$$bg = (0, $591785a32740c673$export$8b4981022bd80a4e)("tooltip-bg");
var $fd7519f20c5c0006$var$$fg = (0, $591785a32740c673$export$8b4981022bd80a4e)("tooltip-fg");
var $fd7519f20c5c0006$var$$arrowBg = (0, $591785a32740c673$export$8b4981022bd80a4e)("popper-arrow-bg");
var $fd7519f20c5c0006$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: $fd7519f20c5c0006$var$$bg.reference,
    color: $fd7519f20c5c0006$var$$fg.reference,
    [$fd7519f20c5c0006$var$$bg.variable]: "colors.gray.700",
    [$fd7519f20c5c0006$var$$fg.variable]: "colors.whiteAlpha.900",
    _dark: {
        [$fd7519f20c5c0006$var$$bg.variable]: "colors.gray.300",
        [$fd7519f20c5c0006$var$$fg.variable]: "colors.gray.900"
    },
    [$fd7519f20c5c0006$var$$arrowBg.variable]: $fd7519f20c5c0006$var$$bg.reference,
    px: "2",
    py: "0.5",
    borderRadius: "sm",
    fontWeight: "medium",
    fontSize: "sm",
    boxShadow: "md",
    maxW: "xs",
    zIndex: "tooltip"
});
var $fd7519f20c5c0006$export$7472a7883840b563 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $fd7519f20c5c0006$var$baseStyle
});


// src/components/progress.ts



var { defineMultiStyleConfig: $924e305cbcea9b38$var$defineMultiStyleConfig, definePartsStyle: $924e305cbcea9b38$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$ba6328c242bd649c).keys);
var $924e305cbcea9b38$var$filledStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: t, isIndeterminate: isIndeterminate, hasStripe: hasStripe } = props;
    const stripeStyle = (0, $6eb225f883147347$export$549ff81930776885)((0, $a031d15006571f58$export$db0ffb03ee9f3080)(), (0, $a031d15006571f58$export$db0ffb03ee9f3080)("1rem", "rgba(0,0,0,0.1)"))(props);
    const bgColor = (0, $6eb225f883147347$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props);
    const gradient = `linear-gradient(
    to right,
    transparent 0%,
    ${(0, $a031d15006571f58$export$5551a2d24ff40153)(t, bgColor)} 50%,
    transparent 100%
  )`;
    const addStripe = !isIndeterminate && hasStripe;
    return {
        ...addStripe && stripeStyle,
        ...isIndeterminate ? {
            bgImage: gradient
        } : {
            bgColor: bgColor
        }
    };
});
var $924e305cbcea9b38$var$baseStyleLabel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    lineHeight: "1",
    fontSize: "0.25em",
    fontWeight: "bold",
    color: "white"
});
var $924e305cbcea9b38$var$baseStyleTrack = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    return {
        bg: (0, $6eb225f883147347$export$549ff81930776885)("gray.100", "whiteAlpha.300")(props)
    };
});
var $924e305cbcea9b38$var$baseStyleFilledTrack = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    return {
        transitionProperty: "common",
        transitionDuration: "slow",
        ...$924e305cbcea9b38$var$filledStyle(props)
    };
});
var $924e305cbcea9b38$var$baseStyle = $924e305cbcea9b38$var$definePartsStyle((props)=>({
        label: $924e305cbcea9b38$var$baseStyleLabel,
        filledTrack: $924e305cbcea9b38$var$baseStyleFilledTrack(props),
        track: $924e305cbcea9b38$var$baseStyleTrack(props)
    }));
var $924e305cbcea9b38$var$sizes = {
    xs: $924e305cbcea9b38$var$definePartsStyle({
        track: {
            h: "1"
        }
    }),
    sm: $924e305cbcea9b38$var$definePartsStyle({
        track: {
            h: "2"
        }
    }),
    md: $924e305cbcea9b38$var$definePartsStyle({
        track: {
            h: "3"
        }
    }),
    lg: $924e305cbcea9b38$var$definePartsStyle({
        track: {
            h: "4"
        }
    })
};
var $924e305cbcea9b38$export$dc04d8e6a17afea1 = $924e305cbcea9b38$var$defineMultiStyleConfig({
    sizes: $924e305cbcea9b38$var$sizes,
    baseStyle: $924e305cbcea9b38$var$baseStyle,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});


// src/utils/run-if-fn.ts
var $245fb38d8179b6d2$var$isFunction = (value)=>typeof value === "function";
function $245fb38d8179b6d2$export$624e501d81f5ffce(valueOrFn, ...args) {
    return $245fb38d8179b6d2$var$isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}





var { definePartsStyle: $3a660172b177ab9e$var$definePartsStyle, defineMultiStyleConfig: $3a660172b177ab9e$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$21946b04497ed6ac).keys);
var $3a660172b177ab9e$var$$size = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("checkbox-size");
var $3a660172b177ab9e$var$baseStyleControl = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        w: $3a660172b177ab9e$var$$size.reference,
        h: $3a660172b177ab9e$var$$size.reference,
        transitionProperty: "box-shadow",
        transitionDuration: "normal",
        border: "2px solid",
        borderRadius: "sm",
        borderColor: "inherit",
        color: "white",
        _checked: {
            bg: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            borderColor: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            color: (0, $6eb225f883147347$export$549ff81930776885)("white", "gray.900")(props),
            _hover: {
                bg: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.600`, `${c}.300`)(props),
                borderColor: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.600`, `${c}.300`)(props)
            },
            _disabled: {
                borderColor: (0, $6eb225f883147347$export$549ff81930776885)("gray.200", "transparent")(props),
                bg: (0, $6eb225f883147347$export$549ff81930776885)("gray.200", "whiteAlpha.300")(props),
                color: (0, $6eb225f883147347$export$549ff81930776885)("gray.500", "whiteAlpha.500")(props)
            }
        },
        _indeterminate: {
            bg: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            borderColor: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            color: (0, $6eb225f883147347$export$549ff81930776885)("white", "gray.900")(props)
        },
        _disabled: {
            bg: (0, $6eb225f883147347$export$549ff81930776885)("gray.100", "whiteAlpha.100")(props),
            borderColor: (0, $6eb225f883147347$export$549ff81930776885)("gray.100", "transparent")(props)
        },
        _focusVisible: {
            boxShadow: "outline"
        },
        _invalid: {
            borderColor: (0, $6eb225f883147347$export$549ff81930776885)("red.500", "red.300")(props)
        }
    };
});
var $3a660172b177ab9e$var$baseStyleContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    _disabled: {
        cursor: "not-allowed"
    }
});
var $3a660172b177ab9e$var$baseStyleLabel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    userSelect: "none",
    _disabled: {
        opacity: 0.4
    }
});
var $3a660172b177ab9e$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    transitionProperty: "transform",
    transitionDuration: "normal"
});
var $3a660172b177ab9e$var$baseStyle = $3a660172b177ab9e$var$definePartsStyle((props)=>({
        icon: $3a660172b177ab9e$var$baseStyleIcon,
        container: $3a660172b177ab9e$var$baseStyleContainer,
        control: (0, $245fb38d8179b6d2$export$624e501d81f5ffce)($3a660172b177ab9e$var$baseStyleControl, props),
        label: $3a660172b177ab9e$var$baseStyleLabel
    }));
var $3a660172b177ab9e$var$sizes = {
    sm: $3a660172b177ab9e$var$definePartsStyle({
        control: {
            [$3a660172b177ab9e$var$$size.variable]: "sizes.3"
        },
        label: {
            fontSize: "sm"
        },
        icon: {
            fontSize: "3xs"
        }
    }),
    md: $3a660172b177ab9e$var$definePartsStyle({
        control: {
            [$3a660172b177ab9e$var$$size.variable]: "sizes.4"
        },
        label: {
            fontSize: "md"
        },
        icon: {
            fontSize: "2xs"
        }
    }),
    lg: $3a660172b177ab9e$var$definePartsStyle({
        control: {
            [$3a660172b177ab9e$var$$size.variable]: "sizes.5"
        },
        label: {
            fontSize: "lg"
        },
        icon: {
            fontSize: "2xs"
        }
    })
};
var $3a660172b177ab9e$export$86286d8c37984115 = $3a660172b177ab9e$var$defineMultiStyleConfig({
    baseStyle: $3a660172b177ab9e$var$baseStyle,
    sizes: $3a660172b177ab9e$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});





var { defineMultiStyleConfig: $21c6841492ceabf9$var$defineMultiStyleConfig, definePartsStyle: $21c6841492ceabf9$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$d28d06d0e29ef022).keys);
var $21c6841492ceabf9$var$baseStyleControl = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    var _a;
    const controlStyle = (_a = (0, $245fb38d8179b6d2$export$624e501d81f5ffce)((0, $3a660172b177ab9e$export$86286d8c37984115).baseStyle, props)) == null ? void 0 : _a.control;
    return {
        ...controlStyle,
        borderRadius: "full",
        _checked: {
            ...controlStyle == null ? void 0 : controlStyle["_checked"],
            _before: {
                content: `""`,
                display: "inline-block",
                pos: "relative",
                w: "50%",
                h: "50%",
                borderRadius: "50%",
                bg: "currentColor"
            }
        }
    };
});
var $21c6841492ceabf9$var$baseStyle = $21c6841492ceabf9$var$definePartsStyle((props)=>{
    var _a, _b, _c, _d;
    return {
        label: (_b = (_a = (0, $3a660172b177ab9e$export$86286d8c37984115)).baseStyle) == null ? void 0 : _b.call(_a, props).label,
        container: (_d = (_c = (0, $3a660172b177ab9e$export$86286d8c37984115)).baseStyle) == null ? void 0 : _d.call(_c, props).container,
        control: $21c6841492ceabf9$var$baseStyleControl(props)
    };
});
var $21c6841492ceabf9$var$sizes = {
    md: $21c6841492ceabf9$var$definePartsStyle({
        control: {
            w: "4",
            h: "4"
        },
        label: {
            fontSize: "md"
        }
    }),
    lg: $21c6841492ceabf9$var$definePartsStyle({
        control: {
            w: "5",
            h: "5"
        },
        label: {
            fontSize: "lg"
        }
    }),
    sm: $21c6841492ceabf9$var$definePartsStyle({
        control: {
            width: "3",
            height: "3"
        },
        label: {
            fontSize: "sm"
        }
    })
};
var $21c6841492ceabf9$export$f0b387b940941887 = $21c6841492ceabf9$var$defineMultiStyleConfig({
    baseStyle: $21c6841492ceabf9$var$baseStyle,
    sizes: $21c6841492ceabf9$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});





var { defineMultiStyleConfig: $aba0b22b8ca9eec7$var$defineMultiStyleConfig, definePartsStyle: $aba0b22b8ca9eec7$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$17993f0be9538b5a).keys);
var $aba0b22b8ca9eec7$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("select-bg");
var $aba0b22b8ca9eec7$var$_a;
var $aba0b22b8ca9eec7$var$baseStyleField = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    ...($aba0b22b8ca9eec7$var$_a = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).baseStyle) == null ? void 0 : $aba0b22b8ca9eec7$var$_a.field,
    appearance: "none",
    paddingBottom: "1px",
    lineHeight: "normal",
    bg: $aba0b22b8ca9eec7$var$$bg.reference,
    [$aba0b22b8ca9eec7$var$$bg.variable]: "colors.white",
    _dark: {
        [$aba0b22b8ca9eec7$var$$bg.variable]: "colors.gray.700"
    },
    "> option, > optgroup": {
        bg: $aba0b22b8ca9eec7$var$$bg.reference
    }
});
var $aba0b22b8ca9eec7$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    width: "6",
    height: "100%",
    insetEnd: "2",
    position: "relative",
    color: "currentColor",
    fontSize: "xl",
    _disabled: {
        opacity: 0.5
    }
});
var $aba0b22b8ca9eec7$var$baseStyle = $aba0b22b8ca9eec7$var$definePartsStyle({
    field: $aba0b22b8ca9eec7$var$baseStyleField,
    icon: $aba0b22b8ca9eec7$var$baseStyleIcon
});
var $aba0b22b8ca9eec7$var$iconSpacing = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    paddingInlineEnd: "8"
});
var $aba0b22b8ca9eec7$var$_a2, $aba0b22b8ca9eec7$var$_b, $aba0b22b8ca9eec7$var$_c, $aba0b22b8ca9eec7$var$_d, $aba0b22b8ca9eec7$var$_e, $aba0b22b8ca9eec7$var$_f, $aba0b22b8ca9eec7$var$_g, $aba0b22b8ca9eec7$var$_h;
var $aba0b22b8ca9eec7$var$sizes = {
    lg: {
        ...($aba0b22b8ca9eec7$var$_a2 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $aba0b22b8ca9eec7$var$_a2.lg,
        field: {
            ...($aba0b22b8ca9eec7$var$_b = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $aba0b22b8ca9eec7$var$_b.lg.field,
            ...$aba0b22b8ca9eec7$var$iconSpacing
        }
    },
    md: {
        ...($aba0b22b8ca9eec7$var$_c = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $aba0b22b8ca9eec7$var$_c.md,
        field: {
            ...($aba0b22b8ca9eec7$var$_d = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $aba0b22b8ca9eec7$var$_d.md.field,
            ...$aba0b22b8ca9eec7$var$iconSpacing
        }
    },
    sm: {
        ...($aba0b22b8ca9eec7$var$_e = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $aba0b22b8ca9eec7$var$_e.sm,
        field: {
            ...($aba0b22b8ca9eec7$var$_f = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $aba0b22b8ca9eec7$var$_f.sm.field,
            ...$aba0b22b8ca9eec7$var$iconSpacing
        }
    },
    xs: {
        ...($aba0b22b8ca9eec7$var$_g = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $aba0b22b8ca9eec7$var$_g.xs,
        field: {
            ...($aba0b22b8ca9eec7$var$_h = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $aba0b22b8ca9eec7$var$_h.xs.field,
            ...$aba0b22b8ca9eec7$var$iconSpacing
        },
        icon: {
            insetEnd: "1"
        }
    }
};
var $aba0b22b8ca9eec7$export$21af0fc3c16183e1 = $aba0b22b8ca9eec7$var$defineMultiStyleConfig({
    baseStyle: $aba0b22b8ca9eec7$var$baseStyle,
    sizes: $aba0b22b8ca9eec7$var$sizes,
    variants: (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants,
    defaultProps: (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).defaultProps
});


// src/components/skeleton.ts

var $6eb62cdac4dee0fa$var$$startColor = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("skeleton-start-color");
var $6eb62cdac4dee0fa$var$$endColor = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("skeleton-end-color");
var $6eb62cdac4dee0fa$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    [$6eb62cdac4dee0fa$var$$startColor.variable]: "colors.gray.100",
    [$6eb62cdac4dee0fa$var$$endColor.variable]: "colors.gray.400",
    _dark: {
        [$6eb62cdac4dee0fa$var$$startColor.variable]: "colors.gray.800",
        [$6eb62cdac4dee0fa$var$$endColor.variable]: "colors.gray.600"
    },
    background: $6eb62cdac4dee0fa$var$$startColor.reference,
    borderColor: $6eb62cdac4dee0fa$var$$endColor.reference,
    opacity: 0.7,
    borderRadius: "sm"
});
var $6eb62cdac4dee0fa$export$7680371ad2d79142 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $6eb62cdac4dee0fa$var$baseStyle
});


// src/components/skip-link.ts

var $de81dc100e8decd2$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("skip-link-bg");
var $de81dc100e8decd2$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    fontWeight: "semibold",
    _focusVisible: {
        boxShadow: "outline",
        padding: "4",
        position: "fixed",
        top: "6",
        insetStart: "6",
        [$de81dc100e8decd2$var$$bg.variable]: "colors.white",
        _dark: {
            [$de81dc100e8decd2$var$$bg.variable]: "colors.gray.700"
        },
        bg: $de81dc100e8decd2$var$$bg.reference
    }
});
var $de81dc100e8decd2$export$a8cf3228ef52959 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $de81dc100e8decd2$var$baseStyle
});


// src/components/slider.ts



var { defineMultiStyleConfig: $8004dd2b97b58653$var$defineMultiStyleConfig, definePartsStyle: $8004dd2b97b58653$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$c21b4b3f8b239f32).keys);
var $8004dd2b97b58653$var$$thumbSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("slider-thumb-size");
var $8004dd2b97b58653$var$$trackSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("slider-track-size");
var $8004dd2b97b58653$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("slider-bg");
var $8004dd2b97b58653$var$baseStyleContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { orientation: orientation } = props;
    return {
        display: "inline-block",
        position: "relative",
        cursor: "pointer",
        _disabled: {
            opacity: 0.6,
            cursor: "default",
            pointerEvents: "none"
        },
        ...(0, $6eb225f883147347$export$f3eec17ee6065eee)({
            orientation: orientation,
            vertical: {
                h: "100%"
            },
            horizontal: {
                w: "100%"
            }
        })
    };
});
var $8004dd2b97b58653$var$baseStyleTrack = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const orientationStyles = (0, $6eb225f883147347$export$f3eec17ee6065eee)({
        orientation: props.orientation,
        horizontal: {
            h: $8004dd2b97b58653$var$$trackSize.reference
        },
        vertical: {
            w: $8004dd2b97b58653$var$$trackSize.reference
        }
    });
    return {
        ...orientationStyles,
        overflow: "hidden",
        borderRadius: "sm",
        [$8004dd2b97b58653$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$8004dd2b97b58653$var$$bg.variable]: "colors.whiteAlpha.200"
        },
        _disabled: {
            [$8004dd2b97b58653$var$$bg.variable]: "colors.gray.300",
            _dark: {
                [$8004dd2b97b58653$var$$bg.variable]: "colors.whiteAlpha.300"
            }
        },
        bg: $8004dd2b97b58653$var$$bg.reference
    };
});
var $8004dd2b97b58653$var$baseStyleThumb = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { orientation: orientation } = props;
    const orientationStyle = (0, $6eb225f883147347$export$f3eec17ee6065eee)({
        orientation: orientation,
        vertical: {
            left: "50%",
            transform: `translateX(-50%)`,
            _active: {
                transform: `translateX(-50%) scale(1.15)`
            }
        },
        horizontal: {
            top: "50%",
            transform: `translateY(-50%)`,
            _active: {
                transform: `translateY(-50%) scale(1.15)`
            }
        }
    });
    return {
        ...orientationStyle,
        w: $8004dd2b97b58653$var$$thumbSize.reference,
        h: $8004dd2b97b58653$var$$thumbSize.reference,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        outline: 0,
        zIndex: 1,
        borderRadius: "full",
        bg: "white",
        boxShadow: "base",
        border: "1px solid",
        borderColor: "transparent",
        transitionProperty: "transform",
        transitionDuration: "normal",
        _focusVisible: {
            boxShadow: "outline"
        },
        _disabled: {
            bg: "gray.300"
        }
    };
});
var $8004dd2b97b58653$var$baseStyleFilledTrack = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        width: "inherit",
        height: "inherit",
        [$8004dd2b97b58653$var$$bg.variable]: `colors.${c}.500`,
        _dark: {
            [$8004dd2b97b58653$var$$bg.variable]: `colors.${c}.200`
        },
        bg: $8004dd2b97b58653$var$$bg.reference
    };
});
var $8004dd2b97b58653$var$baseStyle = $8004dd2b97b58653$var$definePartsStyle((props)=>({
        container: $8004dd2b97b58653$var$baseStyleContainer(props),
        track: $8004dd2b97b58653$var$baseStyleTrack(props),
        thumb: $8004dd2b97b58653$var$baseStyleThumb(props),
        filledTrack: $8004dd2b97b58653$var$baseStyleFilledTrack(props)
    }));
var $8004dd2b97b58653$var$sizeLg = $8004dd2b97b58653$var$definePartsStyle({
    container: {
        [$8004dd2b97b58653$var$$thumbSize.variable]: `sizes.4`,
        [$8004dd2b97b58653$var$$trackSize.variable]: `sizes.1`
    }
});
var $8004dd2b97b58653$var$sizeMd = $8004dd2b97b58653$var$definePartsStyle({
    container: {
        [$8004dd2b97b58653$var$$thumbSize.variable]: `sizes.3.5`,
        [$8004dd2b97b58653$var$$trackSize.variable]: `sizes.1`
    }
});
var $8004dd2b97b58653$var$sizeSm = $8004dd2b97b58653$var$definePartsStyle({
    container: {
        [$8004dd2b97b58653$var$$thumbSize.variable]: `sizes.2.5`,
        [$8004dd2b97b58653$var$$trackSize.variable]: `sizes.0.5`
    }
});
var $8004dd2b97b58653$var$sizes = {
    lg: $8004dd2b97b58653$var$sizeLg,
    md: $8004dd2b97b58653$var$sizeMd,
    sm: $8004dd2b97b58653$var$sizeSm
};
var $8004dd2b97b58653$export$fff8df8fd8e1ed6f = $8004dd2b97b58653$var$defineMultiStyleConfig({
    baseStyle: $8004dd2b97b58653$var$baseStyle,
    sizes: $8004dd2b97b58653$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});


// src/components/spinner.ts


var $a4266c6ac9b1dc5e$var$$size = (0, $591785a32740c673$export$8b4981022bd80a4e)("spinner-size");
var $a4266c6ac9b1dc5e$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    width: [
        $a4266c6ac9b1dc5e$var$$size.reference
    ],
    height: [
        $a4266c6ac9b1dc5e$var$$size.reference
    ]
});
var $a4266c6ac9b1dc5e$var$sizes = {
    xs: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$a4266c6ac9b1dc5e$var$$size.variable]: "sizes.3"
    }),
    sm: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$a4266c6ac9b1dc5e$var$$size.variable]: "sizes.4"
    }),
    md: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$a4266c6ac9b1dc5e$var$$size.variable]: "sizes.6"
    }),
    lg: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$a4266c6ac9b1dc5e$var$$size.variable]: "sizes.8"
    }),
    xl: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$a4266c6ac9b1dc5e$var$$size.variable]: "sizes.12"
    })
};
var $a4266c6ac9b1dc5e$export$d76156e68e556d3f = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $a4266c6ac9b1dc5e$var$baseStyle,
    sizes: $a4266c6ac9b1dc5e$var$sizes,
    defaultProps: {
        size: "md"
    }
});


// src/components/stat.ts


var { defineMultiStyleConfig: $17b9d17ea3bfb461$var$defineMultiStyleConfig, definePartsStyle: $17b9d17ea3bfb461$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$2cfbad67ae6ee421).keys);
var $17b9d17ea3bfb461$var$baseStyleLabel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontWeight: "medium"
});
var $17b9d17ea3bfb461$var$baseStyleHelpText = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    opacity: 0.8,
    marginBottom: "2"
});
var $17b9d17ea3bfb461$var$baseStyleNumber = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    verticalAlign: "baseline",
    fontWeight: "semibold"
});
var $17b9d17ea3bfb461$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    marginEnd: 1,
    w: "3.5",
    h: "3.5",
    verticalAlign: "middle"
});
var $17b9d17ea3bfb461$var$baseStyle = $17b9d17ea3bfb461$var$definePartsStyle({
    container: {},
    label: $17b9d17ea3bfb461$var$baseStyleLabel,
    helpText: $17b9d17ea3bfb461$var$baseStyleHelpText,
    number: $17b9d17ea3bfb461$var$baseStyleNumber,
    icon: $17b9d17ea3bfb461$var$baseStyleIcon
});
var $17b9d17ea3bfb461$var$sizes = {
    md: $17b9d17ea3bfb461$var$definePartsStyle({
        label: {
            fontSize: "sm"
        },
        helpText: {
            fontSize: "sm"
        },
        number: {
            fontSize: "2xl"
        }
    })
};
var $17b9d17ea3bfb461$export$f3301eb37a20f09e = $17b9d17ea3bfb461$var$defineMultiStyleConfig({
    baseStyle: $17b9d17ea3bfb461$var$baseStyle,
    sizes: $17b9d17ea3bfb461$var$sizes,
    defaultProps: {
        size: "md"
    }
});


// src/components/kbd.ts

var $99ce1a067887b061$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("kbd-bg");
var $99ce1a067887b061$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    [$99ce1a067887b061$var$$bg.variable]: "colors.gray.100",
    _dark: {
        [$99ce1a067887b061$var$$bg.variable]: "colors.whiteAlpha.100"
    },
    bg: $99ce1a067887b061$var$$bg.reference,
    borderRadius: "md",
    borderWidth: "1px",
    borderBottomWidth: "3px",
    fontSize: "0.8em",
    fontWeight: "bold",
    lineHeight: "normal",
    px: "0.4em",
    whiteSpace: "nowrap"
});
var $99ce1a067887b061$export$e193528a501e9a4a = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $99ce1a067887b061$var$baseStyle
});


// src/components/link.ts

var $33cdc3a44bd030c6$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    cursor: "pointer",
    textDecoration: "none",
    outline: "none",
    color: "inherit",
    _hover: {
        textDecoration: "underline"
    },
    _focusVisible: {
        boxShadow: "outline"
    }
});
var $33cdc3a44bd030c6$export$af7f58b96695762e = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $33cdc3a44bd030c6$var$baseStyle
});


// src/components/list.ts


var { defineMultiStyleConfig: $7e7ecde49b12814e$var$defineMultiStyleConfig, definePartsStyle: $7e7ecde49b12814e$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$12b3a655a94374ed).keys);
var $7e7ecde49b12814e$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    marginEnd: "2",
    display: "inline",
    verticalAlign: "text-bottom"
});
var $7e7ecde49b12814e$var$baseStyle = $7e7ecde49b12814e$var$definePartsStyle({
    icon: $7e7ecde49b12814e$var$baseStyleIcon
});
var $7e7ecde49b12814e$export$ce840f8e8ef752d = $7e7ecde49b12814e$var$defineMultiStyleConfig({
    baseStyle: $7e7ecde49b12814e$var$baseStyle
});


// src/components/menu.ts


var { defineMultiStyleConfig: $0f90576fb7bd80ad$var$defineMultiStyleConfig, definePartsStyle: $0f90576fb7bd80ad$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$e251092a5dcb1329).keys);
var $0f90576fb7bd80ad$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("menu-bg");
var $0f90576fb7bd80ad$var$$shadow = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("menu-shadow");
var $0f90576fb7bd80ad$var$baseStyleList = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    [$0f90576fb7bd80ad$var$$bg.variable]: "#fff",
    [$0f90576fb7bd80ad$var$$shadow.variable]: "shadows.sm",
    _dark: {
        [$0f90576fb7bd80ad$var$$bg.variable]: "colors.gray.700",
        [$0f90576fb7bd80ad$var$$shadow.variable]: "shadows.dark-lg"
    },
    color: "inherit",
    minW: "3xs",
    py: "2",
    zIndex: 1,
    borderRadius: "md",
    borderWidth: "1px",
    bg: $0f90576fb7bd80ad$var$$bg.reference,
    boxShadow: $0f90576fb7bd80ad$var$$shadow.reference
});
var $0f90576fb7bd80ad$var$baseStyleItem = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    py: "1.5",
    px: "3",
    transitionProperty: "background",
    transitionDuration: "ultra-fast",
    transitionTimingFunction: "ease-in",
    _focus: {
        [$0f90576fb7bd80ad$var$$bg.variable]: "colors.gray.100",
        _dark: {
            [$0f90576fb7bd80ad$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _active: {
        [$0f90576fb7bd80ad$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$0f90576fb7bd80ad$var$$bg.variable]: "colors.whiteAlpha.200"
        }
    },
    _expanded: {
        [$0f90576fb7bd80ad$var$$bg.variable]: "colors.gray.100",
        _dark: {
            [$0f90576fb7bd80ad$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    },
    bg: $0f90576fb7bd80ad$var$$bg.reference
});
var $0f90576fb7bd80ad$var$baseStyleGroupTitle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    mx: 4,
    my: 2,
    fontWeight: "semibold",
    fontSize: "sm"
});
var $0f90576fb7bd80ad$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
});
var $0f90576fb7bd80ad$var$baseStyleCommand = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    opacity: 0.6
});
var $0f90576fb7bd80ad$var$baseStyleDivider = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    border: 0,
    borderBottom: "1px solid",
    borderColor: "inherit",
    my: "2",
    opacity: 0.6
});
var $0f90576fb7bd80ad$var$baseStyleButton = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "normal"
});
var $0f90576fb7bd80ad$var$baseStyle = $0f90576fb7bd80ad$var$definePartsStyle({
    button: $0f90576fb7bd80ad$var$baseStyleButton,
    list: $0f90576fb7bd80ad$var$baseStyleList,
    item: $0f90576fb7bd80ad$var$baseStyleItem,
    groupTitle: $0f90576fb7bd80ad$var$baseStyleGroupTitle,
    icon: $0f90576fb7bd80ad$var$baseStyleIcon,
    command: $0f90576fb7bd80ad$var$baseStyleCommand,
    divider: $0f90576fb7bd80ad$var$baseStyleDivider
});
var $0f90576fb7bd80ad$export$687ce088075ea42b = $0f90576fb7bd80ad$var$defineMultiStyleConfig({
    baseStyle: $0f90576fb7bd80ad$var$baseStyle
});





var { defineMultiStyleConfig: $3966d8e51ac3bc1e$var$defineMultiStyleConfig, definePartsStyle: $3966d8e51ac3bc1e$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$34e33beb8d992ac2).keys);
var $3966d8e51ac3bc1e$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("modal-bg");
var $3966d8e51ac3bc1e$var$$shadow = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("modal-shadow");
var $3966d8e51ac3bc1e$var$baseStyleOverlay = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "blackAlpha.600",
    zIndex: "modal"
});
var $3966d8e51ac3bc1e$var$baseStyleDialogContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { isCentered: isCentered, scrollBehavior: scrollBehavior } = props;
    return {
        display: "flex",
        zIndex: "modal",
        justifyContent: "center",
        alignItems: isCentered ? "center" : "flex-start",
        overflow: scrollBehavior === "inside" ? "hidden" : "auto",
        overscrollBehaviorY: "none"
    };
});
var $3966d8e51ac3bc1e$var$baseStyleDialog = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { isCentered: isCentered, scrollBehavior: scrollBehavior } = props;
    return {
        borderRadius: "md",
        color: "inherit",
        my: isCentered ? "auto" : "16",
        mx: isCentered ? "auto" : void 0,
        zIndex: "modal",
        maxH: scrollBehavior === "inside" ? "calc(100% - 7.5rem)" : void 0,
        [$3966d8e51ac3bc1e$var$$bg.variable]: "colors.white",
        [$3966d8e51ac3bc1e$var$$shadow.variable]: "shadows.lg",
        _dark: {
            [$3966d8e51ac3bc1e$var$$bg.variable]: "colors.gray.700",
            [$3966d8e51ac3bc1e$var$$shadow.variable]: "shadows.dark-lg"
        },
        bg: $3966d8e51ac3bc1e$var$$bg.reference,
        boxShadow: $3966d8e51ac3bc1e$var$$shadow.reference
    };
});
var $3966d8e51ac3bc1e$var$baseStyleHeader = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4",
    fontSize: "xl",
    fontWeight: "semibold"
});
var $3966d8e51ac3bc1e$var$baseStyleCloseButton = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    position: "absolute",
    top: "2",
    insetEnd: "3"
});
var $3966d8e51ac3bc1e$var$baseStyleBody = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { scrollBehavior: scrollBehavior } = props;
    return {
        px: "6",
        py: "2",
        flex: "1",
        overflow: scrollBehavior === "inside" ? "auto" : void 0
    };
});
var $3966d8e51ac3bc1e$var$baseStyleFooter = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4"
});
var $3966d8e51ac3bc1e$var$baseStyle = $3966d8e51ac3bc1e$var$definePartsStyle((props)=>({
        overlay: $3966d8e51ac3bc1e$var$baseStyleOverlay,
        dialogContainer: (0, $245fb38d8179b6d2$export$624e501d81f5ffce)($3966d8e51ac3bc1e$var$baseStyleDialogContainer, props),
        dialog: (0, $245fb38d8179b6d2$export$624e501d81f5ffce)($3966d8e51ac3bc1e$var$baseStyleDialog, props),
        header: $3966d8e51ac3bc1e$var$baseStyleHeader,
        closeButton: $3966d8e51ac3bc1e$var$baseStyleCloseButton,
        body: (0, $245fb38d8179b6d2$export$624e501d81f5ffce)($3966d8e51ac3bc1e$var$baseStyleBody, props),
        footer: $3966d8e51ac3bc1e$var$baseStyleFooter
    }));
function $3966d8e51ac3bc1e$var$getSize(value) {
    if (value === "full") return $3966d8e51ac3bc1e$var$definePartsStyle({
        dialog: {
            maxW: "100vw",
            minH: "$100vh",
            my: "0",
            borderRadius: "0"
        }
    });
    return $3966d8e51ac3bc1e$var$definePartsStyle({
        dialog: {
            maxW: value
        }
    });
}
var $3966d8e51ac3bc1e$var$sizes = {
    xs: $3966d8e51ac3bc1e$var$getSize("xs"),
    sm: $3966d8e51ac3bc1e$var$getSize("sm"),
    md: $3966d8e51ac3bc1e$var$getSize("md"),
    lg: $3966d8e51ac3bc1e$var$getSize("lg"),
    xl: $3966d8e51ac3bc1e$var$getSize("xl"),
    "2xl": $3966d8e51ac3bc1e$var$getSize("2xl"),
    "3xl": $3966d8e51ac3bc1e$var$getSize("3xl"),
    "4xl": $3966d8e51ac3bc1e$var$getSize("4xl"),
    "5xl": $3966d8e51ac3bc1e$var$getSize("5xl"),
    "6xl": $3966d8e51ac3bc1e$var$getSize("6xl"),
    full: $3966d8e51ac3bc1e$var$getSize("full")
};
var $3966d8e51ac3bc1e$export$158ae9a07be41c05 = $3966d8e51ac3bc1e$var$defineMultiStyleConfig({
    baseStyle: $3966d8e51ac3bc1e$var$baseStyle,
    sizes: $3966d8e51ac3bc1e$var$sizes,
    defaultProps: {
        size: "md"
    }
});








var { defineMultiStyleConfig: $57684a561be679fe$var$defineMultiStyleConfig, definePartsStyle: $57684a561be679fe$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$859cc7ca3200df97).keys);
var $57684a561be679fe$var$$stepperWidth = (0, $591785a32740c673$export$8b4981022bd80a4e)("number-input-stepper-width");
var $57684a561be679fe$var$$inputPadding = (0, $591785a32740c673$export$8b4981022bd80a4e)("number-input-input-padding");
var $57684a561be679fe$var$inputPaddingValue = (0, $2ef820b9f4ef8e93$export$42bfa9b2d4dad91a)($57684a561be679fe$var$$stepperWidth).add("0.5rem").toString();
var $57684a561be679fe$var$$bg = (0, $591785a32740c673$export$8b4981022bd80a4e)("number-input-bg");
var $57684a561be679fe$var$$fg = (0, $591785a32740c673$export$8b4981022bd80a4e)("number-input-color");
var $57684a561be679fe$var$$border = (0, $591785a32740c673$export$8b4981022bd80a4e)("number-input-border-color");
var $57684a561be679fe$var$baseStyleRoot = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    [$57684a561be679fe$var$$stepperWidth.variable]: "sizes.6",
    [$57684a561be679fe$var$$inputPadding.variable]: $57684a561be679fe$var$inputPaddingValue
});
var $57684a561be679fe$var$baseStyleField = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    var _a, _b;
    return (_b = (_a = (0, $245fb38d8179b6d2$export$624e501d81f5ffce)((0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).baseStyle, props)) == null ? void 0 : _a.field) != null ? _b : {};
});
var $57684a561be679fe$var$baseStyleStepperGroup = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    width: $57684a561be679fe$var$$stepperWidth.reference
});
var $57684a561be679fe$var$baseStyleStepper = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderStart: "1px solid",
    borderStartColor: $57684a561be679fe$var$$border.reference,
    color: $57684a561be679fe$var$$fg.reference,
    bg: $57684a561be679fe$var$$bg.reference,
    [$57684a561be679fe$var$$fg.variable]: "colors.chakra-body-text",
    [$57684a561be679fe$var$$border.variable]: "colors.chakra-border-color",
    _dark: {
        [$57684a561be679fe$var$$fg.variable]: "colors.whiteAlpha.800",
        [$57684a561be679fe$var$$border.variable]: "colors.whiteAlpha.300"
    },
    _active: {
        [$57684a561be679fe$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$57684a561be679fe$var$$bg.variable]: "colors.whiteAlpha.300"
        }
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    }
});
var $57684a561be679fe$var$baseStyle = $57684a561be679fe$var$definePartsStyle((props)=>{
    var _a;
    return {
        root: $57684a561be679fe$var$baseStyleRoot,
        field: (_a = (0, $245fb38d8179b6d2$export$624e501d81f5ffce)($57684a561be679fe$var$baseStyleField, props)) != null ? _a : {},
        stepperGroup: $57684a561be679fe$var$baseStyleStepperGroup,
        stepper: $57684a561be679fe$var$baseStyleStepper
    };
});
function $57684a561be679fe$var$getSize(size) {
    var _a, _b, _c;
    const sizeStyle = (_a = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : _a[size];
    const radius = {
        lg: "md",
        md: "md",
        sm: "sm",
        xs: "sm"
    };
    const _fontSize = (_c = (_b = sizeStyle.field) == null ? void 0 : _b.fontSize) != null ? _c : "md";
    const fontSize = (0, $bba87cd2f18bf49d$export$d7c5d8884f83c8db).fontSizes[_fontSize];
    return $57684a561be679fe$var$definePartsStyle({
        field: {
            ...sizeStyle.field,
            paddingInlineEnd: $57684a561be679fe$var$$inputPadding.reference,
            verticalAlign: "top"
        },
        stepper: {
            fontSize: (0, $2ef820b9f4ef8e93$export$42bfa9b2d4dad91a)(fontSize).multiply(0.75).toString(),
            _first: {
                borderTopEndRadius: radius[size]
            },
            _last: {
                borderBottomEndRadius: radius[size],
                mt: "-1px",
                borderTopWidth: 1
            }
        }
    });
}
var $57684a561be679fe$var$sizes = {
    xs: $57684a561be679fe$var$getSize("xs"),
    sm: $57684a561be679fe$var$getSize("sm"),
    md: $57684a561be679fe$var$getSize("md"),
    lg: $57684a561be679fe$var$getSize("lg")
};
var $57684a561be679fe$export$b9bc5fa6e7f960a1 = $57684a561be679fe$var$defineMultiStyleConfig({
    baseStyle: $57684a561be679fe$var$baseStyle,
    sizes: $57684a561be679fe$var$sizes,
    variants: (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants,
    defaultProps: (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).defaultProps
});





var $4565c07955136284$var$_a;
var $4565c07955136284$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    ...($4565c07955136284$var$_a = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).baseStyle) == null ? void 0 : $4565c07955136284$var$_a.field,
    textAlign: "center"
});
var $4565c07955136284$var$sizes = {
    lg: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "lg",
        w: 12,
        h: 12,
        borderRadius: "md"
    }),
    md: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "md",
        w: 10,
        h: 10,
        borderRadius: "md"
    }),
    sm: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "sm",
        w: 8,
        h: 8,
        borderRadius: "sm"
    }),
    xs: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "xs",
        w: 6,
        h: 6,
        borderRadius: "sm"
    })
};
var $4565c07955136284$var$_a2, $4565c07955136284$var$_b;
var $4565c07955136284$var$variants = {
    outline: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
        var _a3, _b2, _c;
        return (_c = (_b2 = (0, $245fb38d8179b6d2$export$624e501d81f5ffce)((_a3 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants) == null ? void 0 : _a3.outline, props)) == null ? void 0 : _b2.field) != null ? _c : {};
    }),
    flushed: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
        var _a3, _b2, _c;
        return (_c = (_b2 = (0, $245fb38d8179b6d2$export$624e501d81f5ffce)((_a3 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants) == null ? void 0 : _a3.flushed, props)) == null ? void 0 : _b2.field) != null ? _c : {};
    }),
    filled: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
        var _a3, _b2, _c;
        return (_c = (_b2 = (0, $245fb38d8179b6d2$export$624e501d81f5ffce)((_a3 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants) == null ? void 0 : _a3.filled, props)) == null ? void 0 : _b2.field) != null ? _c : {};
    }),
    unstyled: ($4565c07955136284$var$_b = ($4565c07955136284$var$_a2 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants) == null ? void 0 : $4565c07955136284$var$_a2.unstyled.field) != null ? $4565c07955136284$var$_b : {}
};
var $4565c07955136284$export$8504c22c55a552e0 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $4565c07955136284$var$baseStyle,
    sizes: $4565c07955136284$var$sizes,
    variants: $4565c07955136284$var$variants,
    defaultProps: (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).defaultProps
});


// src/components/popover.ts



var { defineMultiStyleConfig: $dffd16657f8ddad5$var$defineMultiStyleConfig, definePartsStyle: $dffd16657f8ddad5$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$afda07d12cd4337d).keys);
var $dffd16657f8ddad5$var$$popperBg = (0, $591785a32740c673$export$8b4981022bd80a4e)("popper-bg");
var $dffd16657f8ddad5$var$$arrowBg = (0, $591785a32740c673$export$8b4981022bd80a4e)("popper-arrow-bg");
var $dffd16657f8ddad5$var$$arrowShadowColor = (0, $591785a32740c673$export$8b4981022bd80a4e)("popper-arrow-shadow-color");
var $dffd16657f8ddad5$var$baseStylePopper = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    zIndex: 10
});
var $dffd16657f8ddad5$var$baseStyleContent = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    [$dffd16657f8ddad5$var$$popperBg.variable]: `colors.white`,
    bg: $dffd16657f8ddad5$var$$popperBg.reference,
    [$dffd16657f8ddad5$var$$arrowBg.variable]: $dffd16657f8ddad5$var$$popperBg.reference,
    [$dffd16657f8ddad5$var$$arrowShadowColor.variable]: `colors.gray.200`,
    _dark: {
        [$dffd16657f8ddad5$var$$popperBg.variable]: `colors.gray.700`,
        [$dffd16657f8ddad5$var$$arrowShadowColor.variable]: `colors.whiteAlpha.300`
    },
    width: "xs",
    border: "1px solid",
    borderColor: "inherit",
    borderRadius: "md",
    boxShadow: "sm",
    zIndex: "inherit",
    _focusVisible: {
        outline: 0,
        boxShadow: "outline"
    }
});
var $dffd16657f8ddad5$var$baseStyleHeader = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: 3,
    py: 2,
    borderBottomWidth: "1px"
});
var $dffd16657f8ddad5$var$baseStyleBody = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: 3,
    py: 2
});
var $dffd16657f8ddad5$var$baseStyleFooter = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: 3,
    py: 2,
    borderTopWidth: "1px"
});
var $dffd16657f8ddad5$var$baseStyleCloseButton = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    position: "absolute",
    borderRadius: "md",
    top: 1,
    insetEnd: 2,
    padding: 2
});
var $dffd16657f8ddad5$var$baseStyle = $dffd16657f8ddad5$var$definePartsStyle({
    popper: $dffd16657f8ddad5$var$baseStylePopper,
    content: $dffd16657f8ddad5$var$baseStyleContent,
    header: $dffd16657f8ddad5$var$baseStyleHeader,
    body: $dffd16657f8ddad5$var$baseStyleBody,
    footer: $dffd16657f8ddad5$var$baseStyleFooter,
    closeButton: $dffd16657f8ddad5$var$baseStyleCloseButton
});
var $dffd16657f8ddad5$export$135f12f777be1ef7 = $dffd16657f8ddad5$var$defineMultiStyleConfig({
    baseStyle: $dffd16657f8ddad5$var$baseStyle
});





var { definePartsStyle: $58930da1c1c58005$var$definePartsStyle, defineMultiStyleConfig: $58930da1c1c58005$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$d3f4aaa4b0f2907a).keys);
var $58930da1c1c58005$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("drawer-bg");
var $58930da1c1c58005$var$$bs = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("drawer-box-shadow");
function $58930da1c1c58005$var$getSize(value) {
    if (value === "full") return $58930da1c1c58005$var$definePartsStyle({
        dialog: {
            maxW: "100vw",
            h: "100vh"
        }
    });
    return $58930da1c1c58005$var$definePartsStyle({
        dialog: {
            maxW: value
        }
    });
}
var $58930da1c1c58005$var$baseStyleOverlay = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "blackAlpha.600",
    zIndex: "modal"
});
var $58930da1c1c58005$var$baseStyleDialogContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    display: "flex",
    zIndex: "modal",
    justifyContent: "center"
});
var $58930da1c1c58005$var$baseStyleDialog = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { isFullHeight: isFullHeight } = props;
    return {
        ...isFullHeight && {
            height: "100vh"
        },
        zIndex: "modal",
        maxH: "100vh",
        color: "inherit",
        [$58930da1c1c58005$var$$bg.variable]: "colors.white",
        [$58930da1c1c58005$var$$bs.variable]: "shadows.lg",
        _dark: {
            [$58930da1c1c58005$var$$bg.variable]: "colors.gray.700",
            [$58930da1c1c58005$var$$bs.variable]: "shadows.dark-lg"
        },
        bg: $58930da1c1c58005$var$$bg.reference,
        boxShadow: $58930da1c1c58005$var$$bs.reference
    };
});
var $58930da1c1c58005$var$baseStyleHeader = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4",
    fontSize: "xl",
    fontWeight: "semibold"
});
var $58930da1c1c58005$var$baseStyleCloseButton = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    position: "absolute",
    top: "2",
    insetEnd: "3"
});
var $58930da1c1c58005$var$baseStyleBody = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: "6",
    py: "2",
    flex: "1",
    overflow: "auto"
});
var $58930da1c1c58005$var$baseStyleFooter = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4"
});
var $58930da1c1c58005$var$baseStyle = $58930da1c1c58005$var$definePartsStyle((props)=>({
        overlay: $58930da1c1c58005$var$baseStyleOverlay,
        dialogContainer: $58930da1c1c58005$var$baseStyleDialogContainer,
        dialog: (0, $245fb38d8179b6d2$export$624e501d81f5ffce)($58930da1c1c58005$var$baseStyleDialog, props),
        header: $58930da1c1c58005$var$baseStyleHeader,
        closeButton: $58930da1c1c58005$var$baseStyleCloseButton,
        body: $58930da1c1c58005$var$baseStyleBody,
        footer: $58930da1c1c58005$var$baseStyleFooter
    }));
var $58930da1c1c58005$var$sizes = {
    xs: $58930da1c1c58005$var$getSize("xs"),
    sm: $58930da1c1c58005$var$getSize("md"),
    md: $58930da1c1c58005$var$getSize("lg"),
    lg: $58930da1c1c58005$var$getSize("2xl"),
    xl: $58930da1c1c58005$var$getSize("4xl"),
    full: $58930da1c1c58005$var$getSize("full")
};
var $58930da1c1c58005$export$8057937c11129602 = $58930da1c1c58005$var$defineMultiStyleConfig({
    baseStyle: $58930da1c1c58005$var$baseStyle,
    sizes: $58930da1c1c58005$var$sizes,
    defaultProps: {
        size: "xs"
    }
});


// src/components/editable.ts


var { definePartsStyle: $7166b8ecd8c776bf$var$definePartsStyle, defineMultiStyleConfig: $7166b8ecd8c776bf$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$2813c9511eeab082).keys);
var $7166b8ecd8c776bf$var$baseStylePreview = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal"
});
var $7166b8ecd8c776bf$var$baseStyleInput = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal",
    width: "full",
    _focusVisible: {
        boxShadow: "outline"
    },
    _placeholder: {
        opacity: 0.6
    }
});
var $7166b8ecd8c776bf$var$baseStyleTextarea = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal",
    width: "full",
    _focusVisible: {
        boxShadow: "outline"
    },
    _placeholder: {
        opacity: 0.6
    }
});
var $7166b8ecd8c776bf$var$baseStyle = $7166b8ecd8c776bf$var$definePartsStyle({
    preview: $7166b8ecd8c776bf$var$baseStylePreview,
    input: $7166b8ecd8c776bf$var$baseStyleInput,
    textarea: $7166b8ecd8c776bf$var$baseStyleTextarea
});
var $7166b8ecd8c776bf$export$a09813cbe72349b1 = $7166b8ecd8c776bf$var$defineMultiStyleConfig({
    baseStyle: $7166b8ecd8c776bf$var$baseStyle
});


// src/components/form-control.ts


var { definePartsStyle: $e4c11848355b4c9a$var$definePartsStyle, defineMultiStyleConfig: $e4c11848355b4c9a$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$4b243e3f209a7e5e).keys);
var $e4c11848355b4c9a$var$$fg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("form-control-color");
var $e4c11848355b4c9a$var$baseStyleRequiredIndicator = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    marginStart: "1",
    [$e4c11848355b4c9a$var$$fg.variable]: "colors.red.500",
    _dark: {
        [$e4c11848355b4c9a$var$$fg.variable]: "colors.red.300"
    },
    color: $e4c11848355b4c9a$var$$fg.reference
});
var $e4c11848355b4c9a$var$baseStyleHelperText = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    mt: "2",
    [$e4c11848355b4c9a$var$$fg.variable]: "colors.gray.600",
    _dark: {
        [$e4c11848355b4c9a$var$$fg.variable]: "colors.whiteAlpha.600"
    },
    color: $e4c11848355b4c9a$var$$fg.reference,
    lineHeight: "normal",
    fontSize: "sm"
});
var $e4c11848355b4c9a$var$baseStyle = $e4c11848355b4c9a$var$definePartsStyle({
    container: {
        width: "100%",
        position: "relative"
    },
    requiredIndicator: $e4c11848355b4c9a$var$baseStyleRequiredIndicator,
    helperText: $e4c11848355b4c9a$var$baseStyleHelperText
});
var $e4c11848355b4c9a$export$870bcc1d98fee0aa = $e4c11848355b4c9a$var$defineMultiStyleConfig({
    baseStyle: $e4c11848355b4c9a$var$baseStyle
});


// src/components/form-error.ts


var { definePartsStyle: $e978aa0d645b6189$var$definePartsStyle, defineMultiStyleConfig: $e978aa0d645b6189$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$bb18c440c00e82d9).keys);
var $e978aa0d645b6189$var$$fg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("form-error-color");
var $e978aa0d645b6189$var$baseStyleText = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    [$e978aa0d645b6189$var$$fg.variable]: `colors.red.500`,
    _dark: {
        [$e978aa0d645b6189$var$$fg.variable]: `colors.red.300`
    },
    color: $e978aa0d645b6189$var$$fg.reference,
    mt: "2",
    fontSize: "sm",
    lineHeight: "normal"
});
var $e978aa0d645b6189$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    marginEnd: "0.5em",
    [$e978aa0d645b6189$var$$fg.variable]: `colors.red.500`,
    _dark: {
        [$e978aa0d645b6189$var$$fg.variable]: `colors.red.300`
    },
    color: $e978aa0d645b6189$var$$fg.reference
});
var $e978aa0d645b6189$var$baseStyle = $e978aa0d645b6189$var$definePartsStyle({
    text: $e978aa0d645b6189$var$baseStyleText,
    icon: $e978aa0d645b6189$var$baseStyleIcon
});
var $e978aa0d645b6189$export$b8d6747e16cd5f4d = $e978aa0d645b6189$var$defineMultiStyleConfig({
    baseStyle: $e978aa0d645b6189$var$baseStyle
});


// src/components/form-label.ts

var $854669f7a332f337$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontSize: "md",
    marginEnd: "3",
    mb: "2",
    fontWeight: "medium",
    transitionProperty: "common",
    transitionDuration: "normal",
    opacity: 1,
    _disabled: {
        opacity: 0.4
    }
});
var $854669f7a332f337$export$c49af69dbfc0c993 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $854669f7a332f337$var$baseStyle
});


// src/components/heading.ts

var $7303f6ef3f2c4190$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontFamily: "heading",
    fontWeight: "bold"
});
var $7303f6ef3f2c4190$var$sizes = {
    "4xl": (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: [
            "6xl",
            null,
            "7xl"
        ],
        lineHeight: 1
    }),
    "3xl": (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: [
            "5xl",
            null,
            "6xl"
        ],
        lineHeight: 1
    }),
    "2xl": (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: [
            "4xl",
            null,
            "5xl"
        ],
        lineHeight: [
            1.2,
            null,
            1
        ]
    }),
    xl: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: [
            "3xl",
            null,
            "4xl"
        ],
        lineHeight: [
            1.33,
            null,
            1.2
        ]
    }),
    lg: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: [
            "2xl",
            null,
            "3xl"
        ],
        lineHeight: [
            1.33,
            null,
            1.2
        ]
    }),
    md: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "xl",
        lineHeight: 1.2
    }),
    sm: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "md",
        lineHeight: 1.2
    }),
    xs: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "sm",
        lineHeight: 1.2
    })
};
var $7303f6ef3f2c4190$export$5f175074e0f09e7b = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $7303f6ef3f2c4190$var$baseStyle,
    sizes: $7303f6ef3f2c4190$var$sizes,
    defaultProps: {
        size: "xl"
    }
});



// src/components/breadcrumb.ts


var { defineMultiStyleConfig: $025e10043b87c3d1$var$defineMultiStyleConfig, definePartsStyle: $025e10043b87c3d1$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$2fb03f744a6ecf93).keys);
var $025e10043b87c3d1$var$$decor = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("breadcrumb-link-decor");
var $025e10043b87c3d1$var$baseStyleLink = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    outline: "none",
    color: "inherit",
    textDecoration: $025e10043b87c3d1$var$$decor.reference,
    [$025e10043b87c3d1$var$$decor.variable]: "none",
    "&:not([aria-current=page])": {
        cursor: "pointer",
        _hover: {
            [$025e10043b87c3d1$var$$decor.variable]: "underline"
        },
        _focusVisible: {
            boxShadow: "outline"
        }
    }
});
var $025e10043b87c3d1$var$baseStyle = $025e10043b87c3d1$var$definePartsStyle({
    link: $025e10043b87c3d1$var$baseStyleLink
});
var $025e10043b87c3d1$export$e2d8c6f6af55009 = $025e10043b87c3d1$var$defineMultiStyleConfig({
    baseStyle: $025e10043b87c3d1$var$baseStyle
});





var $e1e879e804c8177d$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    lineHeight: "1.2",
    borderRadius: "md",
    fontWeight: "semibold",
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
        boxShadow: "outline"
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        boxShadow: "none"
    },
    _hover: {
        _disabled: {
            bg: "initial"
        }
    }
});
var $e1e879e804c8177d$var$variantGhost = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    if (c === "gray") return {
        color: (0, $6eb225f883147347$export$549ff81930776885)(`gray.800`, `whiteAlpha.900`)(props),
        _hover: {
            bg: (0, $6eb225f883147347$export$549ff81930776885)(`gray.100`, `whiteAlpha.200`)(props)
        },
        _active: {
            bg: (0, $6eb225f883147347$export$549ff81930776885)(`gray.200`, `whiteAlpha.300`)(props)
        }
    };
    const darkHoverBg = (0, $a031d15006571f58$export$d11da87e55cc498f)(`${c}.200`, 0.12)(theme);
    const darkActiveBg = (0, $a031d15006571f58$export$d11da87e55cc498f)(`${c}.200`, 0.24)(theme);
    return {
        color: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.600`, `${c}.200`)(props),
        bg: "transparent",
        _hover: {
            bg: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.50`, darkHoverBg)(props)
        },
        _active: {
            bg: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.100`, darkActiveBg)(props)
        }
    };
});
var $e1e879e804c8177d$var$variantOutline = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    const borderColor = (0, $6eb225f883147347$export$549ff81930776885)(`gray.200`, `whiteAlpha.300`)(props);
    return {
        border: "1px solid",
        borderColor: c === "gray" ? borderColor : "currentColor",
        ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": {
            marginEnd: "-1px"
        },
        ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": {
            marginBottom: "-1px"
        },
        ...(0, $245fb38d8179b6d2$export$624e501d81f5ffce)($e1e879e804c8177d$var$variantGhost, props)
    };
});
var $e1e879e804c8177d$var$accessibleColorMap = {
    yellow: {
        bg: "yellow.400",
        color: "black",
        hoverBg: "yellow.500",
        activeBg: "yellow.600"
    },
    cyan: {
        bg: "cyan.400",
        color: "black",
        hoverBg: "cyan.500",
        activeBg: "cyan.600"
    }
};
var $e1e879e804c8177d$var$variantSolid = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    var _a;
    const { colorScheme: c } = props;
    if (c === "gray") {
        const bg2 = (0, $6eb225f883147347$export$549ff81930776885)(`gray.100`, `whiteAlpha.200`)(props);
        return {
            bg: bg2,
            color: (0, $6eb225f883147347$export$549ff81930776885)(`gray.800`, `whiteAlpha.900`)(props),
            _hover: {
                bg: (0, $6eb225f883147347$export$549ff81930776885)(`gray.200`, `whiteAlpha.300`)(props),
                _disabled: {
                    bg: bg2
                }
            },
            _active: {
                bg: (0, $6eb225f883147347$export$549ff81930776885)(`gray.300`, `whiteAlpha.400`)(props)
            }
        };
    }
    const { bg: bg = `${c}.500`, color: color = "white", hoverBg: hoverBg = `${c}.600`, activeBg: activeBg = `${c}.700` } = (_a = $e1e879e804c8177d$var$accessibleColorMap[c]) != null ? _a : {};
    const background = (0, $6eb225f883147347$export$549ff81930776885)(bg, `${c}.200`)(props);
    return {
        bg: background,
        color: (0, $6eb225f883147347$export$549ff81930776885)(color, `gray.800`)(props),
        _hover: {
            bg: (0, $6eb225f883147347$export$549ff81930776885)(hoverBg, `${c}.300`)(props),
            _disabled: {
                bg: background
            }
        },
        _active: {
            bg: (0, $6eb225f883147347$export$549ff81930776885)(activeBg, `${c}.400`)(props)
        }
    };
});
var $e1e879e804c8177d$var$variantLink = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        padding: 0,
        height: "auto",
        lineHeight: "normal",
        verticalAlign: "baseline",
        color: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
        _hover: {
            textDecoration: "underline",
            _disabled: {
                textDecoration: "none"
            }
        },
        _active: {
            color: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.700`, `${c}.500`)(props)
        }
    };
});
var $e1e879e804c8177d$var$variantUnstyled = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "none",
    color: "inherit",
    display: "inline",
    lineHeight: "inherit",
    m: "0",
    p: "0"
});
var $e1e879e804c8177d$var$variants = {
    ghost: $e1e879e804c8177d$var$variantGhost,
    outline: $e1e879e804c8177d$var$variantOutline,
    solid: $e1e879e804c8177d$var$variantSolid,
    link: $e1e879e804c8177d$var$variantLink,
    unstyled: $e1e879e804c8177d$var$variantUnstyled
};
var $e1e879e804c8177d$var$sizes = {
    lg: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        h: "12",
        minW: "12",
        fontSize: "lg",
        px: "6"
    }),
    md: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        h: "10",
        minW: "10",
        fontSize: "md",
        px: "4"
    }),
    sm: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        h: "8",
        minW: "8",
        fontSize: "sm",
        px: "3"
    }),
    xs: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        h: "6",
        minW: "6",
        fontSize: "xs",
        px: "2"
    })
};
var $e1e879e804c8177d$export$577deec5d331f6be = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $e1e879e804c8177d$var$baseStyle,
    variants: $e1e879e804c8177d$var$variants,
    sizes: $e1e879e804c8177d$var$sizes,
    defaultProps: {
        variant: "solid",
        size: "md",
        colorScheme: "gray"
    }
});


// src/components/card.ts


var { definePartsStyle: $f3eb9c88b5865555$var$definePartsStyle, defineMultiStyleConfig: $f3eb9c88b5865555$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$487a447ffa5755b6).keys);
var $f3eb9c88b5865555$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("card-bg");
var $f3eb9c88b5865555$var$$padding = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("card-padding");
var $f3eb9c88b5865555$var$$shadow = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("card-shadow");
var $f3eb9c88b5865555$var$$radius = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("card-radius");
var $f3eb9c88b5865555$var$$border = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("card-border-width", "0");
var $f3eb9c88b5865555$var$$borderColor = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("card-border-color");
var $f3eb9c88b5865555$var$baseStyle = $f3eb9c88b5865555$var$definePartsStyle({
    container: {
        [$f3eb9c88b5865555$var$$bg.variable]: "colors.chakra-body-bg",
        backgroundColor: $f3eb9c88b5865555$var$$bg.reference,
        boxShadow: $f3eb9c88b5865555$var$$shadow.reference,
        borderRadius: $f3eb9c88b5865555$var$$radius.reference,
        color: "chakra-body-text",
        borderWidth: $f3eb9c88b5865555$var$$border.reference,
        borderColor: $f3eb9c88b5865555$var$$borderColor.reference
    },
    body: {
        padding: $f3eb9c88b5865555$var$$padding.reference,
        flex: "1 1 0%"
    },
    header: {
        padding: $f3eb9c88b5865555$var$$padding.reference
    },
    footer: {
        padding: $f3eb9c88b5865555$var$$padding.reference
    }
});
var $f3eb9c88b5865555$var$sizes = {
    sm: $f3eb9c88b5865555$var$definePartsStyle({
        container: {
            [$f3eb9c88b5865555$var$$radius.variable]: "radii.base",
            [$f3eb9c88b5865555$var$$padding.variable]: "space.3"
        }
    }),
    md: $f3eb9c88b5865555$var$definePartsStyle({
        container: {
            [$f3eb9c88b5865555$var$$radius.variable]: "radii.md",
            [$f3eb9c88b5865555$var$$padding.variable]: "space.5"
        }
    }),
    lg: $f3eb9c88b5865555$var$definePartsStyle({
        container: {
            [$f3eb9c88b5865555$var$$radius.variable]: "radii.xl",
            [$f3eb9c88b5865555$var$$padding.variable]: "space.7"
        }
    })
};
var $f3eb9c88b5865555$var$variants = {
    elevated: $f3eb9c88b5865555$var$definePartsStyle({
        container: {
            [$f3eb9c88b5865555$var$$shadow.variable]: "shadows.base",
            _dark: {
                [$f3eb9c88b5865555$var$$bg.variable]: "colors.gray.700"
            }
        }
    }),
    outline: $f3eb9c88b5865555$var$definePartsStyle({
        container: {
            [$f3eb9c88b5865555$var$$border.variable]: "1px",
            [$f3eb9c88b5865555$var$$borderColor.variable]: "colors.chakra-border-color"
        }
    }),
    filled: $f3eb9c88b5865555$var$definePartsStyle({
        container: {
            [$f3eb9c88b5865555$var$$bg.variable]: "colors.chakra-subtle-bg"
        }
    }),
    unstyled: {
        body: {
            [$f3eb9c88b5865555$var$$padding.variable]: 0
        },
        header: {
            [$f3eb9c88b5865555$var$$padding.variable]: 0
        },
        footer: {
            [$f3eb9c88b5865555$var$$padding.variable]: 0
        }
    }
};
var $f3eb9c88b5865555$export$880f7b1201440c23 = $f3eb9c88b5865555$var$defineMultiStyleConfig({
    baseStyle: $f3eb9c88b5865555$var$baseStyle,
    variants: $f3eb9c88b5865555$var$variants,
    sizes: $f3eb9c88b5865555$var$sizes,
    defaultProps: {
        variant: "elevated",
        size: "md"
    }
});



// src/components/close-button.ts


var $d29ef2a66290cd2b$var$$size = (0, $591785a32740c673$export$8b4981022bd80a4e)("close-button-size");
var $d29ef2a66290cd2b$var$$bg = (0, $591785a32740c673$export$8b4981022bd80a4e)("close-button-bg");
var $d29ef2a66290cd2b$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    w: [
        $d29ef2a66290cd2b$var$$size.reference
    ],
    h: [
        $d29ef2a66290cd2b$var$$size.reference
    ],
    borderRadius: "md",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        boxShadow: "none"
    },
    _hover: {
        [$d29ef2a66290cd2b$var$$bg.variable]: "colors.blackAlpha.100",
        _dark: {
            [$d29ef2a66290cd2b$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _active: {
        [$d29ef2a66290cd2b$var$$bg.variable]: "colors.blackAlpha.200",
        _dark: {
            [$d29ef2a66290cd2b$var$$bg.variable]: "colors.whiteAlpha.200"
        }
    },
    _focusVisible: {
        boxShadow: "outline"
    },
    bg: $d29ef2a66290cd2b$var$$bg.reference
});
var $d29ef2a66290cd2b$var$sizes = {
    lg: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$d29ef2a66290cd2b$var$$size.variable]: "sizes.10",
        fontSize: "md"
    }),
    md: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$d29ef2a66290cd2b$var$$size.variable]: "sizes.8",
        fontSize: "xs"
    }),
    sm: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$d29ef2a66290cd2b$var$$size.variable]: "sizes.6",
        fontSize: "2xs"
    })
};
var $d29ef2a66290cd2b$export$47615e5b7f7e315f = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $d29ef2a66290cd2b$var$baseStyle,
    sizes: $d29ef2a66290cd2b$var$sizes,
    defaultProps: {
        size: "md"
    }
});




var { variants: $c415241fb2714785$var$variants, defaultProps: $c415241fb2714785$var$defaultProps } = (0, $ef3cdcb3a868c7e9$export$eb6e7cbc82d0f88b);
var $c415241fb2714785$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontFamily: "mono",
    fontSize: "sm",
    px: "0.2em",
    borderRadius: "sm",
    bg: (0, $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4).bg.reference,
    color: (0, $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4).color.reference,
    boxShadow: (0, $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4).shadow.reference
});
var $c415241fb2714785$export$f9b9a8633a36e3c7 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $c415241fb2714785$var$baseStyle,
    variants: $c415241fb2714785$var$variants,
    defaultProps: $c415241fb2714785$var$defaultProps
});


// src/components/container.ts

var $f407a7e2828f8e3c$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    w: "100%",
    mx: "auto",
    maxW: "prose",
    px: "4"
});
var $f407a7e2828f8e3c$export$3ca0760d240fe5f4 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $f407a7e2828f8e3c$var$baseStyle
});


// src/components/divider.ts

var $67cebb6688951855$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    opacity: 0.6,
    borderColor: "inherit"
});
var $67cebb6688951855$var$variantSolid = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderStyle: "solid"
});
var $67cebb6688951855$var$variantDashed = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderStyle: "dashed"
});
var $67cebb6688951855$var$variants = {
    solid: $67cebb6688951855$var$variantSolid,
    dashed: $67cebb6688951855$var$variantDashed
};
var $67cebb6688951855$export$f0e91f779c5bb416 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $67cebb6688951855$var$baseStyle,
    variants: $67cebb6688951855$var$variants,
    defaultProps: {
        variant: "solid"
    }
});


// src/components/accordion.ts


var { definePartsStyle: $9008cb79ab92d9f9$var$definePartsStyle, defineMultiStyleConfig: $9008cb79ab92d9f9$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$377a77e99e7c73a5).keys);
var $9008cb79ab92d9f9$var$baseStyleContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderTopWidth: "1px",
    borderColor: "inherit",
    _last: {
        borderBottomWidth: "1px"
    }
});
var $9008cb79ab92d9f9$var$baseStyleButton = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "normal",
    fontSize: "md",
    _focusVisible: {
        boxShadow: "outline"
    },
    _hover: {
        bg: "blackAlpha.50"
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    },
    px: "4",
    py: "2"
});
var $9008cb79ab92d9f9$var$baseStylePanel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    pt: "2",
    px: "4",
    pb: "5"
});
var $9008cb79ab92d9f9$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontSize: "1.25em"
});
var $9008cb79ab92d9f9$var$baseStyle = $9008cb79ab92d9f9$var$definePartsStyle({
    container: $9008cb79ab92d9f9$var$baseStyleContainer,
    button: $9008cb79ab92d9f9$var$baseStyleButton,
    panel: $9008cb79ab92d9f9$var$baseStylePanel,
    icon: $9008cb79ab92d9f9$var$baseStyleIcon
});
var $9008cb79ab92d9f9$export$20ec2254f76fa604 = $9008cb79ab92d9f9$var$defineMultiStyleConfig({
    baseStyle: $9008cb79ab92d9f9$var$baseStyle
});


// src/components/alert.ts



var { definePartsStyle: $82c2d875265854c6$var$definePartsStyle, defineMultiStyleConfig: $82c2d875265854c6$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$fc51889fa4de265a).keys);
var $82c2d875265854c6$var$$fg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("alert-fg");
var $82c2d875265854c6$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("alert-bg");
var $82c2d875265854c6$var$baseStyle = $82c2d875265854c6$var$definePartsStyle({
    container: {
        bg: $82c2d875265854c6$var$$bg.reference,
        px: "4",
        py: "3"
    },
    title: {
        fontWeight: "bold",
        lineHeight: "6",
        marginEnd: "2"
    },
    description: {
        lineHeight: "6"
    },
    icon: {
        color: $82c2d875265854c6$var$$fg.reference,
        flexShrink: 0,
        marginEnd: "3",
        w: "5",
        h: "6"
    },
    spinner: {
        color: $82c2d875265854c6$var$$fg.reference,
        flexShrink: 0,
        marginEnd: "3",
        w: "5",
        h: "5"
    }
});
function $82c2d875265854c6$var$getBg(props) {
    const { theme: theme, colorScheme: c } = props;
    const darkBg = (0, $a031d15006571f58$export$d11da87e55cc498f)(`${c}.200`, 0.16)(theme);
    return {
        light: `colors.${c}.100`,
        dark: darkBg
    };
}
var $82c2d875265854c6$var$variantSubtle = $82c2d875265854c6$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $82c2d875265854c6$var$getBg(props);
    return {
        container: {
            [$82c2d875265854c6$var$$fg.variable]: `colors.${c}.500`,
            [$82c2d875265854c6$var$$bg.variable]: bg.light,
            _dark: {
                [$82c2d875265854c6$var$$fg.variable]: `colors.${c}.200`,
                [$82c2d875265854c6$var$$bg.variable]: bg.dark
            }
        }
    };
});
var $82c2d875265854c6$var$variantLeftAccent = $82c2d875265854c6$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $82c2d875265854c6$var$getBg(props);
    return {
        container: {
            [$82c2d875265854c6$var$$fg.variable]: `colors.${c}.500`,
            [$82c2d875265854c6$var$$bg.variable]: bg.light,
            _dark: {
                [$82c2d875265854c6$var$$fg.variable]: `colors.${c}.200`,
                [$82c2d875265854c6$var$$bg.variable]: bg.dark
            },
            paddingStart: "3",
            borderStartWidth: "4px",
            borderStartColor: $82c2d875265854c6$var$$fg.reference
        }
    };
});
var $82c2d875265854c6$var$variantTopAccent = $82c2d875265854c6$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $82c2d875265854c6$var$getBg(props);
    return {
        container: {
            [$82c2d875265854c6$var$$fg.variable]: `colors.${c}.500`,
            [$82c2d875265854c6$var$$bg.variable]: bg.light,
            _dark: {
                [$82c2d875265854c6$var$$fg.variable]: `colors.${c}.200`,
                [$82c2d875265854c6$var$$bg.variable]: bg.dark
            },
            pt: "2",
            borderTopWidth: "4px",
            borderTopColor: $82c2d875265854c6$var$$fg.reference
        }
    };
});
var $82c2d875265854c6$var$variantSolid = $82c2d875265854c6$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        container: {
            [$82c2d875265854c6$var$$fg.variable]: `colors.white`,
            [$82c2d875265854c6$var$$bg.variable]: `colors.${c}.500`,
            _dark: {
                [$82c2d875265854c6$var$$fg.variable]: `colors.gray.900`,
                [$82c2d875265854c6$var$$bg.variable]: `colors.${c}.200`
            },
            color: $82c2d875265854c6$var$$fg.reference
        }
    };
});
var $82c2d875265854c6$var$variants = {
    subtle: $82c2d875265854c6$var$variantSubtle,
    "left-accent": $82c2d875265854c6$var$variantLeftAccent,
    "top-accent": $82c2d875265854c6$var$variantTopAccent,
    solid: $82c2d875265854c6$var$variantSolid
};
var $82c2d875265854c6$export$9d77d9665d829e89 = $82c2d875265854c6$var$defineMultiStyleConfig({
    baseStyle: $82c2d875265854c6$var$baseStyle,
    variants: $82c2d875265854c6$var$variants,
    defaultProps: {
        variant: "subtle",
        colorScheme: "blue"
    }
});







var { definePartsStyle: $6d15541177ae209c$var$definePartsStyle, defineMultiStyleConfig: $6d15541177ae209c$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $f87e4685273d35d8$export$60f8655d889e17c7).keys);
var $6d15541177ae209c$var$$border = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("avatar-border-color");
var $6d15541177ae209c$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("avatar-bg");
var $6d15541177ae209c$var$$fs = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("avatar-font-size");
var $6d15541177ae209c$var$$size = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("avatar-size");
var $6d15541177ae209c$var$baseStyleBadge = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderRadius: "full",
    border: "0.2em solid",
    borderColor: $6d15541177ae209c$var$$border.reference,
    [$6d15541177ae209c$var$$border.variable]: "white",
    _dark: {
        [$6d15541177ae209c$var$$border.variable]: "colors.gray.800"
    }
});
var $6d15541177ae209c$var$baseStyleExcessLabel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: $6d15541177ae209c$var$$bg.reference,
    fontSize: $6d15541177ae209c$var$$fs.reference,
    width: $6d15541177ae209c$var$$size.reference,
    height: $6d15541177ae209c$var$$size.reference,
    lineHeight: "1",
    [$6d15541177ae209c$var$$bg.variable]: "colors.gray.200",
    _dark: {
        [$6d15541177ae209c$var$$bg.variable]: "colors.whiteAlpha.400"
    }
});
var $6d15541177ae209c$var$baseStyleContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { name: name, theme: theme } = props;
    const bg = name ? (0, $a031d15006571f58$export$f3c6ed4330abfc18)({
        string: name
    }) : "colors.gray.400";
    const isBgDark = (0, $a031d15006571f58$export$a79ad82046afa44e)(bg)(theme);
    let color = "white";
    if (!isBgDark) color = "gray.800";
    return {
        bg: $6d15541177ae209c$var$$bg.reference,
        fontSize: $6d15541177ae209c$var$$fs.reference,
        color: color,
        borderColor: $6d15541177ae209c$var$$border.reference,
        verticalAlign: "top",
        width: $6d15541177ae209c$var$$size.reference,
        height: $6d15541177ae209c$var$$size.reference,
        "&:not([data-loaded])": {
            [$6d15541177ae209c$var$$bg.variable]: bg
        },
        [$6d15541177ae209c$var$$border.variable]: "colors.white",
        _dark: {
            [$6d15541177ae209c$var$$border.variable]: "colors.gray.800"
        }
    };
});
var $6d15541177ae209c$var$baseStyleLabel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontSize: $6d15541177ae209c$var$$fs.reference,
    lineHeight: "1"
});
var $6d15541177ae209c$var$baseStyle = $6d15541177ae209c$var$definePartsStyle((props)=>({
        badge: (0, $245fb38d8179b6d2$export$624e501d81f5ffce)($6d15541177ae209c$var$baseStyleBadge, props),
        excessLabel: (0, $245fb38d8179b6d2$export$624e501d81f5ffce)($6d15541177ae209c$var$baseStyleExcessLabel, props),
        container: (0, $245fb38d8179b6d2$export$624e501d81f5ffce)($6d15541177ae209c$var$baseStyleContainer, props),
        label: $6d15541177ae209c$var$baseStyleLabel
    }));
function $6d15541177ae209c$var$getSize(size) {
    const themeSize = size !== "100%" ? (0, $5013d2c172615a00$export$d7d4c689520cc141)[size] : void 0;
    return $6d15541177ae209c$var$definePartsStyle({
        container: {
            [$6d15541177ae209c$var$$size.variable]: themeSize != null ? themeSize : size,
            [$6d15541177ae209c$var$$fs.variable]: `calc(${themeSize != null ? themeSize : size} / 2.5)`
        },
        excessLabel: {
            [$6d15541177ae209c$var$$size.variable]: themeSize != null ? themeSize : size,
            [$6d15541177ae209c$var$$fs.variable]: `calc(${themeSize != null ? themeSize : size} / 2.5)`
        }
    });
}
var $6d15541177ae209c$var$sizes = {
    "2xs": $6d15541177ae209c$var$getSize(4),
    xs: $6d15541177ae209c$var$getSize(6),
    sm: $6d15541177ae209c$var$getSize(8),
    md: $6d15541177ae209c$var$getSize(12),
    lg: $6d15541177ae209c$var$getSize(16),
    xl: $6d15541177ae209c$var$getSize(24),
    "2xl": $6d15541177ae209c$var$getSize(32),
    full: $6d15541177ae209c$var$getSize("100%")
};
var $6d15541177ae209c$export$9975d21893c10e66 = $6d15541177ae209c$var$defineMultiStyleConfig({
    baseStyle: $6d15541177ae209c$var$baseStyle,
    sizes: $6d15541177ae209c$var$sizes,
    defaultProps: {
        size: "md"
    }
});



// src/components/index.ts
var $62f266ab24ef0552$export$9b5ac10f59f76296 = {
    Accordion: (0, $9008cb79ab92d9f9$export$20ec2254f76fa604),
    Alert: (0, $82c2d875265854c6$export$9d77d9665d829e89),
    Avatar: (0, $6d15541177ae209c$export$9975d21893c10e66),
    Badge: (0, $ef3cdcb3a868c7e9$export$eb6e7cbc82d0f88b),
    Breadcrumb: (0, $025e10043b87c3d1$export$e2d8c6f6af55009),
    Button: (0, $e1e879e804c8177d$export$577deec5d331f6be),
    Checkbox: (0, $3a660172b177ab9e$export$86286d8c37984115),
    CloseButton: (0, $d29ef2a66290cd2b$export$47615e5b7f7e315f),
    Code: (0, $c415241fb2714785$export$f9b9a8633a36e3c7),
    Container: (0, $f407a7e2828f8e3c$export$3ca0760d240fe5f4),
    Divider: (0, $67cebb6688951855$export$f0e91f779c5bb416),
    Drawer: (0, $58930da1c1c58005$export$8057937c11129602),
    Editable: (0, $7166b8ecd8c776bf$export$a09813cbe72349b1),
    Form: (0, $e4c11848355b4c9a$export$870bcc1d98fee0aa),
    FormError: (0, $e978aa0d645b6189$export$b8d6747e16cd5f4d),
    FormLabel: (0, $854669f7a332f337$export$c49af69dbfc0c993),
    Heading: (0, $7303f6ef3f2c4190$export$5f175074e0f09e7b),
    Input: (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54),
    Kbd: (0, $99ce1a067887b061$export$e193528a501e9a4a),
    Link: (0, $33cdc3a44bd030c6$export$af7f58b96695762e),
    List: (0, $7e7ecde49b12814e$export$ce840f8e8ef752d),
    Menu: (0, $0f90576fb7bd80ad$export$687ce088075ea42b),
    Modal: (0, $3966d8e51ac3bc1e$export$158ae9a07be41c05),
    NumberInput: (0, $57684a561be679fe$export$b9bc5fa6e7f960a1),
    PinInput: (0, $4565c07955136284$export$8504c22c55a552e0),
    Popover: (0, $dffd16657f8ddad5$export$135f12f777be1ef7),
    Progress: (0, $924e305cbcea9b38$export$dc04d8e6a17afea1),
    Radio: (0, $21c6841492ceabf9$export$f0b387b940941887),
    Select: (0, $aba0b22b8ca9eec7$export$21af0fc3c16183e1),
    Skeleton: (0, $6eb62cdac4dee0fa$export$7680371ad2d79142),
    SkipLink: (0, $de81dc100e8decd2$export$a8cf3228ef52959),
    Slider: (0, $8004dd2b97b58653$export$fff8df8fd8e1ed6f),
    Spinner: (0, $a4266c6ac9b1dc5e$export$d76156e68e556d3f),
    Stat: (0, $17b9d17ea3bfb461$export$f3301eb37a20f09e),
    Switch: (0, $994d42e36253a2ed$export$6856b73e98185bff),
    Table: (0, $2a4c99e2adafaa9d$export$3339219781bb5161),
    Tabs: (0, $b12872ed3cae6b5f$export$847a245e7ebce2a1),
    Tag: (0, $8e37595eb187b127$export$f8ab9ac2a319695b),
    Textarea: (0, $db4a338c74752624$export$394b8322fab774c1),
    Tooltip: (0, $fd7519f20c5c0006$export$7472a7883840b563),
    Card: (0, $f3eb9c88b5865555$export$880f7b1201440c23),
    Stepper: (0, $b8eda56a5e8ca863$export$54c84d54375c8d75)
};









































// src/semantic-tokens.ts
var $68f026b4ff22fdd7$export$c1b409c4e1d33fce = {
    colors: {
        "chakra-body-text": {
            _light: "gray.800",
            _dark: "whiteAlpha.900"
        },
        "chakra-body-bg": {
            _light: "white",
            _dark: "gray.800"
        },
        "chakra-border-color": {
            _light: "gray.200",
            _dark: "whiteAlpha.300"
        },
        "chakra-inverse-text": {
            _light: "white",
            _dark: "gray.800"
        },
        "chakra-subtle-bg": {
            _light: "gray.100",
            _dark: "gray.700"
        },
        "chakra-subtle-text": {
            _light: "gray.600",
            _dark: "gray.400"
        },
        "chakra-placeholder-color": {
            _light: "gray.500",
            _dark: "whiteAlpha.400"
        }
    }
};


// src/styles.ts
var $052daaab7bc9d2ca$export$9dd6ff9ea0189349 = {
    global: {
        body: {
            fontFamily: "body",
            color: "chakra-body-text",
            bg: "chakra-body-bg",
            transitionProperty: "background-color",
            transitionDuration: "normal",
            lineHeight: "base"
        },
        "*::placeholder": {
            color: "chakra-placeholder-color"
        },
        "*, *::before, &::after": {
            borderColor: "chakra-border-color"
        }
    }
};










// src/index.ts
var $fecf4860da5314d0$var$direction = "ltr";
var $fecf4860da5314d0$var$config = {
    useSystemColorMode: false,
    initialColorMode: "light",
    cssVarPrefix: "chakra"
};
var $fecf4860da5314d0$export$bca14c5b3b88a9c9 = {
    semanticTokens: $68f026b4ff22fdd7$export$c1b409c4e1d33fce,
    direction: $fecf4860da5314d0$var$direction,
    ...(0, $0f31d8688ec7fbf0$export$651a0b7b10dae380),
    components: $62f266ab24ef0552$export$9b5ac10f59f76296,
    styles: $052daaab7bc9d2ca$export$9dd6ff9ea0189349,
    config: $fecf4860da5314d0$var$config
};
var $fecf4860da5314d0$export$9e955aef208055a6 = {
    semanticTokens: $68f026b4ff22fdd7$export$c1b409c4e1d33fce,
    direction: $fecf4860da5314d0$var$direction,
    components: {},
    ...(0, $0f31d8688ec7fbf0$export$651a0b7b10dae380),
    styles: $052daaab7bc9d2ca$export$9dd6ff9ea0189349,
    config: $fecf4860da5314d0$var$config
};



var $5Gn6I = parcelRequire("5Gn6I");
function $a0ae5775f52b77ad$var$isFunction(value) {
    return typeof value === "function";
}
function $a0ae5775f52b77ad$var$pipe(...fns) {
    return (v)=>fns.reduce((a, b)=>b(a), v);
}
var $a0ae5775f52b77ad$var$createExtendTheme = (theme2)=>{
    return function extendTheme2(...extensions) {
        let overrides = [
            ...extensions
        ];
        let activeTheme = extensions[extensions.length - 1];
        if ((0, $aef2905091b67153$export$73a6ae01926a4f0e)(activeTheme) && // this ensures backward compatibility
        // previously only `extendTheme(override, activeTheme?)` was allowed
        overrides.length > 1) overrides = overrides.slice(0, overrides.length - 1);
        else activeTheme = theme2;
        return $a0ae5775f52b77ad$var$pipe(...overrides.map((extension)=>(prevTheme)=>$a0ae5775f52b77ad$var$isFunction(extension) ? extension(prevTheme) : $a0ae5775f52b77ad$export$c42236daa9a25fdd(prevTheme, extension)))(activeTheme);
    };
};
var $a0ae5775f52b77ad$export$33a2b855d5b8731e = $a0ae5775f52b77ad$var$createExtendTheme((0, $fecf4860da5314d0$export$bca14c5b3b88a9c9));
var $a0ae5775f52b77ad$export$4c7add5200c9692a = $a0ae5775f52b77ad$var$createExtendTheme((0, $fecf4860da5314d0$export$9e955aef208055a6));
function $a0ae5775f52b77ad$export$c42236daa9a25fdd(...overrides) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, ...overrides, $a0ae5775f52b77ad$var$mergeThemeCustomizer);
}
function $a0ae5775f52b77ad$var$mergeThemeCustomizer(source, override, key, object) {
    if (($a0ae5775f52b77ad$var$isFunction(source) || $a0ae5775f52b77ad$var$isFunction(override)) && Object.prototype.hasOwnProperty.call(object, key)) return (...args)=>{
        const sourceValue = $a0ae5775f52b77ad$var$isFunction(source) ? source(...args) : source;
        const overrideValue = $a0ae5775f52b77ad$var$isFunction(override) ? override(...args) : override;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, sourceValue, overrideValue, $a0ae5775f52b77ad$var$mergeThemeCustomizer);
    };
    return void 0;
}



var $5Gn6I = parcelRequire("5Gn6I");

var $acw62 = parcelRequire("acw62");
var $77ddc6be16b1d7de$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $77ddc6be16b1d7de$var$hasElementType = typeof Element !== "undefined";
var $77ddc6be16b1d7de$var$hasMap = typeof Map === "function";
var $77ddc6be16b1d7de$var$hasSet = typeof Set === "function";
var $77ddc6be16b1d7de$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $77ddc6be16b1d7de$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($77ddc6be16b1d7de$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$77ddc6be16b1d7de$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($77ddc6be16b1d7de$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($77ddc6be16b1d7de$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($77ddc6be16b1d7de$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$77ddc6be16b1d7de$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$77ddc6be16b1d7de$exports = function isEqual(a, b) {
    try {
        return $77ddc6be16b1d7de$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};


"use client";
function $6225152922b2fd2b$var$useStyleConfigImpl(themeKey, props = {}) {
    var _a;
    const { styleConfig: styleConfigProp, ...rest } = props;
    const { theme: theme, colorMode: colorMode } = (0, $d637f68b5e43da19$export$a513a93efd9ab8a7)();
    const themeStyleConfig = themeKey ? (0, $8cabe7dbd312f1c1$export$1bb32d0c65da6059)(theme, `components.${themeKey}`) : void 0;
    const styleConfig = styleConfigProp || themeStyleConfig;
    const mergedProps = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({
        theme: theme,
        colorMode: colorMode
    }, (_a = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _a : {}, (0, $8cabe7dbd312f1c1$export$2458ce75c8ef9806)((0, $8cabe7dbd312f1c1$export$30a06c8d3562193f)(rest, [
        "children"
    ])));
    const stylesRef = (0, $acw62.useRef)({});
    if (styleConfig) {
        const getStyles = (0, $47a6d9fbbf7ee42d$export$f94106bbb00e81eb)(styleConfig);
        const styles = getStyles(mergedProps);
        const isStyleEqual = (0, (/*@__PURE__*/$parcel$interopDefault($77ddc6be16b1d7de$exports)))(stylesRef.current, styles);
        if (!isStyleEqual) stylesRef.current = styles;
    }
    return stylesRef.current;
}
function $6225152922b2fd2b$export$b863f77547fbcb03(themeKey, props = {}) {
    return $6225152922b2fd2b$var$useStyleConfigImpl(themeKey, props);
}
function $6225152922b2fd2b$export$31cdfe60c085d76f(themeKey, props = {}) {
    return $6225152922b2fd2b$var$useStyleConfigImpl(themeKey, props);
}
function $6225152922b2fd2b$export$d47b3683b351a542(themeKey, props) {
    var _a;
    const { baseConfig: baseConfig, ...restProps } = props;
    const { theme: theme } = (0, $d637f68b5e43da19$export$a513a93efd9ab8a7)();
    const overrides = (_a = theme.components) == null ? void 0 : _a[themeKey];
    const styleConfig = overrides ? (0, $a0ae5775f52b77ad$export$c42236daa9a25fdd)(overrides, baseConfig) : baseConfig;
    return $6225152922b2fd2b$var$useStyleConfigImpl(null, {
        ...restProps,
        styleConfig: styleConfig
    });
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $784730508f12f72c$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $9c674755a93db746$export$700979bc83e7db82 = (0, $784730508f12f72c$export$4e09c449d6c407f7) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);


function $c0a2e592950340df$export$80c2a3957bcb42ea() {
    const isMounted = (0, $acw62.useRef)(false);
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}


const $448ce039afb5ec07$export$8793edee2d425525 = (any)=>any;


class $f4ac54c83388ba0d$var$Queue {
    constructor(){
        this.order = [];
        this.scheduled = new Set();
    }
    add(process) {
        if (!this.scheduled.has(process)) {
            this.scheduled.add(process);
            this.order.push(process);
            return true;
        }
    }
    remove(process) {
        const index = this.order.indexOf(process);
        if (index !== -1) {
            this.order.splice(index, 1);
            this.scheduled.delete(process);
        }
    }
    clear() {
        this.order.length = 0;
        this.scheduled.clear();
    }
}
function $f4ac54c83388ba0d$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new $f4ac54c83388ba0d$var$Queue();
    let nextFrame = new $f4ac54c83388ba0d$var$Queue();
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (queue.add(callback) && addToCurrentFrame && isProcessing) // If we're adding it to the currently running queue, update its measured size
            numToRun = thisFrame.order.length;
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.remove(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            numToRun = thisFrame.order.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = thisFrame.order[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $d022ffbd5a1b0ae4$export$71ecace0a033b35a = [
    "prepare",
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $d022ffbd5a1b0ae4$var$maxElapsed = 40;
function $d022ffbd5a1b0ae4$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const steps = $d022ffbd5a1b0ae4$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $f4ac54c83388ba0d$export$b995e5e85f5c8289)(()=>runNextFrame = true);
        return acc;
    }, {});
    const processStep = (stepId)=>steps[stepId].process(state);
    const processBatch = ()=>{
        const timestamp = performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $d022ffbd5a1b0ae4$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        $d022ffbd5a1b0ae4$export$71ecace0a033b35a.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $d022ffbd5a1b0ae4$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>$d022ffbd5a1b0ae4$export$71ecace0a033b35a.forEach((key)=>steps[key].cancel(process));
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $9f96722ff12dbfe7$export$2cef06c20297c17d, cancel: $9f96722ff12dbfe7$export$ec99c0ef4978dccb, state: $9f96722ff12dbfe7$export$fff89137e9e818ce, steps: $9f96722ff12dbfe7$export$be3f796aed065412 } = (0, $d022ffbd5a1b0ae4$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $448ce039afb5ec07$export$8793edee2d425525), true);


function $0316e1262c81ebb4$export$91db9bc4f8ac944a() {
    const isMounted = (0, $c0a2e592950340df$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $acw62.useState)(0);
    const forceRender = (0, $acw62.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $acw62.useCallback)(()=>(0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ const $dba5d94a982c4145$export$f224e4635b6f8ce2 = (0, $acw62.createContext)(null);



var $acw62 = parcelRequire("acw62");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $40f5fd83135889a9$export$fe4300aa8eebea86(init) {
    const ref = (0, $acw62.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



var $acw62 = parcelRequire("acw62");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $6f8c626e496e1918$var$PopChildMeasure extends $acw62.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $6f8c626e496e1918$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $acw62.useId)();
    const ref = (0, $acw62.useRef)(null);
    const size = (0, $acw62.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $acw62.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return $acw62.createElement($6f8c626e496e1918$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size
    }, $acw62.cloneElement(children, {
        ref: ref
    }));
}


const $f57f9e9f321f3a7c$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $40f5fd83135889a9$export$fe4300aa8eebea86)($f57f9e9f321f3a7c$var$newChildrenMap);
    const id = (0, $acw62.useId)();
    const context = (0, $acw62.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $acw62.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $acw62.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = $acw62.createElement((0, $6f8c626e496e1918$export$1d6cdde0c6816c6d), {
        isPresent: isPresent
    }, children);
    return $acw62.createElement((0, $dba5d94a982c4145$export$f224e4635b6f8ce2).Provider, {
        value: context
    }, children);
};
function $f57f9e9f321f3a7c$var$newChildrenMap() {
    return new Map();
}



var $acw62 = parcelRequire("acw62");
const $4ae202aab5791dbc$export$a3579ca508007a95 = (0, $acw62.createContext)({});




var $acw62 = parcelRequire("acw62");
function $7bbbf777b15ef7cf$export$f3a192d0cbd30b96(callback) {
    return (0, $acw62.useEffect)(()=>()=>callback(), []);
}



let $bf99d85f7a843912$export$491112666e282270 = (0, $448ce039afb5ec07$export$8793edee2d425525);
let $bf99d85f7a843912$export$f5708dca728d7177 = (0, $448ce039afb5ec07$export$8793edee2d425525);
var $bf99d85f7a843912$var$check, $bf99d85f7a843912$var$message, $bf99d85f7a843912$var$check1, $bf99d85f7a843912$var$message1;


const $06516233abcfeeff$var$getChildKey = (child)=>child.key || "";
function $06516233abcfeeff$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $06516233abcfeeff$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $06516233abcfeeff$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $acw62.Children).forEach(children, (child)=>{
        if ((0, $acw62.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $06516233abcfeeff$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    const forceRender = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95)).forceRender || (0, $0316e1262c81ebb4$export$91db9bc4f8ac944a)()[0];
    const isMounted = (0, $c0a2e592950340df$export$80c2a3957bcb42ea)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $06516233abcfeeff$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exitingChildren = (0, $acw62.useRef)(new Map()).current;
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $acw62.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $acw62.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $acw62.useRef)(true);
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        $06516233abcfeeff$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $7bbbf777b15ef7cf$export$f3a192d0cbd30b96)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exitingChildren.clear();
    });
    if (isInitialRender.current) return $acw62.createElement($acw62.Fragment, null, childrenToRender.map((child)=>$acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
            key: $06516233abcfeeff$var$getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child)));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($06516233abcfeeff$var$getChildKey);
    const targetKeys = filteredChildren.map($06516233abcfeeff$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) exitingChildren.set(key, undefined);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exitingChildren.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exitingChildren.forEach((component, key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        let exitingComponent = component;
        if (!exitingComponent) {
            const onExit = ()=>{
                allChildren.delete(key);
                exitingChildren.delete(key);
                // Remove this child from the present children
                const removeIndex = presentChildren.current.findIndex((presentChild)=>presentChild.key === key);
                presentChildren.current.splice(removeIndex, 1);
                // Defer re-rendering until all exiting children have indeed left
                if (!exitingChildren.size) {
                    presentChildren.current = filteredChildren;
                    if (isMounted.current === false) return;
                    forceRender();
                    onExitComplete && onExitComplete();
                }
            };
            exitingComponent = $acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
                key: $06516233abcfeeff$var$getChildKey(child),
                isPresent: false,
                onExitComplete: onExit,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode
            }, child);
            exitingChildren.set(key, exitingComponent);
        }
        childrenToRender.splice(insertionIndex, 0, exitingComponent);
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exitingChildren.has(key) ? child : $acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
            key: $06516233abcfeeff$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child);
    });
    return $acw62.createElement($acw62.Fragment, null, exitingChildren.size ? childrenToRender : childrenToRender.map((child)=>(0, $acw62.cloneElement)(child)));
};



"use client";
var [$4410258333ca5546$var$ModalStylesProvider, $4410258333ca5546$export$c540eec2ed4454a2] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `ModalStylesContext`,
    errorMessage: `useModalStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Modal />" `
});
var [$4410258333ca5546$export$7c9538f5f3c365e9, $4410258333ca5546$export$4cc1699d46f42cae] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    strict: true,
    name: "ModalContext",
    errorMessage: "useModalContext: `context` is undefined. Seems you forgot to wrap modal components in `<Modal />`"
});
var $4410258333ca5546$export$2b77a92f1a5ad772 = (props)=>{
    const modalProps = {
        scrollBehavior: "outside",
        autoFocus: true,
        trapFocus: true,
        returnFocusOnClose: true,
        blockScrollOnMount: true,
        allowPinchZoom: false,
        motionPreset: "scale",
        lockFocusAcrossFrames: true,
        ...props
    };
    const { portalProps: portalProps, children: children, autoFocus: autoFocus, trapFocus: trapFocus, initialFocusRef: initialFocusRef, finalFocusRef: finalFocusRef, returnFocusOnClose: returnFocusOnClose, blockScrollOnMount: blockScrollOnMount, allowPinchZoom: allowPinchZoom, preserveScrollBarGap: preserveScrollBarGap, motionPreset: motionPreset, lockFocusAcrossFrames: lockFocusAcrossFrames, onCloseComplete: onCloseComplete } = modalProps;
    const styles = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Modal", modalProps);
    const modal = (0, $fa7450baa69baf87$export$33ffd74ebf07f060)(modalProps);
    const context = {
        ...modal,
        autoFocus: autoFocus,
        trapFocus: trapFocus,
        initialFocusRef: initialFocusRef,
        finalFocusRef: finalFocusRef,
        returnFocusOnClose: returnFocusOnClose,
        blockScrollOnMount: blockScrollOnMount,
        allowPinchZoom: allowPinchZoom,
        preserveScrollBarGap: preserveScrollBarGap,
        motionPreset: motionPreset,
        lockFocusAcrossFrames: lockFocusAcrossFrames
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($4410258333ca5546$export$7c9538f5f3c365e9, {
        value: context,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($4410258333ca5546$var$ModalStylesProvider, {
            value: styles,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                onExitComplete: onCloseComplete,
                children: context.isOpen && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b71276780b6a43df$export$602eac185826482c), {
                    ...portalProps,
                    children: children
                })
            })
        })
    });
};
$4410258333ca5546$export$2b77a92f1a5ad772.displayName = "Modal";





"use client";
var [$2c5be1008fbfcbeb$var$DrawerContextProvider, $2c5be1008fbfcbeb$export$cc200cef0c88a66f] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)();
var $2c5be1008fbfcbeb$var$placementMap = {
    start: {
        ltr: "left",
        rtl: "right"
    },
    end: {
        ltr: "right",
        rtl: "left"
    }
};
function $2c5be1008fbfcbeb$var$getDrawerPlacement(placement, dir) {
    var _a, _b;
    if (!placement) return;
    return (_b = (_a = $2c5be1008fbfcbeb$var$placementMap[placement]) == null ? void 0 : _a[dir]) != null ? _b : placement;
}
function $2c5be1008fbfcbeb$export$4071300121a182f5(props) {
    var _a;
    const { isOpen: isOpen, onClose: onClose, placement: placementProp = "right", children: children, ...rest } = props;
    const theme = (0, $5f6bf330f809db0e$export$93d4e7f90805808f)();
    const drawerStyleConfig = (_a = theme.components) == null ? void 0 : _a.Drawer;
    const placement = $2c5be1008fbfcbeb$var$getDrawerPlacement(placementProp, theme.direction);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($2c5be1008fbfcbeb$var$DrawerContextProvider, {
        value: {
            placement: placement
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4410258333ca5546$export$2b77a92f1a5ad772), {
            isOpen: isOpen,
            onClose: onClose,
            styleConfig: drawerStyleConfig,
            ...rest,
            children: children
        })
    });
}





var $acw62 = parcelRequire("acw62");

"use client";
var $0caf763c70514c51$export$cb540d8b0ef7906c = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { className: className, ...rest } = props;
    const { bodyId: bodyId, setBodyMounted: setBodyMounted } = (0, $4410258333ca5546$export$4cc1699d46f42cae)();
    (0, $acw62.useEffect)(()=>{
        setBodyMounted(true);
        return ()=>setBodyMounted(false);
    }, [
        setBodyMounted
    ]);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-modal__body", className);
    const styles = (0, $4410258333ca5546$export$c540eec2ed4454a2)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ref: ref,
        className: _className,
        id: bodyId,
        ...rest,
        __css: styles.body
    });
});
$0caf763c70514c51$export$cb540d8b0ef7906c.displayName = "ModalBody";





"use client";
var $6a96cde036d65913$var$fallbackIcon = {
    path: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("g", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                strokeLinecap: "round",
                fill: "none",
                d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "currentColor",
                strokeLinecap: "round",
                d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("circle", {
                fill: "none",
                strokeMiterlimit: "10",
                cx: "12",
                cy: "12",
                r: "11.25"
            })
        ]
    }),
    viewBox: "0 0 24 24"
};
var $6a96cde036d65913$export$f04a61298a47a40f = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { as: element, viewBox: viewBox, color: color = "currentColor", focusable: focusable = false, children: children, className: className, __css: __css, ...rest } = props;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-icon", className);
    const customStyles = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("Icon", props);
    const styles = {
        w: "1em",
        h: "1em",
        display: "inline-block",
        lineHeight: "1em",
        flexShrink: 0,
        color: color,
        ...__css,
        ...customStyles
    };
    const shared = {
        ref: ref,
        focusable: focusable,
        className: _className,
        __css: styles
    };
    const _viewBox = viewBox != null ? viewBox : $6a96cde036d65913$var$fallbackIcon.viewBox;
    if (element && typeof element !== "string") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).svg, {
        as: element,
        ...shared,
        ...rest
    });
    const _path = children != null ? children : $6a96cde036d65913$var$fallbackIcon.path;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).svg, {
        verticalAlign: "middle",
        viewBox: _viewBox,
        ...shared,
        ...rest,
        children: _path
    });
});
$6a96cde036d65913$export$f04a61298a47a40f.displayName = "Icon";
var $6a96cde036d65913$export$21036209a317fcec = $6a96cde036d65913$export$f04a61298a47a40f;




"use client";
function $4a635bb7fe4595f6$var$CloseIcon(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $6a96cde036d65913$export$f04a61298a47a40f), {
        focusable: "false",
        "aria-hidden": true,
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
        })
    });
}
var $4a635bb7fe4595f6$export$de65de8213222d10 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function CloseButton2(props, ref) {
    const styles = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("CloseButton", props);
    const { children: children, isDisabled: isDisabled, __css: __css, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const baseStyle = {
        outline: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).button, {
        type: "button",
        "aria-label": "Close",
        ref: ref,
        disabled: isDisabled,
        __css: {
            ...baseStyle,
            ...styles,
            ...__css
        },
        ...rest,
        children: children || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($4a635bb7fe4595f6$var$CloseIcon, {
            width: "1em",
            height: "1em"
        })
    });
});
$4a635bb7fe4595f6$export$de65de8213222d10.displayName = "CloseButton";





"use client";
var $2e9ac767eb870fd0$export$edf9108895ba774f = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { onClick: onClick, className: className, ...rest } = props;
    const { onClose: onClose } = (0, $4410258333ca5546$export$4cc1699d46f42cae)();
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-modal__close-btn", className);
    const styles = (0, $4410258333ca5546$export$c540eec2ed4454a2)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4a635bb7fe4595f6$export$de65de8213222d10), {
        ref: ref,
        __css: styles.closeButton,
        className: _className,
        onClick: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(onClick, (event)=>{
            event.stopPropagation();
            onClose();
        }),
        ...rest
    });
});
$2e9ac767eb870fd0$export$edf9108895ba774f.displayName = "ModalCloseButton";




function $133b6e059b2f6d5e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

/**
 * defines a focus group
 */ var $34f6623b57e1a1c8$export$4f9a06cb7441a087 = "data-focus-lock";
var $34f6623b57e1a1c8$export$aeda8252e54b50f7 = "data-focus-lock-disabled";
var $34f6623b57e1a1c8$export$54ecf528c58f9ef6 = "data-no-focus-lock";
var $34f6623b57e1a1c8$export$70e9b4a1820af101 = "data-autofocus-inside";
var $34f6623b57e1a1c8$export$134ebef29fd94853 = "data-no-autofocus";


/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $05ac61ef45da8ec5$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, newValue);
        });
    });
}



var $acw62 = parcelRequire("acw62");

var $119d56c93ccd46db$export$b8c7b07253306600 = {
    width: "1px",
    height: "0px",
    padding: 0,
    overflow: "hidden",
    position: "fixed",
    top: "1px",
    left: "1px"
};
var $119d56c93ccd46db$var$InFocusGuard = function InFocusGuard(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $119d56c93ccd46db$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $acw62.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $119d56c93ccd46db$export$b8c7b07253306600
    }));
};
$119d56c93ccd46db$var$InFocusGuard.propTypes = {};
$119d56c93ccd46db$var$InFocusGuard.defaultProps = {
    children: null
};
var $119d56c93ccd46db$export$2e2bcd8739ae039 = $119d56c93ccd46db$var$InFocusGuard;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};


function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $292937b69072d1e6$export$5733e022b1d538cb = (0, $dce67a1050af61cf$export$9ffbfcaf067b02c6)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $292937b69072d1e6$export$b3e9a9312f73723c = (0, $dce67a1050af61cf$export$9ffbfcaf067b02c6)();
var $292937b69072d1e6$export$3a1d52767cbc07b8 = (0, $dce67a1050af61cf$export$9ffbfcaf067b02c6)();
var $292937b69072d1e6$export$892cbf28e5518020 = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)({
    async: true // focus-lock sidecar is not required on the server
});


var $e86725766b4cde33$var$emptyArray = [];
var $e86725766b4cde33$var$FocusLock = /*#__PURE__*/ $acw62.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $acw62.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $acw62.useRef();
    var isActive = $acw62.useRef(false);
    var originalFocusedElement = $acw62.useRef(null);
    var children = props.children, disabled = props.disabled, noFocusGuards = props.noFocusGuards, persistentFocus = props.persistentFocus, crossFrame = props.crossFrame, autoFocus = props.autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $e86725766b4cde33$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? "div" : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, shouldReturnFocus = props.returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState2 = $acw62.useState({}), id = _React$useState2[0]; // SIDE EFFECT CALLBACKS
    var onActivation = $acw62.useCallback(function() {
        originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $acw62.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
    }, [
        onDeactivationCallback
    ]);
    (0, $acw62.useEffect)(function() {
        if (!disabled) // cleanup return focus on trap deactivation
        // sideEffect/returnFocus should happen by this time
        originalFocusedElement.current = null;
    }, []);
    var returnFocus = $acw62.useCallback(function(allowDefer) {
        var returnFocusTo = originalFocusedElement.current;
        if (returnFocusTo && returnFocusTo.focus) {
            var howToReturnFocus = typeof shouldReturnFocus === "function" ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === "object" ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) // React might return focus after update
                // it's safer to defer the action
                Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]); // MEDIUM CALLBACKS
    var onFocus = $acw62.useCallback(function(event) {
        if (isActive.current) (0, $292937b69072d1e6$export$5733e022b1d538cb).useMedium(event);
    }, []);
    var onBlur = (0, $292937b69072d1e6$export$b3e9a9312f73723c).useMedium; // REF PROPAGATION
    // not using real refs due to race conditions
    var setObserveNode = $acw62.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((_extends2 = {}, _extends2[$34f6623b57e1a1c8$export$aeda8252e54b50f7] = disabled && "disabled", _extends2[$34f6623b57e1a1c8$export$4f9a06cb7441a087] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== "tail";
    var mergedRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        parentRef,
        setObserveNode
    ]);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ // nearest focus guard
        $acw62.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $119d56c93ccd46db$export$b8c7b07253306600)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $acw62.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $119d56c93ccd46db$export$b8c7b07253306600)
        }) : null
    ], !disabled && /*#__PURE__*/ $acw62.createElement(SideCar, {
        id: id,
        sideCar: (0, $292937b69072d1e6$export$892cbf28e5518020),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $acw62.createElement(Container, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), children), hasTailingGuards && /*#__PURE__*/ $acw62.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $119d56c93ccd46db$export$b8c7b07253306600)
    }));
});
$e86725766b4cde33$var$FocusLock.propTypes = {};
$e86725766b4cde33$var$FocusLock.defaultProps = {
    children: undefined,
    disabled: false,
    returnFocus: false,
    focusOptions: undefined,
    noFocusGuards: false,
    autoFocus: true,
    persistentFocus: false,
    crossFrame: true,
    hasPositiveIndices: undefined,
    allowTextSelection: undefined,
    group: undefined,
    className: undefined,
    whiteList: undefined,
    shards: undefined,
    as: "div",
    lockProps: {},
    onActivation: undefined,
    onDeactivation: undefined
};
var $e86725766b4cde33$export$2e2bcd8739ae039 = $e86725766b4cde33$var$FocusLock;


/* eslint-disable no-mixed-operators */ 
var $acw62 = parcelRequire("acw62");

function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(subClass, superClass);
}


function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}



function $96eac03571e01dbf$export$2e2bcd8739ae039(input, hint) {
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(arg) {
    var key = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(arg, "string");
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



var $acw62 = parcelRequire("acw62");
function $bec73a156e960f78$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $acw62.PureComponent));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $bec73a156e960f78$export$2e2bcd8739ae039 = $bec73a156e960f78$var$withSideEffect;



/*
IE11 support
 */ var $c2cb5aa387a37a50$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $c2cb5aa387a37a50$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $c2cb5aa387a37a50$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};



var $2cff22612808ae96$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue("display") === "none" || computedStyle.getPropertyValue("visibility") === "hidden";
};
var $2cff22612808ae96$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $2cff22612808ae96$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $2cff22612808ae96$var$isVisibleUncached = function(node, checkParent) {
    return !node || $2cff22612808ae96$var$isTopNode(node) || !$2cff22612808ae96$var$isElementHidden(node) && checkParent($2cff22612808ae96$var$getParentNode(node));
};
var $2cff22612808ae96$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $2cff22612808ae96$var$isVisibleUncached(node, $2cff22612808ae96$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $2cff22612808ae96$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$2cff22612808ae96$var$isTopNode(node) ? $2cff22612808ae96$export$b8550e27de209d85(node) ? checkParent($2cff22612808ae96$var$getParentNode(node)) : false : true;
};
var $2cff22612808ae96$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $2cff22612808ae96$var$isAutoFocusAllowedUncached(node, $2cff22612808ae96$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $2cff22612808ae96$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $2cff22612808ae96$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === "BUTTON";
};
var $2cff22612808ae96$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === "INPUT";
};
var $2cff22612808ae96$export$9d74f6fbc6f469d0 = function(node) {
    return $2cff22612808ae96$export$88a6ceeed5737ba3(node) && node.type === "radio";
};
var $2cff22612808ae96$export$8197b0ea56b3b055 = function(node) {
    return !(($2cff22612808ae96$export$88a6ceeed5737ba3(node) || $2cff22612808ae96$export$65aad1b6bc934b11(node)) && (node.type === "hidden" || node.disabled));
};
var $2cff22612808ae96$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $34f6623b57e1a1c8$export$134ebef29fd94853));
    return ![
        true,
        "true",
        ""
    ].includes(attribute);
};
var $2cff22612808ae96$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $2cff22612808ae96$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $2cff22612808ae96$export$602e5a0d338d7750 = function(node) {
    return !$2cff22612808ae96$export$d94b8b58ec2f30eb(node);
};
var $2cff22612808ae96$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};



var $e6301f5798625d25$export$350ee6c095d98996 = function(a, b) {
    var tabDiff = a.tabIndex - b.tabIndex;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!a.tabIndex) return 1;
        if (!b.tabIndex) return -1;
    }
    return tabDiff || indexDiff;
};
var $e6301f5798625d25$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(nodes).map(function(node, index) {
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($e6301f5798625d25$export$350ee6c095d98996);
};




/**
 * list of the object to be considered as focusable
 */ var $9fc4580037f02fd3$export$8555f4622e95784 = [
    "button:enabled",
    "select:enabled",
    "textarea:enabled",
    "input:enabled",
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[tabindex]",
    "[contenteditable]",
    "[autofocus]"
];


var $c85a3cad3fc06f20$var$queryTabbables = (0, $9fc4580037f02fd3$export$8555f4622e95784).join(",");
var $c85a3cad3fc06f20$var$queryGuardTabbables = "".concat($c85a3cad3fc06f20$var$queryTabbables, ", [data-focus-guard]");
var $c85a3cad3fc06f20$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $c85a3cad3fc06f20$var$queryGuardTabbables : $c85a3cad3fc06f20$var$queryTabbables) ? [
            child
        ] : [], $c85a3cad3fc06f20$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $c85a3cad3fc06f20$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $c85a3cad3fc06f20$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $c85a3cad3fc06f20$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $c85a3cad3fc06f20$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $c85a3cad3fc06f20$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $c2cb5aa387a37a50$export$45b10814cc054894)(parent.parentNode.querySelectorAll($c85a3cad3fc06f20$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $c85a3cad3fc06f20$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $34f6623b57e1a1c8$export$70e9b4a1820af101), "]"));
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(parentFocus).map(function(node) {
        return $c85a3cad3fc06f20$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};


var $9b74641517b143d6$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $2cff22612808ae96$export$3c9dc299685ad160)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $2cff22612808ae96$export$8197b0ea56b3b055)(node);
    });
};
var $9b74641517b143d6$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $2cff22612808ae96$export$bcaa50628f6a736e)(cache, node);
    });
};
var $9b74641517b143d6$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $e6301f5798625d25$export$cb40ee071f0d5226)($9b74641517b143d6$export$6266a5cd5915dc33((0, $c85a3cad3fc06f20$export$f6768025e418420e)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $9b74641517b143d6$export$23c79be8286a3b0c = function(topNodes, visibilityCache) {
    return (0, $e6301f5798625d25$export$cb40ee071f0d5226)($9b74641517b143d6$export$6266a5cd5915dc33((0, $c85a3cad3fc06f20$export$f6768025e418420e)(topNodes), visibilityCache), false);
};
var $9b74641517b143d6$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $9b74641517b143d6$export$6266a5cd5915dc33((0, $c85a3cad3fc06f20$export$853fa94d922e78b9)(topNode), visibilityCache);
};
var $9b74641517b143d6$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $9b74641517b143d6$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $9b74641517b143d6$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $9b74641517b143d6$export$2344b14b097df817(child, element);
        });
    }
};




/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $7bf194f892d90e1b$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $7bf194f892d90e1b$var$getTopParent = function(node) {
    return node.parentNode ? $7bf194f892d90e1b$var$getTopParent(node.parentNode) : node;
};
var $7bf194f892d90e1b$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $34f6623b57e1a1c8$export$4f9a06cb7441a087));
        acc.push.apply(acc, group ? $7bf194f892d90e1b$var$filterNested((0, $c2cb5aa387a37a50$export$45b10814cc054894)($7bf194f892d90e1b$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $34f6623b57e1a1c8$export$4f9a06cb7441a087), '="').concat(group, '"]:not([').concat((0, $34f6623b57e1a1c8$export$aeda8252e54b50f7), '="disabled"])')))) : [
            currentNode
        ]);
        return acc;
    }, []);
};



/**
 * returns active element from document or from nested shadowdoms
 */ var $f296cb52f860ecc3$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};


var $b5783d59678393a3$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $b5783d59678393a3$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $f296cb52f860ecc3$export$78d20aae35adef88)(function() {
        return activeElement.contentWindow.document;
    }) ? $b5783d59678393a3$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};


var $eec3e0cab722c011$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $eec3e0cab722c011$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $c2cb5aa387a37a50$export$45b10814cc054894)(topNode.querySelectorAll("iframe")).some(function(node) {
        return $eec3e0cab722c011$var$focusInFrame(node, activeElement);
    }));
};
var $eec3e0cab722c011$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $b5783d59678393a3$export$cd4e5573fbe2b576)((0, $c2cb5aa387a37a50$export$bcd7afcd904dce14)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $7bf194f892d90e1b$export$7e87c4720b9b279b)(topNode).some(function(node) {
        return (0, $9b74641517b143d6$export$2344b14b097df817)(node, activeElement) || $eec3e0cab722c011$var$focusInsideIframe(node, activeElement);
    });
};






var $4a4957b2dfe49f02$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $b5783d59678393a3$export$cd4e5573fbe2b576)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(inDocument.querySelectorAll("[".concat((0, $34f6623b57e1a1c8$export$54ecf528c58f9ef6), "]"))).some(function(node) {
        return (0, $9b74641517b143d6$export$2344b14b097df817)(node, activeElement);
    });
};








var $51d90458d728fe34$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $51d90458d728fe34$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $51d90458d728fe34$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $51d90458d728fe34$var$getParents(nodeA);
    var parentsB = $51d90458d728fe34$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $51d90458d728fe34$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(baseActiveElement);
    var leftEntries = (0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $51d90458d728fe34$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $51d90458d728fe34$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $9b74641517b143d6$export$2344b14b097df817)(common, topCommon)) topCommon = common;
                else topCommon = $51d90458d728fe34$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $51d90458d728fe34$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $9b74641517b143d6$export$dc26309a71d1ce47)(node, visibilityCache));
    }, []);
};


var $3f73a80c2e676402$export$30d9c643899a8835 = function(topNode) {
    var entries = (0, $7bf194f892d90e1b$export$7e87c4720b9b279b)(topNode).filter((0, $2cff22612808ae96$export$602e5a0d338d7750));
    var commonParent = (0, $51d90458d728fe34$export$a9a7252b5f2e280e)(topNode, topNode, entries);
    var visibilityCache = new Map();
    var outerNodes = (0, $9b74641517b143d6$export$3738e313571e2ad2)([
        commonParent
    ], visibilityCache, true);
    var innerElements = (0, $9b74641517b143d6$export$3738e313571e2ad2)(entries, visibilityCache).filter(function(_a) {
        var node = _a.node;
        return (0, $2cff22612808ae96$export$602e5a0d338d7750)(node);
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $2cff22612808ae96$export$d94b8b58ec2f30eb)(node)
        };
    });
};
var $3f73a80c2e676402$export$5f246425711134ac = $3f73a80c2e676402$export$30d9c643899a8835;



var $3315685220e94b72$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $2cff22612808ae96$export$9d74f6fbc6f469d0)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $3315685220e94b72$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $2cff22612808ae96$export$9d74f6fbc6f469d0)(node) && node.name) return $3315685220e94b72$var$findSelectedRadio(node, nodes);
    return node;
};
var $3315685220e94b72$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($3315685220e94b72$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};



var $550b7510239b204f$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $3315685220e94b72$export$5261662167ad7ced)(nodes[0], nodes);
    return nodes[0];
};
var $550b7510239b204f$export$e06728ee87c96122 = function(nodes, index) {
    if (nodes.length > 1) return nodes.indexOf((0, $3315685220e94b72$export$5261662167ad7ced)(nodes[index], nodes));
    return index;
};



var $5f30961e5fc5285a$export$85710b12cf912438 = "NEW_FOCUS";
var $5f30961e5fc5285a$export$65842178e9bb4205 = function(innerNodes, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $2cff22612808ae96$export$d94b8b58ec2f30eb)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $3315685220e94b72$export$4a5a72a7124e45f9)(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    var returnFirstNode = (0, $550b7510239b204f$export$e06728ee87c96122)(innerNodes, 0);
    var returnLastNode = (0, $550b7510239b204f$export$e06728ee87c96122)(innerNodes, cnt - 1);
    // new focus
    if (activeIndex === -1 || lastNodeInside === -1) return $5f30961e5fc5285a$export$85710b12cf912438;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};








var $0a6fd98cd390fe5b$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $2cff22612808ae96$export$698b339b0c8edae3)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== "false" || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $0a6fd98cd390fe5b$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $9b74641517b143d6$export$2f70373d403a5d2b)(nodes.filter($0a6fd98cd390fe5b$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $550b7510239b204f$export$f4e86cfa0679b9cc)(autoFocusable);
    return (0, $550b7510239b204f$export$f4e86cfa0679b9cc)((0, $9b74641517b143d6$export$2f70373d403a5d2b)(orderedNodes));
};





var $34c76fc1214ef975$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $2cff22612808ae96$export$4e62c701997796c1));
};
var $34c76fc1214ef975$export$82d3f62e3f171d1d = function(topNode, lastNode) {
    var activeElement = (0, $b5783d59678393a3$export$cd4e5573fbe2b576)((0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(topNode).length > 0 ? document : (0, $c2cb5aa387a37a50$export$bcd7afcd904dce14)(topNode).ownerDocument);
    var entries = (0, $7bf194f892d90e1b$export$7e87c4720b9b279b)(topNode).filter((0, $2cff22612808ae96$export$602e5a0d338d7750));
    var commonParent = (0, $51d90458d728fe34$export$a9a7252b5f2e280e)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $9b74641517b143d6$export$23c79be8286a3b0c)(entries, visibilityCache);
    var innerElements = (0, $9b74641517b143d6$export$3738e313571e2ad2)(entries, visibilityCache).filter(function(_a) {
        var node = _a.node;
        return (0, $2cff22612808ae96$export$602e5a0d338d7750)(node);
    });
    if (!innerElements[0]) {
        innerElements = anyFocusable;
        if (!innerElements[0]) return undefined;
    }
    var outerNodes = (0, $9b74641517b143d6$export$23c79be8286a3b0c)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $34c76fc1214ef975$var$reorderNodes(outerNodes, innerElements);
    var innerNodes = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $5f30961e5fc5285a$export$65842178e9bb4205)(innerNodes, outerNodes, activeElement, lastNode);
    if (newId === (0, $5f30961e5fc5285a$export$85710b12cf912438)) {
        var focusNode = (0, $0a6fd98cd390fe5b$export$cfb742983e257555)(anyFocusable, innerNodes, (0, $51d90458d728fe34$export$8f99714c70a37db1)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn("focus-lock: cannot find any node to move focus into");
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};


var $c471be4735bd3878$export$c12b3da842c43a8 = function(target, focusOptions) {
    if ("focus" in target) target.focus(focusOptions);
    if ("contentWindow" in target && target.contentWindow) target.contentWindow.focus();
};
var $c471be4735bd3878$var$guardCount = 0;
var $c471be4735bd3878$var$lockDisabled = false;
var $c471be4735bd3878$export$f06c444b0336b5d5 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $34c76fc1214ef975$export$82d3f62e3f171d1d)(topNode, lastNode);
    if ($c471be4735bd3878$var$lockDisabled) return;
    if (focusable) {
        if ($c471be4735bd3878$var$guardCount > 2) {
            // tslint:disable-next-line:no-console
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $c471be4735bd3878$var$lockDisabled = true;
            setTimeout(function() {
                $c471be4735bd3878$var$lockDisabled = false;
            }, 1);
            return;
        }
        $c471be4735bd3878$var$guardCount++;
        $c471be4735bd3878$export$c12b3da842c43a8(focusable.node, options.focusOptions);
        $c471be4735bd3878$var$guardCount--;
    }
};






var $db815af593127be9$export$2e2bcd8739ae039 //
 = (0, $c471be4735bd3878$export$f06c444b0336b5d5);


function $de7ba2c6b170eb4f$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $de7ba2c6b170eb4f$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};



var $00df5dbe84bcea91$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $00df5dbe84bcea91$var$isFreeFocus = function isFreeFocus() {
    return $00df5dbe84bcea91$var$focusOnBody() || (0, $4a4957b2dfe49f02$export$be6b21806d3fd485)();
};
var $00df5dbe84bcea91$var$lastActiveTrap = null;
var $00df5dbe84bcea91$var$lastActiveFocus = null;
var $00df5dbe84bcea91$var$lastPortaledElement = null;
var $00df5dbe84bcea91$var$focusWasOutsideWindow = false;
var $00df5dbe84bcea91$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $00df5dbe84bcea91$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($00df5dbe84bcea91$var$lastActiveTrap.whiteList || $00df5dbe84bcea91$var$defaultWhitelist)(activeElement);
};
var $00df5dbe84bcea91$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $00df5dbe84bcea91$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $00df5dbe84bcea91$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $00df5dbe84bcea91$var$lastPortaledElement && $00df5dbe84bcea91$var$lastPortaledElement.portaledElement === element;
};
function $00df5dbe84bcea91$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) // we will tab to the next element
            return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $00df5dbe84bcea91$var$extractRef = function extractRef(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $00df5dbe84bcea91$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) // with cross frame return true for any value
    return Boolean($00df5dbe84bcea91$var$focusWasOutsideWindow);
     // in other case return only of focus went a while aho
    return $00df5dbe84bcea91$var$focusWasOutsideWindow === "meanwhile";
};
var $00df5dbe84bcea91$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement) // dive up
    ) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $00df5dbe84bcea91$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $00df5dbe84bcea91$var$checkInHost(activeElement, area, area);
    });
};
var $00df5dbe84bcea91$var$activateTrap = function activateTrap() {
    var result = false;
    if ($00df5dbe84bcea91$var$lastActiveTrap) {
        var _lastActiveTrap = $00df5dbe84bcea91$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $00df5dbe84bcea91$var$lastPortaledElement && $00df5dbe84bcea91$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map($00df5dbe84bcea91$var$extractRef).filter(Boolean));
            if (!activeElement || $00df5dbe84bcea91$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $00df5dbe84bcea91$var$focusWasOutside(crossFrame) || !$00df5dbe84bcea91$var$isFreeFocus() || !$00df5dbe84bcea91$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $eec3e0cab722c011$export$20115f8da7baa6fa)(workingArea) || // check for shadow-dom contained elements
                    activeElement && $00df5dbe84bcea91$var$withinHost(activeElement, workingArea) || $00df5dbe84bcea91$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$00df5dbe84bcea91$var$lastActiveFocus && activeElement && !autoFocus) {
                            // Check if blur() exists, which is missing on certain elements on IE
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $db815af593127be9$export$2e2bcd8739ae039)(workingArea, $00df5dbe84bcea91$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $00df5dbe84bcea91$var$lastPortaledElement = {};
                        }
                    }
                    $00df5dbe84bcea91$var$focusWasOutsideWindow = false;
                    $00df5dbe84bcea91$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $3f73a80c2e676402$export$30d9c643899a8835)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    // remove old focus
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute("tabIndex");
                    });
                    $00df5dbe84bcea91$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $00df5dbe84bcea91$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $00df5dbe84bcea91$var$onTrap = function onTrap(event) {
    if ($00df5dbe84bcea91$var$activateTrap() && event) {
        // prevent scroll jump
        event.stopPropagation();
        event.preventDefault();
    }
};
var $00df5dbe84bcea91$var$onBlur = function onBlur() {
    return (0, $de7ba2c6b170eb4f$export$6523025722806278)($00df5dbe84bcea91$var$activateTrap);
};
var $00df5dbe84bcea91$var$onFocus = function onFocus(event) {
    // detect portal
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $00df5dbe84bcea91$var$recordPortal(currentNode, source);
};
var $00df5dbe84bcea91$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $00df5dbe84bcea91$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $acw62.createElement("div", {
        onBlur: $00df5dbe84bcea91$var$onBlur,
        onFocus: $00df5dbe84bcea91$var$onFocus
    }, children);
};
$00df5dbe84bcea91$var$FocusTrap.propTypes = {};
var $00df5dbe84bcea91$var$onWindowBlur = function onWindowBlur() {
    $00df5dbe84bcea91$var$focusWasOutsideWindow = "just"; // using setTimeout to set  this variable after React/sidecar reaction
    (0, $de7ba2c6b170eb4f$export$6523025722806278)(function() {
        $00df5dbe84bcea91$var$focusWasOutsideWindow = "meanwhile";
    });
};
var $00df5dbe84bcea91$var$attachHandler = function attachHandler() {
    document.addEventListener("focusin", $00df5dbe84bcea91$var$onTrap);
    document.addEventListener("focusout", $00df5dbe84bcea91$var$onBlur);
    window.addEventListener("blur", $00df5dbe84bcea91$var$onWindowBlur);
};
var $00df5dbe84bcea91$var$detachHandler = function detachHandler() {
    document.removeEventListener("focusin", $00df5dbe84bcea91$var$onTrap);
    document.removeEventListener("focusout", $00df5dbe84bcea91$var$onBlur);
    window.removeEventListener("blur", $00df5dbe84bcea91$var$onWindowBlur);
};
function $00df5dbe84bcea91$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
function $00df5dbe84bcea91$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$00df5dbe84bcea91$var$lastActiveTrap) $00df5dbe84bcea91$var$attachHandler();
    var lastTrap = $00df5dbe84bcea91$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $00df5dbe84bcea91$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation(); // return focus only of last trap was removed
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) // allow defer is no other trap is awaiting restore
        lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $00df5dbe84bcea91$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation();
        $00df5dbe84bcea91$var$activateTrap(true);
        (0, $de7ba2c6b170eb4f$export$6523025722806278)($00df5dbe84bcea91$var$activateTrap);
    } else {
        $00df5dbe84bcea91$var$detachHandler();
        $00df5dbe84bcea91$var$lastActiveFocus = null;
    }
} // bind medium
(0, $292937b69072d1e6$export$5733e022b1d538cb).assignSyncMedium($00df5dbe84bcea91$var$onFocus);
(0, $292937b69072d1e6$export$b3e9a9312f73723c).assignMedium($00df5dbe84bcea91$var$onBlur);
(0, $292937b69072d1e6$export$3a1d52767cbc07b8).assignMedium(function(cb) {
    return cb({
        moveFocusInside: (0, $db815af593127be9$export$2e2bcd8739ae039),
        focusInside: (0, $eec3e0cab722c011$export$20115f8da7baa6fa)
    });
});
var $00df5dbe84bcea91$export$2e2bcd8739ae039 = (0, $bec73a156e960f78$export$2e2bcd8739ae039)($00df5dbe84bcea91$var$reducePropsToState, $00df5dbe84bcea91$var$handleStateChangeOnClient)($00df5dbe84bcea91$var$FocusWatcher);


/* that would be a BREAKING CHANGE!
// delaying sidecar execution till the first usage
const RequireSideCar = (props) => {
  // eslint-disable-next-line global-require
  const SideCar = require('./Trap').default;
  return <SideCar {...props} />;
};
*/ var $afd3cd9c4d0274d7$var$FocusLockCombination = /*#__PURE__*/ $acw62.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $e86725766b4cde33$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        sideCar: (0, $00df5dbe84bcea91$export$2e2bcd8739ae039),
        ref: ref
    }, props));
});
var $afd3cd9c4d0274d7$var$_ref = (0, $e86725766b4cde33$export$2e2bcd8739ae039).propTypes || {}, $afd3cd9c4d0274d7$var$sideCar = $afd3cd9c4d0274d7$var$_ref.sideCar, $afd3cd9c4d0274d7$var$propTypes = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)($afd3cd9c4d0274d7$var$_ref, [
    "sideCar"
]);
$afd3cd9c4d0274d7$var$FocusLockCombination.propTypes = {};
var $afd3cd9c4d0274d7$export$2e2bcd8739ae039 = $afd3cd9c4d0274d7$var$FocusLockCombination;



var $9962412629625ccb$export$2e2bcd8739ae039 = (0, $afd3cd9c4d0274d7$export$2e2bcd8739ae039);



// src/dom.ts
function $534108a0b0d3445d$export$45a5e7f76e0caa8d(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function $534108a0b0d3445d$export$1b3bfaa9684536aa(el) {
    var _a;
    if (!$534108a0b0d3445d$export$45a5e7f76e0caa8d(el)) return false;
    const win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
    return el instanceof win.HTMLElement;
}
function $534108a0b0d3445d$export$f21a1ffae260145a(node) {
    var _a, _b;
    return (_b = (_a = $534108a0b0d3445d$export$b204af158042fbac(node)) == null ? void 0 : _a.defaultView) != null ? _b : window;
}
function $534108a0b0d3445d$export$b204af158042fbac(node) {
    return $534108a0b0d3445d$export$45a5e7f76e0caa8d(node) ? node.ownerDocument : document;
}
function $534108a0b0d3445d$export$8d16348623687f6(event) {
    var _a;
    return (_a = event.view) != null ? _a : window;
}
function $534108a0b0d3445d$export$4e09c449d6c407f7() {
    return Boolean(globalThis == null ? void 0 : globalThis.document);
}
function $534108a0b0d3445d$export$cd4e5573fbe2b576(node) {
    return $534108a0b0d3445d$export$b204af158042fbac(node).activeElement;
}
function $534108a0b0d3445d$export$2344b14b097df817(parent, child) {
    if (!parent) return false;
    return parent === child || parent.contains(child);
}


// src/tabbable.ts
var $2d4b29ebc030a42a$export$f5f22eac728522fd = (element)=>window.getComputedStyle(element).display === "none";
var $2d4b29ebc030a42a$export$54209d29bacd2cb9 = (element)=>element.hasAttribute("tabindex");
var $2d4b29ebc030a42a$export$87df0ed37d24dd13 = (element)=>$2d4b29ebc030a42a$export$54209d29bacd2cb9(element) && element.tabIndex === -1;
function $2d4b29ebc030a42a$export$30e0dc115df457ed(element) {
    return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
}
function $2d4b29ebc030a42a$export$63ed1d20cf8213cf(element) {
    return (0, $534108a0b0d3445d$export$1b3bfaa9684536aa)(element) && element.localName === "input" && "select" in element;
}
function $2d4b29ebc030a42a$export$8a2eb51c14bb8899(element) {
    const doc = (0, $534108a0b0d3445d$export$1b3bfaa9684536aa)(element) ? (0, $534108a0b0d3445d$export$b204af158042fbac)(element) : document;
    return doc.activeElement === element;
}
function $2d4b29ebc030a42a$export$848589947316f680(element) {
    if (!document.activeElement) return false;
    return element.contains(document.activeElement);
}
function $2d4b29ebc030a42a$export$ee695c13482bb5dd(element) {
    if (element.parentElement && $2d4b29ebc030a42a$export$ee695c13482bb5dd(element.parentElement)) return true;
    return element.hidden;
}
function $2d4b29ebc030a42a$export$3453cc819780f652(element) {
    const value = element.getAttribute("contenteditable");
    return value !== "false" && value != null;
}
function $2d4b29ebc030a42a$export$4c063cf1350e6fed(element) {
    if (!(0, $534108a0b0d3445d$export$1b3bfaa9684536aa)(element) || $2d4b29ebc030a42a$export$ee695c13482bb5dd(element) || $2d4b29ebc030a42a$export$30e0dc115df457ed(element)) return false;
    const { localName: localName } = element;
    const focusableTags = [
        "input",
        "select",
        "textarea",
        "button"
    ];
    if (focusableTags.indexOf(localName) >= 0) return true;
    const others = {
        a: ()=>element.hasAttribute("href"),
        audio: ()=>element.hasAttribute("controls"),
        video: ()=>element.hasAttribute("controls")
    };
    if (localName in others) return others[localName]();
    if ($2d4b29ebc030a42a$export$3453cc819780f652(element)) return true;
    return $2d4b29ebc030a42a$export$54209d29bacd2cb9(element);
}
function $2d4b29ebc030a42a$export$bebd5a1431fec25d(element) {
    if (!element) return false;
    return (0, $534108a0b0d3445d$export$1b3bfaa9684536aa)(element) && $2d4b29ebc030a42a$export$4c063cf1350e6fed(element) && !$2d4b29ebc030a42a$export$87df0ed37d24dd13(element);
}



// src/index.ts
var $2858cbef67902129$var$focusableElList = [
    "input:not(:disabled):not([disabled])",
    "select:not(:disabled):not([disabled])",
    "textarea:not(:disabled):not([disabled])",
    "embed",
    "iframe",
    "object",
    "a[href]",
    "area[href]",
    "button:not(:disabled):not([disabled])",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    "*[tabindex]:not([aria-disabled])",
    "*[contenteditable]"
];
var $2858cbef67902129$var$focusableElSelector = $2858cbef67902129$var$focusableElList.join();
var $2858cbef67902129$var$isVisible = (el)=>el.offsetWidth > 0 && el.offsetHeight > 0;
function $2858cbef67902129$export$4ae682d253b556eb(container) {
    const focusableEls = Array.from(container.querySelectorAll($2858cbef67902129$var$focusableElSelector));
    focusableEls.unshift(container);
    return focusableEls.filter((el)=>(0, $2d4b29ebc030a42a$export$4c063cf1350e6fed)(el) && $2858cbef67902129$var$isVisible(el));
}
function $2858cbef67902129$export$748138f04a69bf21(container) {
    const allFocusable = $2858cbef67902129$export$4ae682d253b556eb(container);
    return allFocusable.length ? allFocusable[0] : null;
}
function $2858cbef67902129$export$f9ba66356f7359cf(container, fallbackToFocusable) {
    const allFocusable = Array.from(container.querySelectorAll($2858cbef67902129$var$focusableElSelector));
    const allTabbable = allFocusable.filter((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d));
    if ((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d)(container)) allTabbable.unshift(container);
    if (!allTabbable.length && fallbackToFocusable) return allFocusable;
    return allTabbable;
}
function $2858cbef67902129$export$168b663469d4c75e(container, fallbackToFocusable) {
    const [first] = $2858cbef67902129$export$f9ba66356f7359cf(container, fallbackToFocusable);
    return first || null;
}
function $2858cbef67902129$export$a6fe3106a93f5f4b(container, fallbackToFocusable) {
    const allTabbable = $2858cbef67902129$export$f9ba66356f7359cf(container, fallbackToFocusable);
    return allTabbable[allTabbable.length - 1] || null;
}
function $2858cbef67902129$export$28f33206776129a7(container, fallbackToFocusable) {
    const allFocusable = $2858cbef67902129$export$4ae682d253b556eb(container);
    const index = allFocusable.indexOf(document.activeElement);
    const slice = allFocusable.slice(index + 1);
    return slice.find((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d)) || allFocusable.find((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d)) || (fallbackToFocusable ? slice[0] : null);
}
function $2858cbef67902129$export$2e5518c3303f364a(container, fallbackToFocusable) {
    const allFocusable = $2858cbef67902129$export$4ae682d253b556eb(container).reverse();
    const index = allFocusable.indexOf(document.activeElement);
    const slice = allFocusable.slice(index + 1);
    return slice.find((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d)) || allFocusable.find((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d)) || (fallbackToFocusable ? slice[0] : null);
}



var $acw62 = parcelRequire("acw62");

"use client";
var $33e99d423fc5385f$var$_a;
var $33e99d423fc5385f$var$FocusTrap = ($33e99d423fc5385f$var$_a = (0, $9962412629625ccb$export$2e2bcd8739ae039).default) != null ? $33e99d423fc5385f$var$_a : (0, $9962412629625ccb$export$2e2bcd8739ae039);
var $33e99d423fc5385f$export$ae70e1f3be7e1299 = (props)=>{
    const { initialFocusRef: initialFocusRef, finalFocusRef: finalFocusRef, contentRef: contentRef, restoreFocus: restoreFocus, children: children, isDisabled: isDisabled, autoFocus: autoFocus, persistentFocus: persistentFocus, lockFocusAcrossFrames: lockFocusAcrossFrames } = props;
    const onActivation = (0, $acw62.useCallback)(()=>{
        if (initialFocusRef == null ? void 0 : initialFocusRef.current) initialFocusRef.current.focus();
        else if (contentRef == null ? void 0 : contentRef.current) {
            const focusables = (0, $2858cbef67902129$export$4ae682d253b556eb)(contentRef.current);
            if (focusables.length === 0) requestAnimationFrame(()=>{
                var _a2;
                (_a2 = contentRef.current) == null || _a2.focus();
            });
        }
    }, [
        initialFocusRef,
        contentRef
    ]);
    const onDeactivation = (0, $acw62.useCallback)(()=>{
        var _a2;
        (_a2 = finalFocusRef == null ? void 0 : finalFocusRef.current) == null || _a2.focus();
    }, [
        finalFocusRef
    ]);
    const returnFocus = restoreFocus && !finalFocusRef;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($33e99d423fc5385f$var$FocusTrap, {
        crossFrame: lockFocusAcrossFrames,
        persistentFocus: persistentFocus,
        autoFocus: autoFocus,
        disabled: isDisabled,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        children: children
    });
};
$33e99d423fc5385f$export$ae70e1f3be7e1299.displayName = "FocusLock";
var $33e99d423fc5385f$export$5cc412d51d00246f = $33e99d423fc5385f$export$ae70e1f3be7e1299;



var $acw62 = parcelRequire("acw62");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $bc77fac60b5d77cc$export$2a8c16d82a0a0e26() {
    const context = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $acw62.useId)();
    (0, $acw62.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $bc77fac60b5d77cc$export$8249053f690ea39a() {
    return $bc77fac60b5d77cc$export$ee27c052bca048fb((0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2)));
}
function $bc77fac60b5d77cc$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $3f8d56f1a38c65c8$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $3f8d56f1a38c65c8$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $3f8d56f1a38c65c8$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";




var $f6d5b57f3512e73c$export$e27363444bedfeac = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)();


var $cac2578984d345ac$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $cac2578984d345ac$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $cac2578984d345ac$var$nothing,
        onWheelCapture: $cac2578984d345ac$var$nothing,
        onTouchMoveCapture: $cac2578984d345ac$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $f6d5b57f3512e73c$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$cac2578984d345ac$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$cac2578984d345ac$export$22940b497e769dee.classNames = {
    fullWidth: (0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e),
    zeroRight: (0, $3f8d56f1a38c65c8$export$1da7500147d4bc3)
};




var $acw62 = parcelRequire("acw62");
var $c86481a7b0dfcc68$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $acw62.createElement(Target, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest));
};
$c86481a7b0dfcc68$var$SideCar.isSideCarExport = true;
function $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c86481a7b0dfcc68$var$SideCar;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $1334c25f36aeceaf$var$currentNonce;
var $1334c25f36aeceaf$export$c5f670b24c0ae95a = function(nonce) {
    $1334c25f36aeceaf$var$currentNonce = nonce;
};
var $1334c25f36aeceaf$export$2b85b721e524d74b = function() {
    if ($1334c25f36aeceaf$var$currentNonce) return $1334c25f36aeceaf$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $be1d9ed5bb532264$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $1334c25f36aeceaf$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $be1d9ed5bb532264$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $be1d9ed5bb532264$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $be1d9ed5bb532264$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $be1d9ed5bb532264$var$makeStyleTag()) {
                    $be1d9ed5bb532264$var$injectStyles(stylesheet, style);
                    $be1d9ed5bb532264$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $b5f767dd03f483e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $be1d9ed5bb532264$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $acw62.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $eb3b6a23a33fb1ba$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $b5f767dd03f483e5$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $19c77eb414ad2a19$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $19c77eb414ad2a19$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $19c77eb414ad2a19$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $19c77eb414ad2a19$var$parse(left),
        $19c77eb414ad2a19$var$parse(top),
        $19c77eb414ad2a19$var$parse(right)
    ];
};
var $19c77eb414ad2a19$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $19c77eb414ad2a19$export$efed13b5d0ca3386;
    var offsets = $19c77eb414ad2a19$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $9f2b7a700f678519$var$Style = (0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8)();
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9f2b7a700f678519$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $3f8d56f1a38c65c8$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat((0, $3f8d56f1a38c65c8$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $9f2b7a700f678519$export$9aa43b459c5ae9b9 = function(props) {
    var noRelative = props.noRelative, noImportant = props.noImportant, _a = props.gapMode, gapMode = _a === void 0 ? "margin" : _a;
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $acw62.useMemo(function() {
        return (0, $19c77eb414ad2a19$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $acw62.createElement($9f2b7a700f678519$var$Style, {
        styles: $9f2b7a700f678519$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $6f0aa8d921410141$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $6f0aa8d921410141$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $6f0aa8d921410141$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
    // @ts-ignore
    window.removeEventListener("test", $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
} catch (err) {
    $6f0aa8d921410141$var$passiveSupported = false;
}
var $6f0aa8d921410141$export$10a6e88623fa9454 = $6f0aa8d921410141$var$passiveSupported ? {
    passive: false
} : false;


var $a7f277057d6643d0$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $a7f277057d6643d0$var$elementCanBeScrolled = function(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$a7f277057d6643d0$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $a7f277057d6643d0$var$elementCouldBeVScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, "overflowY");
};
var $a7f277057d6643d0$var$elementCouldBeHScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, "overflowX");
};
var $a7f277057d6643d0$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $a7f277057d6643d0$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $a7f277057d6643d0$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $a7f277057d6643d0$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $a7f277057d6643d0$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $a7f277057d6643d0$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $a7f277057d6643d0$var$elementCouldBeVScrolled(node) : $a7f277057d6643d0$var$elementCouldBeHScrolled(node);
};
var $a7f277057d6643d0$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $a7f277057d6643d0$var$getVScrollVariables(node) : $a7f277057d6643d0$var$getHScrollVariables(node);
};
var $a7f277057d6643d0$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $a7f277057d6643d0$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $a7f277057d6643d0$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $a7f277057d6643d0$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($a7f277057d6643d0$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $f5f147098910888d$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $f5f147098910888d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $f5f147098910888d$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $f5f147098910888d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $f5f147098910888d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $f5f147098910888d$var$idCounter = 0;
var $f5f147098910888d$var$lockStack = [];
function $f5f147098910888d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($f5f147098910888d$var$idCounter++)[0];
    var Style = $acw62.useState((0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8))[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($f5f147098910888d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $f5f147098910888d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $a7f277057d6643d0$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$f5f147098910888d$var$lockStack.length || $f5f147098910888d$var$lockStack[$f5f147098910888d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $f5f147098910888d$export$39efaa2ca254a28d(event) : $f5f147098910888d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $f5f147098910888d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($f5f147098910888d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $f5f147098910888d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $f5f147098910888d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        return function() {
            $f5f147098910888d$var$lockStack = $f5f147098910888d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $f5f147098910888d$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $9f2b7a700f678519$export$9aa43b459c5ae9b9), {
        gapMode: props.gapMode
    }) : null);
}



var $0e88b28988758ab2$export$2e2bcd8739ae039 = (0, $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce)((0, $f6d5b57f3512e73c$export$e27363444bedfeac), (0, $f5f147098910888d$export$a09dbff87b5da2d));


var $cfb1c25e3ef3d3bc$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $cac2578984d345ac$export$22940b497e769dee), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $0e88b28988758ab2$export$2e2bcd8739ae039)
    }));
});
$cfb1c25e3ef3d3bc$var$ReactRemoveScroll.classNames = (0, $cac2578984d345ac$export$22940b497e769dee).classNames;
var $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039 = $cfb1c25e3ef3d3bc$var$ReactRemoveScroll;



"use client";
function $a4bb24df8dc40781$export$ffa1d90344e68399(props) {
    const { autoFocus: autoFocus, trapFocus: trapFocus, dialogRef: dialogRef, initialFocusRef: initialFocusRef, blockScrollOnMount: blockScrollOnMount, allowPinchZoom: allowPinchZoom, finalFocusRef: finalFocusRef, returnFocusOnClose: returnFocusOnClose, preserveScrollBarGap: preserveScrollBarGap, lockFocusAcrossFrames: lockFocusAcrossFrames, isOpen: isOpen } = (0, $4410258333ca5546$export$4cc1699d46f42cae)();
    const [isPresent, safeToRemove] = (0, $bc77fac60b5d77cc$export$2a8c16d82a0a0e26)();
    (0, $acw62.useEffect)(()=>{
        if (!isPresent && safeToRemove) setTimeout(safeToRemove);
    }, [
        isPresent,
        safeToRemove
    ]);
    const index = (0, $b09f0d09ca2d779f$export$8557a94b9bb25060)(dialogRef, isOpen);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $33e99d423fc5385f$export$ae70e1f3be7e1299), {
        autoFocus: autoFocus,
        isDisabled: !trapFocus,
        initialFocusRef: initialFocusRef,
        finalFocusRef: finalFocusRef,
        restoreFocus: returnFocusOnClose,
        contentRef: dialogRef,
        lockFocusAcrossFrames: lockFocusAcrossFrames,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039), {
            removeScrollBar: !preserveScrollBarGap,
            allowPinchZoom: allowPinchZoom,
            enabled: index === 1 && blockScrollOnMount,
            forwardProps: true,
            children: props.children
        })
    });
}





"use client";
// src/transition-utils.ts
var $e53c11b120069459$export$9ee1d08bb6db426f = {
    ease: [
        0.25,
        0.1,
        0.25,
        1
    ],
    easeIn: [
        0.4,
        0,
        1,
        1
    ],
    easeOut: [
        0,
        0,
        0.2,
        1
    ],
    easeInOut: [
        0.4,
        0,
        0.2,
        1
    ]
};
var $e53c11b120069459$export$55b7325ba41bb523 = {
    scale: {
        enter: {
            scale: 1
        },
        exit: {
            scale: 0.95
        }
    },
    fade: {
        enter: {
            opacity: 1
        },
        exit: {
            opacity: 0
        }
    },
    pushLeft: {
        enter: {
            x: "100%"
        },
        exit: {
            x: "-30%"
        }
    },
    pushRight: {
        enter: {
            x: "-100%"
        },
        exit: {
            x: "30%"
        }
    },
    pushUp: {
        enter: {
            y: "100%"
        },
        exit: {
            y: "-30%"
        }
    },
    pushDown: {
        enter: {
            y: "-100%"
        },
        exit: {
            y: "30%"
        }
    },
    slideLeft: {
        position: {
            left: 0,
            top: 0,
            bottom: 0,
            width: "100%"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: "-100%",
            y: 0
        }
    },
    slideRight: {
        position: {
            right: 0,
            top: 0,
            bottom: 0,
            width: "100%"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: "100%",
            y: 0
        }
    },
    slideUp: {
        position: {
            top: 0,
            left: 0,
            right: 0,
            maxWidth: "100vw"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: 0,
            y: "-100%"
        }
    },
    slideDown: {
        position: {
            bottom: 0,
            left: 0,
            right: 0,
            maxWidth: "100vw"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: 0,
            y: "100%"
        }
    }
};
function $e53c11b120069459$export$76af7f35258e628d(options) {
    var _a;
    const side = (_a = options == null ? void 0 : options.direction) != null ? _a : "right";
    switch(side){
        case "right":
            return $e53c11b120069459$export$55b7325ba41bb523.slideRight;
        case "left":
            return $e53c11b120069459$export$55b7325ba41bb523.slideLeft;
        case "bottom":
            return $e53c11b120069459$export$55b7325ba41bb523.slideDown;
        case "top":
            return $e53c11b120069459$export$55b7325ba41bb523.slideUp;
        default:
            return $e53c11b120069459$export$55b7325ba41bb523.slideRight;
    }
}
var $e53c11b120069459$export$f995eb860f745cb = {
    enter: {
        duration: 0.2,
        ease: $e53c11b120069459$export$9ee1d08bb6db426f.easeOut
    },
    exit: {
        duration: 0.1,
        ease: $e53c11b120069459$export$9ee1d08bb6db426f.easeIn
    }
};
var $e53c11b120069459$export$fc492bd0f1c91c = {
    enter: (transition, delay)=>({
            ...transition,
            delay: typeof delay === "number" ? delay : delay == null ? void 0 : delay["enter"]
        }),
    exit: (transition, delay)=>({
            ...transition,
            delay: typeof delay === "number" ? delay : delay == null ? void 0 : delay["exit"]
        })
};




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ const $3bbbde5b328b4154$export$22a697fb29aac98d = (0, $acw62.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $acw62 = parcelRequire("acw62");
const $3ce32ada97cfc8f7$export$2285bbca2c666415 = (0, $acw62.createContext)({});



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
const $410b846e117db9e1$export$40f10139ecf1f171 = (0, $acw62.createContext)({
    strict: false
});



function $7fb0f4644b9cc8ad$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const { visualElement: parent } = (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415));
    const lazyContext = (0, $acw62.useContext)((0, $410b846e117db9e1$export$40f10139ecf1f171));
    const presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $acw62.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $acw62.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const canHandoff = (0, $acw62.useRef)(Boolean(window.HandoffAppearAnimations));
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        visualElement.render();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (canHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $acw62.useEffect)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        if (!canHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        /**
         * Once we've handed off animations we can delete HandoffAppearAnimations
         * so components added after the initial render can animate changes
         * in useEffect vs useLayoutEffect.
         */ window.HandoffAppearAnimations = undefined;
        canHandoff.current = false;
    });
    return visualElement;
}



var $acw62 = parcelRequire("acw62");
function $d157673547c2a934$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $88efa764bb00537b$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $acw62.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $d157673547c2a934$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $acw62 = parcelRequire("acw62");

/**
 * Decides if the supplied variable is variant label
 */ function $a35be4d5814e7c66$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $1e5344c7f0db9c8f$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}



const $0172fb3d3512f551$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $0172fb3d3512f551$export$1405a65085f40b9 = [
    "initial",
    ...$0172fb3d3512f551$export$16e45afcc206d3a8
];


function $06b1046bf0f33e63$export$4b3c3bd8d910d78d(props) {
    return (0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(props.animate) || (0, $0172fb3d3512f551$export$1405a65085f40b9).some((name)=>(0, $a35be4d5814e7c66$export$720b90e312cea233)(props[name]));
}
function $06b1046bf0f33e63$export$ce46fa4165cdec40(props) {
    return Boolean($06b1046bf0f33e63$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $9e57028cf0cad086$export$12fc32fc096a04a3(props, context) {
    if ((0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $a35be4d5814e7c66$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $a35be4d5814e7c66$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $4cb87fa0b981df8c$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $9e57028cf0cad086$export$12fc32fc096a04a3)(props, (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415)));
    return (0, $acw62.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(initial),
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(animate)
    ]);
}
function $4cb87fa0b981df8c$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $a8d82256030e9525$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $a8d82256030e9525$export$65570e08d843624d = {};
for(const key in $a8d82256030e9525$var$featureProps)$a8d82256030e9525$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$a8d82256030e9525$var$featureProps[key].some((name)=>!!props[name])
};


function $b9879783068c1762$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $a8d82256030e9525$export$65570e08d843624d)[key] = {
        ...(0, $a8d82256030e9525$export$65570e08d843624d)[key],
        ...features[key]
    };
}






var $acw62 = parcelRequire("acw62");
/**
 * Internal, exported only for usage in Framer
 */ const $c612a166b65a9c69$export$da5f7b802957459a = (0, $acw62.createContext)({});


const $9b94ea54d3350cc1$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $b40dad60036091a1$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $b9879783068c1762$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d)),
            ...props,
            layoutId: $b40dad60036091a1$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $4cb87fa0b981df8c$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $784730508f12f72c$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $7fb0f4644b9cc8ad$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const initialLayoutGroupConfig = (0, $acw62.useContext)((0, $c612a166b65a9c69$export$da5f7b802957459a));
            const isStrict = (0, $acw62.useContext)((0, $410b846e117db9e1$export$40f10139ecf1f171)).strict;
            if (context.visualElement) MeasureLayout = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $acw62.createElement((0, $3ce32ada97cfc8f7$export$2285bbca2c666415).Provider, {
            value: context
        }, MeasureLayout && context.visualElement ? $acw62.createElement(MeasureLayout, {
            visualElement: context.visualElement,
            ...configAndProps
        }) : null, useRender(Component, props, (0, $88efa764bb00537b$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement));
    }
    const ForwardRefComponent = (0, $acw62.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $9b94ea54d3350cc1$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $b40dad60036091a1$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $16a09bb264d348bb$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $b40dad60036091a1$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $1d85745fbdd79bfa$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $ca4ea6365adee72d$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $1d85745fbdd79bfa$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $eced91e16bda42df$export$91ddd985b97788d1 = {};
function $eced91e16bda42df$export$de9e7791c71225fd(correctors) {
    Object.assign($eced91e16bda42df$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $ac502869c4d3e65a$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $ac502869c4d3e65a$export$7b42a0094fb00b6e = new Set($ac502869c4d3e65a$export$280dc01950909d86);


function $443c859766df5778$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $eced91e16bda42df$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $55c3387a92452647$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $1724c99b9b724858$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $1724c99b9b724858$var$numTransforms = (0, $ac502869c4d3e65a$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $1724c99b9b724858$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $1724c99b9b724858$var$numTransforms; i++){
        const key = (0, $ac502869c4d3e65a$export$280dc01950909d86)[i];
        if (transform[key] !== undefined) {
            const transformName = $1724c99b9b724858$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}


const $f9c5e88311214d2a$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $f9c5e88311214d2a$export$9de1236619d9e756 = $f9c5e88311214d2a$var$checkStringStartsWith("--");
const $f9c5e88311214d2a$export$31f9caa2600b5723 = $f9c5e88311214d2a$var$checkStringStartsWith("var(--");
const $f9c5e88311214d2a$export$f7c0a352d8ef6313 = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $a19b1277e1098e3a$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


const $965bce4b5aab9d94$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $965bce4b5aab9d94$export$58f0f39f63f3cf42 = {
    ...$965bce4b5aab9d94$export$98e628dec113755e,
    transform: (v)=>(0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $965bce4b5aab9d94$export$dcdf75081b88279d = {
    ...$965bce4b5aab9d94$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $9d068be114f1d873$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $9d068be114f1d873$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $9d068be114f1d873$export$740b69c5fad25dba = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const $9d068be114f1d873$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $9d068be114f1d873$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $25ca921ba8e55794$var$createUnitType = (unit)=>({
        test: (v)=>(0, $9d068be114f1d873$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $25ca921ba8e55794$export$41fc368e1a942b97 = $25ca921ba8e55794$var$createUnitType("deg");
const $25ca921ba8e55794$export$626336c2cd4b14de = $25ca921ba8e55794$var$createUnitType("%");
const $25ca921ba8e55794$export$91c0eda1d06bf008 = $25ca921ba8e55794$var$createUnitType("px");
const $25ca921ba8e55794$export$f91e8c45a95a32f2 = $25ca921ba8e55794$var$createUnitType("vh");
const $25ca921ba8e55794$export$aed3d7b7d206c196 = $25ca921ba8e55794$var$createUnitType("vw");
const $25ca921ba8e55794$export$44e2e1705876d7ed = {
    ...$25ca921ba8e55794$export$626336c2cd4b14de,
    parse: (v)=>$25ca921ba8e55794$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$25ca921ba8e55794$export$626336c2cd4b14de.transform(v * 100)
};



const $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e = {
    ...(0, $965bce4b5aab9d94$export$98e628dec113755e),
    transform: Math.round
};


const $d5c56ef81d4ff9c2$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderRightWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    radius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    maxWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    height: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    maxHeight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    size: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    top: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    right: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    bottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    left: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingTop: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingRight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingBottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingLeft: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    margin: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginTop: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginRight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginBottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginLeft: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateX: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateY: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateZ: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    scale: $965bce4b5aab9d94$export$dcdf75081b88279d,
    scaleX: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    scaleY: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    scaleZ: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    skew: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    skewX: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    skewY: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    distance: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateX: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateY: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateZ: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    x: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    y: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    z: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    perspective: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    transformPerspective: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    opacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    originX: (0, $25ca921ba8e55794$export$44e2e1705876d7ed),
    originY: (0, $25ca921ba8e55794$export$44e2e1705876d7ed),
    originZ: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    numOctaves: (0, $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e)
};


function $a883e7c624291d03$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $f9c5e88311214d2a$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $d5c56ef81d4ff9c2$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $a19b1277e1098e3a$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $1724c99b9b724858$export$bdc96e0d5c8f914)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $57bb451bc3d87577$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $81d8dfeeb8038b0d$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $55c3387a92452647$export$605d60a2578142d3)(source[key]) && !(0, $443c859766df5778$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $81d8dfeeb8038b0d$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $acw62.useMemo)(()=>{
        const state = (0, $57bb451bc3d87577$export$8940b483cf52eeda)();
        (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $81d8dfeeb8038b0d$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $81d8dfeeb8038b0d$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $81d8dfeeb8038b0d$var$useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function $81d8dfeeb8038b0d$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $81d8dfeeb8038b0d$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $c4bee6acbf082b7d$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $c4bee6acbf082b7d$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || $c4bee6acbf082b7d$var$validMotionProps.has(key);
}


let $05db6db4ebcdf5f1$var$shouldForward = (key)=>!(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key);
function $05db6db4ebcdf5f1$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $05db6db4ebcdf5f1$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $05db6db4ebcdf5f1$export$59d6962c470509a5((parcelRequire("8RYFI")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $05db6db4ebcdf5f1$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($05db6db4ebcdf5f1$var$shouldForward(key) || forwardMotionProps === true && (0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) || !isDom && !(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $acw62 = parcelRequire("acw62");



function $2860344bf6c6c49f$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $2860344bf6c6c49f$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $2860344bf6c6c49f$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $2860344bf6c6c49f$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $f5fdba1fd96a9ba7$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $f5fdba1fd96a9ba7$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $f5fdba1fd96a9ba7$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $f5fdba1fd96a9ba7$var$dashKeys : $f5fdba1fd96a9ba7$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $59f141cfaf6fcabb$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $2860344bf6c6c49f$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $f5fdba1fd96a9ba7$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $b7a2547211637b3c$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $57bb451bc3d87577$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $c139bf35362d2174$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $268dc116ac4d3a3d$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $acw62.useMemo)(()=>{
        const state = (0, $b7a2547211637b3c$export$41be8b43e1c4d4f9)();
        (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $c139bf35362d2174$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $81d8dfeeb8038b0d$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $dc80cb5954e76638$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? (0, $268dc116ac4d3a3d$export$84309c4f53cb1bd5) : (0, $81d8dfeeb8038b0d$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $05db6db4ebcdf5f1$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref: ref
        };
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $acw62.useMemo)(()=>(0, $55c3387a92452647$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $acw62.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}


/**
 * Convert camelCase to dash-case properties.
 */ const $9dc069bda924fd3f$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();


function $a52b6fc2f3af305f$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $ea3ecc5fb2887a0f$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $9422342e44092cf6$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $a52b6fc2f3af305f$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $ea3ecc5fb2887a0f$export$28931db5d57958e5).has(key) ? (0, $9dc069bda924fd3f$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $a8ee53e44f8c4ac8$export$16da615486abaa45(props, prevProps) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $55c3387a92452647$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $55c3387a92452647$export$605d60a2578142d3)(prevProps.style[key]) || (0, $443c859766df5778$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}



function $eac085b45c9e0925$export$16da615486abaa45(props, prevProps) {
    const newValues = (0, $a8ee53e44f8c4ac8$export$16da615486abaa45)(props, prevProps);
    for(const key in props)if ((0, $55c3387a92452647$export$605d60a2578142d3)(props[key]) || (0, $55c3387a92452647$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $ac502869c4d3e65a$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $acw62 = parcelRequire("acw62");


function $abbf779fde460163$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}



const $ef59b2359a289b82$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $21f654501c04362b$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $21f654501c04362b$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $18cbbcef55016eac$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $55c3387a92452647$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $21f654501c04362b$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




function $5c26ebcca6422185$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $5c26ebcca6422185$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415));
        const presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
        const make = ()=>$5c26ebcca6422185$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $40f5fd83135889a9$export$fe4300aa8eebea86)(make);
    };
function $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $06b1046bf0f33e63$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $abbf779fde460163$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}






const $fde6d634ecc7ed6c$export$44dabd3fae512e85 = {
    useVisualState: (0, $5c26ebcca6422185$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $eac085b45c9e0925$export$16da615486abaa45),
        createRenderState: (0, $b7a2547211637b3c$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).render(()=>{
                (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(renderState, latestValues, {
                    enableHardwareAcceleration: false
                }, (0, $c139bf35362d2174$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $9422342e44092cf6$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $dcb38e10dcfb6316$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $5c26ebcca6422185$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $a8ee53e44f8c4ac8$export$16da615486abaa45,
        createRenderState: (0, $57bb451bc3d87577$export$8940b483cf52eeda)
    })
};


function $73e3a8d89278ed7b$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? (0, $fde6d634ecc7ed6c$export$44dabd3fae512e85) : (0, $dcb38e10dcfb6316$export$e13ea21d87ea57c8);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $dc80cb5954e76638$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}


function $43ace1b5a11c3a40$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $6b2f8b101475710a$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $23ab615c547792c0$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"]
        }
    };
}
const $23ab615c547792c0$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $6b2f8b101475710a$export$a4cf9c8a4b063a6e)(event) && handler(event, $23ab615c547792c0$export$12f84bb882d06e1a(event));
};


function $7fd40e38993f1c69$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(target, eventName, (0, $23ab615c547792c0$export$c404e80f92c98d29)(handler), options);
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $21841eadb135946f$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $21841eadb135946f$export$a4627e546088548d = (...transformers)=>transformers.reduce($21841eadb135946f$var$combineFunctions);


function $df8cc4eab047d382$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $df8cc4eab047d382$var$globalHorizontalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragHorizontal");
const $df8cc4eab047d382$var$globalVerticalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragVertical");
function $df8cc4eab047d382$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $df8cc4eab047d382$var$globalVerticalLock();
    else if (drag === "x") lock = $df8cc4eab047d382$var$globalHorizontalLock();
    else {
        const openHorizontal = $df8cc4eab047d382$var$globalHorizontalLock();
        const openVertical = $df8cc4eab047d382$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $df8cc4eab047d382$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $df8cc4eab047d382$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


class $5b9241b1e863e695$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}



function $dfb80d799aa36175$var$addHoverEvent(node, isActive) {
    const eventName = "pointer" + (isActive ? "enter" : "leave");
    const callbackName = "onHover" + (isActive ? "Start" : "End");
    const handleEvent = (event, info)=>{
        if (event.type === "touch" || (0, $df8cc4eab047d382$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        if (props[callbackName]) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>props[callbackName](event, info));
    };
    return (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $dfb80d799aa36175$export$93a81ea037eac456 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $21841eadb135946f$export$a4627e546088548d)($dfb80d799aa36175$var$addHoverEvent(this.node, true), $dfb80d799aa36175$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $46d14c2f8ccf5da4$export$d4826db40d47595b extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $21841eadb135946f$export$a4627e546088548d)((0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $ae5289b89bf4fd95$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $ae5289b89bf4fd95$export$e841ada32ff745b(parent, child.parentElement);
};




function $b3902e3e20ea107a$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $23ab615c547792c0$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $b3902e3e20ea107a$export$f026abdbba7f0c9e extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.removeEndListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            this.removeEndListeners();
            if (this.isPressing) return;
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel } = this.node.getProps();
                (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>{
                    /**
                     * We only count this as a tap gesture if the event.target is the same
                     * as, or a child of, this component's element
                     */ !(0, $ae5289b89bf4fd95$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
                });
            };
            const removePointerUpListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $21841eadb135946f$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $b3902e3e20ea107a$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $b3902e3e20ea107a$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $b3902e3e20ea107a$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $21841eadb135946f$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $df8cc4eab047d382$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $21841eadb135946f$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $577133ec08d9e334$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $577133ec08d9e334$var$observers = new WeakMap();
const $577133ec08d9e334$var$fireObserverCallback = (entry)=>{
    const callback = $577133ec08d9e334$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $577133ec08d9e334$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($577133ec08d9e334$var$fireObserverCallback);
};
function $577133ec08d9e334$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$577133ec08d9e334$var$observers.has(lookupRoot)) $577133ec08d9e334$var$observers.set(lookupRoot, {});
    const rootObservers = $577133ec08d9e334$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($577133ec08d9e334$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $577133ec08d9e334$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $577133ec08d9e334$var$initIntersectionObserver(options);
    $577133ec08d9e334$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $577133ec08d9e334$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $3926a5d0685d183c$var$thresholdNames = {
    some: 0,
    all: 1
};
class $3926a5d0685d183c$export$150851c8cc2f0c72 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $3926a5d0685d183c$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $577133ec08d9e334$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($3926a5d0685d183c$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $3926a5d0685d183c$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $5e115984cd871deb$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $3926a5d0685d183c$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $b3902e3e20ea107a$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $46d14c2f8ccf5da4$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $dfb80d799aa36175$export$93a81ea037eac456)
    }
};





function $21ec58272207c53a$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $58c1fda9d3891d8d$var$getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $58c1fda9d3891d8d$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $58c1fda9d3891d8d$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $abbf779fde460163$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, $58c1fda9d3891d8d$var$getCurrent(visualElement), $58c1fda9d3891d8d$var$getVelocity(visualElement));
}






const $5fd2b57c27674a98$export$ed7b8fa9dbf0105d = "framerAppearId";
const $5fd2b57c27674a98$export$8592e1c077c890a6 = "data-" + (0, $9dc069bda924fd3f$export$9fd24a634729c672)($5fd2b57c27674a98$export$ed7b8fa9dbf0105d);



/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $083454c8244247d6$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $083454c8244247d6$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;


const $77818709e1bb6833$export$888a3d84909f9e3d = {
    current: false
};


const $8a5eba8ea233e901$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $877fa42e69510d34$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && $877fa42e69510d34$export$2cf569f5e2221176[easing] || (0, $8a5eba8ea233e901$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($877fa42e69510d34$export$fcdd8f3f2160beda));
}
const $877fa42e69510d34$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $877fa42e69510d34$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $877fa42e69510d34$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    return (0, $8a5eba8ea233e901$export$ff43f99925d7366b)(easing) ? $877fa42e69510d34$export$2523b8f0bd8f44cb(easing) : Array.isArray(easing) ? easing.map($877fa42e69510d34$export$916ea73bcd3a6030) : $877fa42e69510d34$export$2cf569f5e2221176[easing];
}


function $db913f3e2f893030$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $877fa42e69510d34$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



function $b7455746a6cabbfe$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }) {
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes.length - 1;
    return keyframes[index];
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $cdee14e408821ec6$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $cdee14e408821ec6$var$subdivisionPrecision = 0.0000001;
const $cdee14e408821ec6$var$subdivisionMaxIterations = 12;
function $cdee14e408821ec6$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $cdee14e408821ec6$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $cdee14e408821ec6$var$subdivisionPrecision && ++i < $cdee14e408821ec6$var$subdivisionMaxIterations);
    return currentT;
}
function $cdee14e408821ec6$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $448ce039afb5ec07$export$8793edee2d425525;
    const getTForX = (aX)=>$cdee14e408821ec6$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $cdee14e408821ec6$var$calcBezier(getTForX(t), mY1, mY2);
}


const $c24ef35c6cea05c0$export$929e5a82286172a6 = (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $c24ef35c6cea05c0$export$57636bb43b1ccbb0 = (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $c24ef35c6cea05c0$export$c07234257a03d5e9 = (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $b8e36ee1e1d53e83$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $6fc2fca13a5370f0$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $daf16ad73b68faf0$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $66a2361fd99a4040$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $66a2361fd99a4040$export$c8d67a19199d1a50 = (0, $daf16ad73b68faf0$export$2c07eeff45156d4d)($66a2361fd99a4040$export$e444123e42d03385);
const $66a2361fd99a4040$export$30d3455eee55bed5 = (0, $6fc2fca13a5370f0$export$f946554fb8aeaf0d)($66a2361fd99a4040$export$c8d67a19199d1a50);





const $a7ddcde2a4282efd$export$77edfce482316a60 = (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $a7ddcde2a4282efd$export$b01116c84cdfe1a2 = (0, $daf16ad73b68faf0$export$2c07eeff45156d4d)($a7ddcde2a4282efd$export$77edfce482316a60);
const $a7ddcde2a4282efd$export$ddc5fd596f6c71b2 = (0, $6fc2fca13a5370f0$export$f946554fb8aeaf0d)($a7ddcde2a4282efd$export$b01116c84cdfe1a2);



const $5e5a5cfe1fa796ef$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $a7ddcde2a4282efd$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $15a4078bfbf4856a$var$easingLookup = {
    linear: (0, $448ce039afb5ec07$export$8793edee2d425525),
    easeIn: $c24ef35c6cea05c0$export$929e5a82286172a6,
    easeInOut: $c24ef35c6cea05c0$export$c07234257a03d5e9,
    easeOut: $c24ef35c6cea05c0$export$57636bb43b1ccbb0,
    circIn: $66a2361fd99a4040$export$e444123e42d03385,
    circInOut: $66a2361fd99a4040$export$30d3455eee55bed5,
    circOut: $66a2361fd99a4040$export$c8d67a19199d1a50,
    backIn: $a7ddcde2a4282efd$export$b01116c84cdfe1a2,
    backInOut: $a7ddcde2a4282efd$export$ddc5fd596f6c71b2,
    backOut: $a7ddcde2a4282efd$export$77edfce482316a60,
    anticipate: $5e5a5cfe1fa796ef$export$6b0af63b873d419e
};
const $15a4078bfbf4856a$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $bf99d85f7a843912$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $bf99d85f7a843912$export$f5708dca728d7177)($15a4078bfbf4856a$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $15a4078bfbf4856a$var$easingLookup[definition];
    }
    return definition;
};








/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $ded99e01d9b518c0$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $9d068be114f1d873$export$844ec244b1367d54)(v) && (0, $9d068be114f1d873$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $ded99e01d9b518c0$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $9d068be114f1d873$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $9d068be114f1d873$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $c79d1e7d77418d04$var$clampRgbUnit = (v)=>(0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 255, v);
const $c79d1e7d77418d04$export$7a99c86b5b1f4c9e = {
    ...(0, $965bce4b5aab9d94$export$98e628dec113755e),
    transform: (v)=>Math.round($c79d1e7d77418d04$var$clampRgbUnit(v))
};
const $c79d1e7d77418d04$export$4e46ac54fc82cf3b = {
    test: (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $ded99e01d9b518c0$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(red) + ", " + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(green) + ", " + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)((0, $965bce4b5aab9d94$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $875e9bff470aaa65$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $875e9bff470aaa65$export$834dfc94dde4b3d8 = {
    test: (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("#"),
    parse: $875e9bff470aaa65$var$parseHex,
    transform: (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform
};






const $8bf8a43b3506d305$export$810b04175080204c = {
    test: (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $ded99e01d9b518c0$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $25ca921ba8e55794$export$626336c2cd4b14de).transform((0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $25ca921ba8e55794$export$626336c2cd4b14de).transform((0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)((0, $965bce4b5aab9d94$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $d8fe6ea9e8bd3d9c$export$35e9368ef982300f = {
    test: (v)=>(0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).test(v) || (0, $875e9bff470aaa65$export$834dfc94dde4b3d8).test(v) || (0, $8bf8a43b3506d305$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).test(v)) return (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $8bf8a43b3506d305$export$810b04175080204c).test(v)) return (0, $8bf8a43b3506d305$export$810b04175080204c).parse(v);
        else return (0, $875e9bff470aaa65$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $9d068be114f1d873$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform(v) : (0, $8bf8a43b3506d305$export$810b04175080204c).transform(v);
    }
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $70c54e935a247717$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;




// Adapted from https://gist.github.com/mjackson/5311256
function $fd6f5ba04ea8bac3$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $fd6f5ba04ea8bac3$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue + 1 / 3);
        green = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue);
        blue = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $7691d9e96675321f$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const $7691d9e96675321f$var$colorTypes = [
    (0, $875e9bff470aaa65$export$834dfc94dde4b3d8),
    (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b),
    (0, $8bf8a43b3506d305$export$810b04175080204c)
];
const $7691d9e96675321f$var$getColorType = (v)=>$7691d9e96675321f$var$colorTypes.find((type)=>type.test(v));
function $7691d9e96675321f$var$asRGBA(color) {
    const type = $7691d9e96675321f$var$getColorType(color);
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, $8bf8a43b3506d305$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $fd6f5ba04ea8bac3$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $7691d9e96675321f$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $7691d9e96675321f$var$asRGBA(from);
    const toRGBA = $7691d9e96675321f$var$asRGBA(to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $7691d9e96675321f$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $7691d9e96675321f$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $7691d9e96675321f$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform(blended);
    };
};












function $b7b50ce2c2d54405$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $9d068be114f1d873$export$844ec244b1367d54)(v) && (((_a = v.match((0, $9d068be114f1d873$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $9d068be114f1d873$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $b7b50ce2c2d54405$var$cssVarTokeniser = {
    regex: (0, $f9c5e88311214d2a$export$f7c0a352d8ef6313),
    countKey: "Vars",
    token: "${v}",
    parse: (0, $448ce039afb5ec07$export$8793edee2d425525)
};
const $b7b50ce2c2d54405$var$colorTokeniser = {
    regex: (0, $9d068be114f1d873$export$740b69c5fad25dba),
    countKey: "Colors",
    token: "${c}",
    parse: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).parse
};
const $b7b50ce2c2d54405$var$numberTokeniser = {
    regex: (0, $9d068be114f1d873$export$2444ca58c08448e4),
    countKey: "Numbers",
    token: "${n}",
    parse: (0, $965bce4b5aab9d94$export$98e628dec113755e).parse
};
function $b7b50ce2c2d54405$var$tokenise(info, { regex: regex, countKey: countKey, token: token, parse: parse }) {
    const matches = info.tokenised.match(regex);
    if (!matches) return;
    info["num" + countKey] = matches.length;
    info.tokenised = info.tokenised.replace(regex, token);
    info.values.push(...matches.map(parse));
}
function $b7b50ce2c2d54405$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const info = {
        value: originalValue,
        tokenised: originalValue,
        values: [],
        numVars: 0,
        numColors: 0,
        numNumbers: 0
    };
    if (info.value.includes("var(--")) $b7b50ce2c2d54405$var$tokenise(info, $b7b50ce2c2d54405$var$cssVarTokeniser);
    $b7b50ce2c2d54405$var$tokenise(info, $b7b50ce2c2d54405$var$colorTokeniser);
    $b7b50ce2c2d54405$var$tokenise(info, $b7b50ce2c2d54405$var$numberTokeniser);
    return info;
}
function $b7b50ce2c2d54405$var$parseComplexValue(v) {
    return $b7b50ce2c2d54405$export$b61fc7c44bf646d5(v).values;
}
function $b7b50ce2c2d54405$var$createTransformer(source) {
    const { values: values, numColors: numColors, numVars: numVars, tokenised: tokenised } = $b7b50ce2c2d54405$export$b61fc7c44bf646d5(source);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++){
            if (i < numVars) output = output.replace($b7b50ce2c2d54405$var$cssVarTokeniser.token, v[i]);
            else if (i < numVars + numColors) output = output.replace($b7b50ce2c2d54405$var$colorTokeniser.token, (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).transform(v[i]));
            else output = output.replace($b7b50ce2c2d54405$var$numberTokeniser.token, (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(v[i]));
        }
        return output;
    };
}
const $b7b50ce2c2d54405$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $b7b50ce2c2d54405$var$getAnimatableNone(v) {
    const parsed = $b7b50ce2c2d54405$var$parseComplexValue(v);
    const transformer = $b7b50ce2c2d54405$var$createTransformer(v);
    return transformer(parsed.map($b7b50ce2c2d54405$var$convertNumbersToZero));
}
const $b7b50ce2c2d54405$export$83a0e34f1302825b = {
    test: $b7b50ce2c2d54405$var$test,
    parse: $b7b50ce2c2d54405$var$parseComplexValue,
    createTransformer: $b7b50ce2c2d54405$var$createTransformer,
    getAnimatableNone: $b7b50ce2c2d54405$var$getAnimatableNone
};


const $6ec69123567a0d66$var$mixImmediate = (origin, target)=>(p)=>`${p > 0 ? target : origin}`;
function $6ec69123567a0d66$var$getMixer(origin, target) {
    if (typeof origin === "number") return (v)=>(0, $70c54e935a247717$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).test(origin)) return (0, $7691d9e96675321f$export$51e568cf5c039bac)(origin, target);
    else return origin.startsWith("var(") ? $6ec69123567a0d66$var$mixImmediate(origin, target) : $6ec69123567a0d66$export$65516310a87d8205(origin, target);
}
const $6ec69123567a0d66$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$6ec69123567a0d66$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $6ec69123567a0d66$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = {
        ...origin,
        ...target
    };
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $6ec69123567a0d66$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
const $6ec69123567a0d66$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $b7b50ce2c2d54405$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $b7b50ce2c2d54405$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $21841eadb135946f$export$a4627e546088548d)($6ec69123567a0d66$export$3bbefa2f402845c4(originStats.values, targetStats.values), template);
    else {
        (0, $bf99d85f7a843912$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return $6ec69123567a0d66$var$mixImmediate(origin, target);
    }
};



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $3a28fe0c82ae45f8$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



const $ec602dd05d6627bc$var$mixNumber = (from, to)=>(p)=>(0, $70c54e935a247717$export$2c9e8a9632a706b2)(from, to, p);
function $ec602dd05d6627bc$var$detectMixerFactory(v) {
    if (typeof v === "number") return $ec602dd05d6627bc$var$mixNumber;
    else if (typeof v === "string") return (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).test(v) ? (0, $7691d9e96675321f$export$51e568cf5c039bac) : (0, $6ec69123567a0d66$export$65516310a87d8205);
    else if (Array.isArray(v)) return 0, $6ec69123567a0d66$export$3bbefa2f402845c4;
    else if (typeof v === "object") return 0, $6ec69123567a0d66$export$ebc23b6840c51ba1;
    return $ec602dd05d6627bc$var$mixNumber;
}
function $ec602dd05d6627bc$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $ec602dd05d6627bc$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $448ce039afb5ec07$export$8793edee2d425525) : ease;
            mixer = (0, $21841eadb135946f$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $ec602dd05d6627bc$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $ec602dd05d6627bc$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $a4ecf42dec726852$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, 1, offsetProgress));
    }
}


function $481477152292f1a1$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $a4ecf42dec726852$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $d61eba3ef0284b9c$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $c1d90d9dcdf1c489$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $c24ef35c6cea05c0$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $b8e36ee1e1d53e83$export$216948827bbdc797)(ease) ? ease.map((0, $15a4078bfbf4856a$export$ef97fe084f156ca4)) : (0, $15a4078bfbf4856a$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $d61eba3ef0284b9c$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $481477152292f1a1$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $ec602dd05d6627bc$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $c1d90d9dcdf1c489$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}



/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $acbc43562ac6dbd8$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $8896dd99c5adcd8e$var$velocitySampleDuration = 5; // ms
function $8896dd99c5adcd8e$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $8896dd99c5adcd8e$var$velocitySampleDuration, 0);
    return (0, $acbc43562ac6dbd8$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $18564078b4b5453e$var$safeMin = 0.001;
const $18564078b4b5453e$export$a3cdb76e84ee608e = 0.01;
const $18564078b4b5453e$export$1824b851fad8862b = 10.0;
const $18564078b4b5453e$export$ff08f2d53484465 = 0.05;
const $18564078b4b5453e$export$201ca48e54038115 = 1;
function $18564078b4b5453e$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $bf99d85f7a843912$export$491112666e282270)(duration <= (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)($18564078b4b5453e$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)($18564078b4b5453e$export$ff08f2d53484465, $18564078b4b5453e$export$201ca48e54038115, dampingRatio);
    duration = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)($18564078b4b5453e$export$a3cdb76e84ee608e, $18564078b4b5453e$export$1824b851fad8862b, (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $18564078b4b5453e$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $18564078b4b5453e$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $18564078b4b5453e$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $18564078b4b5453e$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$18564078b4b5453e$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $18564078b4b5453e$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $18564078b4b5453e$var$rootIterations = 12;
function $18564078b4b5453e$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $18564078b4b5453e$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $18564078b4b5453e$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $74970353647274e4$var$durationKeys = [
    "duration",
    "bounce"
];
const $74970353647274e4$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $74970353647274e4$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $74970353647274e4$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$74970353647274e4$var$isSpringType(options, $74970353647274e4$var$physicsKeys) && $74970353647274e4$var$isSpringType(options, $74970353647274e4$var$durationKeys)) {
        const derived = (0, $18564078b4b5453e$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            velocity: 0.0,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $74970353647274e4$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, velocity: velocity, duration: duration, isResolvedFromDuration: isResolvedFromDuration } = $74970353647274e4$var$getSpringOptions(options);
    const initialVelocity = velocity ? -(0, $083454c8244247d6$export$f64c3bfbc58eec0f)(velocity) : 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $18564078b4b5453e$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $8896dd99c5adcd8e$export$854187271d233eb5)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $32590f88ff47d1eb$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $74970353647274e4$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $8896dd99c5adcd8e$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t > timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $cf38d8859c00efa2$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $9f96722ff12dbfe7$export$fff89137e9e818ce).isProcessing ? (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp : performance.now()
    };
};





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $506ba0ac589a486f$export$f4ff70a5b4808fd8 = 20000;
function $506ba0ac589a486f$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $506ba0ac589a486f$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $506ba0ac589a486f$export$f4ff70a5b4808fd8 ? Infinity : duration;
}


const $f8b512b91d9f08e1$var$types = {
    decay: (0, $32590f88ff47d1eb$export$ee3ff3a17106998),
    inertia: $32590f88ff47d1eb$export$ee3ff3a17106998,
    tween: (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e),
    keyframes: (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e),
    spring: $74970353647274e4$export$b36281d89752ae66
};
/**
 * Animate a single value on the main thread.
 *
 * This function is written, where functionality overlaps,
 * to be largely spec-compliant with WAAPI to allow fungibility
 * between the two.
 */ function $f8b512b91d9f08e1$export$ee9b76de7353d815({ autoplay: autoplay = true, delay: delay = 0, driver: driver = (0, $cf38d8859c00efa2$export$c1033964b5ad7fef), keyframes: keyframes$1, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", onPlay: onPlay, onStop: onStop, onComplete: onComplete, onUpdate: onUpdate, ...options }) {
    let speed = 1;
    let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let animationDriver;
    const generatorFactory = $f8b512b91d9f08e1$var$types[type] || (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e);
    /**
     * If this isn't the keyframes generator and we've been provided
     * strings as keyframes, we need to interpolate these.
     * TODO: Support velocity for units and complex value types/
     */ let mapNumbersToKeyframes;
    if (generatorFactory !== (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
        mapNumbersToKeyframes = (0, $ec602dd05d6627bc$export$89e29e4ab65e70a9)([
            0,
            100
        ], keyframes$1, {
            clamp: false
        });
        keyframes$1 = [
            0,
            100
        ];
    }
    const generator = generatorFactory({
        ...options,
        keyframes: keyframes$1
    });
    let mirroredGenerator;
    if (repeatType === "mirror") mirroredGenerator = generatorFactory({
        ...options,
        keyframes: [
            ...keyframes$1
        ].reverse(),
        velocity: -(options.velocity || 0)
    });
    let playState = "idle";
    let holdTime = null;
    let startTime = null;
    let cancelTime = null;
    /**
     * If duration is undefined and we have repeat options,
     * we need to calculate a duration from the generator.
     *
     * We set it to the generator itself to cache the duration.
     * Any timeline resolver will need to have already precalculated
     * the duration by this step.
     */ if (generator.calculatedDuration === null && repeat) generator.calculatedDuration = (0, $506ba0ac589a486f$export$cbdd6b3d40ea54e2)(generator);
    const { calculatedDuration: calculatedDuration } = generator;
    let resolvedDuration = Infinity;
    let totalDuration = Infinity;
    if (calculatedDuration !== null) {
        resolvedDuration = calculatedDuration + repeatDelay;
        totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    }
    let currentTime = 0;
    const tick = (timestamp)=>{
        if (startTime === null) return;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (speed > 0) startTime = Math.min(startTime, timestamp);
        if (speed < 0) startTime = Math.min(timestamp - totalDuration / speed, startTime);
        if (holdTime !== null) currentTime = holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        currentTime = Math.round(timestamp - startTime) * speed;
        // Rebase on delay
        const timeWithoutDelay = currentTime - delay * (speed >= 0 ? 1 : -1);
        const isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        currentTime = Math.max(timeWithoutDelay, 0);
        /**
         * If this animation has finished, set the current time
         * to the total duration.
         */ if (playState === "finished" && holdTime === null) currentTime = totalDuration;
        let elapsed = currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = currentTime / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const iterationIsOdd = Boolean(currentIteration % 2);
            if (iterationIsOdd) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            let p = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress);
            if (currentTime > totalDuration) p = repeatType === "reverse" && iterationIsOdd ? 1 : 0;
            elapsed = p * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes$1[0]
        } : frameGenerator.next(elapsed);
        if (mapNumbersToKeyframes) state.value = mapNumbersToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
        const isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) finish();
        return state;
    };
    const stopAnimationDriver = ()=>{
        animationDriver && animationDriver.stop();
        animationDriver = undefined;
    };
    const cancel = ()=>{
        playState = "idle";
        stopAnimationDriver();
        resolveFinishedPromise();
        updateFinishedPromise();
        startTime = cancelTime = null;
    };
    const finish = ()=>{
        playState = "finished";
        onComplete && onComplete();
        stopAnimationDriver();
        resolveFinishedPromise();
    };
    const play = ()=>{
        if (hasStopped) return;
        if (!animationDriver) animationDriver = driver(tick);
        const now = animationDriver.now();
        onPlay && onPlay();
        if (holdTime !== null) startTime = now - holdTime;
        else if (!startTime || playState === "finished") startTime = now;
        if (playState === "finished") updateFinishedPromise();
        cancelTime = startTime;
        holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ playState = "running";
        animationDriver.start();
    };
    if (autoplay) play();
    const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        get time () {
            return (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(currentTime);
        },
        set time (newTime){
            newTime = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(newTime);
            currentTime = newTime;
            if (holdTime !== null || !animationDriver || speed === 0) holdTime = newTime;
            else startTime = animationDriver.now() - newTime / speed;
        },
        get duration () {
            const duration = generator.calculatedDuration === null ? (0, $506ba0ac589a486f$export$cbdd6b3d40ea54e2)(generator) : generator.calculatedDuration;
            return (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(duration);
        },
        get speed () {
            return speed;
        },
        set speed (newSpeed){
            if (newSpeed === speed || !animationDriver) return;
            speed = newSpeed;
            controls.time = (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(currentTime);
        },
        get state () {
            return playState;
        },
        play: play,
        pause: ()=>{
            playState = "paused";
            holdTime = currentTime;
        },
        stop: ()=>{
            hasStopped = true;
            if (playState === "idle") return;
            playState = "idle";
            onStop && onStop();
            cancel();
        },
        cancel: ()=>{
            if (cancelTime !== null) tick(cancelTime);
            cancel();
        },
        complete: ()=>{
            playState = "finished";
        },
        sample: (elapsed)=>{
            startTime = 0;
            return tick(elapsed);
        }
    };
    return controls;
}



function $af0183976178f4ae$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}




const $132e6771f76a8482$var$supportsWaapi = (0, $af0183976178f4ae$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */ const $132e6771f76a8482$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $132e6771f76a8482$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $132e6771f76a8482$var$maxDuration = 20000;
const $132e6771f76a8482$var$requiresPregeneratedKeyframes = (valueName, options)=>options.type === "spring" || valueName === "backgroundColor" || !(0, $877fa42e69510d34$export$fcdd8f3f2160beda)(options.ease);
function $132e6771f76a8482$export$4d5d9557ab897126(value, valueName, { onUpdate: onUpdate, onComplete: onComplete, ...options }) {
    const canAccelerateAnimation = $132e6771f76a8482$var$supportsWaapi() && $132e6771f76a8482$var$acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && options.type !== "inertia";
    if (!canAccelerateAnimation) return false;
    /**
     * TODO: Unify with js/index
     */ let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let { keyframes: keyframes, duration: duration = 300, ease: ease, times: times } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */ if ($132e6771f76a8482$var$requiresPregeneratedKeyframes(valueName, options)) {
        const sampleAnimation = (0, $f8b512b91d9f08e1$export$ee9b76de7353d815)({
            ...options,
            repeat: 0,
            delay: 0
        });
        let state = {
            done: false,
            value: keyframes[0]
        };
        const pregeneratedKeyframes = [];
        /**
         * Bail after 20 seconds of pre-generated keyframes as it's likely
         * we're heading for an infinite loop.
         */ let t = 0;
        while(!state.done && t < $132e6771f76a8482$var$maxDuration){
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += $132e6771f76a8482$var$sampleDelta;
        }
        times = undefined;
        keyframes = pregeneratedKeyframes;
        duration = t - $132e6771f76a8482$var$sampleDelta;
        ease = "linear";
    }
    const animation = (0, $db913f3e2f893030$export$c76cd972d26986f9)(value.owner.current, valueName, keyframes, {
        ...options,
        duration: duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */ ease: ease,
        times: times
    });
    /**
     * WAAPI animations don't resolve startTime synchronously. But a blocked
     * thread could delay the startTime resolution by a noticeable amount.
     * For synching handoff animations with the new Motion animation we want
     * to ensure startTime is synchronously set.
     */ if (options.syncStart) animation.startTime = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).isProcessing ? (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp : document.timeline ? document.timeline.currentTime : performance.now();
    const cancelAnimation = ()=>animation.cancel();
    const safeCancel = ()=>{
        (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(cancelAnimation);
        resolveFinishedPromise();
        updateFinishedPromise();
    };
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */ animation.onfinish = ()=>{
        value.set((0, $b7455746a6cabbfe$export$14de59408fad90b)(keyframes, options));
        onComplete && onComplete();
        safeCancel();
    };
    /**
     * Animation interrupt callback.
     */ const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        attachTimeline (timeline) {
            animation.timeline = timeline;
            animation.onfinish = null;
            return 0, $448ce039afb5ec07$export$8793edee2d425525;
        },
        get time () {
            return (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
        },
        set time (newTime){
            animation.currentTime = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(newTime);
        },
        get speed () {
            return animation.playbackRate;
        },
        set speed (newSpeed){
            animation.playbackRate = newSpeed;
        },
        get duration () {
            return (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(duration);
        },
        play: ()=>{
            if (hasStopped) return;
            animation.play();
            /**
             * Cancel any pending cancel tasks
             */ (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(cancelAnimation);
        },
        pause: ()=>animation.pause(),
        stop: ()=>{
            hasStopped = true;
            if (animation.playState === "idle") return;
            /**
             * WAAPI doesn't natively have any interruption capabilities.
             *
             * Rather than read commited styles back out of the DOM, we can
             * create a renderless JS animation and sample it twice to calculate
             * its current value, "previous" value, and therefore allow
             * Motion to calculate velocity for any subsequent animation.
             */ const { currentTime: currentTime } = animation;
            if (currentTime) {
                const sampleAnimation = (0, $f8b512b91d9f08e1$export$ee9b76de7353d815)({
                    ...options,
                    autoplay: false
                });
                value.setWithVelocity(sampleAnimation.sample(currentTime - $132e6771f76a8482$var$sampleDelta).value, sampleAnimation.sample(currentTime).value, $132e6771f76a8482$var$sampleDelta);
            }
            safeCancel();
        },
        complete: ()=>animation.finish(),
        cancel: safeCancel
    };
    return controls;
}




function $8aad9a13037709d9$export$6f34fc8ef6c42b70({ keyframes: keyframes, delay: delay, onUpdate: onUpdate, onComplete: onComplete }) {
    const setValue = ()=>{
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        /**
         * TODO: As this API grows it could make sense to always return
         * animateValue. This will be a bigger project as animateValue
         * is frame-locked whereas this function resolves instantly.
         * This is a behavioural change and also has ramifications regarding
         * assumptions within tests.
         */ return {
            time: 0,
            speed: 1,
            duration: 0,
            play: (0, $448ce039afb5ec07$export$8793edee2d425525),
            pause: (0, $448ce039afb5ec07$export$8793edee2d425525),
            stop: (0, $448ce039afb5ec07$export$8793edee2d425525),
            then: (resolve)=>{
                resolve();
                return Promise.resolve();
            },
            cancel: (0, $448ce039afb5ec07$export$8793edee2d425525),
            complete: (0, $448ce039afb5ec07$export$8793edee2d425525)
        };
    };
    return delay ? (0, $f8b512b91d9f08e1$export$ee9b76de7353d815)({
        keyframes: [
            0,
            1
        ],
        duration: 0,
        delay: delay,
        onComplete: setValue
    }) : setValue();
}



const $5f1d5ca1d398e82d$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $5f1d5ca1d398e82d$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $5f1d5ca1d398e82d$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $5f1d5ca1d398e82d$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $5f1d5ca1d398e82d$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $5f1d5ca1d398e82d$var$keyframesTransition;
    else if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $5f1d5ca1d398e82d$var$criticallyDampedSpring(keyframes[1]) : $5f1d5ca1d398e82d$var$underDampedSpring;
    return $5f1d5ca1d398e82d$var$ease;
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $ef4086713d7b0bdb$export$65676b58b122bc38 = (key, value)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $b7b50ce2c2d54405$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};





/**
 * Properties that should default to 1 or 100%
 */ const $c55938f2e5f09a1e$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $c55938f2e5f09a1e$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $9d068be114f1d873$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $c55938f2e5f09a1e$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $c55938f2e5f09a1e$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $c55938f2e5f09a1e$export$3dea766d36a8935f = {
    ...(0, $b7b50ce2c2d54405$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($c55938f2e5f09a1e$var$functionRegex);
        return functions ? functions.map($c55938f2e5f09a1e$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $6da1de6e0a9a8c9d$export$98cd7c72c5a731fb = {
    ...(0, $d5c56ef81d4ff9c2$export$eec14432cd1cb67b),
    color: // Color props
    $d8fe6ea9e8bd3d9c$export$35e9368ef982300f,
    backgroundColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    outlineColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    fill: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    stroke: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderTopColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderRightColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderBottomColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderLeftColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    filter: $c55938f2e5f09a1e$export$3dea766d36a8935f,
    WebkitFilter: (0, $c55938f2e5f09a1e$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $6da1de6e0a9a8c9d$export$67d1babe0338d23b = (key)=>$6da1de6e0a9a8c9d$export$98cd7c72c5a731fb[key];


function $ca0a3798777df465$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $c55938f2e5f09a1e$export$3dea766d36a8935f)) defaultValueType = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}



/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $933209bc9c035719$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/.test(v);


function $e0feaef7a76d9154$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $933209bc9c035719$export$ade84c85e44a6cb1)(value);
}


function $cef4c9de9cdf8072$export$b2b5e866b2fbf2ec(value, valueName, target, transition) {
    const isTargetAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(valueName, target);
    let keyframes;
    if (Array.isArray(target)) keyframes = [
        ...target
    ];
    else keyframes = [
        null,
        target
    ];
    const defaultOrigin = transition.from !== undefined ? transition.from : value.get();
    let animatableTemplateValue = undefined;
    const noneKeyframeIndexes = [];
    for(let i = 0; i < keyframes.length; i++){
        /**
         * Fill null/wildcard keyframes
         */ if (keyframes[i] === null) keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
        if ((0, $e0feaef7a76d9154$export$e56af863d5645d5f)(keyframes[i])) noneKeyframeIndexes.push(i);
        // TODO: Clean this conditional, it works for now
        if (typeof keyframes[i] === "string" && keyframes[i] !== "none" && keyframes[i] !== "0") animatableTemplateValue = keyframes[i];
    }
    if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue) for(let i = 0; i < noneKeyframeIndexes.length; i++){
        const index = noneKeyframeIndexes[i];
        keyframes[index] = (0, $ca0a3798777df465$export$cea0cedcb94873b5)(valueName, animatableTemplateValue);
    }
    return keyframes;
}


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $ec9bae3b9c638c7a$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $9e7a9f8af70c9aa6$export$90b3dfc33ff3548 = (valueName, value, target, transition = {})=>{
    return (onComplete)=>{
        const valueTransition = (0, $ec9bae3b9c638c7a$export$7c1391340308742e)(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */ const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(delay);
        const keyframes = (0, $cef4c9de9cdf8072$export$b2b5e866b2fbf2ec)(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */ const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(valueName, originKeyframe);
        const isTargetAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(valueName, targetKeyframe);
        (0, $bf99d85f7a843912$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes: keyframes,
            velocity: value.getVelocity(),
            ease: "easeOut",
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            }
        };
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */ if (!(0, $ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $5f1d5ca1d398e82d$export$262124b154b9f1c0)(valueName, options)
        };
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */ if (options.duration) options.duration = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (!isOriginAnimatable || !isTargetAnimatable || (0, $77818709e1bb6833$export$888a3d84909f9e3d).current || valueTransition.type === false) /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */ return (0, $8aad9a13037709d9$export$6f34fc8ef6c42b70)((0, $77818709e1bb6833$export$888a3d84909f9e3d).current ? {
            ...options,
            delay: 0
        } : options);
        /**
         * Animate via WAAPI if possible.
         */ if (value.owner && value.owner.current instanceof HTMLElement && !value.owner.getProps().onUpdate) {
            const acceleratedAnimation = (0, $132e6771f76a8482$export$4d5d9557ab897126)(value, valueName, options);
            if (acceleratedAnimation) return acceleratedAnimation;
        }
        /**
         * If we didn't create an accelerated animation, create a JS animation
         */ return (0, $f8b512b91d9f08e1$export$ee9b76de7353d815)(options);
    };
};



function $d94f283b675f700d$export$98397f3adbf6259f(value) {
    return Boolean((0, $55c3387a92452647$export$605d60a2578142d3)(value) && value.add);
}


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $d56714d1e4e43615$export$65583ed5a868f2d9 = (v)=>/^\-?\d*\.?\d+$/.test(v);




function $f9c6cc6428ae273c$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $f9c6cc6428ae273c$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $f9c6cc6428ae273c$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $ad746ac6e5aa4783$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}





const $e32104bb79321603$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $e32104bb79321603$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $e32104bb79321603$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "10.16.4";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta: delta, timestamp: timestamp } = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce);
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) this.events.change.notify(this.current);
            // Update velocity subscribers
            if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = ()=>(0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = ({ timestamp: timestamp })=>{
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $e32104bb79321603$var$isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v) {
        this.updateAndNotify(v);
        this.prev = v;
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($e32104bb79321603$export$67fcd818a264039d.current) $e32104bb79321603$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $acbc43562ac6dbd8$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $e32104bb79321603$export$ce8bdc721e76545f(init, options) {
    return new $e32104bb79321603$export$8cea36d14ee64562(init, options);
}








/**
 * Tests a provided value against a ValueType
 */ const $a1e2618328995be8$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $c231a4375b038d3c$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $a90ec5e4ad59372f$export$d176691c1998a1f5 = [
    (0, $965bce4b5aab9d94$export$98e628dec113755e),
    (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    (0, $25ca921ba8e55794$export$626336c2cd4b14de),
    (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    (0, $25ca921ba8e55794$export$aed3d7b7d206c196),
    (0, $25ca921ba8e55794$export$f91e8c45a95a32f2),
    (0, $c231a4375b038d3c$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $a90ec5e4ad59372f$export$eefdd52e3ccae428 = (v)=>$a90ec5e4ad59372f$export$d176691c1998a1f5.find((0, $a1e2618328995be8$export$6eae4d0a6a7ca7cd)(v));



/**
 * A list of all ValueTypes
 */ const $0bb49f6c51badae3$var$valueTypes = [
    ...(0, $a90ec5e4ad59372f$export$d176691c1998a1f5),
    (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    (0, $b7b50ce2c2d54405$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $0bb49f6c51badae3$export$950e7e59ea1ffed7 = (v)=>$0bb49f6c51badae3$var$valueTypes.find((0, $a1e2618328995be8$export$6eae4d0a6a7ca7cd)(v));



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $ea04fe669600292a$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(value));
}
function $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $21f654501c04362b$export$5485128c47bd48bb)(target[key]);
        $ea04fe669600292a$var$setMotionValue(visualElement, key, value);
    }
}
function $ea04fe669600292a$var$setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        const variant = visualElement.getVariant(key);
        variant && $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, variant);
        if (visualElement.variantChildren) visualElement.variantChildren.forEach((child)=>{
            $ea04fe669600292a$var$setVariants(child, variantLabels);
        });
    });
}
function $ea04fe669600292a$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $ea04fe669600292a$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $ea04fe669600292a$var$setVariants(visualElement, [
        definition
    ]);
    else $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, definition);
}
function $ea04fe669600292a$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key)=>!visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(let i = 0; i < numNewValues; i++){
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $d56714d1e4e43615$export$65583ed5a868f2d9)(value) || (0, $933209bc9c035719$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $0bb49f6c51badae3$export$950e7e59ea1ffed7)(value) && (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).test(targetValue)) value = (0, $ca0a3798777df465$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(value, {
            owner: visualElement
        }));
        if (origin[key] === undefined) origin[key] = value;
        if (value !== null) visualElement.setBaseTarget(key, value);
    }
}
function $ea04fe669600292a$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $ea04fe669600292a$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    const origin = {};
    for(const key in target){
        const transitionOrigin = $ea04fe669600292a$export$c3befe8e18686628(key, transition);
        if (transitionOrigin !== undefined) origin[key] = transitionOrigin;
        else {
            const value = visualElement.getValue(key);
            if (value) origin[key] = value.get();
        }
    }
    return origin;
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $14d5e29c1a7af8ca$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $14d5e29c1a7af8ca$export$68cacfeee78d98d2(visualElement, definition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $14d5e29c1a7af8ca$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...transition
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ if (window.HandoffAppearAnimations && !value.hasAnimated) {
            const appearId = visualElement.getProps()[0, $5fd2b57c27674a98$export$8592e1c077c890a6];
            if (appearId) {
                valueTransition.elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $9f96722ff12dbfe7$export$2cef06c20297c17d));
                valueTransition.syncStart = true;
            }
        }
        value.start((0, $9e7a9f8af70c9aa6$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition));
        const animation = value.animation;
        if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) {
            willChange.add(key);
            animation.then(()=>willChange.remove(key));
        }
        animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        transitionEnd && (0, $ea04fe669600292a$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
    return animations;
}




function $697c3fc694c39c2d$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, variant, options.custom);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $14d5e29c1a7af8ca$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $697c3fc694c39c2d$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $697c3fc694c39c2d$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($697c3fc694c39c2d$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($697c3fc694c39c2d$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $697c3fc694c39c2d$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $7d7d5f8a14d3a662$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $697c3fc694c39c2d$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $697c3fc694c39c2d$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $14d5e29c1a7af8ca$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>visualElement.notify("AnimationComplete", definition));
}


const $351ff45a987b08cc$var$reversePriorityOrder = [
    ...(0, $0172fb3d3512f551$export$16e45afcc206d3a8)
].reverse();
const $351ff45a987b08cc$var$numAnimationTypes = (0, $0172fb3d3512f551$export$16e45afcc206d3a8).length;
function $351ff45a987b08cc$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $7d7d5f8a14d3a662$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $351ff45a987b08cc$export$bb53502b7a672aa8(visualElement) {
    let animate = $351ff45a987b08cc$var$animateList(visualElement);
    const state = $351ff45a987b08cc$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (acc, definition)=>{
        const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition);
        if (resolved) {
            const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
            acc = {
                ...acc,
                ...target,
                ...transitionEnd
            };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $351ff45a987b08cc$var$numAnimationTypes; i++){
            const type = $351ff45a987b08cc$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $a35be4d5814e7c66$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $351ff45a987b08cc$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(next) && (0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(prev)) {
                        if (!(0, $21ec58272207c53a$export$90e866afbd6b9f1a)(next, prev) || variantDidChange) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type,
                        ...options
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $351ff45a987b08cc$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $21ec58272207c53a$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $351ff45a987b08cc$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $351ff45a987b08cc$var$createState() {
    return {
        animate: $351ff45a987b08cc$var$createTypeState(true),
        whileInView: $351ff45a987b08cc$var$createTypeState(),
        whileHover: $351ff45a987b08cc$var$createTypeState(),
        whileTap: $351ff45a987b08cc$var$createTypeState(),
        whileDrag: $351ff45a987b08cc$var$createTypeState(),
        whileFocus: $351ff45a987b08cc$var$createTypeState(),
        exit: $351ff45a987b08cc$var$createTypeState()
    };
}



class $bfc36aed86970b83$export$b45b3fe5caabdca extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $351ff45a987b08cc$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        this.unmount();
        if ((0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(animate)) this.unmount = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {}
}



let $7ad505f20eee7073$var$id = 0;
class $7ad505f20eee7073$export$4989d1eb6104cc6c extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $7ad505f20eee7073$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete, custom: custom } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent, {
            custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom
        });
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $03e8b675a1009b68$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $bfc36aed86970b83$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $7ad505f20eee7073$export$4989d1eb6104cc6c)
    }
};









const $8eeaeb5692ba8175$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $8eeaeb5692ba8175$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $8eeaeb5692ba8175$export$9f17032d917177de(a.x, b.x);
    const yDelta = $8eeaeb5692ba8175$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $2bb1a5b2e1002b2e$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $2bb1a5b2e1002b2e$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $8eeaeb5692ba8175$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const { onEnd: onEnd, onSessionEnd: onSessionEnd } = this.handlers;
            const panInfo = $2bb1a5b2e1002b2e$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $6b2f8b101475710a$export$a4cf9c8a4b063a6e)(event)) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        const info = (0, $23ab615c547792c0$export$12f84bb882d06e1a)(event);
        const initialInfo = $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $2bb1a5b2e1002b2e$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $21841eadb135946f$export$a4627e546088548d)((0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointermove", this.handlePointerMove), (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointerup", this.handlePointerUp), (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $2bb1a5b2e1002b2e$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $2bb1a5b2e1002b2e$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $2bb1a5b2e1002b2e$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $2bb1a5b2e1002b2e$var$subtractPoint(point, $2bb1a5b2e1002b2e$var$lastDevicePoint(history)),
        offset: $2bb1a5b2e1002b2e$var$subtractPoint(point, $2bb1a5b2e1002b2e$var$startDevicePoint(history)),
        velocity: $2bb1a5b2e1002b2e$var$getVelocity(history, 0.1)
    };
}
function $2bb1a5b2e1002b2e$var$startDevicePoint(history) {
    return history[0];
}
function $2bb1a5b2e1002b2e$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $2bb1a5b2e1002b2e$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $2bb1a5b2e1002b2e$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







function $b352f7cdd42c49d7$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $b352f7cdd42c49d7$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(source.min, source.max, delta.origin);
    delta.scale = $b352f7cdd42c49d7$export$c1c127004b72a37(target) / $b352f7cdd42c49d7$export$c1c127004b72a37(source);
    if ($b352f7cdd42c49d7$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($b352f7cdd42c49d7$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $b352f7cdd42c49d7$export$c0d25e96fc67d310(delta, source, target, origin) {
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $b352f7cdd42c49d7$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(relative);
}
function $b352f7cdd42c49d7$export$426154f9d100f99(target, relative, parent) {
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(layout);
}
function $b352f7cdd42c49d7$export$2785bfcc929c5650(target, layout, parent) {
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $70c54e935a247717$export$2c9e8a9632a706b2)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $2df0cf7aa8fef8fc$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $2df0cf7aa8fef8fc$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.x, left, right),
        y: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $2df0cf7aa8fef8fc$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $2df0cf7aa8fef8fc$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(source);
    const targetLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $2df0cf7aa8fef8fc$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22(dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742;
    return {
        x: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $a3727e4e12b23353$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $a3727e4e12b23353$export$3d227df54007d73a = ()=>({
        x: $a3727e4e12b23353$export$ff25708b37f72782(),
        y: $a3727e4e12b23353$export$ff25708b37f72782()
    });
const $a3727e4e12b23353$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $a3727e4e12b23353$export$6459fc9e86be362e = ()=>({
        x: $a3727e4e12b23353$export$6db76765312617ac(),
        y: $a3727e4e12b23353$export$6db76765312617ac()
    });


function $247f90d2510fbc55$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $0e0401fe38bd0bd1$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $0e0401fe38bd0bd1$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $0e0401fe38bd0bd1$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $fe0ee806cd19fc1f$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $fe0ee806cd19fc1f$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$fe0ee806cd19fc1f$var$isIdentityScale(scale) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleX) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleY);
}
function $fe0ee806cd19fc1f$export$a545127cf1fbb600(values) {
    return $fe0ee806cd19fc1f$export$bdf30dca883ea463(values) || $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f(values) {
    return $fe0ee806cd19fc1f$var$is2DTranslate(values.x) || $fe0ee806cd19fc1f$var$is2DTranslate(values.y);
}
function $fe0ee806cd19fc1f$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $d8332eb74969584e$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $d8332eb74969584e$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $d8332eb74969584e$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $d8332eb74969584e$export$d80074982803af5c(box, { x: x, y: y }) {
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $d8332eb74969584e$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $d8332eb74969584e$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $d8332eb74969584e$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) $d8332eb74969584e$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $d8332eb74969584e$var$snapToDefault(treeScale.x);
    treeScale.y = $d8332eb74969584e$var$snapToDefault(treeScale.y);
}
function $d8332eb74969584e$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $d8332eb74969584e$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $d8332eb74969584e$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $d8332eb74969584e$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $d8332eb74969584e$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $d8332eb74969584e$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $d8332eb74969584e$export$58b16271041fbfb(box, transform) {
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.x, transform, $d8332eb74969584e$var$xKeys);
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.y, transform, $d8332eb74969584e$var$yKeys);
}


function $4ca2f8055771ddf4$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $0e0401fe38bd0bd1$export$d3955c6a8f65a36b)((0, $0e0401fe38bd0bd1$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $4ca2f8055771ddf4$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $4ca2f8055771ddf4$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}










const $59924ee873defaad$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $59924ee873defaad$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $23ab615c547792c0$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $df8cc4eab047d382$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onDragStart(event, info), false, true);
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $59924ee873defaad$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        this.panSession = new (0, $2bb1a5b2e1002b2e$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint()
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const { layout: layout } = this.visualElement.projection || {};
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $2df0cf7aa8fef8fc$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $d157673547c2a934$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $bf99d85f7a843912$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $4ca2f8055771ddf4$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $2df0cf7aa8fef8fc$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $0e0401fe38bd0bd1$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $0e0401fe38bd0bd1$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $9e7a9f8af70c9aa6$export$90b3dfc33ff3548)(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = "_drag" + axis.toUpperCase();
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $2df0cf7aa8fef8fc$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $59924ee873defaad$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $2df0cf7aa8fef8fc$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $59924ee873defaad$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $59924ee873defaad$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $abae7830ca84eed8$export$5d97dc2872682820 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.removeListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.controls = new (0, $59924ee873defaad$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $448ce039afb5ec07$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}







const $d43ff984f7bd7f1a$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>handler(event, info));
    };
class $d43ff984f7bd7f1a$export$b4f8f1ee75ce5859 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $448ce039afb5ec07$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $2bb1a5b2e1002b2e$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint()
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $d43ff984f7bd7f1a$var$asyncHandler(onPanSessionStart),
            onStart: $d43ff984f7bd7f1a$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}



var $acw62 = parcelRequire("acw62");



/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $b29dc04080b74d0c$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $967b202c839557ef$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $967b202c839557ef$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $25ca921ba8e55794$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $967b202c839557ef$export$fafff692be55225d(latest, node.target.x);
        const y = $967b202c839557ef$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $a42cd9e0ef50cb70$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};




class $cdf2a2ac04e7ce67$var$MeasureLayoutWithContext extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $eced91e16bda42df$export$de9e7791c71225fd)($cdf2a2ac04e7ce67$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            queueMicrotask(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $cdf2a2ac04e7ce67$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $bc77fac60b5d77cc$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cdf2a2ac04e7ce67$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $acw62.useContext)((0, $c612a166b65a9c69$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $cdf2a2ac04e7ce67$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $967b202c839557ef$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    boxShadow: (0, $a42cd9e0ef50cb70$export$eb0bc629e74dcf8)
};








const $82b1c16a20b13fa0$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $82b1c16a20b13fa0$var$numBorders = $82b1c16a20b13fa0$var$borders.length;
const $82b1c16a20b13fa0$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $82b1c16a20b13fa0$var$isPx = (value)=>typeof value === "number" || (0, $25ca921ba8e55794$export$91c0eda1d06bf008).test(value);
function $82b1c16a20b13fa0$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $82b1c16a20b13fa0$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, 0, $82b1c16a20b13fa0$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $82b1c16a20b13fa0$var$numBorders; i++){
        const borderLabel = `border${$82b1c16a20b13fa0$var$borders[i]}Radius`;
        let followRadius = $82b1c16a20b13fa0$var$getRadius(follow, borderLabel);
        let leadRadius = $82b1c16a20b13fa0$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $82b1c16a20b13fa0$var$isPx(followRadius) === $82b1c16a20b13fa0$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $70c54e935a247717$export$2c9e8a9632a706b2)($82b1c16a20b13fa0$var$asNumber(followRadius), $82b1c16a20b13fa0$var$asNumber(leadRadius), progress), 0);
            if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(leadRadius) || (0, $25ca921ba8e55794$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $82b1c16a20b13fa0$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $82b1c16a20b13fa0$var$easeCrossfadeIn = $82b1c16a20b13fa0$var$compress(0, 0.5, (0, $66a2361fd99a4040$export$c8d67a19199d1a50));
const $82b1c16a20b13fa0$var$easeCrossfadeOut = $82b1c16a20b13fa0$var$compress(0.5, 0.95, (0, $448ce039afb5ec07$export$8793edee2d425525));
function $82b1c16a20b13fa0$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$c53fd88f45d77e4b(box, originBox) {
    $5960d81994414d5a$export$a0230ae482601ae8(box.x, originBox.x);
    $5960d81994414d5a$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $db628fcc785b8b87$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $d8332eb74969584e$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $d8332eb74969584e$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $db628fcc785b8b87$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $db628fcc785b8b87$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $db628fcc785b8b87$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $db628fcc785b8b87$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.x, transforms, $db628fcc785b8b87$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.y, transforms, $db628fcc785b8b87$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}





function $b070f9c5f268d45c$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $b070f9c5f268d45c$export$a7ec7642fe550fb6(delta) {
    return $b070f9c5f268d45c$var$isAxisDeltaZero(delta.x) && $b070f9c5f268d45c$var$isAxisDeltaZero(delta.y);
}
function $b070f9c5f268d45c$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $b070f9c5f268d45c$export$ef641b782d85522(a, b) {
    return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function $b070f9c5f268d45c$export$c5706146bc63213(box) {
    return (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(box.x) / (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(box.y);
}



class $a040ab986103db06$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $0214cdf9d4bb801d$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { rotate: rotate, rotateX: rotateX, rotateY: rotateY } = latestTransform;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $8e214807702da081$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $e21f5e6c9473a18c$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $8e214807702da081$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}





/**
 * Timeout defined in ms
 */ function $fab50a206e6cc096$export$1391212d75b2ee65(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(checkElapsed);
}



function $0b58405220d0640d$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}


function $c4715fe9f944e8b8$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $f5de8fc8cd768a38$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $55c3387a92452647$export$605d60a2578142d3)(value) ? value : (0, $e32104bb79321603$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $9e7a9f8af70c9aa6$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}





const $d2ca41ba1b84bcfe$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $d2ca41ba1b84bcfe$var$animationTarget = 1000;
let $d2ca41ba1b84bcfe$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const $d2ca41ba1b84bcfe$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $d2ca41ba1b84bcfe$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $d2ca41ba1b84bcfe$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $d2ca41ba1b84bcfe$var$projectionFrameData.totalNodes = $d2ca41ba1b84bcfe$var$projectionFrameData.resolvedTargetDeltas = $d2ca41ba1b84bcfe$var$projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach($d2ca41ba1b84bcfe$export$131f2f0cc5fe9609);
                this.nodes.forEach($d2ca41ba1b84bcfe$var$resolveTargetDelta);
                this.nodes.forEach($d2ca41ba1b84bcfe$var$calcProjection);
                this.nodes.forEach($d2ca41ba1b84bcfe$export$c2664f37bc951031);
                (0, $0b58405220d0640d$export$e5185e241753e543)($d2ca41ba1b84bcfe$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $e21f5e6c9473a18c$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $c4715fe9f944e8b8$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $fab50a206e6cc096$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($d2ca41ba1b84bcfe$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $d2ca41ba1b84bcfe$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $b070f9c5f268d45c$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $ec9bae3b9c638c7a$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $d2ca41ba1b84bcfe$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($d2ca41ba1b84bcfe$var$resetRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($d2ca41ba1b84bcfe$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($d2ca41ba1b84bcfe$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($d2ca41ba1b84bcfe$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($d2ca41ba1b84bcfe$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = performance.now();
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).delta = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp);
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp = now;
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).isProcessing = true;
            (0, $9f96722ff12dbfe7$export$be3f796aed065412).update.process((0, $9f96722ff12dbfe7$export$fff89137e9e818ce));
            (0, $9f96722ff12dbfe7$export$be3f796aed065412).preRender.process((0, $9f96722ff12dbfe7$export$fff89137e9e818ce));
            (0, $9f96722ff12dbfe7$export$be3f796aed065412).render.process((0, $9f96722ff12dbfe7$export$fff89137e9e818ce));
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                queueMicrotask(()=>this.update());
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($d2ca41ba1b84bcfe$var$clearSnapshot);
            this.sharedNodes.forEach($d2ca41ba1b84bcfe$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $b070f9c5f268d45c$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $d2ca41ba1b84bcfe$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $fe0ee806cd19fc1f$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $db628fcc785b8b87$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) (0, $db628fcc785b8b87$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $b352f7cdd42c49d7$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $d8332eb74969584e$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ $d2ca41ba1b84bcfe$var$projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $fe0ee806cd19fc1f$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $d8332eb74969584e$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) lead.target = lead.layout.layoutBox;
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                    this.projectionDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $0214cdf9d4bb801d$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ $d2ca41ba1b84bcfe$var$projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($d2ca41ba1b84bcfe$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $b070f9c5f268d45c$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $82b1c16a20b13fa0$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>{
                (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $f5de8fc8cd768a38$export$335a17c977067b99)(0, $d2ca41ba1b84bcfe$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($d2ca41ba1b84bcfe$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                const xLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $d8332eb74969584e$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $a040ab986103db06$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) hasRotate = true;
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(let i = 0; i < $d2ca41ba1b84bcfe$var$transformAxes.length; i++){
                const key = "rotate" + $d2ca41ba1b84bcfe$var$transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp = {}) {
            var _a, _b;
            // TODO: Return lifecycle-persistent object
            const styles = {};
            if (!this.instance || this.isSVG) return styles;
            if (!this.isVisible) return {
                visibility: "hidden"
            };
            else styles.visibility = "";
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $0214cdf9d4bb801d$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $eced91e16bda42df$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $eced91e16bda42df$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $d2ca41ba1b84bcfe$var$updateLayout(node) {
    node.updateLayout();
}
function $d2ca41ba1b84bcfe$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        if (isShared) (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $b070f9c5f268d45c$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $b070f9c5f268d45c$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $d2ca41ba1b84bcfe$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $d2ca41ba1b84bcfe$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $d2ca41ba1b84bcfe$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $d2ca41ba1b84bcfe$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $d2ca41ba1b84bcfe$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $d2ca41ba1b84bcfe$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $d2ca41ba1b84bcfe$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $d2ca41ba1b84bcfe$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $d2ca41ba1b84bcfe$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $d2ca41ba1b84bcfe$var$calcProjection(node) {
    node.calcProjection();
}
function $d2ca41ba1b84bcfe$var$resetRotation(node) {
    node.resetRotation();
}
function $d2ca41ba1b84bcfe$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(delta.translate, 0, p);
    output.scale = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(from.min, to.min, p);
    output.max = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(from.max, to.max, p);
}
function $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(output, from, to, p) {
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $d2ca41ba1b84bcfe$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $d2ca41ba1b84bcfe$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $d2ca41ba1b84bcfe$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $d2ca41ba1b84bcfe$var$roundPoint = $d2ca41ba1b84bcfe$var$userAgentContains("applewebkit/") && !$d2ca41ba1b84bcfe$var$userAgentContains("chrome/") ? Math.round : (0, $448ce039afb5ec07$export$8793edee2d425525);
function $d2ca41ba1b84bcfe$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $d2ca41ba1b84bcfe$var$roundPoint(axis.min);
    axis.max = $d2ca41ba1b84bcfe$var$roundPoint(axis.max);
}
function $d2ca41ba1b84bcfe$var$roundBox(box) {
    $d2ca41ba1b84bcfe$var$roundAxis(box.x);
    $d2ca41ba1b84bcfe$var$roundAxis(box.y);
}
function $d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $b352f7cdd42c49d7$export$28d0384c4b79bde2)((0, $b070f9c5f268d45c$export$c5706146bc63213)(snapshot), (0, $b070f9c5f268d45c$export$c5706146bc63213)(layout), 0.2);
}




const $6e97f3a9a89d5fc1$export$2d029a49a09b6177 = (0, $d2ca41ba1b84bcfe$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $a3289660bde9b219$export$b91509fcf893b648 = {
    current: undefined
};
const $a3289660bde9b219$export$b61a9eb3dbde8858 = (0, $d2ca41ba1b84bcfe$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$a3289660bde9b219$export$b91509fcf893b648.current) {
            const documentNode = new (0, $6e97f3a9a89d5fc1$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $a3289660bde9b219$export$b91509fcf893b648.current = documentNode;
        }
        return $a3289660bde9b219$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $fc1974bcfc4fde1a$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $d43ff984f7bd7f1a$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $abae7830ca84eed8$export$5d97dc2872682820),
        ProjectionNode: (0, $a3289660bde9b219$export$b61a9eb3dbde8858),
        MeasureLayout: $cdf2a2ac04e7ce67$export$779f5fb01ad751cd
    }
};













/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $ac0e5a3978f40f61$var$splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current) {
    const match = $ac0e5a3978f40f61$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
}
const $ac0e5a3978f40f61$var$maxDepth = 4;
function $ac0e5a3978f40f61$var$getVariableValue(current, element, depth = 1) {
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(depth <= $ac0e5a3978f40f61$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $d56714d1e4e43615$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    } else if ((0, $f9c5e88311214d2a$export$31f9caa2600b5723)(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $ac0e5a3978f40f61$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $ac0e5a3978f40f61$export$669319b042b57350(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = {
        ...transitionEnd
    };
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value)=>{
        const current = value.get();
        if (!(0, $f9c5e88311214d2a$export$31f9caa2600b5723)(current)) return;
        const resolved = $ac0e5a3978f40f61$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(const key in target){
        const current = target[key];
        if (!(0, $f9c5e88311214d2a$export$31f9caa2600b5723)(current)) continue;
        const resolved = $ac0e5a3978f40f61$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        if (!transitionEnd) transitionEnd = {};
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd[key] === undefined) transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}









const $a731b8aa4fe311d9$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $a731b8aa4fe311d9$var$isPositionalKey = (key)=>$a731b8aa4fe311d9$var$positionalKeys.has(key);
const $a731b8aa4fe311d9$var$hasPositionalKey = (target)=>{
    return Object.keys(target).some($a731b8aa4fe311d9$var$isPositionalKey);
};
const $a731b8aa4fe311d9$var$isNumOrPxType = (v)=>v === (0, $965bce4b5aab9d94$export$98e628dec113755e) || v === (0, $25ca921ba8e55794$export$91c0eda1d06bf008);
const $a731b8aa4fe311d9$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $a731b8aa4fe311d9$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $a731b8aa4fe311d9$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $a731b8aa4fe311d9$var$nonTranslationalTransformKeys = (0, $ac502869c4d3e65a$export$280dc01950909d86).filter((key)=>!$a731b8aa4fe311d9$var$transformKeys.has(key));
function $a731b8aa4fe311d9$var$removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    $a731b8aa4fe311d9$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.render();
    return removedTransforms;
}
const $a731b8aa4fe311d9$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $a731b8aa4fe311d9$var$getTranslateFromMatrix(4, 13),
    y: $a731b8aa4fe311d9$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$a731b8aa4fe311d9$export$781d46a8aa670d52.translateX = $a731b8aa4fe311d9$export$781d46a8aa670d52.x;
$a731b8aa4fe311d9$export$781d46a8aa670d52.translateY = $a731b8aa4fe311d9$export$781d46a8aa670d52.y;
const $a731b8aa4fe311d9$var$convertChangedValueTypes = (target, visualElement, changedKeys)=>{
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display: display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach((key)=>{
        origin[key] = $a731b8aa4fe311d9$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key)=>{
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        value && value.jump(origin[key]);
        target[key] = $a731b8aa4fe311d9$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const $a731b8aa4fe311d9$var$checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {})=>{
    target = {
        ...target
    };
    transitionEnd = {
        ...transitionEnd
    };
    const targetPositionalKeys = Object.keys(target).filter($a731b8aa4fe311d9$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        let from = origin[key];
        let fromType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(from);
            for(let i = fromIndex; i < numKeyframes; i++){
                /**
                 * Don't allow wildcard keyframes to be used to detect
                 * a difference in value types.
                 */ if (to[i] === null) break;
                if (!toType) {
                    toType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to[i]);
                    (0, $bf99d85f7a843912$export$f5708dca728d7177)(toType === fromType || $a731b8aa4fe311d9$var$isNumOrPxType(fromType) && $a731b8aa4fe311d9$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
                } else (0, $bf99d85f7a843912$export$f5708dca728d7177)((0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
            }
        } else toType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($a731b8aa4fe311d9$var$isNumOrPxType(fromType) && $a731b8aa4fe311d9$var$isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $25ca921ba8e55794$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $a731b8aa4fe311d9$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                value.jump(to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        const convertedTarget = $a731b8aa4fe311d9$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(([key, value])=>{
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if ((0, $784730508f12f72c$export$4e09c449d6c407f7) && scrollY !== null) window.scrollTo({
            top: scrollY
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $a731b8aa4fe311d9$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $a731b8aa4fe311d9$var$hasPositionalKey(target) ? $a731b8aa4fe311d9$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ const $d9a589b84d5ec1d1$export$5849e743e29831d6 = (visualElement, target, origin, transitionEnd)=>{
    const resolved = (0, $ac0e5a3978f40f61$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $a731b8aa4fe311d9$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};






// Does this device prefer reduced motion? Returns `null` server-side.
const $5d1c3a7750a03ec7$export$ff7706047246b98b = {
    current: null
};
const $5d1c3a7750a03ec7$export$6476d16e2fd2d0db = {
    current: false
};


function $402b11b96c54cb2c$export$ca9f41fb23dded3d() {
    (0, $5d1c3a7750a03ec7$export$6476d16e2fd2d0db).current = true;
    if (!(0, $784730508f12f72c$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current = false;
}














function $69635cdb8982f9d2$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $55c3387a92452647$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $55c3387a92452647$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(nextValue, {
                owner: element
            }));
            if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $a4ccbde0d696dfdf$export$bc2a978a17abfdde = new WeakMap();



const $e66750f3fb0f96bb$var$featureNames = Object.keys((0, $a8d82256030e9525$export$65570e08d843624d));
const $e66750f3fb0f96bb$var$numFeatures = $e66750f3fb0f96bb$var$featureNames.length;
const $e66750f3fb0f96bb$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $e66750f3fb0f96bb$var$numVariantProps = (0, $0172fb3d3512f551$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $e66750f3fb0f96bb$export$fa8b653c0f3714e5 {
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $9f96722ff12dbfe7$export$2cef06c20297c17d).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = (0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $06b1046bf0f33e63$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $55c3387a92452647$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        (0, $a4ccbde0d696dfdf$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $5d1c3a7750a03ec7$export$6476d16e2fd2d0db).current) (0, $402b11b96c54cb2c$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $a4ccbde0d696dfdf$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)this.features[key].unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children: children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < $e66750f3fb0f96bb$var$numFeatures; i++){
            const name = $e66750f3fb0f96bb$var$featureNames[i];
            const { isEnabled: isEnabled, Feature: FeatureConstructor, ProjectionNode: ProjectionNode, MeasureLayout: MeasureLayoutComponent } = (0, $a8d82256030e9525$export$65570e08d843624d)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if (!this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = renderedProps;
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll,
                layoutRoot: layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update();
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */ makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $e66750f3fb0f96bb$var$propEventHandlers.length; i++){
            const key = $e66750f3fb0f96bb$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $69635cdb8982f9d2$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $e66750f3fb0f96bb$var$numVariantProps; i++){
            const name = (0, $0172fb3d3512f551$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $a35be4d5814e7c66$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $e32104bb79321603$export$ce8bdc721e76545f)(defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key) {
        var _a;
        return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = (0, $abbf779fde460163$export$d68f140c4d9b48bc)(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $55c3387a92452647$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}


class $28a1ebc4c0bc036f$export$e49735c2a366bdc7 extends (0, $e66750f3fb0f96bb$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition: transition, transitionEnd: transitionEnd, ...target }, { transformValues: transformValues }, isMounted) {
        let origin = (0, $ea04fe669600292a$export$5a759dc7a1cfb72a)(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $ea04fe669600292a$export$6afbed164019a54c)(this, target, origin);
            const parsed = (0, $d9a589b84d5ec1d1$export$5849e743e29831d6)(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition: transition,
            transitionEnd: transitionEnd,
            ...target
        };
    }
}



function $bce82b8bf0dbf6b7$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $bce82b8bf0dbf6b7$export$23fea75b03ac16b3 extends (0, $28a1ebc4c0bc036f$export$e49735c2a366bdc7) {
    readValueFromInstance(instance, key) {
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $bce82b8bf0dbf6b7$export$3735103072e4a80(instance);
            const value = ((0, $f9c5e88311214d2a$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $4ca2f8055771ddf4$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $a8ee53e44f8c4ac8$export$16da615486abaa45)(props, prevProps);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $55c3387a92452647$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $a52b6fc2f3af305f$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}












class $a0798b9f9973cb35$export$86bcdffbaf733d84 extends (0, $28a1ebc4c0bc036f$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $ea3ecc5fb2887a0f$export$28931db5d57958e5).has(key) ? (0, $9dc069bda924fd3f$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $eac085b45c9e0925$export$16da615486abaa45)(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $9422342e44092cf6$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $c139bf35362d2174$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $2f8881102ac6dde9$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? new (0, $a0798b9f9973cb35$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $bce82b8bf0dbf6b7$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
};




const $2c407ffdaf3c120a$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $a3289660bde9b219$export$b61a9eb3dbde8858),
        MeasureLayout: $cdf2a2ac04e7ce67$export$779f5fb01ad751cd
    }
};


const $a93b6401f922fd1e$var$preloadedFeatures = {
    ...(0, $03e8b675a1009b68$export$7f9953c70dacfd7f),
    ...(0, $5e115984cd871deb$export$e5b72898e5a201f1),
    ...(0, $fc1974bcfc4fde1a$export$d7d5d435647ed5a0),
    ...(0, $2c407ffdaf3c120a$export$b3219800bda33a1f)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $a93b6401f922fd1e$export$e25e478948902b8b = /*@__PURE__*/ (0, $16a09bb264d348bb$export$a28d6df673050e18)((Component, config)=>(0, $73e3a8d89278ed7b$export$732916c0e88175fb)(Component, config, $a93b6401f922fd1e$var$preloadedFeatures, (0, $2f8881102ac6dde9$export$56ba0183203348f5)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $a93b6401f922fd1e$export$546614c4a05701f9(key) {
    return (0, $b40dad60036091a1$export$46b7e4b9dc6110c3)((0, $73e3a8d89278ed7b$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $a93b6401f922fd1e$var$preloadedFeatures, (0, $2f8881102ac6dde9$export$56ba0183203348f5)));
}



var $acw62 = parcelRequire("acw62");

"use client";
var $fd46c561f9dcf861$var$defaultTransition = {
    exit: {
        duration: 0.15,
        ease: (0, $e53c11b120069459$export$9ee1d08bb6db426f).easeInOut
    },
    enter: {
        type: "spring",
        damping: 25,
        stiffness: 180
    }
};
var $fd46c561f9dcf861$var$variants = {
    exit: ({ direction: direction, transition: transition, transitionEnd: transitionEnd, delay: delay })=>{
        var _a;
        const { exit: exitStyles } = (0, $e53c11b120069459$export$76af7f35258e628d)({
            direction: direction
        });
        return {
            ...exitStyles,
            transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : (0, $e53c11b120069459$export$fc492bd0f1c91c).exit($fd46c561f9dcf861$var$defaultTransition.exit, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
        };
    },
    enter: ({ direction: direction, transitionEnd: transitionEnd, transition: transition, delay: delay })=>{
        var _a;
        const { enter: enterStyles } = (0, $e53c11b120069459$export$76af7f35258e628d)({
            direction: direction
        });
        return {
            ...enterStyles,
            transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : (0, $e53c11b120069459$export$fc492bd0f1c91c).enter($fd46c561f9dcf861$var$defaultTransition.enter, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
        };
    }
};
var $fd46c561f9dcf861$export$d8dc01b5c85a37b9 = (0, $acw62.forwardRef)(function Slide2(props, ref) {
    const { direction: direction = "right", style: style, unmountOnExit: unmountOnExit, in: isOpen, className: className, transition: transition, transitionEnd: transitionEnd, delay: delay, motionProps: motionProps, ...rest } = props;
    const transitionStyles = (0, $e53c11b120069459$export$76af7f35258e628d)({
        direction: direction
    });
    const computedStyle = Object.assign({
        position: "fixed"
    }, transitionStyles.position, style);
    const show = unmountOnExit ? isOpen && unmountOnExit : true;
    const animate = isOpen || unmountOnExit ? "enter" : "exit";
    const custom = {
        transitionEnd: transitionEnd,
        transition: transition,
        direction: direction,
        delay: delay
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        custom: custom,
        children: show && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
            ...rest,
            ref: ref,
            initial: "exit",
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-slide", className),
            animate: animate,
            exit: "exit",
            custom: custom,
            variants: $fd46c561f9dcf861$var$variants,
            style: computedStyle,
            ...motionProps
        })
    });
});
$fd46c561f9dcf861$export$d8dc01b5c85a37b9.displayName = "Slide";



"use client";
var $de1928e3734003a6$var$MotionDiv = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $fd46c561f9dcf861$export$d8dc01b5c85a37b9));
var $de1928e3734003a6$export$57ca055474bc0056 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { className: className, children: children, motionProps: motionProps, containerProps: rootProps, ...rest } = props;
    const { getDialogProps: getDialogProps, getDialogContainerProps: getDialogContainerProps, isOpen: isOpen } = (0, $4410258333ca5546$export$4cc1699d46f42cae)();
    const dialogProps = getDialogProps(rest, ref);
    const containerProps = getDialogContainerProps(rootProps);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-modal__content", className);
    const styles = (0, $4410258333ca5546$export$c540eec2ed4454a2)();
    const dialogStyles = {
        display: "flex",
        flexDirection: "column",
        position: "relative",
        width: "100%",
        outline: 0,
        ...styles.dialog
    };
    const dialogContainerStyles = {
        display: "flex",
        width: "100vw",
        height: "$100vh",
        position: "fixed",
        left: 0,
        top: 0,
        ...styles.dialogContainer
    };
    const { placement: placement } = (0, $2c5be1008fbfcbeb$export$cc200cef0c88a66f)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a4bb24df8dc40781$export$ffa1d90344e68399), {
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
            ...containerProps,
            className: "chakra-modal__content-container",
            __css: dialogContainerStyles,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($de1928e3734003a6$var$MotionDiv, {
                motionProps: motionProps,
                direction: placement,
                in: isOpen,
                className: _className,
                ...dialogProps,
                __css: dialogStyles,
                children: children
            })
        })
    });
});
$de1928e3734003a6$export$57ca055474bc0056.displayName = "DrawerContent";








var $acw62 = parcelRequire("acw62");

"use client";
var $9ba9961d8b5e5518$var$variants = {
    enter: ({ transition: transition, transitionEnd: transitionEnd, delay: delay } = {})=>{
        var _a;
        return {
            opacity: 1,
            transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : (0, $e53c11b120069459$export$fc492bd0f1c91c).enter((0, $e53c11b120069459$export$f995eb860f745cb).enter, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
        };
    },
    exit: ({ transition: transition, transitionEnd: transitionEnd, delay: delay } = {})=>{
        var _a;
        return {
            opacity: 0,
            transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : (0, $e53c11b120069459$export$fc492bd0f1c91c).exit((0, $e53c11b120069459$export$f995eb860f745cb).exit, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
        };
    }
};
var $9ba9961d8b5e5518$export$4342735ea5c231d = {
    initial: "exit",
    animate: "enter",
    exit: "exit",
    variants: $9ba9961d8b5e5518$var$variants
};
var $9ba9961d8b5e5518$export$c983850c6c9d8b0e = (0, $acw62.forwardRef)(function Fade2(props, ref) {
    const { unmountOnExit: unmountOnExit, in: isOpen, className: className, transition: transition, transitionEnd: transitionEnd, delay: delay, ...rest } = props;
    const animate = isOpen || unmountOnExit ? "enter" : "exit";
    const show = unmountOnExit ? isOpen && unmountOnExit : true;
    const custom = {
        transition: transition,
        transitionEnd: transitionEnd,
        delay: delay
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        custom: custom,
        children: show && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
            ref: ref,
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-fade", className),
            custom: custom,
            ...$9ba9961d8b5e5518$export$4342735ea5c231d,
            animate: animate,
            ...rest
        })
    });
});
$9ba9961d8b5e5518$export$c983850c6c9d8b0e.displayName = "Fade";




"use client";
var $006bfa297e893b21$var$MotionDiv = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div);
var $006bfa297e893b21$export$8948f78d83984c69 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { className: className, transition: transition, motionProps: _motionProps, ...rest } = props;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-modal__overlay", className);
    const styles = (0, $4410258333ca5546$export$c540eec2ed4454a2)();
    const overlayStyle = {
        pos: "fixed",
        left: "0",
        top: "0",
        w: "100vw",
        h: "100vh",
        ...styles.overlay
    };
    const { motionPreset: motionPreset } = (0, $4410258333ca5546$export$4cc1699d46f42cae)();
    const defaultMotionProps = motionPreset === "none" ? {} : (0, $9ba9961d8b5e5518$export$4342735ea5c231d);
    const motionProps = _motionProps || defaultMotionProps;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($006bfa297e893b21$var$MotionDiv, {
        ...motionProps,
        __css: overlayStyle,
        ref: ref,
        className: _className,
        ...rest
    });
});
$006bfa297e893b21$export$8948f78d83984c69.displayName = "ModalOverlay";



"use client";
var $2231dd843a1dfd59$export$f51f4c4ede09e011 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Flex2(props, ref) {
    const { direction: direction, align: align, justify: justify, wrap: wrap, basis: basis, grow: grow, shrink: shrink, ...rest } = props;
    const styles = {
        display: "flex",
        flexDirection: direction,
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap,
        flexBasis: basis,
        flexGrow: grow,
        flexShrink: shrink
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ref: ref,
        __css: styles,
        ...rest
    });
});
$2231dd843a1dfd59$export$f51f4c4ede09e011.displayName = "Flex";


var $acw62 = parcelRequire("acw62");
"use client";
function $5efc0ab8376c922b$export$867b668ad7ef61e5(value) {
    const [isButton, setIsButton] = (0, $acw62.useState)(!value);
    const refCallback = (0, $acw62.useCallback)((node)=>{
        if (!node) return;
        setIsButton(node.tagName === "BUTTON");
    }, []);
    const type = isButton ? "button" : void 0;
    return {
        ref: refCallback,
        type: type
    };
}



"use client";
var [$7e55cb64d43f1645$export$85041a2bb9328e33, $7e55cb64d43f1645$export$749e21be8b14b968] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    strict: false,
    name: "ButtonGroupContext"
});





var $acw62 = parcelRequire("acw62");

"use client";
function $3033a23dbf9db859$export$e1c22a2ee2645e36(props) {
    const { children: children, className: className, ...rest } = props;
    const _children = (0, $acw62.isValidElement)(children) ? (0, $acw62.cloneElement)(children, {
        "aria-hidden": true,
        focusable: false
    }) : children;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-button__icon", className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
        display: "inline-flex",
        alignSelf: "center",
        flexShrink: 0,
        ...rest,
        className: _className,
        children: _children
    });
}
$3033a23dbf9db859$export$e1c22a2ee2645e36.displayName = "ButtonIcon";





"use client";
var $6c35780027222e0c$var$spin = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "rotate(0deg)"
    },
    "100%": {
        transform: "rotate(360deg)"
    }
});
var $6c35780027222e0c$export$7f7cbe89f1eacd2 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("Spinner", props);
    const { label: label = "Loading...", thickness: thickness = "2px", speed: speed = "0.45s", emptyColor: emptyColor = "transparent", className: className, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-spinner", className);
    const spinnerStyles = {
        display: "inline-block",
        borderColor: "currentColor",
        borderStyle: "solid",
        borderRadius: "99999px",
        borderWidth: thickness,
        borderBottomColor: emptyColor,
        borderLeftColor: emptyColor,
        animation: `${$6c35780027222e0c$var$spin} ${speed} linear infinite`,
        ...styles
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ref: ref,
        __css: spinnerStyles,
        className: _className,
        ...rest,
        children: label && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
            srOnly: true,
            children: label
        })
    });
});
$6c35780027222e0c$export$7f7cbe89f1eacd2.displayName = "Spinner";





var $acw62 = parcelRequire("acw62");

"use client";
function $444db0b46076cf5f$export$f2c034885dd3ba7b(props) {
    const { label: label, placement: placement, spacing: spacing = "0.5rem", children: children = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $6c35780027222e0c$export$7f7cbe89f1eacd2), {
        color: "currentColor",
        width: "1em",
        height: "1em"
    }), className: className, __css: __css, ...rest } = props;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-button__spinner", className);
    const marginProp = placement === "start" ? "marginEnd" : "marginStart";
    const spinnerStyles = (0, $acw62.useMemo)(()=>({
            display: "flex",
            alignItems: "center",
            position: label ? "relative" : "absolute",
            [marginProp]: label ? spacing : 0,
            fontSize: "1em",
            lineHeight: "normal",
            ...__css
        }), [
        __css,
        label,
        marginProp,
        spacing
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        className: _className,
        ...rest,
        __css: spinnerStyles,
        children: children
    });
}
$444db0b46076cf5f$export$f2c034885dd3ba7b.displayName = "ButtonSpinner";






var $acw62 = parcelRequire("acw62");

"use client";
var $df191e1c46987458$export$353f5b6fc5456de1 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const group = (0, $7e55cb64d43f1645$export$749e21be8b14b968)();
    const styles = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("Button", {
        ...group,
        ...props
    });
    const { isDisabled: isDisabled = group == null ? void 0 : group.isDisabled, isLoading: isLoading, isActive: isActive, children: children, leftIcon: leftIcon, rightIcon: rightIcon, loadingText: loadingText, iconSpacing: iconSpacing = "0.5rem", type: type, spinner: spinner, spinnerPlacement: spinnerPlacement = "start", className: className, as: as, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const buttonStyles = (0, $acw62.useMemo)(()=>{
        const _focus = {
            ...styles == null ? void 0 : styles["_focus"],
            zIndex: 1
        };
        return {
            display: "inline-flex",
            appearance: "none",
            alignItems: "center",
            justifyContent: "center",
            userSelect: "none",
            position: "relative",
            whiteSpace: "nowrap",
            verticalAlign: "middle",
            outline: "none",
            ...styles,
            ...!!group && {
                _focus: _focus
            }
        };
    }, [
        styles,
        group
    ]);
    const { ref: _ref, type: defaultType } = (0, $5efc0ab8376c922b$export$867b668ad7ef61e5)(as);
    const contentProps = {
        rightIcon: rightIcon,
        leftIcon: leftIcon,
        iconSpacing: iconSpacing,
        children: children
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).button, {
        ref: (0, $457901a59fc0a4e6$export$74665b213cb5c4cf)(ref, _ref),
        as: as,
        type: type != null ? type : defaultType,
        "data-active": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isActive),
        "data-loading": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isLoading),
        __css: buttonStyles,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-button", className),
        ...rest,
        disabled: isDisabled || isLoading,
        children: [
            isLoading && spinnerPlacement === "start" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $444db0b46076cf5f$export$f2c034885dd3ba7b), {
                className: "chakra-button__spinner--start",
                label: loadingText,
                placement: "start",
                spacing: iconSpacing,
                children: spinner
            }),
            isLoading ? loadingText || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
                opacity: 0,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($df191e1c46987458$var$ButtonContent, {
                    ...contentProps
                })
            }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($df191e1c46987458$var$ButtonContent, {
                ...contentProps
            }),
            isLoading && spinnerPlacement === "end" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $444db0b46076cf5f$export$f2c034885dd3ba7b), {
                className: "chakra-button__spinner--end",
                label: loadingText,
                placement: "end",
                spacing: iconSpacing,
                children: spinner
            })
        ]
    });
});
$df191e1c46987458$export$353f5b6fc5456de1.displayName = "Button";
function $df191e1c46987458$var$ButtonContent(props) {
    const { leftIcon: leftIcon, rightIcon: rightIcon, children: children, iconSpacing: iconSpacing } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            leftIcon && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3033a23dbf9db859$export$e1c22a2ee2645e36), {
                marginEnd: iconSpacing,
                children: leftIcon
            }),
            children,
            rightIcon && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3033a23dbf9db859$export$e1c22a2ee2645e36), {
                marginStart: iconSpacing,
                children: rightIcon
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

"use client";
var $8ddb6cf7f4890f79$export$c25acd513dcc8062 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { icon: icon, children: children, isRound: isRound, "aria-label": ariaLabel, ...rest } = props;
    const element = icon || children;
    const _children = (0, $acw62.isValidElement)(element) ? (0, $acw62.cloneElement)(element, {
        "aria-hidden": true,
        focusable: false
    }) : null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $df191e1c46987458$export$353f5b6fc5456de1), {
        padding: "0",
        borderRadius: isRound ? "full" : void 0,
        ref: ref,
        "aria-label": ariaLabel,
        ...rest,
        children: _children
    });
});
$8ddb6cf7f4890f79$export$c25acd513dcc8062.displayName = "IconButton";



// src/compact.ts
function $6bc154251470a415$export$8e16b83750b44988(object) {
    const clone = Object.assign({}, object);
    for(let key in clone)if (clone[key] === void 0) delete clone[key];
    return clone;
}



"use client";
var $7a2900ce3f78a504$export$5f1af8db9871e1d6 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Text2(props, ref) {
    const styles = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("Text", props);
    const { className: className, align: align, decoration: decoration, casing: casing, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const aliasedProps = (0, $6bc154251470a415$export$8e16b83750b44988)({
        textAlign: props.align,
        textDecoration: props.decoration,
        textTransform: props.casing
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).p, {
        ref: ref,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-text", props.className),
        ...aliasedProps,
        ...rest,
        __css: styles
    });
});
$7a2900ce3f78a504$export$5f1af8db9871e1d6.displayName = "Text";

// src/responsive.ts

var $37c1adb04c994149$export$d07517a676ce386f = Object.freeze([
    "base",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl"
]);
function $37c1adb04c994149$export$eca1915781c2aaca(prop, mapper) {
    if (Array.isArray(prop)) return prop.map((item)=>item === null ? null : mapper(item));
    if ((0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(prop)) return Object.keys(prop).reduce((result, key)=>{
        result[key] = mapper(prop[key]);
        return result;
    }, {});
    if (prop != null) return mapper(prop);
    return null;
}
function $37c1adb04c994149$export$d9dcf045f3ec145e(obj, bps = $37c1adb04c994149$export$d07517a676ce386f) {
    const result = bps.map((br)=>{
        var _a;
        return (_a = obj[br]) != null ? _a : null;
    });
    const lastItem = result[result.length - 1];
    while(lastItem === null)result.pop();
    return result;
}
function $37c1adb04c994149$export$60476530468641e7(values, bps = $37c1adb04c994149$export$d07517a676ce386f) {
    const result = {};
    values.forEach((value, index)=>{
        const key = bps[index];
        if (value == null) return;
        result[key] = value;
    });
    return result;
}
function $37c1adb04c994149$export$2f4b3062f5f33794(obj, bps = $37c1adb04c994149$export$d07517a676ce386f) {
    const keys = Object.keys(obj);
    return keys.length > 0 && keys.every((key)=>bps.includes(key));
}
var $37c1adb04c994149$export$4cdfc817e07de39e = (v)=>Number.isNaN(Number(v));


"use client";
function $467e1bbcb85cb8c9$export$4b9ea961bfd9be6e(values, breakpoint, breakpoints = (0, $37c1adb04c994149$export$d07517a676ce386f)) {
    let index = Object.keys(values).indexOf(breakpoint);
    if (index !== -1) return values[breakpoint];
    let stopIndex = breakpoints.indexOf(breakpoint);
    while(stopIndex >= 0){
        const key = breakpoints[stopIndex];
        if (values.hasOwnProperty(key)) {
            index = stopIndex;
            break;
        }
        stopIndex -= 1;
    }
    if (index !== -1) {
        const key = breakpoints[index];
        return values[key];
    }
    return void 0;
}




var $acw62 = parcelRequire("acw62");

"use client";
var $3a87268155f9f2cb$var$EnvironmentContext = (0, $acw62.createContext)({
    getDocument () {
        return document;
    },
    getWindow () {
        return window;
    }
});
$3a87268155f9f2cb$var$EnvironmentContext.displayName = "EnvironmentContext";
function $3a87268155f9f2cb$export$ea7ed2425832167d({ defer: defer } = {}) {
    const [, forceUpdate] = (0, $acw62.useReducer)((c)=>c + 1, 0);
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (!defer) return;
        forceUpdate();
    }, [
        defer
    ]);
    return (0, $acw62.useContext)($3a87268155f9f2cb$var$EnvironmentContext);
}
function $3a87268155f9f2cb$export$29a4c0b32fc9db42(props) {
    const { children: children, environment: environmentProp, disabled: disabled } = props;
    const ref = (0, $acw62.useRef)(null);
    const context = (0, $acw62.useMemo)(()=>{
        if (environmentProp) return environmentProp;
        return {
            getDocument: ()=>{
                var _a, _b;
                return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) != null ? _b : document;
            },
            getWindow: ()=>{
                var _a, _b;
                return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument.defaultView) != null ? _b : window;
            }
        };
    }, [
        environmentProp
    ]);
    const showSpan = !disabled || !environmentProp;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)($3a87268155f9f2cb$var$EnvironmentContext.Provider, {
        value: context,
        children: [
            children,
            showSpan && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                id: "__chakra_env",
                hidden: true,
                ref: ref
            })
        ]
    });
}
$3a87268155f9f2cb$export$29a4c0b32fc9db42.displayName = "EnvironmentProvider";



var $acw62 = parcelRequire("acw62");
"use client";
function $63be06194fb9f91c$export$32d5543ab307c01(query, options = {}) {
    const { ssr: ssr = true, fallback: fallback } = options;
    const { getWindow: getWindow } = (0, $3a87268155f9f2cb$export$ea7ed2425832167d)();
    const queries = Array.isArray(query) ? query : [
        query
    ];
    let fallbackValues = Array.isArray(fallback) ? fallback : [
        fallback
    ];
    fallbackValues = fallbackValues.filter((v)=>v != null);
    const [value, setValue] = (0, $acw62.useState)(()=>{
        return queries.map((query2, index)=>({
                media: query2,
                matches: ssr ? !!fallbackValues[index] : getWindow().matchMedia(query2).matches
            }));
    });
    (0, $acw62.useEffect)(()=>{
        const win = getWindow();
        setValue(queries.map((query2)=>({
                media: query2,
                matches: win.matchMedia(query2).matches
            })));
        const mql = queries.map((query2)=>win.matchMedia(query2));
        const handler = (evt)=>{
            setValue((prev)=>{
                return prev.slice().map((item)=>{
                    if (item.media === evt.media) return {
                        ...item,
                        matches: evt.matches
                    };
                    return item;
                });
            });
        };
        mql.forEach((mql2)=>{
            if (typeof mql2.addListener === "function") mql2.addListener(handler);
            else mql2.addEventListener("change", handler);
        });
        return ()=>{
            mql.forEach((mql2)=>{
                if (typeof mql2.removeListener === "function") mql2.removeListener(handler);
                else mql2.removeEventListener("change", handler);
            });
        };
    }, [
        getWindow
    ]);
    return value.map((item)=>item.matches);
}




"use client";
function $ac019495ebd4a1a2$export$199d6754bdf4e1e3(arg) {
    var _a, _b;
    const opts = (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(arg) ? arg : {
        fallback: arg != null ? arg : "base"
    };
    const theme = (0, $5f6bf330f809db0e$export$93d4e7f90805808f)();
    const breakpoints = theme.__breakpoints.details.map(({ minMaxQuery: minMaxQuery, breakpoint: breakpoint })=>({
            breakpoint: breakpoint,
            query: minMaxQuery.replace("@media screen and ", "")
        }));
    const fallback = breakpoints.map((bp)=>bp.breakpoint === opts.fallback);
    const values = (0, $63be06194fb9f91c$export$32d5543ab307c01)(breakpoints.map((bp)=>bp.query), {
        fallback: fallback,
        ssr: opts.ssr
    });
    const index = values.findIndex((value)=>value == true);
    return (_b = (_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) != null ? _b : opts.fallback;
}





"use client";
function $b54379f4aa442bae$export$dc0946e21e709aff(values, arg) {
    var _a;
    const opts = (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(arg) ? arg : {
        fallback: arg != null ? arg : "base"
    };
    const breakpoint = (0, $ac019495ebd4a1a2$export$199d6754bdf4e1e3)(opts);
    const theme = (0, $5f6bf330f809db0e$export$93d4e7f90805808f)();
    if (!breakpoint) return;
    const breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
    const obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0, $37c1adb04c994149$export$60476530468641e7)(values, breakpoints)).map(([key, value])=>[
            key,
            value
        ])) : values;
    return (0, $467e1bbcb85cb8c9$export$4b9ea961bfd9be6e)(obj, breakpoint, breakpoints);
}


var $acw62 = parcelRequire("acw62");
"use client";
function $ce14011db4e17e58$export$f680877a34711e37(idProp, prefix) {
    const id = (0, $acw62.useId)();
    return (0, $acw62.useMemo)(()=>idProp || [
            prefix,
            id
        ].filter(Boolean).join("-"), [
        idProp,
        prefix,
        id
    ]);
}
function $ce14011db4e17e58$export$365c04e2f432779(idProp, ...prefixes) {
    const id = $ce14011db4e17e58$export$f680877a34711e37(idProp);
    return (0, $acw62.useMemo)(()=>{
        return prefixes.map((prefix)=>`${prefix}-${id}`);
    }, [
        id,
        prefixes
    ]);
}
function $ce14011db4e17e58$export$bc294ecf36b44bfb(partId) {
    const [id, setId] = (0, $acw62.useState)(null);
    const ref = (0, $acw62.useCallback)((node)=>{
        setId(node ? partId : null);
    }, [
        partId
    ]);
    return {
        ref: ref,
        id: id,
        isRendered: Boolean(id)
    };
}


// src/dom.ts
function $a1c7b8cf646d4454$export$45a5e7f76e0caa8d(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function $a1c7b8cf646d4454$export$1b3bfaa9684536aa(el) {
    var _a;
    if (!$a1c7b8cf646d4454$export$45a5e7f76e0caa8d(el)) return false;
    const win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
    return el instanceof win.HTMLElement;
}
function $a1c7b8cf646d4454$export$f21a1ffae260145a(node) {
    var _a, _b;
    return $a1c7b8cf646d4454$export$45a5e7f76e0caa8d(node) ? (_b = (_a = $a1c7b8cf646d4454$export$b204af158042fbac(node)) == null ? void 0 : _a.defaultView) != null ? _b : window : window;
}
function $a1c7b8cf646d4454$export$b204af158042fbac(node) {
    var _a;
    return $a1c7b8cf646d4454$export$45a5e7f76e0caa8d(node) ? (_a = node.ownerDocument) != null ? _a : document : document;
}
function $a1c7b8cf646d4454$export$8d16348623687f6(event) {
    var _a;
    return (_a = event.view) != null ? _a : window;
}
function $a1c7b8cf646d4454$export$71594e8a50f746f4() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var $a1c7b8cf646d4454$export$4e09c449d6c407f7 = /* @__PURE__ */ $a1c7b8cf646d4454$export$71594e8a50f746f4();
var $a1c7b8cf646d4454$export$5cc3b7b83e34ade7 = (condition)=>condition ? "" : void 0;
var $a1c7b8cf646d4454$export$91a6105db3d4be7b = (condition)=>condition ? true : void 0;
var $a1c7b8cf646d4454$export$a274e22fb40f762e = (...classNames)=>classNames.filter(Boolean).join(" ");
function $a1c7b8cf646d4454$export$cd4e5573fbe2b576(node) {
    const doc = $a1c7b8cf646d4454$export$b204af158042fbac(node);
    return doc == null ? void 0 : doc.activeElement;
}
function $a1c7b8cf646d4454$export$2344b14b097df817(parent, child) {
    if (!parent) return false;
    return parent === child || parent.contains(child);
}
function $a1c7b8cf646d4454$export$b1d829ddf82884aa(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return ()=>{
        target.removeEventListener(eventName, handler, options);
    };
}
function $a1c7b8cf646d4454$export$17948c8429b9b73a(event) {
    const { key: key, keyCode: keyCode } = event;
    const isArrowKey = keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0;
    const eventKey = isArrowKey ? `Arrow${key}` : key;
    return eventKey;
}
function $a1c7b8cf646d4454$export$a7a83d2a1d2d9e91(event) {
    var _a, _b;
    const target = (_a = event.target) != null ? _a : event.currentTarget;
    const activeElement = $a1c7b8cf646d4454$export$cd4e5573fbe2b576(target);
    return (_b = event.relatedTarget) != null ? _b : activeElement;
}
function $a1c7b8cf646d4454$export$189689d1febf0166(event) {
    return event.button !== 0;
}



var $acw62 = parcelRequire("acw62");
"use client";
var $45157ab301125bc7$export$deebe11a338de063 = (0, $a1c7b8cf646d4454$export$4e09c449d6c407f7) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



var $acw62 = parcelRequire("acw62");
"use client";
function $1c499373c234ef17$export$25bec8c6f54ee79a(fn, deps = []) {
    const ref = (0, $acw62.useRef)(fn);
    (0, $45157ab301125bc7$export$deebe11a338de063)(()=>{
        ref.current = fn;
    });
    return (0, $acw62.useCallback)((...args)=>{
        var _a;
        return (_a = ref.current) == null ? void 0 : _a.call(ref, ...args);
    }, deps);
}




var $acw62 = parcelRequire("acw62");
"use client";
function $147ea746fc385b52$export$7301e09313e4cf1b(prop, state) {
    const isControlled = prop !== void 0;
    const value = isControlled && typeof prop !== "undefined" ? prop : state;
    return [
        isControlled,
        value
    ];
}
function $147ea746fc385b52$export$6f32135080cb4c3(props) {
    const { value: valueProp, defaultValue: defaultValue, onChange: onChange, shouldUpdate: shouldUpdate = (prev, next)=>prev !== next } = props;
    const onChangeProp = (0, $1c499373c234ef17$export$25bec8c6f54ee79a)(onChange);
    const shouldUpdateProp = (0, $1c499373c234ef17$export$25bec8c6f54ee79a)(shouldUpdate);
    const [valueState, setValue] = (0, $acw62.useState)(defaultValue);
    const isControlled = valueProp !== void 0;
    const value = isControlled ? valueProp : valueState;
    const updateValue = (0, $acw62.useCallback)((next)=>{
        const nextValue = (0, $7e9e3a2462729b7f$export$624e501d81f5ffce)(next, value);
        if (!shouldUpdateProp(value, nextValue)) return;
        if (!isControlled) setValue(nextValue);
        onChangeProp(nextValue);
    }, [
        isControlled,
        onChangeProp,
        value,
        shouldUpdateProp
    ]);
    return [
        value,
        updateValue
    ];
}





var $acw62 = parcelRequire("acw62");
"use client";
function $8b7bde38f2a271a2$export$6e3e27031a30522f(props = {}) {
    const { onClose: onCloseProp, onOpen: onOpenProp, isOpen: isOpenProp, id: idProp } = props;
    const onOpenPropCallbackRef = (0, $1c499373c234ef17$export$25bec8c6f54ee79a)(onOpenProp);
    const onClosePropCallbackRef = (0, $1c499373c234ef17$export$25bec8c6f54ee79a)(onCloseProp);
    const [isOpenState, setIsOpen] = (0, $acw62.useState)(props.defaultIsOpen || false);
    const [isControlled, isOpen] = (0, $147ea746fc385b52$export$7301e09313e4cf1b)(isOpenProp, isOpenState);
    const id = (0, $ce14011db4e17e58$export$f680877a34711e37)(idProp, "disclosure");
    const onClose = (0, $acw62.useCallback)(()=>{
        if (!isControlled) setIsOpen(false);
        onClosePropCallbackRef == null || onClosePropCallbackRef();
    }, [
        isControlled,
        onClosePropCallbackRef
    ]);
    const onOpen = (0, $acw62.useCallback)(()=>{
        if (!isControlled) setIsOpen(true);
        onOpenPropCallbackRef == null || onOpenPropCallbackRef();
    }, [
        isControlled,
        onOpenPropCallbackRef
    ]);
    const onToggle = (0, $acw62.useCallback)(()=>{
        const action = isOpen ? onClose : onOpen;
        action();
    }, [
        isOpen,
        onOpen,
        onClose
    ]);
    return {
        isOpen: !!isOpen,
        onOpen: onOpen,
        onClose: onClose,
        onToggle: onToggle,
        isControlled: isControlled,
        getButtonProps: (props2 = {})=>({
                ...props2,
                "aria-expanded": isOpen,
                "aria-controls": id,
                onClick: (0, $7e9e3a2462729b7f$export$5bdd3f730ec2c47e)(props2.onClick, onToggle)
            }),
        getDisclosureProps: (props2 = {})=>({
                ...props2,
                hidden: !isOpen,
                id: id
            })
    };
}





var $acw62 = parcelRequire("acw62");

"use client";
function $57ab4518d7256dec$export$274edc73af1ae9c8(options) {
    const { viewBox: viewBox = "0 0 24 24", d: pathDefinition, displayName: displayName, defaultProps: defaultProps = {} } = options;
    const path = (0, $acw62.Children).toArray(options.path);
    const Comp = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $6a96cde036d65913$export$f04a61298a47a40f), {
            ref: ref,
            viewBox: viewBox,
            ...defaultProps,
            ...props,
            children: path.length ? path : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "currentColor",
                d: pathDefinition
            })
        }));
    Comp.displayName = displayName;
    return Comp;
}


"use client";
var $2f84d66857e2fec8$export$cae179f078f4b4a4 = (0, $57ab4518d7256dec$export$274edc73af1ae9c8)({
    displayName: "CloseIcon",
    d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
});


"use client";
var $c14ccf14a23812f9$export$e369611dc3dfbf44 = (0, $57ab4518d7256dec$export$274edc73af1ae9c8)({
    displayName: "HamburgerIcon",
    viewBox: "0 0 24 24",
    d: "M 3 5 A 1.0001 1.0001 0 1 0 3 7 L 21 7 A 1.0001 1.0001 0 1 0 21 5 L 3 5 z M 3 11 A 1.0001 1.0001 0 1 0 3 13 L 21 13 A 1.0001 1.0001 0 1 0 21 11 L 3 11 z M 3 17 A 1.0001 1.0001 0 1 0 3 19 L 21 19 A 1.0001 1.0001 0 1 0 21 17 L 3 17 z"
});


/**
 * React Router DOM v6.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");


function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367)
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367)
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref2;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, future: future, history: history } = _ref3;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref4, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref5, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $040dbb9c344a508d$var$FormImpl = /*#__PURE__*/ $acw62.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref6, $040dbb9c344a508d$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $040dbb9c344a508d$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
function $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
        let submit = $040dbb9c344a508d$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $040dbb9c344a508d$var$fetcherId = 0;
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $acw62.useState(()=>String(++$040dbb9c344a508d$var$fetcherId));
    let [Form] = $acw62.useState(()=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        return $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $acw62.useState(()=>(href)=>{
            !router && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
            !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $040dbb9c344a508d$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $acw62.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $7939e29d663dd3ed$export$2af03a1de5c0910)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}


var $93dcb5d2a38d8faf$exports = {};

$93dcb5d2a38d8faf$exports = new URL((parcelRequire("27Lyk")).resolve("8TNAE"), import.meta.url).toString();


var $3eb293e0666ec520$exports = {};

$3eb293e0666ec520$exports = new URL((parcelRequire("27Lyk")).resolve("6yQke"), import.meta.url).toString();


var $72ef0cd6da1f3d6c$exports = {};

$72ef0cd6da1f3d6c$exports = new URL((parcelRequire("27Lyk")).resolve("5fDFI"), import.meta.url).toString();


var $e73c29414f4c5dae$exports = {};

$e73c29414f4c5dae$exports = new URL((parcelRequire("27Lyk")).resolve("fR5Iz"), import.meta.url).toString();


var $24ffb9dc9901d8ff$exports = {};

$24ffb9dc9901d8ff$exports = new URL((parcelRequire("27Lyk")).resolve("cSSTG"), import.meta.url).toString();


var $65bdcaec64e31b5c$exports = {};

$65bdcaec64e31b5c$exports = new URL((parcelRequire("27Lyk")).resolve("fp6dP"), import.meta.url).toString();


var $d36b9241727d123a$exports = {};

$d36b9241727d123a$exports = new URL((parcelRequire("27Lyk")).resolve("lLcmO"), import.meta.url).toString();


var $29a3b4d527ec578f$exports = {};

$29a3b4d527ec578f$exports = new URL((parcelRequire("27Lyk")).resolve("hW1QD"), import.meta.url).toString();


var $f2f516cb37ac0c8a$exports = {};

$f2f516cb37ac0c8a$exports = new URL((parcelRequire("27Lyk")).resolve("j9yG8"), import.meta.url).toString();


var $dae86360e224d709$exports = {};

$dae86360e224d709$exports = new URL((parcelRequire("27Lyk")).resolve("aMHva"), import.meta.url).toString();


var $966afd34f0f50073$exports = {};

$966afd34f0f50073$exports = new URL((parcelRequire("27Lyk")).resolve("eRy3D"), import.meta.url).toString();


var $c3fde82440127bca$exports = {};

$c3fde82440127bca$exports = new URL((parcelRequire("27Lyk")).resolve("4BdL9"), import.meta.url).toString();


var $a7d8f378d39278c5$exports = {};

$a7d8f378d39278c5$exports = new URL((parcelRequire("27Lyk")).resolve("lIcmy"), import.meta.url).toString();





parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

"use client";
var $cb476d4702afcfc2$var$isNumeric = (value)=>value != null && parseInt(value.toString(), 10) > 0;
var $cb476d4702afcfc2$var$defaultTransitions = {
    exit: {
        height: {
            duration: 0.2,
            ease: (0, $e53c11b120069459$export$9ee1d08bb6db426f).ease
        },
        opacity: {
            duration: 0.3,
            ease: (0, $e53c11b120069459$export$9ee1d08bb6db426f).ease
        }
    },
    enter: {
        height: {
            duration: 0.3,
            ease: (0, $e53c11b120069459$export$9ee1d08bb6db426f).ease
        },
        opacity: {
            duration: 0.4,
            ease: (0, $e53c11b120069459$export$9ee1d08bb6db426f).ease
        }
    }
};
var $cb476d4702afcfc2$var$variants = {
    exit: ({ animateOpacity: animateOpacity, startingHeight: startingHeight, transition: transition, transitionEnd: transitionEnd, delay: delay })=>{
        var _a;
        return {
            ...animateOpacity && {
                opacity: $cb476d4702afcfc2$var$isNumeric(startingHeight) ? 1 : 0
            },
            height: startingHeight,
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit,
            transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : (0, $e53c11b120069459$export$fc492bd0f1c91c).exit($cb476d4702afcfc2$var$defaultTransitions.exit, delay)
        };
    },
    enter: ({ animateOpacity: animateOpacity, endingHeight: endingHeight, transition: transition, transitionEnd: transitionEnd, delay: delay })=>{
        var _a;
        return {
            ...animateOpacity && {
                opacity: 1
            },
            height: endingHeight,
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter,
            transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : (0, $e53c11b120069459$export$fc492bd0f1c91c).enter($cb476d4702afcfc2$var$defaultTransitions.enter, delay)
        };
    }
};
var $cb476d4702afcfc2$export$78768a9af065a7b = (0, $acw62.forwardRef)((props, ref)=>{
    const { in: isOpen, unmountOnExit: unmountOnExit, animateOpacity: animateOpacity = true, startingHeight: startingHeight = 0, endingHeight: endingHeight = "auto", style: style, className: className, transition: transition, transitionEnd: transitionEnd, ...rest } = props;
    const [mounted, setMounted] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            setMounted(true);
        });
        return ()=>clearTimeout(timeout);
    }, []);
    (0, $abe97432afb3d989$export$c106dd0671a0fc2d)({
        condition: Number(startingHeight) > 0 && !!unmountOnExit,
        message: `startingHeight and unmountOnExit are mutually exclusive. You can't use them together`
    });
    const hasStartingHeight = parseFloat(startingHeight.toString()) > 0;
    const custom = {
        startingHeight: startingHeight,
        endingHeight: endingHeight,
        animateOpacity: animateOpacity,
        transition: !mounted ? {
            enter: {
                duration: 0
            }
        } : transition,
        transitionEnd: {
            enter: transitionEnd == null ? void 0 : transitionEnd.enter,
            exit: unmountOnExit ? transitionEnd == null ? void 0 : transitionEnd.exit : {
                ...transitionEnd == null ? void 0 : transitionEnd.exit,
                display: hasStartingHeight ? "block" : "none"
            }
        }
    };
    const show = unmountOnExit ? isOpen : true;
    const animate = isOpen || unmountOnExit ? "enter" : "exit";
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        initial: false,
        custom: custom,
        children: show && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
            ref: ref,
            ...rest,
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-collapse", className),
            style: {
                overflow: "hidden",
                display: "block",
                ...style
            },
            custom: custom,
            variants: $cb476d4702afcfc2$var$variants,
            initial: unmountOnExit ? "exit" : false,
            animate: animate,
            exit: "exit"
        })
    });
});
$cb476d4702afcfc2$export$78768a9af065a7b.displayName = "Collapse";


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
function $eeeb32c390fb7f0b$export$25bec8c6f54ee79a(callback, deps = []) {
    const callbackRef = (0, $acw62.useRef)(callback);
    (0, $acw62.useEffect)(()=>{
        callbackRef.current = callback;
    });
    return (0, $acw62.useCallback)((...args)=>{
        var _a;
        return (_a = callbackRef.current) == null ? void 0 : _a.call(callbackRef, ...args);
    }, deps);
}


"use client";
function $3bc081da2876e6e9$export$7080b3e976bc91ab(target, event, handler, options) {
    const listener = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(handler);
    (0, $acw62.useEffect)(()=>{
        const node = typeof target === "function" ? target() : target != null ? target : document;
        if (!handler || !node) return;
        node.addEventListener(event, listener, options);
        return ()=>{
            node.removeEventListener(event, listener, options);
        };
    }, [
        event,
        target,
        options,
        listener,
        handler
    ]);
    return ()=>{
        const node = typeof target === "function" ? target() : target != null ? target : document;
        node == null || node.removeEventListener(event, listener, options);
    };
}



"use client";
function $ed3c43d27f5556ee$export$7ee548861327febe(props) {
    const { isOpen: isOpen, ref: ref } = props;
    const [mounted, setMounted] = (0, $acw62.useState)(isOpen);
    const [once, setOnce] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!once) {
            setMounted(isOpen);
            setOnce(true);
        }
    }, [
        isOpen,
        once,
        mounted
    ]);
    (0, $3bc081da2876e6e9$export$7080b3e976bc91ab)(()=>ref.current, "animationend", ()=>{
        setMounted(isOpen);
    });
    const hidden = isOpen ? false : !mounted;
    return {
        present: !hidden,
        onComplete () {
            var _a;
            const win = (0, $534108a0b0d3445d$export$f21a1ffae260145a)(ref.current);
            const evt = new win.CustomEvent("animationend", {
                bubbles: true
            });
            (_a = ref.current) == null || _a.dispatchEvent(evt);
        }
    };
}



"use client";
function $20cfd22d42f8a10a$var$isRefObject(val) {
    return "current" in val;
}
var $20cfd22d42f8a10a$var$isDom = ()=>typeof window !== "undefined";
function $20cfd22d42f8a10a$var$getPlatform() {
    var _a;
    const agent = navigator.userAgentData;
    return (_a = agent == null ? void 0 : agent.platform) != null ? _a : navigator.platform;
}
var $20cfd22d42f8a10a$var$vn = (v)=>$20cfd22d42f8a10a$var$isDom() && v.test(navigator.vendor);
var $20cfd22d42f8a10a$var$pt = (v)=>$20cfd22d42f8a10a$var$isDom() && v.test($20cfd22d42f8a10a$var$getPlatform());
var $20cfd22d42f8a10a$var$isApple = ()=>$20cfd22d42f8a10a$var$pt(/mac|iphone|ipad|ipod/i);
var $20cfd22d42f8a10a$var$isSafari = ()=>$20cfd22d42f8a10a$var$isApple() && $20cfd22d42f8a10a$var$vn(/apple/i);
function $20cfd22d42f8a10a$export$16a61b931588d888(props) {
    const { ref: ref, elements: elements, enabled: enabled } = props;
    const doc = ()=>{
        var _a, _b;
        return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) != null ? _b : document;
    };
    (0, $3bc081da2876e6e9$export$7080b3e976bc91ab)(doc, "pointerdown", (event)=>{
        if (!$20cfd22d42f8a10a$var$isSafari() || !enabled) return;
        const target = event.target;
        const els = elements != null ? elements : [
            ref
        ];
        const isValidTarget = els.some((elementOrRef)=>{
            const el = $20cfd22d42f8a10a$var$isRefObject(elementOrRef) ? elementOrRef.current : elementOrRef;
            return (el == null ? void 0 : el.contains(target)) || el === target;
        });
        if (doc().activeElement !== target && isValidTarget) {
            event.preventDefault();
            target.focus();
        }
    });
}






var $acw62 = parcelRequire("acw62");
"use client";
function $9af20caeda6fe4e1$export$496315a1608d9602(callback, deps) {
    const renderCycleRef = (0, $acw62.useRef)(false);
    const effectCycleRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const mounted = renderCycleRef.current;
        const run = mounted && effectCycleRef.current;
        if (run) return callback();
        effectCycleRef.current = true;
    }, deps);
    (0, $acw62.useEffect)(()=>{
        renderCycleRef.current = true;
        return ()=>{
            renderCycleRef.current = false;
        };
    }, []);
}



var $acw62 = parcelRequire("acw62");
"use client";
function $96ef6c3784d3cdb8$var$preventReturnFocus(containerRef) {
    const el = containerRef.current;
    if (!el) return false;
    const activeElement = (0, $534108a0b0d3445d$export$cd4e5573fbe2b576)(el);
    if (!activeElement) return false;
    if (el.contains(activeElement)) return false;
    if ((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d)(activeElement)) return true;
    return false;
}
function $96ef6c3784d3cdb8$export$68b323438c1fbb28(containerRef, options) {
    const { shouldFocus: shouldFocusProp, visible: visible, focusRef: focusRef } = options;
    const shouldFocus = shouldFocusProp && !visible;
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        if (!shouldFocus) return;
        if ($96ef6c3784d3cdb8$var$preventReturnFocus(containerRef)) return;
        const el = (focusRef == null ? void 0 : focusRef.current) || containerRef.current;
        let rafId;
        if (el) {
            rafId = requestAnimationFrame(()=>{
                el.focus({
                    preventScroll: true
                });
            });
            return ()=>{
                cancelAnimationFrame(rafId);
            };
        }
    }, [
        shouldFocus,
        containerRef,
        focusRef
    ]);
}
var $96ef6c3784d3cdb8$var$defaultOptions = {
    preventScroll: true,
    shouldFocus: false
};
function $96ef6c3784d3cdb8$export$54b5c2a5755195e7(target, options = $96ef6c3784d3cdb8$var$defaultOptions) {
    const { focusRef: focusRef, preventScroll: preventScroll, shouldFocus: shouldFocus, visible: visible } = options;
    const element = $96ef6c3784d3cdb8$var$isRefObject(target) ? target.current : target;
    const autoFocusValue = shouldFocus && visible;
    const autoFocusRef = (0, $acw62.useRef)(autoFocusValue);
    const lastVisibleRef = (0, $acw62.useRef)(visible);
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (!lastVisibleRef.current && visible) autoFocusRef.current = autoFocusValue;
        lastVisibleRef.current = visible;
    }, [
        visible,
        autoFocusValue
    ]);
    const onFocus = (0, $acw62.useCallback)(()=>{
        if (!visible || !element || !autoFocusRef.current) return;
        autoFocusRef.current = false;
        if (element.contains(document.activeElement)) return;
        if (focusRef == null ? void 0 : focusRef.current) requestAnimationFrame(()=>{
            var _a;
            (_a = focusRef.current) == null || _a.focus({
                preventScroll: preventScroll
            });
        });
        else {
            const tabbableEls = (0, $2858cbef67902129$export$4ae682d253b556eb)(element);
            if (tabbableEls.length > 0) requestAnimationFrame(()=>{
                tabbableEls[0].focus({
                    preventScroll: preventScroll
                });
            });
        }
    }, [
        visible,
        preventScroll,
        element,
        focusRef
    ]);
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        onFocus();
    }, [
        onFocus
    ]);
    (0, $3bc081da2876e6e9$export$7080b3e976bc91ab)(element, "transitionend", onFocus);
}
function $96ef6c3784d3cdb8$var$isRefObject(val) {
    return "current" in val;
}




var $acw62 = parcelRequire("acw62");
"use client";
function $7bea845a3dd58b1a$export$6e3e27031a30522f(props = {}) {
    const { onClose: onCloseProp, onOpen: onOpenProp, isOpen: isOpenProp, id: idProp } = props;
    const handleOpen = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onOpenProp);
    const handleClose = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onCloseProp);
    const [isOpenState, setIsOpen] = (0, $acw62.useState)(props.defaultIsOpen || false);
    const isOpen = isOpenProp !== void 0 ? isOpenProp : isOpenState;
    const isControlled = isOpenProp !== void 0;
    const uid = (0, $acw62.useId)();
    const id = idProp != null ? idProp : `disclosure-${uid}`;
    const onClose = (0, $acw62.useCallback)(()=>{
        if (!isControlled) setIsOpen(false);
        handleClose == null || handleClose();
    }, [
        isControlled,
        handleClose
    ]);
    const onOpen = (0, $acw62.useCallback)(()=>{
        if (!isControlled) setIsOpen(true);
        handleOpen == null || handleOpen();
    }, [
        isControlled,
        handleOpen
    ]);
    const onToggle = (0, $acw62.useCallback)(()=>{
        if (isOpen) onClose();
        else onOpen();
    }, [
        isOpen,
        onOpen,
        onClose
    ]);
    function getButtonProps(props2 = {}) {
        return {
            ...props2,
            "aria-expanded": isOpen,
            "aria-controls": id,
            onClick (event) {
                var _a;
                (_a = props2.onClick) == null || _a.call(props2, event);
                onToggle();
            }
        };
    }
    function getDisclosureProps(props2 = {}) {
        return {
            ...props2,
            hidden: !isOpen,
            id: id
        };
    }
    return {
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: onClose,
        onToggle: onToggle,
        isControlled: isControlled,
        getButtonProps: getButtonProps,
        getDisclosureProps: getDisclosureProps
    };
}


"use client";
// src/utils.ts
var $49cad064bf4d553f$var$toVar = (value, fallback)=>({
        var: value,
        varRef: fallback ? `var(${value}, ${fallback})` : `var(${value})`
    });
var $49cad064bf4d553f$export$fd62969fb0b7081c = {
    arrowShadowColor: $49cad064bf4d553f$var$toVar("--popper-arrow-shadow-color"),
    arrowSize: $49cad064bf4d553f$var$toVar("--popper-arrow-size", "8px"),
    arrowSizeHalf: $49cad064bf4d553f$var$toVar("--popper-arrow-size-half"),
    arrowBg: $49cad064bf4d553f$var$toVar("--popper-arrow-bg"),
    transformOrigin: $49cad064bf4d553f$var$toVar("--popper-transform-origin"),
    arrowOffset: $49cad064bf4d553f$var$toVar("--popper-arrow-offset")
};
function $49cad064bf4d553f$export$bba5a971afe05444(placement) {
    if (placement.includes("top")) return `1px 1px 0px 0 var(--popper-arrow-shadow-color)`;
    if (placement.includes("bottom")) return `-1px -1px 0px 0 var(--popper-arrow-shadow-color)`;
    if (placement.includes("right")) return `-1px 1px 0px 0 var(--popper-arrow-shadow-color)`;
    if (placement.includes("left")) return `1px -1px 0px 0 var(--popper-arrow-shadow-color)`;
}
var $49cad064bf4d553f$var$transforms = {
    top: "bottom center",
    "top-start": "bottom left",
    "top-end": "bottom right",
    bottom: "top center",
    "bottom-start": "top left",
    "bottom-end": "top right",
    left: "right center",
    "left-start": "right top",
    "left-end": "right bottom",
    right: "left center",
    "right-start": "left top",
    "right-end": "left bottom"
};
var $49cad064bf4d553f$export$4b94194e48e4ec29 = (placement)=>$49cad064bf4d553f$var$transforms[placement];
var $49cad064bf4d553f$var$defaultEventListeners = {
    scroll: true,
    resize: true
};
function $49cad064bf4d553f$export$fafd30a196ad8838(value) {
    let eventListeners;
    if (typeof value === "object") eventListeners = {
        enabled: true,
        options: {
            ...$49cad064bf4d553f$var$defaultEventListeners,
            ...value
        }
    };
    else eventListeners = {
        enabled: value,
        options: $49cad064bf4d553f$var$defaultEventListeners
    };
    return eventListeners;
}


"use client";
// src/modifiers.ts
var $5a0cdca50d778174$export$45d38cc6268103c7 = {
    name: "matchWidth",
    enabled: true,
    phase: "beforeWrite",
    requires: [
        "computeStyles"
    ],
    fn: ({ state: state })=>{
        state.styles.popper.width = `${state.rects.reference.width}px`;
    },
    effect: ({ state: state })=>()=>{
            const reference = state.elements.reference;
            state.elements.popper.style.width = `${reference.offsetWidth}px`;
        }
};
var $5a0cdca50d778174$export$bd7bb1bc943e0611 = {
    name: "transformOrigin",
    enabled: true,
    phase: "write",
    fn: ({ state: state })=>{
        $5a0cdca50d778174$var$setTransformOrigin(state);
    },
    effect: ({ state: state })=>()=>{
            $5a0cdca50d778174$var$setTransformOrigin(state);
        }
};
var $5a0cdca50d778174$var$setTransformOrigin = (state)=>{
    state.elements.popper.style.setProperty((0, $49cad064bf4d553f$export$fd62969fb0b7081c).transformOrigin.var, (0, $49cad064bf4d553f$export$4b94194e48e4ec29)(state.placement));
};
var $5a0cdca50d778174$export$36f2614d91c73bb6 = {
    name: "positionArrow",
    enabled: true,
    phase: "afterWrite",
    fn: ({ state: state })=>{
        $5a0cdca50d778174$var$setArrowStyles(state);
    }
};
var $5a0cdca50d778174$var$setArrowStyles = (state)=>{
    var _a;
    if (!state.placement) return;
    const overrides = $5a0cdca50d778174$var$getArrowStyle(state.placement);
    if (((_a = state.elements) == null ? void 0 : _a.arrow) && overrides) {
        Object.assign(state.elements.arrow.style, {
            [overrides.property]: overrides.value,
            width: (0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowSize.varRef,
            height: (0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowSize.varRef,
            zIndex: -1
        });
        const vars = {
            [(0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowSizeHalf.var]: `calc(${(0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowSize.varRef} / 2 - 1px)`,
            [(0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowOffset.var]: `calc(${(0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowSizeHalf.varRef} * -1)`
        };
        for(const property in vars)state.elements.arrow.style.setProperty(property, vars[property]);
    }
};
var $5a0cdca50d778174$var$getArrowStyle = (placement)=>{
    if (placement.startsWith("top")) return {
        property: "bottom",
        value: (0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowOffset.varRef
    };
    if (placement.startsWith("bottom")) return {
        property: "top",
        value: (0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowOffset.varRef
    };
    if (placement.startsWith("left")) return {
        property: "right",
        value: (0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowOffset.varRef
    };
    if (placement.startsWith("right")) return {
        property: "left",
        value: (0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowOffset.varRef
    };
};
var $5a0cdca50d778174$export$616f7fc4ffce8510 = {
    name: "innerArrow",
    enabled: true,
    phase: "main",
    requires: [
        "arrow"
    ],
    fn: ({ state: state })=>{
        $5a0cdca50d778174$var$setInnerArrowStyles(state);
    },
    effect: ({ state: state })=>()=>{
            $5a0cdca50d778174$var$setInnerArrowStyles(state);
        }
};
var $5a0cdca50d778174$var$setInnerArrowStyles = (state)=>{
    if (!state.elements.arrow) return;
    const inner = state.elements.arrow.querySelector("[data-popper-arrow-inner]");
    if (!inner) return;
    const boxShadow = (0, $49cad064bf4d553f$export$bba5a971afe05444)(state.placement);
    if (boxShadow) inner.style.setProperty("--popper-arrow-default-shadow", boxShadow);
    Object.assign(inner.style, {
        transform: "rotate(45deg)",
        background: (0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowBg.varRef,
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        position: "absolute",
        zIndex: "inherit",
        boxShadow: `var(--popper-arrow-shadow, var(--popper-arrow-default-shadow))`
    });
};


"use client";
// src/popper.placement.ts
var $0e4d0230e74cb517$var$logicals = {
    "start-start": {
        ltr: "left-start",
        rtl: "right-start"
    },
    "start-end": {
        ltr: "left-end",
        rtl: "right-end"
    },
    "end-start": {
        ltr: "right-start",
        rtl: "left-start"
    },
    "end-end": {
        ltr: "right-end",
        rtl: "left-end"
    },
    start: {
        ltr: "left",
        rtl: "right"
    },
    end: {
        ltr: "right",
        rtl: "left"
    }
};
var $0e4d0230e74cb517$var$opposites = {
    "auto-start": "auto-end",
    "auto-end": "auto-start",
    "top-start": "top-end",
    "top-end": "top-start",
    "bottom-start": "bottom-end",
    "bottom-end": "bottom-start"
};
function $0e4d0230e74cb517$export$833b022d5a236f09(placement, dir = "ltr") {
    var _a, _b;
    const value = ((_a = $0e4d0230e74cb517$var$logicals[placement]) == null ? void 0 : _a[dir]) || placement;
    if (dir === "ltr") return value;
    return (_b = $0e4d0230e74cb517$var$opposites[placement]) != null ? _b : value;
}




function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}


function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}







function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


var $1472b89a65155de2$export$1e95b668f3b82d = "top";
var $1472b89a65155de2$export$40e543e69a8b3fbb = "bottom";
var $1472b89a65155de2$export$79ffe56a765070d2 = "right";
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = "left";
var $1472b89a65155de2$export$dfb5619354ba860 = "auto";
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = "start";
var $1472b89a65155de2$export$bd5df0f255a350f8 = "end";
var $1472b89a65155de2$export$390fd549c5303b4d = "clippingParents";
var $1472b89a65155de2$export$d7b7311ec04a3e8f = "viewport";
var $1472b89a65155de2$export$ae5ab1c730825774 = "popper";
var $1472b89a65155de2$export$ca50aac9f3ba507f = "reference";
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = "beforeRead";
var $1472b89a65155de2$export$aafa59e2e03f2942 = "read";
var $1472b89a65155de2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = "beforeMain";
var $1472b89a65155de2$export$f22da7240b7add18 = "main";
var $1472b89a65155de2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = "beforeWrite";
var $1472b89a65155de2$export$68d8715fc104d294 = "write";
var $1472b89a65155de2$export$70a6e5159acce2e6 = "afterWrite";
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};










var $45d468ca92a1d24b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ff9a9783c10adebd$var$offset
};


var $aaefa8315f14c8e2$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: "end",
    end: "start"
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}







function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $69d8d7bda7717b01$var$hide
};




var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules



var $acw62 = parcelRequire("acw62");
"use client";
function $5f2d029a715100c2$export$f4d5bf230a36dd6e(props = {}) {
    const { enabled: enabled = true, modifiers: modifiers, placement: placementProp = "bottom", strategy: strategy = "absolute", arrowPadding: arrowPadding = 8, eventListeners: eventListeners = true, offset: offset, gutter: gutter = 8, flip: flip = true, boundary: boundary = "clippingParents", preventOverflow: preventOverflow = true, matchWidth: matchWidth2, direction: direction = "ltr" } = props;
    const reference = (0, $acw62.useRef)(null);
    const popper = (0, $acw62.useRef)(null);
    const instance = (0, $acw62.useRef)(null);
    const placement = (0, $0e4d0230e74cb517$export$833b022d5a236f09)(placementProp, direction);
    const cleanup = (0, $acw62.useRef)(()=>{});
    const setupPopper = (0, $acw62.useCallback)(()=>{
        var _a;
        if (!enabled || !reference.current || !popper.current) return;
        (_a = cleanup.current) == null || _a.call(cleanup);
        instance.current = (0, $288fbeb449f53487$export$8f7491d57c8f97a9)(reference.current, popper.current, {
            placement: placement,
            modifiers: [
                (0, $5a0cdca50d778174$export$616f7fc4ffce8510),
                (0, $5a0cdca50d778174$export$36f2614d91c73bb6),
                (0, $5a0cdca50d778174$export$bd7bb1bc943e0611),
                {
                    ...(0, $5a0cdca50d778174$export$45d38cc6268103c7),
                    enabled: !!matchWidth2
                },
                {
                    name: "eventListeners",
                    ...(0, $49cad064bf4d553f$export$fafd30a196ad8838)(eventListeners)
                },
                {
                    name: "arrow",
                    options: {
                        padding: arrowPadding
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: offset != null ? offset : [
                            0,
                            gutter
                        ]
                    }
                },
                {
                    name: "flip",
                    enabled: !!flip,
                    options: {
                        padding: 8
                    }
                },
                {
                    name: "preventOverflow",
                    enabled: !!preventOverflow,
                    options: {
                        boundary: boundary
                    }
                },
                // allow users override internal modifiers
                ...modifiers != null ? modifiers : []
            ],
            strategy: strategy
        });
        instance.current.forceUpdate();
        cleanup.current = instance.current.destroy;
    }, [
        placement,
        enabled,
        modifiers,
        matchWidth2,
        eventListeners,
        arrowPadding,
        offset,
        gutter,
        flip,
        preventOverflow,
        boundary,
        strategy
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            var _a;
            if (!reference.current && !popper.current) {
                (_a = instance.current) == null || _a.destroy();
                instance.current = null;
            }
        };
    }, []);
    const referenceRef = (0, $acw62.useCallback)((node)=>{
        reference.current = node;
        setupPopper();
    }, [
        setupPopper
    ]);
    const getReferenceProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(referenceRef, ref)
        }), [
        referenceRef
    ]);
    const popperRef = (0, $acw62.useCallback)((node)=>{
        popper.current = node;
        setupPopper();
    }, [
        setupPopper
    ]);
    const getPopperProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(popperRef, ref),
            style: {
                ...props2.style,
                position: strategy,
                minWidth: matchWidth2 ? void 0 : "max-content",
                inset: "0 auto auto 0"
            }
        }), [
        strategy,
        popperRef,
        matchWidth2
    ]);
    const getArrowProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>{
        const { size: size, shadowColor: shadowColor, bg: bg, style: style, ...rest } = props2;
        return {
            ...rest,
            ref: ref,
            "data-popper-arrow": "",
            style: $5f2d029a715100c2$var$getArrowStyle(props2)
        };
    }, []);
    const getArrowInnerProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: ref,
            "data-popper-arrow-inner": ""
        }), []);
    return {
        update () {
            var _a;
            (_a = instance.current) == null || _a.update();
        },
        forceUpdate () {
            var _a;
            (_a = instance.current) == null || _a.forceUpdate();
        },
        transformOrigin: (0, $49cad064bf4d553f$export$fd62969fb0b7081c).transformOrigin.varRef,
        referenceRef: referenceRef,
        popperRef: popperRef,
        getPopperProps: getPopperProps,
        getArrowProps: getArrowProps,
        getArrowInnerProps: getArrowInnerProps,
        getReferenceProps: getReferenceProps
    };
}
function $5f2d029a715100c2$var$getArrowStyle(props) {
    const { size: size, shadowColor: shadowColor, bg: bg, style: style } = props;
    const computedStyle = {
        ...style,
        position: "absolute"
    };
    if (size) computedStyle["--popper-arrow-size"] = size;
    if (shadowColor) computedStyle["--popper-arrow-shadow-color"] = shadowColor;
    if (bg) computedStyle["--popper-arrow-bg"] = bg;
    return computedStyle;
}




// src/index.ts
function $d3159b9260b16e67$export$76655e7dd9ffc0ba(options) {
    const { wasSelected: wasSelected, enabled: enabled, isSelected: isSelected, mode: mode = "unmount" } = options;
    if (!enabled) return true;
    if (isSelected) return true;
    if (mode === "keepMounted" && wasSelected) return true;
    return false;
}



var $acw62 = parcelRequire("acw62");
"use client";
var $f5ca8043f5717fad$var$TRIGGER = {
    click: "click",
    hover: "hover"
};
function $f5ca8043f5717fad$export$542a6fd13ac93354(props = {}) {
    const { closeOnBlur: closeOnBlur = true, closeOnEsc: closeOnEsc = true, initialFocusRef: initialFocusRef, id: id, returnFocusOnClose: returnFocusOnClose = true, autoFocus: autoFocus = true, arrowSize: arrowSize, arrowShadowColor: arrowShadowColor, trigger: trigger = $f5ca8043f5717fad$var$TRIGGER.click, openDelay: openDelay = 200, closeDelay: closeDelay = 200, isLazy: isLazy, lazyBehavior: lazyBehavior = "unmount", computePositionOnMount: computePositionOnMount, ...popperProps } = props;
    const { isOpen: isOpen, onClose: onClose, onOpen: onOpen, onToggle: onToggle } = (0, $7bea845a3dd58b1a$export$6e3e27031a30522f)(props);
    const anchorRef = (0, $acw62.useRef)(null);
    const triggerRef = (0, $acw62.useRef)(null);
    const popoverRef = (0, $acw62.useRef)(null);
    const isHoveringRef = (0, $acw62.useRef)(false);
    const hasBeenOpened = (0, $acw62.useRef)(false);
    if (isOpen) hasBeenOpened.current = true;
    const [hasHeader, setHasHeader] = (0, $acw62.useState)(false);
    const [hasBody, setHasBody] = (0, $acw62.useState)(false);
    const uuid = (0, $acw62.useId)();
    const uid = id != null ? id : uuid;
    const [triggerId, popoverId, headerId, bodyId] = [
        "popover-trigger",
        "popover-content",
        "popover-header",
        "popover-body"
    ].map((id2)=>`${id2}-${uid}`);
    const { referenceRef: referenceRef, getArrowProps: getArrowProps, getPopperProps: getPopperProps, getArrowInnerProps: getArrowInnerProps, forceUpdate: forceUpdate } = (0, $5f2d029a715100c2$export$f4d5bf230a36dd6e)({
        ...popperProps,
        enabled: isOpen || !!computePositionOnMount
    });
    const animated = (0, $ed3c43d27f5556ee$export$7ee548861327febe)({
        isOpen: isOpen,
        ref: popoverRef
    });
    (0, $20cfd22d42f8a10a$export$16a61b931588d888)({
        enabled: isOpen,
        ref: triggerRef
    });
    (0, $96ef6c3784d3cdb8$export$68b323438c1fbb28)(popoverRef, {
        focusRef: triggerRef,
        visible: isOpen,
        shouldFocus: returnFocusOnClose && trigger === $f5ca8043f5717fad$var$TRIGGER.click
    });
    (0, $96ef6c3784d3cdb8$export$54b5c2a5755195e7)(popoverRef, {
        focusRef: initialFocusRef,
        visible: isOpen,
        shouldFocus: autoFocus && trigger === $f5ca8043f5717fad$var$TRIGGER.click
    });
    const shouldRenderChildren = (0, $d3159b9260b16e67$export$76655e7dd9ffc0ba)({
        wasSelected: hasBeenOpened.current,
        enabled: isLazy,
        mode: lazyBehavior,
        isSelected: animated.present
    });
    const getPopoverProps = (0, $acw62.useCallback)((props2 = {}, _ref = null)=>{
        const popoverProps = {
            ...props2,
            style: {
                ...props2.style,
                transformOrigin: (0, $49cad064bf4d553f$export$fd62969fb0b7081c).transformOrigin.varRef,
                [(0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowSize.var]: arrowSize ? `${arrowSize}px` : void 0,
                [(0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowShadowColor.var]: arrowShadowColor
            },
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(popoverRef, _ref),
            children: shouldRenderChildren ? props2.children : null,
            id: popoverId,
            tabIndex: -1,
            role: "dialog",
            onKeyDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onKeyDown, (event)=>{
                if (closeOnEsc && event.key === "Escape") onClose();
            }),
            onBlur: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onBlur, (event)=>{
                const relatedTarget = $f5ca8043f5717fad$var$getRelatedTarget(event);
                const targetIsPopover = $f5ca8043f5717fad$var$contains(popoverRef.current, relatedTarget);
                const targetIsTrigger = $f5ca8043f5717fad$var$contains(triggerRef.current, relatedTarget);
                const isValidBlur = !targetIsPopover && !targetIsTrigger;
                if (isOpen && closeOnBlur && isValidBlur) onClose();
            }),
            "aria-labelledby": hasHeader ? headerId : void 0,
            "aria-describedby": hasBody ? bodyId : void 0
        };
        if (trigger === $f5ca8043f5717fad$var$TRIGGER.hover) {
            popoverProps.role = "tooltip";
            popoverProps.onMouseEnter = (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseEnter, ()=>{
                isHoveringRef.current = true;
            });
            popoverProps.onMouseLeave = (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseLeave, (event)=>{
                if (event.nativeEvent.relatedTarget === null) return;
                isHoveringRef.current = false;
                setTimeout(()=>onClose(), closeDelay);
            });
        }
        return popoverProps;
    }, [
        shouldRenderChildren,
        popoverId,
        hasHeader,
        headerId,
        hasBody,
        bodyId,
        trigger,
        closeOnEsc,
        onClose,
        isOpen,
        closeOnBlur,
        closeDelay,
        arrowShadowColor,
        arrowSize
    ]);
    const getPopoverPositionerProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>getPopperProps({
            ...props2,
            style: {
                visibility: isOpen ? "visible" : "hidden",
                ...props2.style
            }
        }, forwardedRef), [
        isOpen,
        getPopperProps
    ]);
    const getAnchorProps = (0, $acw62.useCallback)((props2, _ref = null)=>{
        return {
            ...props2,
            // If anchor is rendered, it is used as reference.
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(_ref, anchorRef, referenceRef)
        };
    }, [
        anchorRef,
        referenceRef
    ]);
    const openTimeout = (0, $acw62.useRef)();
    const closeTimeout = (0, $acw62.useRef)();
    const maybeReferenceRef = (0, $acw62.useCallback)((node)=>{
        if (anchorRef.current == null) referenceRef(node);
    }, [
        referenceRef
    ]);
    const getTriggerProps = (0, $acw62.useCallback)((props2 = {}, _ref = null)=>{
        const triggerProps = {
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(triggerRef, _ref, maybeReferenceRef),
            id: triggerId,
            "aria-haspopup": "dialog",
            "aria-expanded": isOpen,
            "aria-controls": popoverId
        };
        if (trigger === $f5ca8043f5717fad$var$TRIGGER.click) triggerProps.onClick = (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onClick, onToggle);
        if (trigger === $f5ca8043f5717fad$var$TRIGGER.hover) {
            triggerProps.onFocus = (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onFocus, ()=>{
                if (openTimeout.current === void 0) onOpen();
            });
            triggerProps.onBlur = (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onBlur, (event)=>{
                const relatedTarget = $f5ca8043f5717fad$var$getRelatedTarget(event);
                const isValidBlur = !$f5ca8043f5717fad$var$contains(popoverRef.current, relatedTarget);
                if (isOpen && closeOnBlur && isValidBlur) onClose();
            });
            triggerProps.onKeyDown = (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onKeyDown, (event)=>{
                if (event.key === "Escape") onClose();
            });
            triggerProps.onMouseEnter = (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseEnter, ()=>{
                isHoveringRef.current = true;
                openTimeout.current = window.setTimeout(()=>onOpen(), openDelay);
            });
            triggerProps.onMouseLeave = (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseLeave, ()=>{
                isHoveringRef.current = false;
                if (openTimeout.current) {
                    clearTimeout(openTimeout.current);
                    openTimeout.current = void 0;
                }
                closeTimeout.current = window.setTimeout(()=>{
                    if (isHoveringRef.current === false) onClose();
                }, closeDelay);
            });
        }
        return triggerProps;
    }, [
        triggerId,
        isOpen,
        popoverId,
        trigger,
        maybeReferenceRef,
        onToggle,
        onOpen,
        closeOnBlur,
        onClose,
        openDelay,
        closeDelay
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (openTimeout.current) clearTimeout(openTimeout.current);
            if (closeTimeout.current) clearTimeout(closeTimeout.current);
        };
    }, []);
    const getHeaderProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            id: headerId,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(ref, (node)=>{
                setHasHeader(!!node);
            })
        }), [
        headerId
    ]);
    const getBodyProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            id: bodyId,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(ref, (node)=>{
                setHasBody(!!node);
            })
        }), [
        bodyId
    ]);
    return {
        forceUpdate: forceUpdate,
        isOpen: isOpen,
        onAnimationComplete: animated.onComplete,
        onClose: onClose,
        getAnchorProps: getAnchorProps,
        getArrowProps: getArrowProps,
        getArrowInnerProps: getArrowInnerProps,
        getPopoverPositionerProps: getPopoverPositionerProps,
        getPopoverProps: getPopoverProps,
        getTriggerProps: getTriggerProps,
        getHeaderProps: getHeaderProps,
        getBodyProps: getBodyProps
    };
}
function $f5ca8043f5717fad$var$contains(parent, child) {
    return parent === child || (parent == null ? void 0 : parent.contains(child));
}
function $f5ca8043f5717fad$var$getRelatedTarget(event) {
    var _a;
    const activeEl = event.currentTarget.ownerDocument.activeElement;
    return (_a = event.relatedTarget) != null ? _a : activeEl;
}



"use client";
var [$46856c160bb91641$export$bf694c7c431c162a, $46856c160bb91641$export$1468d0761b26e6c8] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: "PopoverContext",
    errorMessage: "usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`"
});
var [$46856c160bb91641$export$286407fa0c94e3f1, $46856c160bb91641$export$bdabad59d033c81a] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `PopoverStylesContext`,
    errorMessage: `usePopoverStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Popover />" `
});





"use client";
function $ed010ac8b557d13a$export$5b6b19405a83ff9d(props) {
    const styles = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Popover", props);
    const { children: children, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const theme = (0, $5f6bf330f809db0e$export$93d4e7f90805808f)();
    const context = (0, $f5ca8043f5717fad$export$542a6fd13ac93354)({
        ...rest,
        direction: theme.direction
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $46856c160bb91641$export$bf694c7c431c162a), {
        value: context,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $46856c160bb91641$export$286407fa0c94e3f1), {
            value: styles,
            children: (0, $abe97432afb3d989$export$624e501d81f5ffce)(children, {
                isOpen: context.isOpen,
                onClose: context.onClose,
                forceUpdate: context.forceUpdate
            })
        })
    });
}
$ed010ac8b557d13a$export$5b6b19405a83ff9d.displayName = "Popover";





"use client";
function $a6959cf2d82538e7$var$mergeVariants(variants) {
    if (!variants) return;
    return {
        enter: {
            ...variants.enter,
            visibility: "visible"
        },
        exit: {
            ...variants.exit,
            transitionEnd: {
                visibility: "hidden"
            }
        }
    };
}
var $a6959cf2d82538e7$var$scaleFade = {
    exit: {
        opacity: 0,
        scale: 0.95,
        transition: {
            duration: 0.1,
            ease: [
                0.4,
                0,
                1,
                1
            ]
        }
    },
    enter: {
        scale: 1,
        opacity: 1,
        transition: {
            duration: 0.15,
            ease: [
                0,
                0,
                0.2,
                1
            ]
        }
    }
};
var $a6959cf2d82538e7$var$MotionSection = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $a93b6401f922fd1e$export$e25e478948902b8b).section);
var $a6959cf2d82538e7$export$295130c75b678e2c = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function PopoverTransition2(props, ref) {
    const { variants: variants = $a6959cf2d82538e7$var$scaleFade, ...rest } = props;
    const { isOpen: isOpen } = (0, $46856c160bb91641$export$1468d0761b26e6c8)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a6959cf2d82538e7$var$MotionSection, {
        ref: ref,
        variants: $a6959cf2d82538e7$var$mergeVariants(variants),
        initial: false,
        animate: isOpen ? "enter" : "exit",
        ...rest
    });
});
$a6959cf2d82538e7$export$295130c75b678e2c.displayName = "PopoverTransition";






"use client";
var $eb164341cd6ef22b$export$d7e1f420b25549ff = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function PopoverContent2(props, ref) {
    const { rootProps: rootProps, motionProps: motionProps, ...contentProps } = props;
    const { getPopoverProps: getPopoverProps, getPopoverPositionerProps: getPopoverPositionerProps, onAnimationComplete: onAnimationComplete } = (0, $46856c160bb91641$export$1468d0761b26e6c8)();
    const styles = (0, $46856c160bb91641$export$bdabad59d033c81a)();
    const contentStyles = {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        ...styles.content
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ...getPopoverPositionerProps(rootProps),
        __css: styles.popper,
        className: "chakra-popover__popper",
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a6959cf2d82538e7$export$295130c75b678e2c), {
            ...motionProps,
            ...getPopoverProps(contentProps, ref),
            onAnimationComplete: (0, $abe97432afb3d989$export$9dd9a52f2dd5b9ce)(onAnimationComplete, contentProps.onAnimationComplete),
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-popover__content", props.className),
            __css: contentStyles
        })
    });
});
$eb164341cd6ef22b$export$d7e1f420b25549ff.displayName = "PopoverContent";



var $acw62 = parcelRequire("acw62");
"use client";
function $b5a21e3a933f1aae$export$7dacb05d26466c3(props) {
    const child = (0, $acw62.Children).only(props.children);
    const { getTriggerProps: getTriggerProps } = (0, $46856c160bb91641$export$1468d0761b26e6c8)();
    return (0, $acw62.cloneElement)(child, getTriggerProps(child.props, child.ref));
}
$b5a21e3a933f1aae$export$7dacb05d26466c3.displayName = "PopoverTrigger";



"use client";
var $1e675b0524633ecf$export$50d5391cd1a018c6 = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        className: "chakra-stack__item",
        ...props,
        __css: {
            display: "inline-block",
            flex: "0 0 auto",
            minWidth: 0,
            ...props["__css"]
        }
    });
$1e675b0524633ecf$export$50d5391cd1a018c6.displayName = "StackItem";



"use client";
function $89adde6ec4368b45$export$d4a6a5cc582519a5(options) {
    const { spacing: spacing, direction: direction } = options;
    const dividerStyles = {
        column: {
            my: spacing,
            mx: 0,
            borderLeftWidth: 0,
            borderBottomWidth: "1px"
        },
        "column-reverse": {
            my: spacing,
            mx: 0,
            borderLeftWidth: 0,
            borderBottomWidth: "1px"
        },
        row: {
            mx: spacing,
            my: 0,
            borderLeftWidth: "1px",
            borderBottomWidth: 0
        },
        "row-reverse": {
            mx: spacing,
            my: 0,
            borderLeftWidth: "1px",
            borderBottomWidth: 0
        }
    };
    return {
        "&": (0, $37c1adb04c994149$export$eca1915781c2aaca)(direction, (value)=>dividerStyles[value])
    };
}


// src/index.ts

var $acw62 = parcelRequire("acw62");
function $197fffec5094e9ee$export$b2c43d7d050b2e63(children) {
    return (0, $acw62.Children).toArray(children).filter((child)=>(0, $acw62.isValidElement)(child));
}





var $acw62 = parcelRequire("acw62");

"use client";
var $ec37ab1d016e4ce2$export$694e0d28c7ffc90c = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { isInline: isInline, direction: directionProp, align: align, justify: justify, spacing: spacing = "0.5rem", wrap: wrap, children: children, divider: divider, className: className, shouldWrapChildren: shouldWrapChildren, ...rest } = props;
    const direction = isInline ? "row" : directionProp != null ? directionProp : "column";
    const dividerStyle = (0, $acw62.useMemo)(()=>(0, $89adde6ec4368b45$export$d4a6a5cc582519a5)({
            spacing: spacing,
            direction: direction
        }), [
        spacing,
        direction
    ]);
    const hasDivider = !!divider;
    const shouldUseChildren = !shouldWrapChildren && !hasDivider;
    const clones = (0, $acw62.useMemo)(()=>{
        const validChildren = (0, $197fffec5094e9ee$export$b2c43d7d050b2e63)(children);
        return shouldUseChildren ? validChildren : validChildren.map((child, index)=>{
            const key = typeof child.key !== "undefined" ? child.key : index;
            const isLast = index + 1 === validChildren.length;
            const wrappedChild = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $1e675b0524633ecf$export$50d5391cd1a018c6), {
                children: child
            }, key);
            const _child = shouldWrapChildren ? wrappedChild : child;
            if (!hasDivider) return _child;
            const clonedDivider = (0, $acw62.cloneElement)(divider, {
                __css: dividerStyle
            });
            const _divider = isLast ? null : clonedDivider;
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                children: [
                    _child,
                    _divider
                ]
            }, key);
        });
    }, [
        divider,
        dividerStyle,
        hasDivider,
        shouldUseChildren,
        shouldWrapChildren,
        children
    ]);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-stack", className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ref: ref,
        display: "flex",
        alignItems: align,
        justifyContent: justify,
        flexDirection: direction,
        flexWrap: wrap,
        gap: hasDivider ? void 0 : spacing,
        className: _className,
        ...rest,
        children: clones
    });
});
$ec37ab1d016e4ce2$export$694e0d28c7ffc90c.displayName = "Stack";



"use client";
var $cdefbc9a0543e2f2$export$4857d3f3f5f8319b = (0, $57ab4518d7256dec$export$274edc73af1ae9c8)({
    displayName: "ChevronDownIcon",
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
});


"use client";
var $eae42415035b7b00$export$b837bd7eac09a33e = (0, $57ab4518d7256dec$export$274edc73af1ae9c8)({
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z",
    displayName: "ChevronRightIcon"
});


const $dcabb0f3ce30a5ad$export$d42503afcc3a9b06 = [
    {
        label: "Men",
        children: [
            {
                label: "Jeans",
                href: "/men/jeans"
            },
            {
                label: "Shirt",
                href: "/men/shirt"
            }
        ]
    },
    {
        label: "Women",
        children: [
            {
                label: "Top",
                href: "/women/top"
            },
            {
                label: "Jeans",
                href: "/women/jeans"
            }
        ]
    },
    {
        label: "New Arrival",
        href: "/new-arrival"
    },
    {
        label: "Top Selling",
        href: "/top-selling"
    }
];



const $ae19d542a7c5ce03$export$a0180b468ac3302f = ()=>{
    const linkColor = (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("gray.600", "gray.200");
    const linkHoverColor = (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("gray.800", "white");
    const popoverContentBgColor = (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("white", "gray.800");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec37ab1d016e4ce2$export$694e0d28c7ffc90c), {
        direction: "row",
        spacing: 4,
        children: (0, $dcabb0f3ce30a5ad$export$d42503afcc3a9b06).map((navItem)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed010ac8b557d13a$export$5b6b19405a83ff9d), {
                    trigger: "hover",
                    placement: "bottom-start",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5a21e3a933f1aae$export$7dacb05d26466c3), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: navItem.href,
                                children: navItem.label
                            })
                        }),
                        navItem.children && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb164341cd6ef22b$export$d7e1f420b25549ff), {
                            border: 0,
                            boxShadow: "xl",
                            bg: popoverContentBgColor,
                            p: 4,
                            rounded: "xl",
                            minW: "sm",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec37ab1d016e4ce2$export$694e0d28c7ffc90c), {
                                children: navItem.children.map((child)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ae19d542a7c5ce03$var$DesktopSubNav, {
                                        ...child
                                    }, child.label))
                            })
                        })
                    ]
                })
            }, navItem.label))
    });
};
const $ae19d542a7c5ce03$var$DesktopSubNav = ({ label: label, href: href })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
        to: href,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
            role: "group",
            display: "block",
            p: 2,
            rounded: "md",
            _hover: {
                bg: (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("pink.50", "gray.900")
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ec37ab1d016e4ce2$export$694e0d28c7ffc90c), {
                direction: "row",
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a2900ce3f78a504$export$5f1af8db9871e1d6), {
                            transition: "all .3s ease",
                            _groupHover: {
                                color: "pink.400"
                            },
                            fontWeight: 500,
                            children: label
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2231dd843a1dfd59$export$f51f4c4ede09e011), {
                        transition: "all .3s ease",
                        transform: "translateX(-10px)",
                        opacity: 0,
                        _groupHover: {
                            opacity: "100%",
                            transform: "translateX(0)"
                        },
                        justify: "flex-end",
                        align: "center",
                        flex: 1,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a96cde036d65913$export$f04a61298a47a40f), {
                            color: "pink.400",
                            w: 5,
                            h: 5,
                            as: (0, $eae42415035b7b00$export$b837bd7eac09a33e)
                        })
                    })
                ]
            })
        })
    });
};
const $ae19d542a7c5ce03$export$3a923eed7dfec49a = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec37ab1d016e4ce2$export$694e0d28c7ffc90c), {
        bg: (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("white", "gray.800"),
        p: 4,
        display: {
            md: "none"
        },
        children: (0, $dcabb0f3ce30a5ad$export$d42503afcc3a9b06).map((navItem)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ae19d542a7c5ce03$var$MobileNavItem, {
                ...navItem
            }, navItem.label))
    });
};
const $ae19d542a7c5ce03$var$MobileNavItem = ({ label: label, children: children, href: href })=>{
    const { isOpen: isOpen, onToggle: onToggle } = (0, $8b7bde38f2a271a2$export$6e3e27031a30522f)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ec37ab1d016e4ce2$export$694e0d28c7ffc90c), {
        spacing: 4,
        onClick: children && onToggle,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                py: 2,
                as: "a",
                href: href ?? "#",
                justifyContent: "space-between",
                alignItems: "center",
                _hover: {
                    textDecoration: "none"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a2900ce3f78a504$export$5f1af8db9871e1d6), {
                        fontWeight: 600,
                        color: (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("gray.600", "gray.200"),
                        children: label
                    }),
                    children && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a96cde036d65913$export$f04a61298a47a40f), {
                        as: (0, $cdefbc9a0543e2f2$export$4857d3f3f5f8319b),
                        transition: "all .25s ease-in-out",
                        transform: isOpen ? "rotate(180deg)" : "",
                        w: 6,
                        h: 6
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb476d4702afcfc2$export$78768a9af065a7b), {
                in: isOpen,
                animateOpacity: true,
                style: {
                    marginTop: "0!important"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec37ab1d016e4ce2$export$694e0d28c7ffc90c), {
                    mt: 2,
                    pl: 4,
                    borderLeft: 1,
                    borderStyle: "solid",
                    borderColor: (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("gray.200", "gray.700"),
                    align: "start",
                    children: children && children.map((child)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                            as: "a",
                            py: 2,
                            href: child.href,
                            children: child.label
                        }, child.label))
                })
            })
        ]
    });
};


const $ff199c4243e12e71$var$Navbar = (props)=>{
    const [isLogin, setIsLogin] = (0, $acw62.useState)(true);
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose } = (0, $8b7bde38f2a271a2$export$6e3e27031a30522f)();
    const btnRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                className: "bg-[#1E212C] px-3 py-2",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "container text-white flex justify-between flex-col md:flex-row",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-sm font-medium tracking-wider text-slate-300",
                            children: [
                                "Available 24/7 at",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "font-semibold",
                                    children: "(405) 555-0128"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col md:flex-row  md:gap-5 text-sm font-medium tracking-wider text-slate-300",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "Delivery & returns"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "Track order"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "Blog"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "Contacts"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex md:gap-3",
                            children: isLogin ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex md:gap-5 flex-col md:flex-row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90bba72fbdd9e9$export$2e2bcd8739ae039), {}),
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "2"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee6f13a46cf9100a$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "bg-green-500 px-2 text-white",
                                                children: "4"
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eebbdbda5fc86e89$export$2e2bcd8739ae039), {
                                        size: 20
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Log-in / Register"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                className: "container flex gap-5 justify-center items-center py-2 px-2",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2231dd843a1dfd59$export$f51f4c4ede09e011), {
                        bg: (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("white", "gray.800"),
                        color: (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("gray.600", "white"),
                        minH: "60px",
                        py: {
                            base: 2
                        },
                        px: {
                            base: 4
                        },
                        borderBottom: 1,
                        borderStyle: "solid",
                        borderColor: (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("gray.200", "gray.900"),
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2231dd843a1dfd59$export$f51f4c4ede09e011), {
                                flex: {
                                    base: 1,
                                    md: "auto"
                                },
                                ml: {
                                    base: -2
                                },
                                display: {
                                    base: "flex",
                                    md: "none"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ddb6cf7f4890f79$export$c25acd513dcc8062), {
                                    ref: btnRef,
                                    colorScheme: "teal",
                                    onClick: onOpen,
                                    icon: isOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f84d66857e2fec8$export$cae179f078f4b4a4), {
                                        w: 3,
                                        h: 3
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c14ccf14a23812f9$export$e369611dc3dfbf44), {
                                        w: 5,
                                        h: 5
                                    }),
                                    variant: "ghost",
                                    "aria-label": "Toggle Navigation"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2231dd843a1dfd59$export$f51f4c4ede09e011), {
                                flex: {
                                    base: 1
                                },
                                justify: {
                                    base: "center",
                                    md: "start"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a2900ce3f78a504$export$5f1af8db9871e1d6), {
                                        textAlign: (0, $b54379f4aa442bae$export$dc0946e21e709aff)({
                                            base: "center",
                                            md: "left"
                                        }),
                                        fontFamily: "heading",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        color: (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("gray.800", "white"),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($93dcb5d2a38d8faf$exports)))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2231dd843a1dfd59$export$f51f4c4ede09e011), {
                                        display: {
                                            base: "none",
                                            md: "flex"
                                        },
                                        ml: 10,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae19d542a7c5ce03$export$a0180b468ac3302f), {})
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2c5be1008fbfcbeb$export$4071300121a182f5), {
                isOpen: isOpen,
                placement: "left",
                onClose: onClose,
                finalFocusRef: btnRef,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $006bfa297e893b21$export$8948f78d83984c69), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $de1928e3734003a6$export$57ca055474bc0056), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e9ac767eb870fd0$export$edf9108895ba774f), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0caf763c70514c51$export$cb540d8b0ef7906c), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae19d542a7c5ce03$export$3a923eed7dfec49a), {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "flex gap-3 text-sm justify-center items-center p-2 bg-green-800 text-white",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {}),
                    " Up to 70% Sale.",
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        className: "underline",
                        to: "",
                        children: "Shop at our latest sale"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $ff199c4243e12e71$export$2e2bcd8739ae039 = $ff199c4243e12e71$var$Navbar;






var $acw62 = parcelRequire("acw62");

const $0e7e16638e3e82d5$var$slideVariants = {
    hiddenRight: {
        x: "100%",
        opacity: 0
    },
    hiddenLeft: {
        x: "100%",
        opacity: 0
    },
    visible: {
        x: "0",
        opacity: 1,
        transition: {
            duration: 1
        }
    },
    exit: {
        opacity: 0,
        scale: 0.8,
        transition: {
            duration: 0.5
        }
    }
};
const $0e7e16638e3e82d5$var$slidersVariants = {
    hover: {
        scale: 1.2,
        backgroundColor: "#ff00008e"
    }
};
const $0e7e16638e3e82d5$var$Carousel = ({ images: images })=>{
    const [currentIndex, setCurrentIndex] = (0, $acw62.useState)(0);
    const autoplayDelay = 5000;
    const [autoplayInterval, setAutoplayInterval] = (0, $acw62.useState)(null);
    const [direction, setDirection] = (0, $acw62.useState)("left");
    const handleNext = ()=>{
        setDirection("right");
        setCurrentIndex((prevIndex)=>prevIndex + 1 === images.length ? 0 : prevIndex + 1);
    };
    (0, $acw62.useEffect)(()=>{
        const interval = setInterval(()=>{
            const nextIndex = (currentIndex + 1) % images.length;
            setCurrentIndex(nextIndex);
        }, autoplayDelay);
        setAutoplayInterval(interval);
        return ()=>{
            clearInterval(autoplayInterval);
        };
    }, [
        currentIndex
    ]);
    const handlePrevious = ()=>{
        setDirection("left");
        setCurrentIndex((prevIndex)=>prevIndex - 1 < 0 ? images.length - 1 : prevIndex - 1);
    };
    const handleDotClick = (index)=>{
        setDirection(index > currentIndex ? "right" : "left");
        setCurrentIndex(index);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "carousel",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "carousel-images",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).img, {
                            className: "w-full  object-cover",
                            src: images[currentIndex],
                            variants: $0e7e16638e3e82d5$var$slideVariants,
                            initial: direction === "right" ? "hiddenRight" : "hiddenLeft",
                            animate: "visible",
                            exit: "exit"
                        }, currentIndex)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "slide_direction",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
                                variants: $0e7e16638e3e82d5$var$slidersVariants,
                                whileHover: "hover",
                                className: "left",
                                onClick: handlePrevious,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    height: "20",
                                    viewBox: "0 96 960 960",
                                    className: "left__icon",
                                    width: "20",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M400 976 0 576l400-400 56 57-343 343 343 343-56 57Z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
                                variants: $0e7e16638e3e82d5$var$slidersVariants,
                                whileHover: "hover",
                                className: "right",
                                onClick: handleNext,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    height: "20",
                                    className: "right__icon",
                                    viewBox: "0 96 960 960",
                                    width: "20",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "m304 974-56-57 343-343-343-343 56-57 400 400-400 400Z"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "carousel-indicator",
                children: images.map((_, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
                        className: `dot ${currentIndex === index ? "active" : ""}`,
                        onClick: ()=>handleDotClick(index),
                        initial: "initial",
                        animate: currentIndex === index ? "animate" : "",
                        whileHover: "hover"
                    }, index))
            })
        ]
    });
};
var $0e7e16638e3e82d5$export$2e2bcd8739ae039 = $0e7e16638e3e82d5$var$Carousel;


parcelRequire("acw62");

const $11053db89a68aa8b$var$images = [
    (0, (/*@__PURE__*/$parcel$interopDefault($72ef0cd6da1f3d6c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d36b9241727d123a$exports)))
];
const $11053db89a68aa8b$var$HomePage = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        className: "",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e7e16638e3e82d5$export$2e2bcd8739ae039), {
            images: $11053db89a68aa8b$var$images
        })
    });
};
var $11053db89a68aa8b$export$2e2bcd8739ae039 = $11053db89a68aa8b$var$HomePage;


parcelRequire("acw62");
const $0575cabfa6539371$var$BaseLayout = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11053db89a68aa8b$export$2e2bcd8739ae039), {});
};
var $0575cabfa6539371$export$2e2bcd8739ae039 = $0575cabfa6539371$var$BaseLayout;


const $71a2f54afc2a7bcd$var$Appp = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ff199c4243e12e71$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0575cabfa6539371$export$2e2bcd8739ae039), {})
                    }),
                    ";"
                ]
            })
        ]
    });
};
var $71a2f54afc2a7bcd$export$2e2bcd8739ae039 = $71a2f54afc2a7bcd$var$Appp;






"use client";
var $c3e440ef7c3cf4d3$var$css = String.raw;
var $c3e440ef7c3cf4d3$var$vhPolyfill = $c3e440ef7c3cf4d3$var$css`
  :root,
  :host {
    --chakra-vh: 100vh;
  }

  @supports (height: -webkit-fill-available) {
    :root,
    :host {
      --chakra-vh: -webkit-fill-available;
    }
  }

  @supports (height: -moz-fill-available) {
    :root,
    :host {
      --chakra-vh: -moz-fill-available;
    }
  }

  @supports (height: 100dvh) {
    :root,
    :host {
      --chakra-vh: 100dvh;
    }
  }
`;
var $c3e440ef7c3cf4d3$export$43a6590e493ec44a = ()=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $63d46a01db878c10$export$98f03c5d19621d70), {
        styles: $c3e440ef7c3cf4d3$var$vhPolyfill
    });
var $c3e440ef7c3cf4d3$export$b751feffed387621 = ({ scope: scope = "" })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $63d46a01db878c10$export$98f03c5d19621d70), {
        styles: $c3e440ef7c3cf4d3$var$css`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        margin: 0;
        font-feature-settings: "kern";
      }

      ${scope} :where(*, *::before, *::after) {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      main {
        display: block;
      }

      ${scope} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${scope} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${scope} a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      ${scope} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${scope} :where(b, strong) {
        font-weight: bold;
      }

      ${scope} small {
        font-size: 80%;
      }

      ${scope} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${scope} sub {
        bottom: -0.25em;
      }

      ${scope} sup {
        top: -0.5em;
      }

      ${scope} img {
        border-style: none;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      ${scope} :where(button, input) {
        overflow: visible;
      }

      ${scope} :where(button, select) {
        text-transform: none;
      }

      ${scope} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${scope} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${scope} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${scope} progress {
        vertical-align: baseline;
      }

      ${scope} textarea {
        overflow: auto;
      }

      ${scope} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${scope} input[type="number"]::-webkit-inner-spin-button,
      ${scope} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${scope} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${scope} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${scope} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${scope} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${scope} details {
        display: block;
      }

      ${scope} summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      ${scope} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        margin: 0;
      }

      ${scope} button {
        background: transparent;
        padding: 0;
      }

      ${scope} fieldset {
        margin: 0;
        padding: 0;
      }

      ${scope} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${scope} textarea {
        resize: vertical;
      }

      ${scope} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${scope} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${scope} table {
        border-collapse: collapse;
      }

      ${scope} :where(h1, h2, h3, h4, h5, h6) {
        font-size: inherit;
        font-weight: inherit;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${scope} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${scope} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${scope} select::-ms-expand {
        display: none;
      }

      ${$c3e440ef7c3cf4d3$var$vhPolyfill}
    `
    });
var $c3e440ef7c3cf4d3$export$428e8dbfc1580f11 = $c3e440ef7c3cf4d3$export$b751feffed387621;




"use client";
// src/color-mode.utils.ts
var $62ca5ae58df67fd2$var$classNames = {
    light: "chakra-ui-light",
    dark: "chakra-ui-dark"
};
function $62ca5ae58df67fd2$export$4bb933d353baa01c(options = {}) {
    const { preventTransition: preventTransition = true } = options;
    const utils = {
        setDataset: (value)=>{
            const cleanup = preventTransition ? utils.preventTransition() : void 0;
            document.documentElement.dataset.theme = value;
            document.documentElement.style.colorScheme = value;
            cleanup == null || cleanup();
        },
        setClassName (dark) {
            document.body.classList.add(dark ? $62ca5ae58df67fd2$var$classNames.dark : $62ca5ae58df67fd2$var$classNames.light);
            document.body.classList.remove(dark ? $62ca5ae58df67fd2$var$classNames.light : $62ca5ae58df67fd2$var$classNames.dark);
        },
        query () {
            return window.matchMedia("(prefers-color-scheme: dark)");
        },
        getSystemTheme (fallback) {
            var _a;
            const dark = (_a = utils.query().matches) != null ? _a : fallback === "dark";
            return dark ? "dark" : "light";
        },
        addListener (fn) {
            const mql = utils.query();
            const listener = (e)=>{
                fn(e.matches ? "dark" : "light");
            };
            if (typeof mql.addListener === "function") mql.addListener(listener);
            else mql.addEventListener("change", listener);
            return ()=>{
                if (typeof mql.removeListener === "function") mql.removeListener(listener);
                else mql.removeEventListener("change", listener);
            };
        },
        preventTransition () {
            const css = document.createElement("style");
            css.appendChild(document.createTextNode(`*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}`));
            document.head.appendChild(css);
            return ()=>{
                (()=>window.getComputedStyle(document.body))();
                requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        document.head.removeChild(css);
                    });
                });
            };
        }
    };
    return utils;
}


"use client";
// src/storage-manager.ts
var $961ae7cfe6b3d4e3$export$86880b4b2e1a2384 = "chakra-ui-color-mode";
function $961ae7cfe6b3d4e3$export$cdf53b88b62eb393(key) {
    return {
        ssr: false,
        type: "localStorage",
        get (init) {
            if (!(globalThis == null ? void 0 : globalThis.document)) return init;
            let value;
            try {
                value = localStorage.getItem(key) || init;
            } catch (e) {}
            return value || init;
        },
        set (value) {
            try {
                localStorage.setItem(key, value);
            } catch (e) {}
        }
    };
}
var $961ae7cfe6b3d4e3$export$8e35886de8a54f45 = $961ae7cfe6b3d4e3$export$cdf53b88b62eb393($961ae7cfe6b3d4e3$export$86880b4b2e1a2384);
function $961ae7cfe6b3d4e3$var$parseCookie(cookie, key) {
    const match = cookie.match(new RegExp(`(^| )${key}=([^;]+)`));
    return match == null ? void 0 : match[2];
}
function $961ae7cfe6b3d4e3$export$df28b7d6efe2673c(key, cookie) {
    return {
        ssr: !!cookie,
        type: "cookie",
        get (init) {
            if (cookie) return $961ae7cfe6b3d4e3$var$parseCookie(cookie, key);
            if (!(globalThis == null ? void 0 : globalThis.document)) return init;
            return $961ae7cfe6b3d4e3$var$parseCookie(document.cookie, key) || init;
        },
        set (value) {
            document.cookie = `${key}=${value}; max-age=31536000; path=/`;
        }
    };
}
var $961ae7cfe6b3d4e3$export$2e2b0158437077e3 = $961ae7cfe6b3d4e3$export$df28b7d6efe2673c($961ae7cfe6b3d4e3$export$86880b4b2e1a2384);
var $961ae7cfe6b3d4e3$export$d76e8eed3e914fa0 = (cookie)=>$961ae7cfe6b3d4e3$export$df28b7d6efe2673c($961ae7cfe6b3d4e3$export$86880b4b2e1a2384, cookie);




var $acw62 = parcelRequire("acw62");

"use client";
var $78f995395c70cd91$var$noop = ()=>{};
function $78f995395c70cd91$var$getTheme(manager, fallback) {
    return manager.type === "cookie" && manager.ssr ? manager.get(fallback) : fallback;
}
function $78f995395c70cd91$export$7a858aa3ff83dde7(props) {
    const { value: value, children: children, options: { useSystemColorMode: useSystemColorMode, initialColorMode: initialColorMode, disableTransitionOnChange: disableTransitionOnChange } = {}, colorModeManager: colorModeManager = (0, $961ae7cfe6b3d4e3$export$8e35886de8a54f45) } = props;
    const defaultColorMode = initialColorMode === "dark" ? "dark" : "light";
    const [colorMode, rawSetColorMode] = (0, $acw62.useState)(()=>$78f995395c70cd91$var$getTheme(colorModeManager, defaultColorMode));
    const [resolvedColorMode, setResolvedColorMode] = (0, $acw62.useState)(()=>$78f995395c70cd91$var$getTheme(colorModeManager));
    const { getSystemTheme: getSystemTheme, setClassName: setClassName, setDataset: setDataset, addListener: addListener } = (0, $acw62.useMemo)(()=>(0, $62ca5ae58df67fd2$export$4bb933d353baa01c)({
            preventTransition: disableTransitionOnChange
        }), [
        disableTransitionOnChange
    ]);
    const resolvedValue = initialColorMode === "system" && !colorMode ? resolvedColorMode : colorMode;
    const setColorMode = (0, $acw62.useCallback)((value2)=>{
        const resolved = value2 === "system" ? getSystemTheme() : value2;
        rawSetColorMode(resolved);
        setClassName(resolved === "dark");
        setDataset(resolved);
        colorModeManager.set(resolved);
    }, [
        colorModeManager,
        getSystemTheme,
        setClassName,
        setDataset
    ]);
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (initialColorMode === "system") setResolvedColorMode(getSystemTheme());
    }, []);
    (0, $acw62.useEffect)(()=>{
        const managerValue = colorModeManager.get();
        if (managerValue) {
            setColorMode(managerValue);
            return;
        }
        if (initialColorMode === "system") {
            setColorMode("system");
            return;
        }
        setColorMode(defaultColorMode);
    }, [
        colorModeManager,
        defaultColorMode,
        initialColorMode,
        setColorMode
    ]);
    const toggleColorMode = (0, $acw62.useCallback)(()=>{
        setColorMode(resolvedValue === "dark" ? "light" : "dark");
    }, [
        resolvedValue,
        setColorMode
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!useSystemColorMode) return;
        return addListener(setColorMode);
    }, [
        useSystemColorMode,
        addListener,
        setColorMode
    ]);
    const context = (0, $acw62.useMemo)(()=>({
            colorMode: value != null ? value : resolvedValue,
            toggleColorMode: value ? $78f995395c70cd91$var$noop : toggleColorMode,
            setColorMode: value ? $78f995395c70cd91$var$noop : setColorMode,
            forced: value !== void 0
        }), [
        resolvedValue,
        toggleColorMode,
        setColorMode,
        value
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b80b1cf263c5808a$export$49ddd74a6729fdb0).Provider, {
        value: context,
        children: children
    });
}
$78f995395c70cd91$export$7a858aa3ff83dde7.displayName = "ColorModeProvider";
function $78f995395c70cd91$export$8b41b18ed1f3731e(props) {
    const context = (0, $acw62.useMemo)(()=>({
            colorMode: "dark",
            toggleColorMode: $78f995395c70cd91$var$noop,
            setColorMode: $78f995395c70cd91$var$noop,
            forced: true
        }), []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b80b1cf263c5808a$export$49ddd74a6729fdb0).Provider, {
        value: context,
        ...props
    });
}
$78f995395c70cd91$export$8b41b18ed1f3731e.displayName = "DarkMode";
function $78f995395c70cd91$export$cee2b1aa9166b2a3(props) {
    const context = (0, $acw62.useMemo)(()=>({
            colorMode: "light",
            toggleColorMode: $78f995395c70cd91$var$noop,
            setColorMode: $78f995395c70cd91$var$noop,
            forced: true
        }), []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b80b1cf263c5808a$export$49ddd74a6729fdb0).Provider, {
        value: context,
        ...props
    });
}
$78f995395c70cd91$export$cee2b1aa9166b2a3.displayName = "LightMode";


// src/context.ts

var $acw62 = parcelRequire("acw62");
function $e54f09380e048946$export$fd42f52fd3ae1109(options = {}) {
    const { strict: strict = true, errorMessage: errorMessage = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider", name: name } = options;
    const Context = (0, $acw62.createContext)(void 0);
    Context.displayName = name;
    function useContext() {
        var _a;
        const context = (0, $acw62.useContext)(Context);
        if (!context && strict) {
            const error = new Error(errorMessage);
            error.name = "ContextError";
            (_a = Error.captureStackTrace) == null || _a.call(Error, error, useContext);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext,
        Context
    ];
}






var $acw62 = parcelRequire("acw62");

"use client";
function $c3f04b55c7a24011$export$d8964aec282183a3(props) {
    const { cssVarsRoot: cssVarsRoot, theme: theme, children: children } = props;
    const computedTheme = (0, $acw62.useMemo)(()=>(0, $47a6d9fbbf7ee42d$export$d4e5dc2a444c0164)(theme), [
        theme
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $0fe24a6591b39473$export$407448d2b89b1813), {
        theme: computedTheme,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($c3f04b55c7a24011$export$d767872124667db6, {
                root: cssVarsRoot
            }),
            children
        ]
    });
}
function $c3f04b55c7a24011$export$d767872124667db6({ root: root = ":host, :root" }) {
    const selector = [
        root,
        `[data-theme]`
    ].join(",");
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $63d46a01db878c10$export$98f03c5d19621d70), {
        styles: (theme)=>({
                [selector]: theme.__cssVars
            })
    });
}
var [$c3f04b55c7a24011$export$dc4c659861f00dbe, $c3f04b55c7a24011$export$28e6b9b82ee883c] = (0, $e54f09380e048946$export$fd42f52fd3ae1109)({
    name: "StylesContext",
    errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function $c3f04b55c7a24011$export$11d9f9905bcdc114(componentName) {
    return (0, $e54f09380e048946$export$fd42f52fd3ae1109)({
        name: `${componentName}StylesContext`,
        errorMessage: `useStyles: "styles" is undefined. Seems you forgot to wrap the components in "<${componentName} />" `
    });
}
function $c3f04b55c7a24011$export$f05794e648629f6c() {
    const { colorMode: colorMode } = (0, $b80b1cf263c5808a$export$20f3076712c8dfa)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $63d46a01db878c10$export$98f03c5d19621d70), {
        styles: (theme)=>{
            const styleObjectOrFn = (0, $8cabe7dbd312f1c1$export$1bb32d0c65da6059)(theme, "styles.global");
            const globalStyles = (0, $7e9e3a2462729b7f$export$624e501d81f5ffce)(styleObjectOrFn, {
                theme: theme,
                colorMode: colorMode
            });
            if (!globalStyles) return void 0;
            const styles = (0, $47a6d9fbbf7ee42d$export$dbf350e5966cf602)(globalStyles)(theme);
            return styles;
        }
    });
}




"use client";
var $be3187ddebc65cb1$export$80dbe0482bcbd25a = (props)=>{
    const { children: children, colorModeManager: colorModeManager, portalZIndex: portalZIndex, resetScope: resetScope, resetCSS: resetCSS = true, theme: theme = {}, environment: environment, cssVarsRoot: cssVarsRoot, disableEnvironment: disableEnvironment, disableGlobalStyle: disableGlobalStyle } = props;
    const _children = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a87268155f9f2cb$export$29a4c0b32fc9db42), {
        environment: environment,
        disabled: disableEnvironment,
        children: children
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c3f04b55c7a24011$export$d8964aec282183a3), {
        theme: theme,
        cssVarsRoot: cssVarsRoot,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $78f995395c70cd91$export$7a858aa3ff83dde7), {
            colorModeManager: colorModeManager,
            options: theme.config,
            children: [
                resetCSS ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c3e440ef7c3cf4d3$export$b751feffed387621), {
                    scope: resetScope
                }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c3e440ef7c3cf4d3$export$43a6590e493ec44a), {}),
                !disableGlobalStyle && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c3f04b55c7a24011$export$f05794e648629f6c), {}),
                portalZIndex ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cb17b1dba222b22e$export$52c7ef79917c2f38), {
                    zIndex: portalZIndex,
                    children: _children
                }) : _children
            ]
        })
    });
};



"use client";
// src/toast.utils.ts
var $13c58346a8d373ae$export$6486ede9e74d7d9d = (arr, id)=>arr.find((toast)=>toast.id === id);
function $13c58346a8d373ae$export$67080b9d5f0a62ea(toasts, id) {
    const position = $13c58346a8d373ae$export$500f52ac46324ec6(toasts, id);
    const index = position ? toasts[position].findIndex((toast)=>toast.id === id) : -1;
    return {
        position: position,
        index: index
    };
}
function $13c58346a8d373ae$export$500f52ac46324ec6(toasts, id) {
    for (const [position, values] of Object.entries(toasts)){
        if ($13c58346a8d373ae$export$6486ede9e74d7d9d(values, id)) return position;
    }
}
var $13c58346a8d373ae$export$795910f5f15a9633 = (toasts, id)=>!!$13c58346a8d373ae$export$500f52ac46324ec6(toasts, id);
function $13c58346a8d373ae$export$27777812cc6d52de(position) {
    const isRighty = position.includes("right");
    const isLefty = position.includes("left");
    let alignItems = "center";
    if (isRighty) alignItems = "flex-end";
    if (isLefty) alignItems = "flex-start";
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: alignItems
    };
}
function $13c58346a8d373ae$export$55dd410e8ef136e0(position) {
    const isTopOrBottom = position === "top" || position === "bottom";
    const margin = isTopOrBottom ? "0 auto" : void 0;
    const top = position.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0;
    const bottom = position.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0;
    const right = !position.includes("left") ? "env(safe-area-inset-right, 0px)" : void 0;
    const left = !position.includes("right") ? "env(safe-area-inset-left, 0px)" : void 0;
    return {
        position: "fixed",
        zIndex: "var(--toast-z-index, 5500)",
        pointerEvents: "none",
        display: "flex",
        flexDirection: "column",
        margin: margin,
        top: top,
        bottom: bottom,
        right: right,
        left: left
    };
}



var $acw62 = parcelRequire("acw62");

"use client";
function $3efd861ddab1b905$export$d8e6abf214c9ec0f(callback, delay) {
    const fn = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(callback);
    (0, $acw62.useEffect)(()=>{
        if (delay == null) return void 0;
        let timeoutId = null;
        timeoutId = window.setTimeout(()=>{
            fn();
        }, delay);
        return ()=>{
            if (timeoutId) window.clearTimeout(timeoutId);
        };
    }, [
        delay,
        fn
    ]);
}







var $acw62 = parcelRequire("acw62");

"use client";
var $c6c69dab3415618a$var$toastMotionVariants = {
    initial: (props)=>{
        const { position: position } = props;
        const dir = [
            "top",
            "bottom"
        ].includes(position) ? "y" : "x";
        let factor = [
            "top-right",
            "bottom-right"
        ].includes(position) ? 1 : -1;
        if (position === "bottom") factor = 1;
        return {
            opacity: 0,
            [dir]: factor * 24
        };
    },
    animate: {
        opacity: 1,
        y: 0,
        x: 0,
        scale: 1,
        transition: {
            duration: 0.4,
            ease: [
                0.4,
                0,
                0.2,
                1
            ]
        }
    },
    exit: {
        opacity: 0,
        scale: 0.85,
        transition: {
            duration: 0.2,
            ease: [
                0.4,
                0,
                1,
                1
            ]
        }
    }
};
var $c6c69dab3415618a$export$8743ba3ef25f9582 = (0, $acw62.memo)((props)=>{
    const { id: id, message: message, onCloseComplete: onCloseComplete, onRequestRemove: onRequestRemove, requestClose: requestClose = false, position: position = "bottom", duration: duration = 5e3, containerStyle: containerStyle, motionVariants: motionVariants = $c6c69dab3415618a$var$toastMotionVariants, toastSpacing: toastSpacing = "0.5rem" } = props;
    const [delay, setDelay] = (0, $acw62.useState)(duration);
    const isPresent = (0, $bc77fac60b5d77cc$export$8249053f690ea39a)();
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        if (!isPresent) onCloseComplete == null || onCloseComplete();
    }, [
        isPresent
    ]);
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        setDelay(duration);
    }, [
        duration
    ]);
    const onMouseEnter = ()=>setDelay(null);
    const onMouseLeave = ()=>setDelay(duration);
    const close = ()=>{
        if (isPresent) onRequestRemove();
    };
    (0, $acw62.useEffect)(()=>{
        if (isPresent && requestClose) onRequestRemove();
    }, [
        isPresent,
        requestClose,
        onRequestRemove
    ]);
    (0, $3efd861ddab1b905$export$d8e6abf214c9ec0f)(close, delay);
    const containerStyles = (0, $acw62.useMemo)(()=>({
            pointerEvents: "auto",
            maxWidth: 560,
            minWidth: 300,
            margin: toastSpacing,
            ...containerStyle
        }), [
        containerStyle,
        toastSpacing
    ]);
    const toastStyle = (0, $acw62.useMemo)(()=>(0, $13c58346a8d373ae$export$27777812cc6d52de)(position), [
        position
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
        layout: true,
        className: "chakra-toast",
        variants: motionVariants,
        initial: "initial",
        animate: "animate",
        exit: "exit",
        onHoverStart: onMouseEnter,
        onHoverEnd: onMouseLeave,
        custom: {
            position: position
        },
        style: toastStyle,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
            role: "status",
            "aria-atomic": "true",
            className: "chakra-toast__inner",
            __css: containerStyles,
            children: (0, $abe97432afb3d989$export$624e501d81f5ffce)(message, {
                id: id,
                onClose: close
            })
        })
    });
});
$c6c69dab3415618a$export$8743ba3ef25f9582.displayName = "ToastComponent";



"use client";
// src/toast.placement.ts
function $c13e78f3f75f793d$export$5b03f73d5fd4425(position, dir) {
    var _a;
    const computedPosition = position != null ? position : "bottom";
    const logicals = {
        "top-start": {
            ltr: "top-left",
            rtl: "top-right"
        },
        "top-end": {
            ltr: "top-right",
            rtl: "top-left"
        },
        "bottom-start": {
            ltr: "bottom-left",
            rtl: "bottom-right"
        },
        "bottom-end": {
            ltr: "bottom-right",
            rtl: "bottom-left"
        }
    };
    const logical = logicals[computedPosition];
    return (_a = logical == null ? void 0 : logical[dir]) != null ? _a : computedPosition;
}




"use client";
function $747925a80656aa47$export$7dd004358974b05d(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $6a96cde036d65913$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
        })
    });
}
function $747925a80656aa47$export$2957fc44b3d2481(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $6a96cde036d65913$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
        })
    });
}
function $747925a80656aa47$export$f7dc499a72baa103(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $6a96cde036d65913$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
        })
    });
}




"use client";
var [$e8473bbab2974e87$export$a7901f7b4cce70b0, $e8473bbab2974e87$export$50b520f08832063d] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: "AlertContext",
    hookName: "useAlertContext",
    providerName: "<Alert />"
});
var [$e8473bbab2974e87$export$17cf5063e294f385, $e8473bbab2974e87$export$167ececdbea67592] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `AlertStylesContext`,
    hookName: `useAlertStyles`,
    providerName: "<Alert />"
});
var $e8473bbab2974e87$var$STATUSES = {
    info: {
        icon: (0, $747925a80656aa47$export$2957fc44b3d2481),
        colorScheme: "blue"
    },
    warning: {
        icon: (0, $747925a80656aa47$export$f7dc499a72baa103),
        colorScheme: "orange"
    },
    success: {
        icon: (0, $747925a80656aa47$export$7dd004358974b05d),
        colorScheme: "green"
    },
    error: {
        icon: (0, $747925a80656aa47$export$f7dc499a72baa103),
        colorScheme: "red"
    },
    loading: {
        icon: (0, $6c35780027222e0c$export$7f7cbe89f1eacd2),
        colorScheme: "blue"
    }
};
function $e8473bbab2974e87$export$8df8f66d0469c54d(status) {
    return $e8473bbab2974e87$var$STATUSES[status].colorScheme;
}
function $e8473bbab2974e87$export$c742923ea4ac4c1c(status) {
    return $e8473bbab2974e87$var$STATUSES[status].icon;
}





"use client";
var $e6d3646647574d7b$export$caec2af78bcc877f = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Alert2(props, ref) {
    var _a;
    const { status: status = "info", addRole: addRole = true, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const colorScheme = (_a = props.colorScheme) != null ? _a : (0, $e8473bbab2974e87$export$8df8f66d0469c54d)(status);
    const styles = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Alert", {
        ...props,
        colorScheme: colorScheme
    });
    const alertStyles = {
        width: "100%",
        display: "flex",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
        ...styles.container
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e8473bbab2974e87$export$a7901f7b4cce70b0), {
        value: {
            status: status
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e8473bbab2974e87$export$17cf5063e294f385), {
            value: styles,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
                "data-status": status,
                role: addRole ? "alert" : void 0,
                ref: ref,
                ...rest,
                className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-alert", props.className),
                __css: alertStyles
            })
        })
    });
});
$e6d3646647574d7b$export$caec2af78bcc877f.displayName = "Alert";





"use client";
var $47cb36091e93dfa4$export$d4feae172fccda11 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function AlertDescription2(props, ref) {
    const styles = (0, $e8473bbab2974e87$export$167ececdbea67592)();
    const { status: status } = (0, $e8473bbab2974e87$export$50b520f08832063d)();
    const descriptionStyles = {
        display: "inline",
        ...styles.description
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ref: ref,
        "data-status": status,
        ...props,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-alert__desc", props.className),
        __css: descriptionStyles
    });
});
$47cb36091e93dfa4$export$d4feae172fccda11.displayName = "AlertDescription";





"use client";
function $39514ae01177ad54$export$4a143c8822a09fb4(props) {
    const { status: status } = (0, $e8473bbab2974e87$export$50b520f08832063d)();
    const BaseIcon = (0, $e8473bbab2974e87$export$c742923ea4ac4c1c)(status);
    const styles = (0, $e8473bbab2974e87$export$167ececdbea67592)();
    const css = status === "loading" ? styles.spinner : styles.icon;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
        display: "inherit",
        "data-status": status,
        ...props,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-alert__icon", props.className),
        __css: css,
        children: props.children || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(BaseIcon, {
            h: "100%",
            w: "100%"
        })
    });
}
$39514ae01177ad54$export$4a143c8822a09fb4.displayName = "AlertIcon";





"use client";
var $1437852cd8382f03$export$4a7253439a300753 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function AlertTitle2(props, ref) {
    const styles = (0, $e8473bbab2974e87$export$167ececdbea67592)();
    const { status: status } = (0, $e8473bbab2974e87$export$50b520f08832063d)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ref: ref,
        "data-status": status,
        ...props,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-alert__title", props.className),
        __css: styles.title
    });
});
$1437852cd8382f03$export$4a7253439a300753.displayName = "AlertTitle";






"use client";
// src/toast.store.ts
var $5d453eab4ae9d3d7$var$initialState = {
    top: [],
    "top-left": [],
    "top-right": [],
    "bottom-left": [],
    bottom: [],
    "bottom-right": []
};
var $5d453eab4ae9d3d7$export$e80fa18a42ed98ef = $5d453eab4ae9d3d7$var$createStore($5d453eab4ae9d3d7$var$initialState);
function $5d453eab4ae9d3d7$var$createStore(initialState2) {
    let state = initialState2;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (setStateFn)=>{
        state = setStateFn(state);
        listeners.forEach((l)=>l());
    };
    return {
        getState: ()=>state,
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>{
                setState(()=>initialState2);
                listeners.delete(listener);
            };
        },
        /**
     * Delete a toast record at its position
     */ removeToast: (id, position)=>{
            setState((prevState)=>({
                    ...prevState,
                    // id may be string or number
                    // eslint-disable-next-line eqeqeq
                    [position]: prevState[position].filter((toast)=>toast.id != id)
                }));
        },
        notify: (message, options)=>{
            const toast = $5d453eab4ae9d3d7$var$createToast(message, options);
            const { position: position, id: id } = toast;
            setState((prevToasts)=>{
                var _a, _b;
                const isTop = position.includes("top");
                const toasts = isTop ? [
                    toast,
                    ...(_a = prevToasts[position]) != null ? _a : []
                ] : [
                    ...(_b = prevToasts[position]) != null ? _b : [],
                    toast
                ];
                return {
                    ...prevToasts,
                    [position]: toasts
                };
            });
            return id;
        },
        update: (id, options)=>{
            if (!id) return;
            setState((prevState)=>{
                const nextState = {
                    ...prevState
                };
                const { position: position, index: index } = (0, $13c58346a8d373ae$export$67080b9d5f0a62ea)(nextState, id);
                if (position && index !== -1) nextState[position][index] = {
                    ...nextState[position][index],
                    ...options,
                    message: $5d453eab4ae9d3d7$export$d9d796c483697359(options)
                };
                return nextState;
            });
        },
        closeAll: ({ positions: positions } = {})=>{
            setState((prev)=>{
                const allPositions = [
                    "bottom",
                    "bottom-right",
                    "bottom-left",
                    "top",
                    "top-left",
                    "top-right"
                ];
                const positionsToClose = positions != null ? positions : allPositions;
                return positionsToClose.reduce((acc, position)=>{
                    acc[position] = prev[position].map((toast)=>({
                            ...toast,
                            requestClose: true
                        }));
                    return acc;
                }, {
                    ...prev
                });
            });
        },
        close: (id)=>{
            setState((prevState)=>{
                const position = (0, $13c58346a8d373ae$export$500f52ac46324ec6)(prevState, id);
                if (!position) return prevState;
                return {
                    ...prevState,
                    [position]: prevState[position].map((toast)=>{
                        if (toast.id == id) return {
                            ...toast,
                            requestClose: true
                        };
                        return toast;
                    })
                };
            });
        },
        isActive: (id)=>Boolean((0, $13c58346a8d373ae$export$67080b9d5f0a62ea)($5d453eab4ae9d3d7$export$e80fa18a42ed98ef.getState(), id).position)
    };
}
var $5d453eab4ae9d3d7$var$counter = 0;
function $5d453eab4ae9d3d7$var$createToast(message, options = {}) {
    var _a, _b;
    $5d453eab4ae9d3d7$var$counter += 1;
    const id = (_a = options.id) != null ? _a : $5d453eab4ae9d3d7$var$counter;
    const position = (_b = options.position) != null ? _b : "bottom";
    return {
        id: id,
        message: message,
        position: position,
        duration: options.duration,
        onCloseComplete: options.onCloseComplete,
        onRequestRemove: ()=>$5d453eab4ae9d3d7$export$e80fa18a42ed98ef.removeToast(String(id), position),
        status: options.status,
        requestClose: false,
        containerStyle: options.containerStyle
    };
}
var $5d453eab4ae9d3d7$export$8d8dc7d5f743331b = (props)=>{
    const { status: status, variant: variant = "solid", id: id, title: title, isClosable: isClosable, onClose: onClose, description: description, colorScheme: colorScheme, icon: icon } = props;
    const ids = id ? {
        root: `toast-${id}`,
        title: `toast-${id}-title`,
        description: `toast-${id}-description`
    } : void 0;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $e6d3646647574d7b$export$caec2af78bcc877f), {
        addRole: false,
        status: status,
        variant: variant,
        id: ids == null ? void 0 : ids.root,
        alignItems: "start",
        borderRadius: "md",
        boxShadow: "lg",
        paddingEnd: 8,
        textAlign: "start",
        width: "auto",
        colorScheme: colorScheme,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $39514ae01177ad54$export$4a143c8822a09fb4), {
                children: icon
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
                flex: "1",
                maxWidth: "100%",
                children: [
                    title && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $1437852cd8382f03$export$4a7253439a300753), {
                        id: ids == null ? void 0 : ids.title,
                        children: title
                    }),
                    description && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $47cb36091e93dfa4$export$d4feae172fccda11), {
                        id: ids == null ? void 0 : ids.description,
                        display: "block",
                        children: description
                    })
                ]
            }),
            isClosable && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4a635bb7fe4595f6$export$de65de8213222d10), {
                size: "sm",
                onClick: onClose,
                position: "absolute",
                insetEnd: 1,
                top: 1
            })
        ]
    });
};
function $5d453eab4ae9d3d7$export$d9d796c483697359(options = {}) {
    const { render: render, toastComponent: ToastComponent = $5d453eab4ae9d3d7$export$8d8dc7d5f743331b } = options;
    const renderToast = (props)=>{
        if (typeof render === "function") return render({
            ...props,
            ...options
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(ToastComponent, {
            ...props,
            ...options
        });
    };
    return renderToast;
}
function $5d453eab4ae9d3d7$export$f3af62d19eb14261(dir, defaultOptions) {
    const normalizeToastOptions = (options)=>{
        var _a;
        return {
            ...defaultOptions,
            ...options,
            position: (0, $c13e78f3f75f793d$export$5b03f73d5fd4425)((_a = options == null ? void 0 : options.position) != null ? _a : defaultOptions == null ? void 0 : defaultOptions.position, dir)
        };
    };
    const toast = (options)=>{
        const normalizedToastOptions = normalizeToastOptions(options);
        const Message = $5d453eab4ae9d3d7$export$d9d796c483697359(normalizedToastOptions);
        return $5d453eab4ae9d3d7$export$e80fa18a42ed98ef.notify(Message, normalizedToastOptions);
    };
    toast.update = (id, options)=>{
        $5d453eab4ae9d3d7$export$e80fa18a42ed98ef.update(id, normalizeToastOptions(options));
    };
    toast.promise = (promise, options)=>{
        const id = toast({
            ...options.loading,
            status: "loading",
            duration: null
        });
        promise.then((data)=>toast.update(id, {
                status: "success",
                duration: 5e3,
                ...(0, $abe97432afb3d989$export$624e501d81f5ffce)(options.success, data)
            })).catch((error)=>toast.update(id, {
                status: "error",
                duration: 5e3,
                ...(0, $abe97432afb3d989$export$624e501d81f5ffce)(options.error, error)
            }));
    };
    toast.closeAll = $5d453eab4ae9d3d7$export$e80fa18a42ed98ef.closeAll;
    toast.close = $5d453eab4ae9d3d7$export$e80fa18a42ed98ef.close;
    toast.isActive = $5d453eab4ae9d3d7$export$e80fa18a42ed98ef.isActive;
    return toast;
}






var $acw62 = parcelRequire("acw62");


"use client";
var [$b00acac8a28d413b$export$cfcc07abbe2e36a8, $b00acac8a28d413b$export$7c4af276256dc908] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `ToastOptionsContext`,
    strict: false
});
var $b00acac8a28d413b$export$f5d03d415824e0e = (props)=>{
    const state = (0, $acw62.useSyncExternalStore)((0, $5d453eab4ae9d3d7$export$e80fa18a42ed98ef).subscribe, (0, $5d453eab4ae9d3d7$export$e80fa18a42ed98ef).getState, (0, $5d453eab4ae9d3d7$export$e80fa18a42ed98ef).getState);
    const { motionVariants: motionVariants, component: Component = (0, $c6c69dab3415618a$export$8743ba3ef25f9582), portalProps: portalProps } = props;
    const stateKeys = Object.keys(state);
    const toastList = stateKeys.map((position)=>{
        const toasts = state[position];
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            role: "region",
            "aria-live": "polite",
            "aria-label": "Notifications",
            id: `chakra-toast-manager-${position}`,
            style: (0, $13c58346a8d373ae$export$55dd410e8ef136e0)(position),
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                initial: false,
                children: toasts.map((toast)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                        motionVariants: motionVariants,
                        ...toast
                    }, toast.id))
            })
        }, position);
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b71276780b6a43df$export$602eac185826482c), {
        ...portalProps,
        children: toastList
    });
};



"use client";
var $87af691840ea6fe4$var$createChakraProvider = (providerTheme)=>{
    return function ChakraProvider2({ children: children, theme: theme = providerTheme, toastOptions: toastOptions, ...restProps }) {
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $be3187ddebc65cb1$export$80dbe0482bcbd25a), {
            theme: theme,
            ...restProps,
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b00acac8a28d413b$export$cfcc07abbe2e36a8), {
                    value: toastOptions == null ? void 0 : toastOptions.defaultOptions,
                    children: children
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b00acac8a28d413b$export$f5d03d415824e0e), {
                    ...toastOptions
                })
            ]
        });
    };
};
var $87af691840ea6fe4$export$80dbe0482bcbd25a = $87af691840ea6fe4$var$createChakraProvider((0, $fecf4860da5314d0$export$bca14c5b3b88a9c9));
var $87af691840ea6fe4$export$39d642dd5c97e94c = $87af691840ea6fe4$var$createChakraProvider((0, $fecf4860da5314d0$export$9e955aef208055a6));


(0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById("app")).render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$7221d69dcfc8e36b), {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87af691840ea6fe4$export$80dbe0482bcbd25a), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $71a2f54afc2a7bcd$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=index.97602bfd.js.map
